(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
const $dec17af1c054e95f$export$4a278486528d5cfb = "generated";
const $dec17af1c054e95f$export$9ffd73c9a0e32c34 = "pointerdown";
const $dec17af1c054e95f$export$9fb0268ce1bdbca0 = "pointerup";
const $dec17af1c054e95f$export$f4b184a85a586f8a = "pointerleave";
const $dec17af1c054e95f$export$55cc1d6a692feb2b = "pointerout";
const $dec17af1c054e95f$export$1ffe551d7d33cd33 = "pointermove";
const $dec17af1c054e95f$export$d5353b6c79bbcc70 = "touchstart";
const $dec17af1c054e95f$export$11164630b85c192d = "touchend";
const $dec17af1c054e95f$export$d28a82874c0e6212 = "touchmove";
const $dec17af1c054e95f$export$65db1c69591947a7 = "touchcancel";
const $dec17af1c054e95f$export$8b3d73c91cd7cc65 = "resize";
const $dec17af1c054e95f$export$73536144dc68dd0f = "visibilitychange";
const $dec17af1c054e95f$export$adea4917e02d93dc = "tsParticles - Error";
const $dec17af1c054e95f$export$9519bca7a9fbeccd = 100;
const $dec17af1c054e95f$export$fa0534be1c9f2e23 = 0.5;
const $dec17af1c054e95f$export$f64c3bfbc58eec0f = 1000;


var $aeeeb4a954ef988f$export$cc1a246adca07dd4;
(function(MoveDirection) {
    MoveDirection["bottom"] = "bottom";
    MoveDirection["bottomLeft"] = "bottom-left";
    MoveDirection["bottomRight"] = "bottom-right";
    MoveDirection["left"] = "left";
    MoveDirection["none"] = "none";
    MoveDirection["right"] = "right";
    MoveDirection["top"] = "top";
    MoveDirection["topLeft"] = "top-left";
    MoveDirection["topRight"] = "top-right";
    MoveDirection["outside"] = "outside";
    MoveDirection["inside"] = "inside";
})($aeeeb4a954ef988f$export$cc1a246adca07dd4 || ($aeeeb4a954ef988f$export$cc1a246adca07dd4 = {}));



function $ad25b6e319f6df8c$export$f9ce7b637dfbe238(arg) {
    return typeof arg === "boolean";
}
function $ad25b6e319f6df8c$export$844ec244b1367d54(arg) {
    return typeof arg === "string";
}
function $ad25b6e319f6df8c$export$7e4aa119212bc614(arg) {
    return typeof arg === "number";
}
function $ad25b6e319f6df8c$export$f6e2535fb5126e54(arg) {
    return typeof arg === "function";
}
function $ad25b6e319f6df8c$export$a6cdc56e425d0d0a(arg) {
    return typeof arg === "object" && arg !== null;
}
function $ad25b6e319f6df8c$export$43bee75e5e14138e(arg) {
    return Array.isArray(arg);
}


const $04697537ec8dce5b$var$origin = {
    x: 0,
    y: 0,
    z: 0
}, $04697537ec8dce5b$var$squareExp = 2, $04697537ec8dce5b$var$inverseFactorNumerator = 1.0;
class $04697537ec8dce5b$export$ece015703618ce3d {
    constructor(xOrCoords, y, z){
        this._updateFromAngle = (angle, length)=>{
            this.x = Math.cos(angle) * length;
            this.y = Math.sin(angle) * length;
        };
        if (!(0, $ad25b6e319f6df8c$export$7e4aa119212bc614)(xOrCoords) && xOrCoords) {
            this.x = xOrCoords.x;
            this.y = xOrCoords.y;
            const coords3d = xOrCoords;
            this.z = coords3d.z ? coords3d.z : $04697537ec8dce5b$var$origin.z;
        } else if (xOrCoords !== undefined && y !== undefined) {
            this.x = xOrCoords;
            this.y = y;
            this.z = z ?? $04697537ec8dce5b$var$origin.z;
        } else throw new Error(`${(0, $dec17af1c054e95f$export$adea4917e02d93dc)} Vector3d not initialized correctly`);
    }
    static get origin() {
        return $04697537ec8dce5b$export$ece015703618ce3d.create($04697537ec8dce5b$var$origin.x, $04697537ec8dce5b$var$origin.y, $04697537ec8dce5b$var$origin.z);
    }
    get angle() {
        return Math.atan2(this.y, this.x);
    }
    set angle(angle) {
        this._updateFromAngle(angle, this.length);
    }
    get length() {
        return Math.sqrt(this.getLengthSq());
    }
    set length(length) {
        this._updateFromAngle(this.angle, length);
    }
    static clone(source) {
        return $04697537ec8dce5b$export$ece015703618ce3d.create(source.x, source.y, source.z);
    }
    static create(x, y, z) {
        return new $04697537ec8dce5b$export$ece015703618ce3d(x, y, z);
    }
    add(v) {
        return $04697537ec8dce5b$export$ece015703618ce3d.create(this.x + v.x, this.y + v.y, this.z + v.z);
    }
    addTo(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
    }
    copy() {
        return $04697537ec8dce5b$export$ece015703618ce3d.clone(this);
    }
    distanceTo(v) {
        return this.sub(v).length;
    }
    distanceToSq(v) {
        return this.sub(v).getLengthSq();
    }
    div(n) {
        return $04697537ec8dce5b$export$ece015703618ce3d.create(this.x / n, this.y / n, this.z / n);
    }
    divTo(n) {
        this.x /= n;
        this.y /= n;
        this.z /= n;
    }
    getLengthSq() {
        return this.x ** $04697537ec8dce5b$var$squareExp + this.y ** $04697537ec8dce5b$var$squareExp;
    }
    mult(n) {
        return $04697537ec8dce5b$export$ece015703618ce3d.create(this.x * n, this.y * n, this.z * n);
    }
    multTo(n) {
        this.x *= n;
        this.y *= n;
        this.z *= n;
    }
    normalize() {
        const length = this.length, noLength = 0;
        if (length != noLength) this.multTo($04697537ec8dce5b$var$inverseFactorNumerator / length);
    }
    rotate(angle) {
        return $04697537ec8dce5b$export$ece015703618ce3d.create(this.x * Math.cos(angle) - this.y * Math.sin(angle), this.x * Math.sin(angle) + this.y * Math.cos(angle), $04697537ec8dce5b$var$origin.z);
    }
    setTo(c) {
        this.x = c.x;
        this.y = c.y;
        const v3d = c;
        this.z = v3d.z ? v3d.z : $04697537ec8dce5b$var$origin.z;
    }
    sub(v) {
        return $04697537ec8dce5b$export$ece015703618ce3d.create(this.x - v.x, this.y - v.y, this.z - v.z);
    }
    subFrom(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
    }
}
class $04697537ec8dce5b$export$9b781de7bf37bf48 extends $04697537ec8dce5b$export$ece015703618ce3d {
    constructor(xOrCoords, y){
        super(xOrCoords, y, $04697537ec8dce5b$var$origin.z);
    }
    static get origin() {
        return $04697537ec8dce5b$export$9b781de7bf37bf48.create($04697537ec8dce5b$var$origin.x, $04697537ec8dce5b$var$origin.y);
    }
    static clone(source) {
        return $04697537ec8dce5b$export$9b781de7bf37bf48.create(source.x, source.y);
    }
    static create(x, y) {
        return new $04697537ec8dce5b$export$9b781de7bf37bf48(x, y);
    }
}




let $1ff4dfb77b7bb646$var$_random = Math.random;
const $1ff4dfb77b7bb646$var$easings = new Map(), $1ff4dfb77b7bb646$var$double = 2, $1ff4dfb77b7bb646$var$doublePI = Math.PI * $1ff4dfb77b7bb646$var$double;
function $1ff4dfb77b7bb646$export$e2251c95822ce867(name, easing) {
    if ($1ff4dfb77b7bb646$var$easings.get(name)) return;
    $1ff4dfb77b7bb646$var$easings.set(name, easing);
}
function $1ff4dfb77b7bb646$export$2bbf531f74195405(name) {
    return $1ff4dfb77b7bb646$var$easings.get(name) ?? ((value)=>value);
}
function $1ff4dfb77b7bb646$export$3ba5cb2c014ef7d5(rnd = Math.random) {
    $1ff4dfb77b7bb646$var$_random = rnd;
}
function $1ff4dfb77b7bb646$export$1a76347094524b3b() {
    const min = 0, max = 1;
    return $1ff4dfb77b7bb646$export$7d15b64cf5a3a4c4($1ff4dfb77b7bb646$var$_random(), min, max - Number.EPSILON);
}
function $1ff4dfb77b7bb646$export$7d15b64cf5a3a4c4(num, min, max) {
    return Math.min(Math.max(num, min), max);
}
function $1ff4dfb77b7bb646$export$2c9e8a9632a706b2(comp1, comp2, weight1, weight2) {
    return Math.floor((comp1 * weight1 + comp2 * weight2) / (weight1 + weight2));
}
function $1ff4dfb77b7bb646$export$8b958c8ecd94a804(r) {
    const max = $1ff4dfb77b7bb646$export$27d2c76f835d583d(r), minOffset = 0;
    let min = $1ff4dfb77b7bb646$export$71c94d28c0fa4bfe(r);
    if (max === min) min = minOffset;
    return $1ff4dfb77b7bb646$export$1a76347094524b3b() * (max - min) + min;
}
function $1ff4dfb77b7bb646$export$e70c64b68236cb4e(value) {
    return (0, $ad25b6e319f6df8c$export$7e4aa119212bc614)(value) ? value : $1ff4dfb77b7bb646$export$8b958c8ecd94a804(value);
}
function $1ff4dfb77b7bb646$export$71c94d28c0fa4bfe(value) {
    return (0, $ad25b6e319f6df8c$export$7e4aa119212bc614)(value) ? value : value.min;
}
function $1ff4dfb77b7bb646$export$27d2c76f835d583d(value) {
    return (0, $ad25b6e319f6df8c$export$7e4aa119212bc614)(value) ? value : value.max;
}
function $1ff4dfb77b7bb646$export$6dcd5a07b989db7(source, value) {
    if (source === value || value === undefined && (0, $ad25b6e319f6df8c$export$7e4aa119212bc614)(source)) return source;
    const min = $1ff4dfb77b7bb646$export$71c94d28c0fa4bfe(source), max = $1ff4dfb77b7bb646$export$27d2c76f835d583d(source);
    return value !== undefined ? {
        min: Math.min(min, value),
        max: Math.max(max, value)
    } : $1ff4dfb77b7bb646$export$6dcd5a07b989db7(min, max);
}
function $1ff4dfb77b7bb646$export$c76b58cfe053f228(pointA, pointB) {
    const dx = pointA.x - pointB.x, dy = pointA.y - pointB.y, squareExp = 2;
    return {
        dx: dx,
        dy: dy,
        distance: Math.sqrt(dx ** squareExp + dy ** squareExp)
    };
}
function $1ff4dfb77b7bb646$export$79376507b09a66f(pointA, pointB) {
    return $1ff4dfb77b7bb646$export$c76b58cfe053f228(pointA, pointB).distance;
}
function $1ff4dfb77b7bb646$export$e6bfdeff8bfc94f9(degrees) {
    const PIDeg = 180;
    return degrees * Math.PI / PIDeg;
}
function $1ff4dfb77b7bb646$export$2045f76df51d18c4(direction, position, center) {
    if ((0, $ad25b6e319f6df8c$export$7e4aa119212bc614)(direction)) return $1ff4dfb77b7bb646$export$e6bfdeff8bfc94f9(direction);
    const empty = 0, half = 0.5, quarter = 0.25, threeQuarter = half + quarter;
    switch(direction){
        case (0, $aeeeb4a954ef988f$export$cc1a246adca07dd4).top:
            return -Math.PI * half;
        case (0, $aeeeb4a954ef988f$export$cc1a246adca07dd4).topRight:
            return -Math.PI * quarter;
        case (0, $aeeeb4a954ef988f$export$cc1a246adca07dd4).right:
            return empty;
        case (0, $aeeeb4a954ef988f$export$cc1a246adca07dd4).bottomRight:
            return Math.PI * quarter;
        case (0, $aeeeb4a954ef988f$export$cc1a246adca07dd4).bottom:
            return Math.PI * half;
        case (0, $aeeeb4a954ef988f$export$cc1a246adca07dd4).bottomLeft:
            return Math.PI * threeQuarter;
        case (0, $aeeeb4a954ef988f$export$cc1a246adca07dd4).left:
            return Math.PI;
        case (0, $aeeeb4a954ef988f$export$cc1a246adca07dd4).topLeft:
            return -Math.PI * threeQuarter;
        case (0, $aeeeb4a954ef988f$export$cc1a246adca07dd4).inside:
            return Math.atan2(center.y - position.y, center.x - position.x);
        case (0, $aeeeb4a954ef988f$export$cc1a246adca07dd4).outside:
            return Math.atan2(position.y - center.y, position.x - center.x);
        default:
            return $1ff4dfb77b7bb646$export$1a76347094524b3b() * $1ff4dfb77b7bb646$var$doublePI;
    }
}
function $1ff4dfb77b7bb646$export$cce6f12debc4024a(direction) {
    const baseVelocity = (0, $04697537ec8dce5b$export$9b781de7bf37bf48).origin;
    baseVelocity.length = 1;
    baseVelocity.angle = direction;
    return baseVelocity;
}
function $1ff4dfb77b7bb646$export$ee2fb97c67882d88(v1, v2, m1, m2) {
    const double = 2;
    return (0, $04697537ec8dce5b$export$9b781de7bf37bf48).create(v1.x * (m1 - m2) / (m1 + m2) + v2.x * double * m2 / (m1 + m2), v1.y);
}
function $1ff4dfb77b7bb646$export$3cb8a699840fed18(data) {
    return data.position?.x !== undefined && data.position.y !== undefined ? {
        x: data.position.x * data.size.width / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd),
        y: data.position.y * data.size.height / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd)
    } : undefined;
}
function $1ff4dfb77b7bb646$export$b19bedb83d642783(data) {
    return {
        x: (data.position?.x ?? $1ff4dfb77b7bb646$export$1a76347094524b3b() * (0, $dec17af1c054e95f$export$9519bca7a9fbeccd)) * data.size.width / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd),
        y: (data.position?.y ?? $1ff4dfb77b7bb646$export$1a76347094524b3b() * (0, $dec17af1c054e95f$export$9519bca7a9fbeccd)) * data.size.height / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd)
    };
}
function $1ff4dfb77b7bb646$export$b6e437e0d75e3d2c(data) {
    const position = {
        x: data.position?.x !== undefined ? $1ff4dfb77b7bb646$export$e70c64b68236cb4e(data.position.x) : undefined,
        y: data.position?.y !== undefined ? $1ff4dfb77b7bb646$export$e70c64b68236cb4e(data.position.y) : undefined
    };
    return $1ff4dfb77b7bb646$export$b19bedb83d642783({
        size: data.size,
        position: position
    });
}
function $1ff4dfb77b7bb646$export$a3c87c98a736c457(data) {
    return {
        x: data.position?.x ?? $1ff4dfb77b7bb646$export$1a76347094524b3b() * data.size.width,
        y: data.position?.y ?? $1ff4dfb77b7bb646$export$1a76347094524b3b() * data.size.height
    };
}
function $1ff4dfb77b7bb646$export$30970e96ab2e23ee(data) {
    const position = {
        x: data.position?.x !== undefined ? $1ff4dfb77b7bb646$export$e70c64b68236cb4e(data.position.x) : undefined,
        y: data.position?.y !== undefined ? $1ff4dfb77b7bb646$export$e70c64b68236cb4e(data.position.y) : undefined
    };
    return $1ff4dfb77b7bb646$export$a3c87c98a736c457({
        size: data.size,
        position: position
    });
}
function $1ff4dfb77b7bb646$export$988633967de92230(input) {
    const defaultAlpha = 1;
    if (!input) return defaultAlpha;
    return input.endsWith("%") ? parseFloat(input) / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd) : parseFloat(input);
}




var $f2542365babf2329$export$6bf57c7f0219f07d;
(function(AnimationMode) {
    AnimationMode["auto"] = "auto";
    AnimationMode["increase"] = "increase";
    AnimationMode["decrease"] = "decrease";
    AnimationMode["random"] = "random";
})($f2542365babf2329$export$6bf57c7f0219f07d || ($f2542365babf2329$export$6bf57c7f0219f07d = {}));


var $c443c1fece529b66$export$a2d3d93c57d16a1a;
(function(AnimationStatus) {
    AnimationStatus["increasing"] = "increasing";
    AnimationStatus["decreasing"] = "decreasing";
})($c443c1fece529b66$export$a2d3d93c57d16a1a || ($c443c1fece529b66$export$a2d3d93c57d16a1a = {}));


var $a06b3f24e43fa14b$export$41a461248611663e;
(function(DestroyType) {
    DestroyType["none"] = "none";
    DestroyType["max"] = "max";
    DestroyType["min"] = "min";
})($a06b3f24e43fa14b$export$41a461248611663e || ($a06b3f24e43fa14b$export$41a461248611663e = {}));


var $0130b9f9f1247165$export$56c1e4693edf08f9;
(function(OutModeDirection) {
    OutModeDirection["bottom"] = "bottom";
    OutModeDirection["left"] = "left";
    OutModeDirection["right"] = "right";
    OutModeDirection["top"] = "top";
})($0130b9f9f1247165$export$56c1e4693edf08f9 || ($0130b9f9f1247165$export$56c1e4693edf08f9 = {}));


var $990956d8c795e3d5$export$1009f0178778a981;
(function(PixelMode) {
    PixelMode["precise"] = "precise";
    PixelMode["percent"] = "percent";
})($990956d8c795e3d5$export$1009f0178778a981 || ($990956d8c795e3d5$export$1009f0178778a981 = {}));


var $2cd6de34519be269$export$5385b9a82993d2c8;
(function(StartValueType) {
    StartValueType["max"] = "max";
    StartValueType["min"] = "min";
    StartValueType["random"] = "random";
})($2cd6de34519be269$export$5385b9a82993d2c8 || ($2cd6de34519be269$export$5385b9a82993d2c8 = {}));



const $eee2fa4b9ebe63e9$var$_logger = {
    debug: console.debug,
    error: console.error,
    info: console.info,
    log: console.log,
    verbose: console.log,
    warning: console.warn
};
function $eee2fa4b9ebe63e9$export$3abbd92f765bee58(logger) {
    $eee2fa4b9ebe63e9$var$_logger.debug = logger.debug || $eee2fa4b9ebe63e9$var$_logger.debug;
    $eee2fa4b9ebe63e9$var$_logger.error = logger.error || $eee2fa4b9ebe63e9$var$_logger.error;
    $eee2fa4b9ebe63e9$var$_logger.info = logger.info || $eee2fa4b9ebe63e9$var$_logger.info;
    $eee2fa4b9ebe63e9$var$_logger.log = logger.log || $eee2fa4b9ebe63e9$var$_logger.log;
    $eee2fa4b9ebe63e9$var$_logger.verbose = logger.verbose || $eee2fa4b9ebe63e9$var$_logger.verbose;
    $eee2fa4b9ebe63e9$var$_logger.warning = logger.warning || $eee2fa4b9ebe63e9$var$_logger.warning;
}
function $eee2fa4b9ebe63e9$export$2b1d391cd05230fd() {
    return $eee2fa4b9ebe63e9$var$_logger;
}
function $eee2fa4b9ebe63e9$var$rectSideBounce(data) {
    const res = {
        bounced: false
    }, { pSide: pSide, pOtherSide: pOtherSide, rectSide: rectSide, rectOtherSide: rectOtherSide, velocity: velocity, factor: factor } = data, half = 0.5, minVelocity = 0;
    if (pOtherSide.min < rectOtherSide.min || pOtherSide.min > rectOtherSide.max || pOtherSide.max < rectOtherSide.min || pOtherSide.max > rectOtherSide.max) return res;
    if (pSide.max >= rectSide.min && pSide.max <= (rectSide.max + rectSide.min) * half && velocity > minVelocity || pSide.min <= rectSide.max && pSide.min > (rectSide.max + rectSide.min) * half && velocity < minVelocity) {
        res.velocity = velocity * -factor;
        res.bounced = true;
    }
    return res;
}
function $eee2fa4b9ebe63e9$var$checkSelector(element, selectors) {
    const res = $eee2fa4b9ebe63e9$export$8e5dc47097396754(selectors, (selector)=>{
        return element.matches(selector);
    });
    return (0, $ad25b6e319f6df8c$export$43bee75e5e14138e)(res) ? res.some((t)=>t) : res;
}
function $eee2fa4b9ebe63e9$export$460b6777813d3d86() {
    return typeof window === "undefined" || !window || typeof window.document === "undefined" || !window.document;
}
function $eee2fa4b9ebe63e9$export$c242851ed0beda6c() {
    return !$eee2fa4b9ebe63e9$export$460b6777813d3d86() && typeof matchMedia !== "undefined";
}
function $eee2fa4b9ebe63e9$export$db32b9574e21e00f(query) {
    if (!$eee2fa4b9ebe63e9$export$c242851ed0beda6c()) return;
    return matchMedia(query);
}
function $eee2fa4b9ebe63e9$export$d97d2a93dce76cc2(callback) {
    if ($eee2fa4b9ebe63e9$export$460b6777813d3d86() || typeof IntersectionObserver === "undefined") return;
    return new IntersectionObserver(callback);
}
function $eee2fa4b9ebe63e9$export$c2f9084a48da0641(callback) {
    if ($eee2fa4b9ebe63e9$export$460b6777813d3d86() || typeof MutationObserver === "undefined") return;
    return new MutationObserver(callback);
}
function $eee2fa4b9ebe63e9$export$5e9bb4359042e24b(value, array) {
    const invalidIndex = -1;
    return value === array || (0, $ad25b6e319f6df8c$export$43bee75e5e14138e)(array) && array.indexOf(value) > invalidIndex;
}
async function $eee2fa4b9ebe63e9$export$672089c3debc1182(font, weight) {
    try {
        await document.fonts.load(`${weight ?? "400"} 36px '${font ?? "Verdana"}'`);
    } catch  {}
}
function $eee2fa4b9ebe63e9$export$aab6d48e027939d7(array) {
    return Math.floor((0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * array.length);
}
function $eee2fa4b9ebe63e9$export$3a5d12ca7137122f(array, index, useIndex = true) {
    return array[index !== undefined && useIndex ? index % array.length : $eee2fa4b9ebe63e9$export$aab6d48e027939d7(array)];
}
function $eee2fa4b9ebe63e9$export$2ea42ef493c7076c(point, size, offset, radius, direction) {
    const minRadius = 0;
    return $eee2fa4b9ebe63e9$export$bb47d4799bdb9a4d($eee2fa4b9ebe63e9$export$b0a2169b5f9d18d8(point, radius ?? minRadius), size, offset, direction);
}
function $eee2fa4b9ebe63e9$export$bb47d4799bdb9a4d(bounds, size, offset, direction) {
    let inside = true;
    if (!direction || direction === (0, $0130b9f9f1247165$export$56c1e4693edf08f9).bottom) inside = bounds.top < size.height + offset.x;
    if (inside && (!direction || direction === (0, $0130b9f9f1247165$export$56c1e4693edf08f9).left)) inside = bounds.right > offset.x;
    if (inside && (!direction || direction === (0, $0130b9f9f1247165$export$56c1e4693edf08f9).right)) inside = bounds.left < size.width + offset.y;
    if (inside && (!direction || direction === (0, $0130b9f9f1247165$export$56c1e4693edf08f9).top)) inside = bounds.bottom > offset.y;
    return inside;
}
function $eee2fa4b9ebe63e9$export$b0a2169b5f9d18d8(point, radius) {
    return {
        bottom: point.y + radius,
        left: point.x - radius,
        right: point.x + radius,
        top: point.y - radius
    };
}
function $eee2fa4b9ebe63e9$export$54e9fb29908872fa(destination, ...sources) {
    for (const source of sources){
        if (source === undefined || source === null) continue;
        if (!(0, $ad25b6e319f6df8c$export$a6cdc56e425d0d0a)(source)) {
            destination = source;
            continue;
        }
        const sourceIsArray = Array.isArray(source);
        if (sourceIsArray && ((0, $ad25b6e319f6df8c$export$a6cdc56e425d0d0a)(destination) || !destination || !Array.isArray(destination))) destination = [];
        else if (!sourceIsArray && ((0, $ad25b6e319f6df8c$export$a6cdc56e425d0d0a)(destination) || !destination || Array.isArray(destination))) destination = {};
        for(const key in source){
            if (key === "__proto__") continue;
            const sourceDict = source, value = sourceDict[key], destDict = destination;
            destDict[key] = (0, $ad25b6e319f6df8c$export$a6cdc56e425d0d0a)(value) && Array.isArray(value) ? value.map((v)=>$eee2fa4b9ebe63e9$export$54e9fb29908872fa(destDict[key], v)) : $eee2fa4b9ebe63e9$export$54e9fb29908872fa(destDict[key], value);
        }
    }
    return destination;
}
function $eee2fa4b9ebe63e9$export$5d1f020956707f4(mode, divs) {
    return !!$eee2fa4b9ebe63e9$export$bfd133b0f67a5a3a(divs, (t)=>t.enable && $eee2fa4b9ebe63e9$export$5e9bb4359042e24b(mode, t.mode));
}
function $eee2fa4b9ebe63e9$export$194f9554360903fd(mode, divs, callback) {
    $eee2fa4b9ebe63e9$export$8e5dc47097396754(divs, (div)=>{
        const divMode = div.mode, divEnabled = div.enable;
        if (divEnabled && $eee2fa4b9ebe63e9$export$5e9bb4359042e24b(mode, divMode)) $eee2fa4b9ebe63e9$export$921eaa53ee8b79db(div, callback);
    });
}
function $eee2fa4b9ebe63e9$export$921eaa53ee8b79db(div, callback) {
    const selectors = div.selectors;
    $eee2fa4b9ebe63e9$export$8e5dc47097396754(selectors, (selector)=>{
        callback(selector, div);
    });
}
function $eee2fa4b9ebe63e9$export$f7c2b83aad443adb(divs, element) {
    if (!element || !divs) return;
    return $eee2fa4b9ebe63e9$export$bfd133b0f67a5a3a(divs, (div)=>{
        return $eee2fa4b9ebe63e9$var$checkSelector(element, div.selectors);
    });
}
function $eee2fa4b9ebe63e9$export$11ae16f2acc5c3ba(p) {
    return {
        position: p.getPosition(),
        radius: p.getRadius(),
        mass: p.getMass(),
        velocity: p.velocity,
        factor: (0, $04697537ec8dce5b$export$9b781de7bf37bf48).create((0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(p.options.bounce.horizontal.value), (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(p.options.bounce.vertical.value))
    };
}
function $eee2fa4b9ebe63e9$export$c6e9f28fb57ea828(p1, p2) {
    const { x: xVelocityDiff, y: yVelocityDiff } = p1.velocity.sub(p2.velocity), [pos1, pos2] = [
        p1.position,
        p2.position
    ], { dx: xDist, dy: yDist } = (0, $1ff4dfb77b7bb646$export$c76b58cfe053f228)(pos2, pos1), minimumDistance = 0;
    if (xVelocityDiff * xDist + yVelocityDiff * yDist < minimumDistance) return;
    const angle = -Math.atan2(yDist, xDist), m1 = p1.mass, m2 = p2.mass, u1 = p1.velocity.rotate(angle), u2 = p2.velocity.rotate(angle), v1 = (0, $1ff4dfb77b7bb646$export$ee2fb97c67882d88)(u1, u2, m1, m2), v2 = (0, $1ff4dfb77b7bb646$export$ee2fb97c67882d88)(u2, u1, m1, m2), vFinal1 = v1.rotate(-angle), vFinal2 = v2.rotate(-angle);
    p1.velocity.x = vFinal1.x * p1.factor.x;
    p1.velocity.y = vFinal1.y * p1.factor.y;
    p2.velocity.x = vFinal2.x * p2.factor.x;
    p2.velocity.y = vFinal2.y * p2.factor.y;
}
function $eee2fa4b9ebe63e9$export$e83851ba31840182(particle, divBounds) {
    const pPos = particle.getPosition(), size = particle.getRadius(), bounds = $eee2fa4b9ebe63e9$export$b0a2169b5f9d18d8(pPos, size), bounceOptions = particle.options.bounce, resH = $eee2fa4b9ebe63e9$var$rectSideBounce({
        pSide: {
            min: bounds.left,
            max: bounds.right
        },
        pOtherSide: {
            min: bounds.top,
            max: bounds.bottom
        },
        rectSide: {
            min: divBounds.left,
            max: divBounds.right
        },
        rectOtherSide: {
            min: divBounds.top,
            max: divBounds.bottom
        },
        velocity: particle.velocity.x,
        factor: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(bounceOptions.horizontal.value)
    });
    if (resH.bounced) {
        if (resH.velocity !== undefined) particle.velocity.x = resH.velocity;
        if (resH.position !== undefined) particle.position.x = resH.position;
    }
    const resV = $eee2fa4b9ebe63e9$var$rectSideBounce({
        pSide: {
            min: bounds.top,
            max: bounds.bottom
        },
        pOtherSide: {
            min: bounds.left,
            max: bounds.right
        },
        rectSide: {
            min: divBounds.top,
            max: divBounds.bottom
        },
        rectOtherSide: {
            min: divBounds.left,
            max: divBounds.right
        },
        velocity: particle.velocity.y,
        factor: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(bounceOptions.vertical.value)
    });
    if (resV.bounced) {
        if (resV.velocity !== undefined) particle.velocity.y = resV.velocity;
        if (resV.position !== undefined) particle.position.y = resV.position;
    }
}
function $eee2fa4b9ebe63e9$export$8e5dc47097396754(obj, callback) {
    const defaultIndex = 0;
    return (0, $ad25b6e319f6df8c$export$43bee75e5e14138e)(obj) ? obj.map((item, index)=>callback(item, index)) : callback(obj, defaultIndex);
}
function $eee2fa4b9ebe63e9$export$3fbf39566d3ee62e(obj, index, useIndex) {
    return (0, $ad25b6e319f6df8c$export$43bee75e5e14138e)(obj) ? $eee2fa4b9ebe63e9$export$3a5d12ca7137122f(obj, index, useIndex) : obj;
}
function $eee2fa4b9ebe63e9$export$bfd133b0f67a5a3a(obj, callback) {
    if ((0, $ad25b6e319f6df8c$export$43bee75e5e14138e)(obj)) return obj.find((t, index)=>callback(t, index));
    const defaultIndex = 0;
    return callback(obj, defaultIndex) ? obj : undefined;
}
function $eee2fa4b9ebe63e9$export$bebd78259cce4fd(options, pxRatio) {
    const valueRange = options.value, animationOptions = options.animation, res = {
        delayTime: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(animationOptions.delay) * (0, $dec17af1c054e95f$export$f64c3bfbc58eec0f),
        enable: animationOptions.enable,
        value: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(options.value) * pxRatio,
        max: (0, $1ff4dfb77b7bb646$export$27d2c76f835d583d)(valueRange) * pxRatio,
        min: (0, $1ff4dfb77b7bb646$export$71c94d28c0fa4bfe)(valueRange) * pxRatio,
        loops: 0,
        maxLoops: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(animationOptions.count),
        time: 0
    }, decayOffset = 1;
    if (animationOptions.enable) {
        res.decay = decayOffset - (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(animationOptions.decay);
        switch(animationOptions.mode){
            case (0, $f2542365babf2329$export$6bf57c7f0219f07d).increase:
                res.status = (0, $c443c1fece529b66$export$a2d3d93c57d16a1a).increasing;
                break;
            case (0, $f2542365babf2329$export$6bf57c7f0219f07d).decrease:
                res.status = (0, $c443c1fece529b66$export$a2d3d93c57d16a1a).decreasing;
                break;
            case (0, $f2542365babf2329$export$6bf57c7f0219f07d).random:
                res.status = (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() >= (0, $dec17af1c054e95f$export$fa0534be1c9f2e23) ? (0, $c443c1fece529b66$export$a2d3d93c57d16a1a).increasing : (0, $c443c1fece529b66$export$a2d3d93c57d16a1a).decreasing;
                break;
        }
        const autoStatus = animationOptions.mode === (0, $f2542365babf2329$export$6bf57c7f0219f07d).auto;
        switch(animationOptions.startValue){
            case (0, $2cd6de34519be269$export$5385b9a82993d2c8).min:
                res.value = res.min;
                if (autoStatus) res.status = (0, $c443c1fece529b66$export$a2d3d93c57d16a1a).increasing;
                break;
            case (0, $2cd6de34519be269$export$5385b9a82993d2c8).max:
                res.value = res.max;
                if (autoStatus) res.status = (0, $c443c1fece529b66$export$a2d3d93c57d16a1a).decreasing;
                break;
            case (0, $2cd6de34519be269$export$5385b9a82993d2c8).random:
            default:
                res.value = (0, $1ff4dfb77b7bb646$export$8b958c8ecd94a804)(res);
                if (autoStatus) res.status = (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() >= (0, $dec17af1c054e95f$export$fa0534be1c9f2e23) ? (0, $c443c1fece529b66$export$a2d3d93c57d16a1a).increasing : (0, $c443c1fece529b66$export$a2d3d93c57d16a1a).decreasing;
                break;
        }
    }
    res.initialValue = res.value;
    return res;
}
function $eee2fa4b9ebe63e9$var$getPositionOrSize(positionOrSize, canvasSize) {
    const isPercent = positionOrSize.mode === (0, $990956d8c795e3d5$export$1009f0178778a981).percent;
    if (!isPercent) {
        const { mode: _, ...rest } = positionOrSize;
        return rest;
    }
    const isPosition = "x" in positionOrSize;
    if (isPosition) return {
        x: positionOrSize.x / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd) * canvasSize.width,
        y: positionOrSize.y / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd) * canvasSize.height
    };
    else return {
        width: positionOrSize.width / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd) * canvasSize.width,
        height: positionOrSize.height / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd) * canvasSize.height
    };
}
function $eee2fa4b9ebe63e9$export$1690e12b840569b9(position, canvasSize) {
    return $eee2fa4b9ebe63e9$var$getPositionOrSize(position, canvasSize);
}
function $eee2fa4b9ebe63e9$export$31b21d0167753bb4(size, canvasSize) {
    return $eee2fa4b9ebe63e9$var$getPositionOrSize(size, canvasSize);
}
function $eee2fa4b9ebe63e9$var$checkDestroy(particle, destroyType, value, minValue, maxValue) {
    switch(destroyType){
        case (0, $a06b3f24e43fa14b$export$41a461248611663e).max:
            if (value >= maxValue) particle.destroy();
            break;
        case (0, $a06b3f24e43fa14b$export$41a461248611663e).min:
            if (value <= minValue) particle.destroy();
            break;
    }
}
function $eee2fa4b9ebe63e9$export$efead17ed5dcfd2(particle, data, changeDirection, destroyType, delta) {
    const minLoops = 0, minDelay = 0, identity = 1, minVelocity = 0, minDecay = 1;
    if (particle.destroyed || !data || !data.enable || (data.maxLoops ?? minLoops) > minLoops && (data.loops ?? minLoops) > (data.maxLoops ?? minLoops)) return;
    const velocity = (data.velocity ?? minVelocity) * delta.factor, minValue = data.min, maxValue = data.max, decay = data.decay ?? minDecay;
    if (!data.time) data.time = 0;
    if ((data.delayTime ?? minDelay) > minDelay && data.time < (data.delayTime ?? minDelay)) data.time += delta.value;
    if ((data.delayTime ?? minDelay) > minDelay && data.time < (data.delayTime ?? minDelay)) return;
    switch(data.status){
        case (0, $c443c1fece529b66$export$a2d3d93c57d16a1a).increasing:
            if (data.value >= maxValue) {
                if (changeDirection) data.status = (0, $c443c1fece529b66$export$a2d3d93c57d16a1a).decreasing;
                else data.value -= maxValue;
                if (!data.loops) data.loops = minLoops;
                data.loops++;
            } else data.value += velocity;
            break;
        case (0, $c443c1fece529b66$export$a2d3d93c57d16a1a).decreasing:
            if (data.value <= minValue) {
                if (changeDirection) data.status = (0, $c443c1fece529b66$export$a2d3d93c57d16a1a).increasing;
                else data.value += maxValue;
                if (!data.loops) data.loops = minLoops;
                data.loops++;
            } else data.value -= velocity;
    }
    if (data.velocity && decay !== identity) data.velocity *= decay;
    $eee2fa4b9ebe63e9$var$checkDestroy(particle, destroyType, data.value, minValue, maxValue);
    if (!particle.destroyed) data.value = (0, $1ff4dfb77b7bb646$export$7d15b64cf5a3a4c4)(data.value, minValue, maxValue);
}




var $c9d3d993d79e9eed$export$d3c0448523aecc2e;
(function(AlterType) {
    AlterType["darken"] = "darken";
    AlterType["enlighten"] = "enlighten";
})($c9d3d993d79e9eed$export$d3c0448523aecc2e || ($c9d3d993d79e9eed$export$d3c0448523aecc2e = {}));







var $fd6faa9f4e5410ac$var$RgbIndexes;
(function(RgbIndexes) {
    RgbIndexes[RgbIndexes["r"] = 1] = "r";
    RgbIndexes[RgbIndexes["g"] = 2] = "g";
    RgbIndexes[RgbIndexes["b"] = 3] = "b";
    RgbIndexes[RgbIndexes["a"] = 4] = "a";
})($fd6faa9f4e5410ac$var$RgbIndexes || ($fd6faa9f4e5410ac$var$RgbIndexes = {}));
const $fd6faa9f4e5410ac$var$randomColorValue = "random", $fd6faa9f4e5410ac$var$midColorValue = "mid", $fd6faa9f4e5410ac$var$colorManagers = new Map();
function $fd6faa9f4e5410ac$export$fac4919b23cbaf23(manager) {
    $fd6faa9f4e5410ac$var$colorManagers.set(manager.key, manager);
}
function $fd6faa9f4e5410ac$var$stringToRgba(input) {
    for (const [, manager] of $fd6faa9f4e5410ac$var$colorManagers){
        if (input.startsWith(manager.stringPrefix)) return manager.parseString(input);
    }
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])([a-f\d])?$/i, hexFixed = input.replace(shorthandRegex, (_, r, g, b, a)=>{
        return r + r + g + g + b + b + (a !== undefined ? a + a : "");
    }), regex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i, result = regex.exec(hexFixed), radix = 16, defaultAlpha = 1, alphaFactor = 0xff;
    return result ? {
        a: result[$fd6faa9f4e5410ac$var$RgbIndexes.a] !== undefined ? parseInt(result[$fd6faa9f4e5410ac$var$RgbIndexes.a], radix) / alphaFactor : defaultAlpha,
        b: parseInt(result[$fd6faa9f4e5410ac$var$RgbIndexes.b], radix),
        g: parseInt(result[$fd6faa9f4e5410ac$var$RgbIndexes.g], radix),
        r: parseInt(result[$fd6faa9f4e5410ac$var$RgbIndexes.r], radix)
    } : undefined;
}
function $fd6faa9f4e5410ac$export$fbf0bf3cc1fc0cc4(input, index, useIndex = true) {
    if (!input) return;
    const color = (0, $ad25b6e319f6df8c$export$844ec244b1367d54)(input) ? {
        value: input
    } : input;
    if ((0, $ad25b6e319f6df8c$export$844ec244b1367d54)(color.value)) return $fd6faa9f4e5410ac$export$170d64abcc52d97a(color.value, index, useIndex);
    if ((0, $ad25b6e319f6df8c$export$43bee75e5e14138e)(color.value)) return $fd6faa9f4e5410ac$export$fbf0bf3cc1fc0cc4({
        value: (0, $eee2fa4b9ebe63e9$export$3a5d12ca7137122f)(color.value, index, useIndex)
    });
    for (const [, manager] of $fd6faa9f4e5410ac$var$colorManagers){
        const res = manager.handleRangeColor(color);
        if (res) return res;
    }
}
function $fd6faa9f4e5410ac$export$170d64abcc52d97a(input, index, useIndex = true) {
    if (!input) return;
    const color = (0, $ad25b6e319f6df8c$export$844ec244b1367d54)(input) ? {
        value: input
    } : input;
    if ((0, $ad25b6e319f6df8c$export$844ec244b1367d54)(color.value)) return color.value === $fd6faa9f4e5410ac$var$randomColorValue ? $fd6faa9f4e5410ac$export$ac4fc8e9144a1018() : $fd6faa9f4e5410ac$export$d2c5ec93815c4391(color.value);
    if ((0, $ad25b6e319f6df8c$export$43bee75e5e14138e)(color.value)) return $fd6faa9f4e5410ac$export$170d64abcc52d97a({
        value: (0, $eee2fa4b9ebe63e9$export$3a5d12ca7137122f)(color.value, index, useIndex)
    });
    for (const [, manager] of $fd6faa9f4e5410ac$var$colorManagers){
        const res = manager.handleColor(color);
        if (res) return res;
    }
}
function $fd6faa9f4e5410ac$export$5e49d166a305dfce(color, index, useIndex = true) {
    const rgb = $fd6faa9f4e5410ac$export$170d64abcc52d97a(color, index, useIndex);
    return rgb ? $fd6faa9f4e5410ac$export$c85ca4f4753af384(rgb) : undefined;
}
function $fd6faa9f4e5410ac$export$79a89086521c0f12(color, index, useIndex = true) {
    const rgb = $fd6faa9f4e5410ac$export$fbf0bf3cc1fc0cc4(color, index, useIndex);
    return rgb ? $fd6faa9f4e5410ac$export$c85ca4f4753af384(rgb) : undefined;
}
function $fd6faa9f4e5410ac$export$c85ca4f4753af384(color) {
    const rgbMax = 255, hMax = 360, sMax = 100, lMax = 100, hMin = 0, sMin = 0, hPhase = 60, half = 0.5, double = 2, r1 = color.r / rgbMax, g1 = color.g / rgbMax, b1 = color.b / rgbMax, max = Math.max(r1, g1, b1), min = Math.min(r1, g1, b1), res = {
        h: hMin,
        l: (max + min) * half,
        s: sMin
    };
    if (max !== min) {
        res.s = res.l < half ? (max - min) / (max + min) : (max - min) / (double - max - min);
        res.h = r1 === max ? (g1 - b1) / (max - min) : res.h = g1 === max ? double + (b1 - r1) / (max - min) : double * double + (r1 - g1) / (max - min);
    }
    res.l *= lMax;
    res.s *= sMax;
    res.h *= hPhase;
    if (res.h < hMin) res.h += hMax;
    if (res.h >= hMax) res.h -= hMax;
    return res;
}
function $fd6faa9f4e5410ac$export$143dda7722fd213d(input) {
    return $fd6faa9f4e5410ac$var$stringToRgba(input)?.a;
}
function $fd6faa9f4e5410ac$export$d2c5ec93815c4391(input) {
    return $fd6faa9f4e5410ac$var$stringToRgba(input);
}
function $fd6faa9f4e5410ac$export$29fb7152bd3f781a(hsl) {
    const hMax = 360, sMax = 100, lMax = 100, sMin = 0, lMin = 0, h = (hsl.h % hMax + hMax) % hMax, s = Math.max(sMin, Math.min(sMax, hsl.s)), l = Math.max(lMin, Math.min(lMax, hsl.l)), hNormalized = h / hMax, sNormalized = s / sMax, lNormalized = l / lMax, rgbFactor = 255, triple = 3;
    if (s === sMin) {
        const grayscaleValue = Math.round(lNormalized * rgbFactor);
        return {
            r: grayscaleValue,
            g: grayscaleValue,
            b: grayscaleValue
        };
    }
    const half = 0.5, double = 2, channel = (temp1, temp2, temp3)=>{
        const temp3Min = 0, temp3Max = 1, sextuple = 6;
        if (temp3 < temp3Min) temp3++;
        if (temp3 > temp3Max) temp3--;
        if (temp3 * sextuple < temp3Max) return temp1 + (temp2 - temp1) * sextuple * temp3;
        if (temp3 * double < temp3Max) return temp2;
        if (temp3 * triple < temp3Max * double) {
            const temp3Offset = double / triple;
            return temp1 + (temp2 - temp1) * (temp3Offset - temp3) * sextuple;
        }
        return temp1;
    }, sNormalizedOffset = 1, temp1 = lNormalized < half ? lNormalized * (sNormalizedOffset + sNormalized) : lNormalized + sNormalized - lNormalized * sNormalized, temp2 = double * lNormalized - temp1, phaseNumerator = 1, phaseThird = phaseNumerator / triple, red = Math.min(rgbFactor, rgbFactor * channel(temp2, temp1, hNormalized + phaseThird)), green = Math.min(rgbFactor, rgbFactor * channel(temp2, temp1, hNormalized)), blue = Math.min(rgbFactor, rgbFactor * channel(temp2, temp1, hNormalized - phaseThird));
    return {
        r: Math.round(red),
        g: Math.round(green),
        b: Math.round(blue)
    };
}
function $fd6faa9f4e5410ac$export$6ae64dbcd6bfc33e(hsla) {
    const rgbResult = $fd6faa9f4e5410ac$export$29fb7152bd3f781a(hsla);
    return {
        a: hsla.a,
        b: rgbResult.b,
        g: rgbResult.g,
        r: rgbResult.r
    };
}
function $fd6faa9f4e5410ac$export$ac4fc8e9144a1018(min) {
    const defaultMin = 0, fixedMin = min ?? defaultMin, rgbMax = 256;
    return {
        b: Math.floor((0, $1ff4dfb77b7bb646$export$8b958c8ecd94a804)((0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(fixedMin, rgbMax))),
        g: Math.floor((0, $1ff4dfb77b7bb646$export$8b958c8ecd94a804)((0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(fixedMin, rgbMax))),
        r: Math.floor((0, $1ff4dfb77b7bb646$export$8b958c8ecd94a804)((0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(fixedMin, rgbMax)))
    };
}
function $fd6faa9f4e5410ac$export$2476af37e47fcae2(color, opacity) {
    const defaultOpacity = 1;
    return `rgba(${color.r}, ${color.g}, ${color.b}, ${opacity ?? defaultOpacity})`;
}
function $fd6faa9f4e5410ac$export$9d057e59c7b0a82d(color, opacity) {
    const defaultOpacity = 1;
    return `hsla(${color.h}, ${color.s}%, ${color.l}%, ${opacity ?? defaultOpacity})`;
}
function $fd6faa9f4e5410ac$export$9b476054b78b89cd(color1, color2, size1, size2) {
    let rgb1 = color1, rgb2 = color2;
    if (rgb1.r === undefined) rgb1 = $fd6faa9f4e5410ac$export$29fb7152bd3f781a(color1);
    if (rgb2.r === undefined) rgb2 = $fd6faa9f4e5410ac$export$29fb7152bd3f781a(color2);
    return {
        b: (0, $1ff4dfb77b7bb646$export$2c9e8a9632a706b2)(rgb1.b, rgb2.b, size1, size2),
        g: (0, $1ff4dfb77b7bb646$export$2c9e8a9632a706b2)(rgb1.g, rgb2.g, size1, size2),
        r: (0, $1ff4dfb77b7bb646$export$2c9e8a9632a706b2)(rgb1.r, rgb2.r, size1, size2)
    };
}
function $fd6faa9f4e5410ac$export$b676eb46c472d7df(p1, p2, linkColor) {
    if (linkColor === $fd6faa9f4e5410ac$var$randomColorValue) return $fd6faa9f4e5410ac$export$ac4fc8e9144a1018();
    else if (linkColor === $fd6faa9f4e5410ac$var$midColorValue) {
        const sourceColor = p1.getFillColor() ?? p1.getStrokeColor(), destColor = p2?.getFillColor() ?? p2?.getStrokeColor();
        if (sourceColor && destColor && p2) return $fd6faa9f4e5410ac$export$9b476054b78b89cd(sourceColor, destColor, p1.getRadius(), p2.getRadius());
        else {
            const hslColor = sourceColor ?? destColor;
            if (hslColor) return $fd6faa9f4e5410ac$export$29fb7152bd3f781a(hslColor);
        }
    } else return linkColor;
}
function $fd6faa9f4e5410ac$export$cf0e5a4ae26bdcdc(optColor, blink, consent) {
    const color = (0, $ad25b6e319f6df8c$export$844ec244b1367d54)(optColor) ? optColor : optColor.value;
    if (color === $fd6faa9f4e5410ac$var$randomColorValue) {
        if (consent) return $fd6faa9f4e5410ac$export$fbf0bf3cc1fc0cc4({
            value: color
        });
        if (blink) return $fd6faa9f4e5410ac$var$randomColorValue;
        return $fd6faa9f4e5410ac$var$midColorValue;
    } else if (color === $fd6faa9f4e5410ac$var$midColorValue) return $fd6faa9f4e5410ac$var$midColorValue;
    else return $fd6faa9f4e5410ac$export$fbf0bf3cc1fc0cc4({
        value: color
    });
}
function $fd6faa9f4e5410ac$export$c90768c73bc1d7ab(animation) {
    return animation !== undefined ? {
        h: animation.h.value,
        s: animation.s.value,
        l: animation.l.value
    } : undefined;
}
function $fd6faa9f4e5410ac$export$6e8a573710bea117(hsl, animationOptions, reduceFactor) {
    const resColor = {
        h: {
            enable: false,
            value: hsl.h
        },
        s: {
            enable: false,
            value: hsl.s
        },
        l: {
            enable: false,
            value: hsl.l
        }
    };
    if (animationOptions) {
        $fd6faa9f4e5410ac$var$setColorAnimation(resColor.h, animationOptions.h, reduceFactor);
        $fd6faa9f4e5410ac$var$setColorAnimation(resColor.s, animationOptions.s, reduceFactor);
        $fd6faa9f4e5410ac$var$setColorAnimation(resColor.l, animationOptions.l, reduceFactor);
    }
    return resColor;
}
function $fd6faa9f4e5410ac$var$setColorAnimation(colorValue, colorAnimation, reduceFactor) {
    colorValue.enable = colorAnimation.enable;
    const defaultVelocity = 0, decayOffset = 1, defaultLoops = 0, defaultTime = 0;
    if (colorValue.enable) {
        colorValue.velocity = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(colorAnimation.speed) / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd) * reduceFactor;
        colorValue.decay = decayOffset - (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(colorAnimation.decay);
        colorValue.status = (0, $c443c1fece529b66$export$a2d3d93c57d16a1a).increasing;
        colorValue.loops = defaultLoops;
        colorValue.maxLoops = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(colorAnimation.count);
        colorValue.time = defaultTime;
        colorValue.delayTime = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(colorAnimation.delay) * (0, $dec17af1c054e95f$export$f64c3bfbc58eec0f);
        if (!colorAnimation.sync) {
            colorValue.velocity *= (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)();
            colorValue.value *= (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)();
        }
        colorValue.initialValue = colorValue.value;
        colorValue.offset = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(colorAnimation.offset);
    } else colorValue.velocity = defaultVelocity;
}
function $fd6faa9f4e5410ac$export$a151177c20377190(data, range, decrease, delta) {
    const minLoops = 0, minDelay = 0, identity = 1, minVelocity = 0, minOffset = 0, velocityFactor = 3.6;
    if (!data || !data.enable || (data.maxLoops ?? minLoops) > minLoops && (data.loops ?? minLoops) > (data.maxLoops ?? minLoops)) return;
    if (!data.time) data.time = 0;
    if ((data.delayTime ?? minDelay) > minDelay && data.time < (data.delayTime ?? minDelay)) data.time += delta.value;
    if ((data.delayTime ?? minDelay) > minDelay && data.time < (data.delayTime ?? minDelay)) return;
    const offset = data.offset ? (0, $1ff4dfb77b7bb646$export$8b958c8ecd94a804)(data.offset) : minOffset, velocity = (data.velocity ?? minVelocity) * delta.factor + offset * velocityFactor, decay = data.decay ?? identity, max = (0, $1ff4dfb77b7bb646$export$27d2c76f835d583d)(range), min = (0, $1ff4dfb77b7bb646$export$71c94d28c0fa4bfe)(range);
    if (!decrease || data.status === (0, $c443c1fece529b66$export$a2d3d93c57d16a1a).increasing) {
        data.value += velocity;
        if (data.value > max) {
            if (!data.loops) data.loops = 0;
            data.loops++;
            if (decrease) data.status = (0, $c443c1fece529b66$export$a2d3d93c57d16a1a).decreasing;
            else data.value -= max;
        }
    } else {
        data.value -= velocity;
        const minValue = 0;
        if (data.value < minValue) {
            if (!data.loops) data.loops = 0;
            data.loops++;
            data.status = (0, $c443c1fece529b66$export$a2d3d93c57d16a1a).increasing;
        }
    }
    if (data.velocity && decay !== identity) data.velocity *= decay;
    data.value = (0, $1ff4dfb77b7bb646$export$7d15b64cf5a3a4c4)(data.value, min, max);
}
function $fd6faa9f4e5410ac$export$649b44ac750da8e(color, delta) {
    if (!color) return;
    const { h: h, s: s, l: l } = color;
    const ranges = {
        h: {
            min: 0,
            max: 360
        },
        s: {
            min: 0,
            max: 100
        },
        l: {
            min: 0,
            max: 100
        }
    };
    if (h) $fd6faa9f4e5410ac$export$a151177c20377190(h, ranges.h, false, delta);
    if (s) $fd6faa9f4e5410ac$export$a151177c20377190(s, ranges.s, true, delta);
    if (l) $fd6faa9f4e5410ac$export$a151177c20377190(l, ranges.l, true, delta);
}


const $44906e93848638c3$var$origin = {
    x: 0,
    y: 0
}, $44906e93848638c3$var$defaultTransform = {
    a: 1,
    b: 0,
    c: 0,
    d: 1
};
function $44906e93848638c3$export$819db45aec5fcbe5(context, begin, end) {
    context.beginPath();
    context.moveTo(begin.x, begin.y);
    context.lineTo(end.x, end.y);
    context.closePath();
}
function $44906e93848638c3$export$2837cdf5427f767e(context, dimension, baseColor) {
    context.fillStyle = baseColor ?? "rgba(0,0,0,0)";
    context.fillRect($44906e93848638c3$var$origin.x, $44906e93848638c3$var$origin.y, dimension.width, dimension.height);
}
function $44906e93848638c3$export$a17334b9431a8cb2(context, dimension, image, opacity) {
    if (!image) return;
    context.globalAlpha = opacity;
    context.drawImage(image, $44906e93848638c3$var$origin.x, $44906e93848638c3$var$origin.y, dimension.width, dimension.height);
    context.globalAlpha = 1;
}
function $44906e93848638c3$export$42ffd38884aecdac(context, dimension) {
    context.clearRect($44906e93848638c3$var$origin.x, $44906e93848638c3$var$origin.y, dimension.width, dimension.height);
}
function $44906e93848638c3$export$fca8f175741ef351(data) {
    const { container: container, context: context, particle: particle, delta: delta, colorStyles: colorStyles, backgroundMask: backgroundMask, composite: composite, radius: radius, opacity: opacity, shadow: shadow, transform: transform } = data, pos = particle.getPosition(), defaultAngle = 0, angle = particle.rotation + (particle.pathRotation ? particle.velocity.angle : defaultAngle), rotateData = {
        sin: Math.sin(angle),
        cos: Math.cos(angle)
    }, rotating = !!angle, identity = 1, transformData = {
        a: rotateData.cos * (transform.a ?? $44906e93848638c3$var$defaultTransform.a),
        b: rotating ? rotateData.sin * (transform.b ?? identity) : transform.b ?? $44906e93848638c3$var$defaultTransform.b,
        c: rotating ? -rotateData.sin * (transform.c ?? identity) : transform.c ?? $44906e93848638c3$var$defaultTransform.c,
        d: rotateData.cos * (transform.d ?? $44906e93848638c3$var$defaultTransform.d)
    };
    context.setTransform(transformData.a, transformData.b, transformData.c, transformData.d, pos.x, pos.y);
    if (backgroundMask) context.globalCompositeOperation = composite;
    const shadowColor = particle.shadowColor;
    if (shadow.enable && shadowColor) {
        context.shadowBlur = shadow.blur;
        context.shadowColor = (0, $fd6faa9f4e5410ac$export$2476af37e47fcae2)(shadowColor);
        context.shadowOffsetX = shadow.offset.x;
        context.shadowOffsetY = shadow.offset.y;
    }
    if (colorStyles.fill) context.fillStyle = colorStyles.fill;
    const minStrokeWidth = 0, strokeWidth = particle.strokeWidth ?? minStrokeWidth;
    context.lineWidth = strokeWidth;
    if (colorStyles.stroke) context.strokeStyle = colorStyles.stroke;
    const drawData = {
        container: container,
        context: context,
        particle: particle,
        radius: radius,
        opacity: opacity,
        delta: delta,
        transformData: transformData,
        strokeWidth: strokeWidth
    };
    $44906e93848638c3$export$71b514a25c47df50(drawData);
    $44906e93848638c3$export$2808702213c51f09(drawData);
    $44906e93848638c3$export$27b58ff3abda0f8e(drawData);
    context.globalCompositeOperation = "source-over";
    context.resetTransform();
}
function $44906e93848638c3$export$27b58ff3abda0f8e(data) {
    const { container: container, context: context, particle: particle, radius: radius, opacity: opacity, delta: delta, transformData: transformData } = data;
    if (!particle.effect) return;
    const drawer = container.effectDrawers.get(particle.effect);
    if (!drawer) return;
    drawer.draw({
        context: context,
        particle: particle,
        radius: radius,
        opacity: opacity,
        delta: delta,
        pixelRatio: container.retina.pixelRatio,
        transformData: {
            ...transformData
        }
    });
}
function $44906e93848638c3$export$71b514a25c47df50(data) {
    const { container: container, context: context, particle: particle, radius: radius, opacity: opacity, delta: delta, strokeWidth: strokeWidth, transformData: transformData } = data, minStrokeWidth = 0;
    if (!particle.shape) return;
    const drawer = container.shapeDrawers.get(particle.shape);
    if (!drawer) return;
    context.beginPath();
    drawer.draw({
        context: context,
        particle: particle,
        radius: radius,
        opacity: opacity,
        delta: delta,
        pixelRatio: container.retina.pixelRatio,
        transformData: {
            ...transformData
        }
    });
    if (particle.shapeClose) context.closePath();
    if (strokeWidth > minStrokeWidth) context.stroke();
    if (particle.shapeFill) context.fill();
}
function $44906e93848638c3$export$2808702213c51f09(data) {
    const { container: container, context: context, particle: particle, radius: radius, opacity: opacity, delta: delta, transformData: transformData } = data;
    if (!particle.shape) return;
    const drawer = container.shapeDrawers.get(particle.shape);
    if (!drawer?.afterDraw) return;
    drawer.afterDraw({
        context: context,
        particle: particle,
        radius: radius,
        opacity: opacity,
        delta: delta,
        pixelRatio: container.retina.pixelRatio,
        transformData: {
            ...transformData
        }
    });
}
function $44906e93848638c3$export$ee9933e1bf4ba142(context, plugin, delta) {
    if (!plugin.draw) return;
    plugin.draw(context, delta);
}
function $44906e93848638c3$export$3493f6d6277d918a(context, plugin, particle, delta) {
    if (!plugin.drawParticle) return;
    plugin.drawParticle(context, particle, delta);
}
function $44906e93848638c3$export$fe1d034b0e82666(color, type, value) {
    const lFactor = 1;
    return {
        h: color.h,
        s: color.s,
        l: color.l + (type === (0, $c9d3d993d79e9eed$export$d3c0448523aecc2e).darken ? -lFactor : lFactor) * value
    };
}





function $7919f78a40afc6fa$var$setTransformValue(factor, newFactor, key) {
    const newValue = newFactor[key], defaultValue = 1;
    if (newValue !== undefined) factor[key] = (factor[key] ?? defaultValue) * newValue;
}
function $7919f78a40afc6fa$var$setStyle(canvas, style, important = false) {
    if (!style) return;
    const element = canvas;
    if (!element) return;
    const elementStyle = element.style;
    if (!elementStyle) return;
    for(const key in style){
        const value = style[key];
        if (!value) continue;
        elementStyle.setProperty(key, value, important ? "important" : "");
    }
}
class $7919f78a40afc6fa$export$8d01c972ee8b14a9 {
    constructor(container){
        this.container = container;
        this._applyPostDrawUpdaters = (particle)=>{
            for (const updater of this._postDrawUpdaters)updater.afterDraw?.(particle);
        };
        this._applyPreDrawUpdaters = (ctx, particle, radius, zOpacity, colorStyles, transform)=>{
            for (const updater of this._preDrawUpdaters){
                if (updater.getColorStyles) {
                    const { fill: fill, stroke: stroke } = updater.getColorStyles(particle, ctx, radius, zOpacity);
                    if (fill) colorStyles.fill = fill;
                    if (stroke) colorStyles.stroke = stroke;
                }
                if (updater.getTransformValues) {
                    const updaterTransform = updater.getTransformValues(particle);
                    for(const key in updaterTransform)$7919f78a40afc6fa$var$setTransformValue(transform, updaterTransform, key);
                }
                updater.beforeDraw?.(particle);
            }
        };
        this._applyResizePlugins = ()=>{
            for (const plugin of this._resizePlugins)plugin.resize?.();
        };
        this._getPluginParticleColors = (particle)=>{
            let fColor, sColor;
            for (const plugin of this._colorPlugins){
                if (!fColor && plugin.particleFillColor) fColor = (0, $fd6faa9f4e5410ac$export$79a89086521c0f12)(plugin.particleFillColor(particle));
                if (!sColor && plugin.particleStrokeColor) sColor = (0, $fd6faa9f4e5410ac$export$79a89086521c0f12)(plugin.particleStrokeColor(particle));
                if (fColor && sColor) break;
            }
            return [
                fColor,
                sColor
            ];
        };
        this._initCover = async ()=>{
            const options = this.container.actualOptions, cover = options.backgroundMask.cover, color = cover.color;
            if (color) {
                const coverRgb = (0, $fd6faa9f4e5410ac$export$fbf0bf3cc1fc0cc4)(color);
                if (coverRgb) {
                    const coverColor = {
                        ...coverRgb,
                        a: cover.opacity
                    };
                    this._coverColorStyle = (0, $fd6faa9f4e5410ac$export$2476af37e47fcae2)(coverColor, coverColor.a);
                }
            } else await new Promise((resolve, reject)=>{
                if (!cover.image) return;
                const img = document.createElement("img");
                img.addEventListener("load", ()=>{
                    this._coverImage = {
                        image: img,
                        opacity: cover.opacity
                    };
                    resolve();
                });
                img.addEventListener("error", (evt)=>{
                    reject(evt.error);
                });
                img.src = cover.image;
            });
        };
        this._initStyle = ()=>{
            const element = this.element, options = this.container.actualOptions;
            if (!element) return;
            if (this._fullScreen) {
                this._originalStyle = (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)({}, element.style);
                this._setFullScreenStyle();
            } else this._resetOriginalStyle();
            for(const key in options.style){
                if (!key || !options.style) continue;
                const value = options.style[key];
                if (!value) continue;
                element.style.setProperty(key, value, "important");
            }
        };
        this._initTrail = async ()=>{
            const options = this.container.actualOptions, trail = options.particles.move.trail, trailFill = trail.fill;
            if (!trail.enable) return;
            const factorNumerator = 1, opacity = factorNumerator / trail.length;
            if (trailFill.color) {
                const fillColor = (0, $fd6faa9f4e5410ac$export$fbf0bf3cc1fc0cc4)(trailFill.color);
                if (!fillColor) return;
                this._trailFill = {
                    color: {
                        ...fillColor
                    },
                    opacity: opacity
                };
            } else await new Promise((resolve, reject)=>{
                if (!trailFill.image) return;
                const img = document.createElement("img");
                img.addEventListener("load", ()=>{
                    this._trailFill = {
                        image: img,
                        opacity: opacity
                    };
                    resolve();
                });
                img.addEventListener("error", (evt)=>{
                    reject(evt.error);
                });
                img.src = trailFill.image;
            });
        };
        this._paintBase = (baseColor)=>{
            this.draw((ctx)=>(0, $44906e93848638c3$export$2837cdf5427f767e)(ctx, this.size, baseColor));
        };
        this._paintImage = (image, opacity)=>{
            this.draw((ctx)=>(0, $44906e93848638c3$export$a17334b9431a8cb2)(ctx, this.size, image, opacity));
        };
        this._repairStyle = ()=>{
            const element = this.element;
            if (!element) return;
            this._safeMutationObserver((observer)=>observer.disconnect());
            this._initStyle();
            this.initBackground();
            this._safeMutationObserver((observer)=>{
                if (!element || !(element instanceof Node)) return;
                observer.observe(element, {
                    attributes: true
                });
            });
        };
        this._resetOriginalStyle = ()=>{
            const element = this.element, originalStyle = this._originalStyle;
            if (!(element && originalStyle)) return;
            $7919f78a40afc6fa$var$setStyle(element, originalStyle);
        };
        this._safeMutationObserver = (callback)=>{
            if (!this._mutationObserver) return;
            callback(this._mutationObserver);
        };
        this._setFullScreenStyle = ()=>{
            const element = this.element;
            if (!element) return;
            const radix = 10;
            $7919f78a40afc6fa$var$setStyle(element, {
                position: "fixed",
                zIndex: this.container.actualOptions.fullScreen.zIndex.toString(radix),
                top: "0",
                left: "0",
                width: "100%",
                height: "100%"
            }, true);
        };
        this.size = {
            height: 0,
            width: 0
        };
        this._context = null;
        this._generated = false;
        this._preDrawUpdaters = [];
        this._postDrawUpdaters = [];
        this._resizePlugins = [];
        this._colorPlugins = [];
    }
    get _fullScreen() {
        return this.container.actualOptions.fullScreen.enable;
    }
    clear() {
        const options = this.container.actualOptions, trail = options.particles.move.trail, trailFill = this._trailFill, minimumLength = 0;
        if (options.backgroundMask.enable) this.paint();
        else if (trail.enable && trail.length > minimumLength && trailFill) {
            if (trailFill.color) this._paintBase((0, $fd6faa9f4e5410ac$export$2476af37e47fcae2)(trailFill.color, trailFill.opacity));
            else if (trailFill.image) this._paintImage(trailFill.image, trailFill.opacity);
        } else if (options.clear) this.draw((ctx)=>{
            (0, $44906e93848638c3$export$42ffd38884aecdac)(ctx, this.size);
        });
    }
    destroy() {
        this.stop();
        if (this._generated) {
            const element = this.element;
            element?.remove();
        } else this._resetOriginalStyle();
        this._preDrawUpdaters = [];
        this._postDrawUpdaters = [];
        this._resizePlugins = [];
        this._colorPlugins = [];
    }
    draw(cb) {
        const ctx = this._context;
        if (!ctx) return;
        return cb(ctx);
    }
    drawAsync(cb) {
        const ctx = this._context;
        if (!ctx) return undefined;
        return cb(ctx);
    }
    drawParticle(particle, delta) {
        if (particle.spawning || particle.destroyed) return;
        const radius = particle.getRadius(), minimumSize = 0;
        if (radius <= minimumSize) return;
        const pfColor = particle.getFillColor(), psColor = particle.getStrokeColor() ?? pfColor;
        let [fColor, sColor] = this._getPluginParticleColors(particle);
        if (!fColor) fColor = pfColor;
        if (!sColor) sColor = psColor;
        if (!fColor && !sColor) return;
        this.draw((ctx)=>{
            const container = this.container, options = container.actualOptions, zIndexOptions = particle.options.zIndex, zIndexFactorOffset = 1, zIndexFactor = zIndexFactorOffset - particle.zIndexFactor, zOpacityFactor = zIndexFactor ** zIndexOptions.opacityRate, defaultOpacity = 1, opacity = particle.bubble.opacity ?? particle.opacity?.value ?? defaultOpacity, strokeOpacity = particle.strokeOpacity ?? opacity, zOpacity = opacity * zOpacityFactor, zStrokeOpacity = strokeOpacity * zOpacityFactor, transform = {}, colorStyles = {
                fill: fColor ? (0, $fd6faa9f4e5410ac$export$9d057e59c7b0a82d)(fColor, zOpacity) : undefined
            };
            colorStyles.stroke = sColor ? (0, $fd6faa9f4e5410ac$export$9d057e59c7b0a82d)(sColor, zStrokeOpacity) : colorStyles.fill;
            this._applyPreDrawUpdaters(ctx, particle, radius, zOpacity, colorStyles, transform);
            (0, $44906e93848638c3$export$fca8f175741ef351)({
                container: container,
                context: ctx,
                particle: particle,
                delta: delta,
                colorStyles: colorStyles,
                backgroundMask: options.backgroundMask.enable,
                composite: options.backgroundMask.composite,
                radius: radius * zIndexFactor ** zIndexOptions.sizeRate,
                opacity: zOpacity,
                shadow: particle.options.shadow,
                transform: transform
            });
            this._applyPostDrawUpdaters(particle);
        });
    }
    drawParticlePlugin(plugin, particle, delta) {
        this.draw((ctx)=>(0, $44906e93848638c3$export$3493f6d6277d918a)(ctx, plugin, particle, delta));
    }
    drawPlugin(plugin, delta) {
        this.draw((ctx)=>(0, $44906e93848638c3$export$ee9933e1bf4ba142)(ctx, plugin, delta));
    }
    async init() {
        this._safeMutationObserver((obs)=>obs.disconnect());
        this._mutationObserver = (0, $eee2fa4b9ebe63e9$export$c2f9084a48da0641)((records)=>{
            for (const record of records)if (record.type === "attributes" && record.attributeName === "style") this._repairStyle();
        });
        this.resize();
        this._initStyle();
        await this._initCover();
        try {
            await this._initTrail();
        } catch (e) {
            (0, $eee2fa4b9ebe63e9$export$2b1d391cd05230fd)().error(e);
        }
        this.initBackground();
        this._safeMutationObserver((obs)=>{
            if (!this.element || !(this.element instanceof Node)) return;
            obs.observe(this.element, {
                attributes: true
            });
        });
        this.initUpdaters();
        this.initPlugins();
        this.paint();
    }
    initBackground() {
        const options = this.container.actualOptions, background = options.background, element = this.element;
        if (!element) return;
        const elementStyle = element.style;
        if (!elementStyle) return;
        if (background.color) {
            const color = (0, $fd6faa9f4e5410ac$export$fbf0bf3cc1fc0cc4)(background.color);
            elementStyle.backgroundColor = color ? (0, $fd6faa9f4e5410ac$export$2476af37e47fcae2)(color, background.opacity) : "";
        } else elementStyle.backgroundColor = "";
        elementStyle.backgroundImage = background.image || "";
        elementStyle.backgroundPosition = background.position || "";
        elementStyle.backgroundRepeat = background.repeat || "";
        elementStyle.backgroundSize = background.size || "";
    }
    initPlugins() {
        this._resizePlugins = [];
        for (const [, plugin] of this.container.plugins){
            if (plugin.resize) this._resizePlugins.push(plugin);
            if (plugin.particleFillColor ?? plugin.particleStrokeColor) this._colorPlugins.push(plugin);
        }
    }
    initUpdaters() {
        this._preDrawUpdaters = [];
        this._postDrawUpdaters = [];
        for (const updater of this.container.particles.updaters){
            if (updater.afterDraw) this._postDrawUpdaters.push(updater);
            if (updater.getColorStyles ?? updater.getTransformValues ?? updater.beforeDraw) this._preDrawUpdaters.push(updater);
        }
    }
    loadCanvas(canvas) {
        if (this._generated && this.element) this.element.remove();
        this._generated = canvas.dataset && (0, $dec17af1c054e95f$export$4a278486528d5cfb) in canvas.dataset ? canvas.dataset[0, $dec17af1c054e95f$export$4a278486528d5cfb] === "true" : this._generated;
        this.element = canvas;
        this.element.ariaHidden = "true";
        this._originalStyle = (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)({}, this.element.style);
        this.size.height = canvas.offsetHeight;
        this.size.width = canvas.offsetWidth;
        this._context = this.element.getContext("2d");
        this._safeMutationObserver((obs)=>{
            if (!this.element || !(this.element instanceof Node)) return;
            obs.observe(this.element, {
                attributes: true
            });
        });
        this.container.retina.init();
        this.initBackground();
    }
    paint() {
        const options = this.container.actualOptions;
        this.draw((ctx)=>{
            if (options.backgroundMask.enable && options.backgroundMask.cover) {
                (0, $44906e93848638c3$export$42ffd38884aecdac)(ctx, this.size);
                if (this._coverImage) this._paintImage(this._coverImage.image, this._coverImage.opacity);
                else if (this._coverColorStyle) this._paintBase(this._coverColorStyle);
                else this._paintBase();
            } else this._paintBase();
        });
    }
    resize() {
        if (!this.element) return false;
        const container = this.container, pxRatio = container.retina.pixelRatio, size = container.canvas.size, newSize = {
            width: this.element.offsetWidth * pxRatio,
            height: this.element.offsetHeight * pxRatio
        };
        if (newSize.height === size.height && newSize.width === size.width && newSize.height === this.element.height && newSize.width === this.element.width) return false;
        const oldSize = {
            ...size
        };
        this.element.width = size.width = this.element.offsetWidth * pxRatio;
        this.element.height = size.height = this.element.offsetHeight * pxRatio;
        if (this.container.started) container.particles.setResizeFactor({
            width: size.width / oldSize.width,
            height: size.height / oldSize.height
        });
        return true;
    }
    stop() {
        this._safeMutationObserver((obs)=>obs.disconnect());
        this._mutationObserver = undefined;
        this.draw((ctx)=>(0, $44906e93848638c3$export$42ffd38884aecdac)(ctx, this.size));
    }
    async windowResize() {
        if (!this.element || !this.resize()) return;
        const container = this.container, needsRefresh = container.updateActualOptions();
        container.particles.setDensity();
        this._applyResizePlugins();
        if (needsRefresh) await container.refresh();
    }
}




var $e778bd14aff834f0$export$a061a4a5d124ecc0;
(function(InteractivityDetect) {
    InteractivityDetect["canvas"] = "canvas";
    InteractivityDetect["parent"] = "parent";
    InteractivityDetect["window"] = "window";
})($e778bd14aff834f0$export$a061a4a5d124ecc0 || ($e778bd14aff834f0$export$a061a4a5d124ecc0 = {}));



const $6ba34dc75ffe70d8$var$double = 2;
function $6ba34dc75ffe70d8$var$manageListener(element, event, handler, add, options) {
    if (add) {
        let addOptions = {
            passive: true
        };
        if ((0, $ad25b6e319f6df8c$export$f9ce7b637dfbe238)(options)) addOptions.capture = options;
        else if (options !== undefined) addOptions = options;
        element.addEventListener(event, handler, addOptions);
    } else {
        const removeOptions = options;
        element.removeEventListener(event, handler, removeOptions);
    }
}
class $6ba34dc75ffe70d8$export$b20b719ec758a20f {
    constructor(container){
        this.container = container;
        this._doMouseTouchClick = (e)=>{
            const container = this.container, options = container.actualOptions;
            if (this._canPush) {
                const mouseInteractivity = container.interactivity.mouse, mousePos = mouseInteractivity.position;
                if (!mousePos) return;
                mouseInteractivity.clickPosition = {
                    ...mousePos
                };
                mouseInteractivity.clickTime = new Date().getTime();
                const onClick = options.interactivity.events.onClick;
                (0, $eee2fa4b9ebe63e9$export$8e5dc47097396754)(onClick.mode, (mode)=>this.container.handleClickMode(mode));
            }
            if (e.type === "touchend") {
                const touchDelay = 500;
                setTimeout(()=>this._mouseTouchFinish(), touchDelay);
            }
        };
        this._handleThemeChange = (e)=>{
            const mediaEvent = e, container = this.container, options = container.options, defaultThemes = options.defaultThemes, themeName = mediaEvent.matches ? defaultThemes.dark : defaultThemes.light, theme = options.themes.find((theme)=>theme.name === themeName);
            if (theme?.default.auto) container.loadTheme(themeName);
        };
        this._handleVisibilityChange = ()=>{
            const container = this.container, options = container.actualOptions;
            this._mouseTouchFinish();
            if (!options.pauseOnBlur) return;
            if (document?.hidden) {
                container.pageHidden = true;
                container.pause();
            } else {
                container.pageHidden = false;
                if (container.animationStatus) container.play(true);
                else container.draw(true);
            }
        };
        this._handleWindowResize = ()=>{
            if (this._resizeTimeout) {
                clearTimeout(this._resizeTimeout);
                delete this._resizeTimeout;
            }
            const handleResize = async ()=>{
                const canvas = this.container.canvas;
                await canvas?.windowResize();
            };
            this._resizeTimeout = setTimeout(()=>void handleResize(), this.container.actualOptions.interactivity.events.resize.delay * (0, $dec17af1c054e95f$export$f64c3bfbc58eec0f));
        };
        this._manageInteractivityListeners = (mouseLeaveTmpEvent, add)=>{
            const handlers = this._handlers, container = this.container, options = container.actualOptions;
            const interactivityEl = container.interactivity.element;
            if (!interactivityEl) return;
            const html = interactivityEl, canvasEl = container.canvas.element;
            if (canvasEl) canvasEl.style.pointerEvents = html === canvasEl ? "initial" : "none";
            if (!(options.interactivity.events.onHover.enable || options.interactivity.events.onClick.enable)) return;
            $6ba34dc75ffe70d8$var$manageListener(interactivityEl, (0, $dec17af1c054e95f$export$1ffe551d7d33cd33), handlers.mouseMove, add);
            $6ba34dc75ffe70d8$var$manageListener(interactivityEl, (0, $dec17af1c054e95f$export$d5353b6c79bbcc70), handlers.touchStart, add);
            $6ba34dc75ffe70d8$var$manageListener(interactivityEl, (0, $dec17af1c054e95f$export$d28a82874c0e6212), handlers.touchMove, add);
            if (!options.interactivity.events.onClick.enable) $6ba34dc75ffe70d8$var$manageListener(interactivityEl, (0, $dec17af1c054e95f$export$11164630b85c192d), handlers.touchEnd, add);
            else {
                $6ba34dc75ffe70d8$var$manageListener(interactivityEl, (0, $dec17af1c054e95f$export$11164630b85c192d), handlers.touchEndClick, add);
                $6ba34dc75ffe70d8$var$manageListener(interactivityEl, (0, $dec17af1c054e95f$export$9fb0268ce1bdbca0), handlers.mouseUp, add);
                $6ba34dc75ffe70d8$var$manageListener(interactivityEl, (0, $dec17af1c054e95f$export$9ffd73c9a0e32c34), handlers.mouseDown, add);
            }
            $6ba34dc75ffe70d8$var$manageListener(interactivityEl, mouseLeaveTmpEvent, handlers.mouseLeave, add);
            $6ba34dc75ffe70d8$var$manageListener(interactivityEl, (0, $dec17af1c054e95f$export$65db1c69591947a7), handlers.touchCancel, add);
        };
        this._manageListeners = (add)=>{
            const handlers = this._handlers, container = this.container, options = container.actualOptions, detectType = options.interactivity.detectsOn, canvasEl = container.canvas.element;
            let mouseLeaveTmpEvent = (0, $dec17af1c054e95f$export$f4b184a85a586f8a);
            if (detectType === (0, $e778bd14aff834f0$export$a061a4a5d124ecc0).window) {
                container.interactivity.element = window;
                mouseLeaveTmpEvent = (0, $dec17af1c054e95f$export$55cc1d6a692feb2b);
            } else if (detectType === (0, $e778bd14aff834f0$export$a061a4a5d124ecc0).parent && canvasEl) container.interactivity.element = canvasEl.parentElement ?? canvasEl.parentNode;
            else container.interactivity.element = canvasEl;
            this._manageMediaMatch(add);
            this._manageResize(add);
            this._manageInteractivityListeners(mouseLeaveTmpEvent, add);
            if (document) $6ba34dc75ffe70d8$var$manageListener(document, (0, $dec17af1c054e95f$export$73536144dc68dd0f), handlers.visibilityChange, add, false);
        };
        this._manageMediaMatch = (add)=>{
            const handlers = this._handlers, mediaMatch = (0, $eee2fa4b9ebe63e9$export$db32b9574e21e00f)("(prefers-color-scheme: dark)");
            if (!mediaMatch) return;
            if (mediaMatch.addEventListener !== undefined) {
                $6ba34dc75ffe70d8$var$manageListener(mediaMatch, "change", handlers.themeChange, add);
                return;
            }
            if (mediaMatch.addListener === undefined) return;
            if (add) mediaMatch.addListener(handlers.oldThemeChange);
            else mediaMatch.removeListener(handlers.oldThemeChange);
        };
        this._manageResize = (add)=>{
            const handlers = this._handlers, container = this.container, options = container.actualOptions;
            if (!options.interactivity.events.resize) return;
            if (typeof ResizeObserver === "undefined") {
                $6ba34dc75ffe70d8$var$manageListener(window, (0, $dec17af1c054e95f$export$8b3d73c91cd7cc65), handlers.resize, add);
                return;
            }
            const canvasEl = container.canvas.element;
            if (this._resizeObserver && !add) {
                if (canvasEl) this._resizeObserver.unobserve(canvasEl);
                this._resizeObserver.disconnect();
                delete this._resizeObserver;
            } else if (!this._resizeObserver && add && canvasEl) {
                this._resizeObserver = new ResizeObserver((entries)=>{
                    const entry = entries.find((e)=>e.target === canvasEl);
                    if (!entry) return;
                    this._handleWindowResize();
                });
                this._resizeObserver.observe(canvasEl);
            }
        };
        this._mouseDown = ()=>{
            const { interactivity: interactivity } = this.container;
            if (!interactivity) return;
            const { mouse: mouse } = interactivity;
            mouse.clicking = true;
            mouse.downPosition = mouse.position;
        };
        this._mouseTouchClick = (e)=>{
            const container = this.container, options = container.actualOptions, { mouse: mouse } = container.interactivity;
            mouse.inside = true;
            let handled = false;
            const mousePosition = mouse.position;
            if (!mousePosition || !options.interactivity.events.onClick.enable) return;
            for (const [, plugin] of container.plugins){
                if (!plugin.clickPositionValid) continue;
                handled = plugin.clickPositionValid(mousePosition);
                if (handled) break;
            }
            if (!handled) this._doMouseTouchClick(e);
            mouse.clicking = false;
        };
        this._mouseTouchFinish = ()=>{
            const interactivity = this.container.interactivity;
            if (!interactivity) return;
            const mouse = interactivity.mouse;
            delete mouse.position;
            delete mouse.clickPosition;
            delete mouse.downPosition;
            interactivity.status = (0, $dec17af1c054e95f$export$f4b184a85a586f8a);
            mouse.inside = false;
            mouse.clicking = false;
        };
        this._mouseTouchMove = (e)=>{
            const container = this.container, options = container.actualOptions, interactivity = container.interactivity, canvasEl = container.canvas.element;
            if (!interactivity?.element) return;
            interactivity.mouse.inside = true;
            let pos;
            if (e.type.startsWith("pointer")) {
                this._canPush = true;
                const mouseEvent = e;
                if (interactivity.element === window) {
                    if (canvasEl) {
                        const clientRect = canvasEl.getBoundingClientRect();
                        pos = {
                            x: mouseEvent.clientX - clientRect.left,
                            y: mouseEvent.clientY - clientRect.top
                        };
                    }
                } else if (options.interactivity.detectsOn === (0, $e778bd14aff834f0$export$a061a4a5d124ecc0).parent) {
                    const source = mouseEvent.target, target = mouseEvent.currentTarget;
                    if (source && target && canvasEl) {
                        const sourceRect = source.getBoundingClientRect(), targetRect = target.getBoundingClientRect(), canvasRect = canvasEl.getBoundingClientRect();
                        pos = {
                            x: mouseEvent.offsetX + $6ba34dc75ffe70d8$var$double * sourceRect.left - (targetRect.left + canvasRect.left),
                            y: mouseEvent.offsetY + $6ba34dc75ffe70d8$var$double * sourceRect.top - (targetRect.top + canvasRect.top)
                        };
                    } else pos = {
                        x: mouseEvent.offsetX ?? mouseEvent.clientX,
                        y: mouseEvent.offsetY ?? mouseEvent.clientY
                    };
                } else if (mouseEvent.target === canvasEl) pos = {
                    x: mouseEvent.offsetX ?? mouseEvent.clientX,
                    y: mouseEvent.offsetY ?? mouseEvent.clientY
                };
            } else {
                this._canPush = e.type !== "touchmove";
                if (canvasEl) {
                    const touchEvent = e, lengthOffset = 1, lastTouch = touchEvent.touches[touchEvent.touches.length - lengthOffset], canvasRect = canvasEl.getBoundingClientRect(), defaultCoordinate = 0;
                    pos = {
                        x: lastTouch.clientX - (canvasRect.left ?? defaultCoordinate),
                        y: lastTouch.clientY - (canvasRect.top ?? defaultCoordinate)
                    };
                }
            }
            const pxRatio = container.retina.pixelRatio;
            if (pos) {
                pos.x *= pxRatio;
                pos.y *= pxRatio;
            }
            interactivity.mouse.position = pos;
            interactivity.status = (0, $dec17af1c054e95f$export$1ffe551d7d33cd33);
        };
        this._touchEnd = (e)=>{
            const evt = e, touches = Array.from(evt.changedTouches);
            for (const touch of touches)this._touches.delete(touch.identifier);
            this._mouseTouchFinish();
        };
        this._touchEndClick = (e)=>{
            const evt = e, touches = Array.from(evt.changedTouches);
            for (const touch of touches)this._touches.delete(touch.identifier);
            this._mouseTouchClick(e);
        };
        this._touchStart = (e)=>{
            const evt = e, touches = Array.from(evt.changedTouches);
            for (const touch of touches)this._touches.set(touch.identifier, performance.now());
            this._mouseTouchMove(e);
        };
        this._canPush = true;
        this._touches = new Map();
        this._handlers = {
            mouseDown: ()=>this._mouseDown(),
            mouseLeave: ()=>this._mouseTouchFinish(),
            mouseMove: (e)=>this._mouseTouchMove(e),
            mouseUp: (e)=>this._mouseTouchClick(e),
            touchStart: (e)=>this._touchStart(e),
            touchMove: (e)=>this._mouseTouchMove(e),
            touchEnd: (e)=>this._touchEnd(e),
            touchCancel: (e)=>this._touchEnd(e),
            touchEndClick: (e)=>this._touchEndClick(e),
            visibilityChange: ()=>this._handleVisibilityChange(),
            themeChange: (e)=>this._handleThemeChange(e),
            oldThemeChange: (e)=>this._handleThemeChange(e),
            resize: ()=>{
                this._handleWindowResize();
            }
        };
    }
    addListeners() {
        this._manageListeners(true);
    }
    removeListeners() {
        this._manageListeners(false);
    }
}


var $df94476ffe249114$export$3d7865934588d77e;
(function(EventType) {
    EventType["configAdded"] = "configAdded";
    EventType["containerInit"] = "containerInit";
    EventType["particlesSetup"] = "particlesSetup";
    EventType["containerStarted"] = "containerStarted";
    EventType["containerStopped"] = "containerStopped";
    EventType["containerDestroyed"] = "containerDestroyed";
    EventType["containerPaused"] = "containerPaused";
    EventType["containerPlay"] = "containerPlay";
    EventType["containerBuilt"] = "containerBuilt";
    EventType["particleAdded"] = "particleAdded";
    EventType["particleDestroyed"] = "particleDestroyed";
    EventType["particleRemoved"] = "particleRemoved";
})($df94476ffe249114$export$3d7865934588d77e || ($df94476ffe249114$export$3d7865934588d77e = {}));




class $c86524210cdfad1b$export$c2b08aa25660fcaa {
    constructor(){
        this.value = "";
    }
    static create(source, data) {
        const color = new $c86524210cdfad1b$export$c2b08aa25660fcaa();
        color.load(source);
        if (data !== undefined) {
            if ((0, $ad25b6e319f6df8c$export$844ec244b1367d54)(data) || (0, $ad25b6e319f6df8c$export$43bee75e5e14138e)(data)) color.load({
                value: data
            });
            else color.load(data);
        }
        return color;
    }
    load(data) {
        if (data?.value === undefined) return;
        this.value = data.value;
    }
}


class $fb28bcba41ca7c48$export$668799e4797757a8 {
    constructor(){
        this.color = new (0, $c86524210cdfad1b$export$c2b08aa25660fcaa)();
        this.color.value = "";
        this.image = "";
        this.position = "";
        this.repeat = "";
        this.size = "";
        this.opacity = 1;
    }
    load(data) {
        if (!data) return;
        if (data.color !== undefined) this.color = (0, $c86524210cdfad1b$export$c2b08aa25660fcaa).create(this.color, data.color);
        if (data.image !== undefined) this.image = data.image;
        if (data.position !== undefined) this.position = data.position;
        if (data.repeat !== undefined) this.repeat = data.repeat;
        if (data.size !== undefined) this.size = data.size;
        if (data.opacity !== undefined) this.opacity = data.opacity;
    }
}



class $b4c4b1739004ef60$export$83d45d4584162ec0 {
    constructor(){
        this.opacity = 1;
    }
    load(data) {
        if (!data) return;
        if (data.color !== undefined) this.color = (0, $c86524210cdfad1b$export$c2b08aa25660fcaa).create(this.color, data.color);
        if (data.image !== undefined) this.image = data.image;
        if (data.opacity !== undefined) this.opacity = data.opacity;
    }
}



class $39ed4c62a4877755$export$36a2fa1e47ffeebc {
    constructor(){
        this.composite = "destination-out";
        this.cover = new (0, $b4c4b1739004ef60$export$83d45d4584162ec0)();
        this.enable = false;
    }
    load(data) {
        if (!data) return;
        if (data.composite !== undefined) this.composite = data.composite;
        if (data.cover !== undefined) {
            const cover = data.cover, color = (0, $ad25b6e319f6df8c$export$844ec244b1367d54)(data.cover) ? {
                color: data.cover
            } : data.cover;
            this.cover.load(cover.color !== undefined || cover.image !== undefined ? cover : {
                color: color
            });
        }
        if (data.enable !== undefined) this.enable = data.enable;
    }
}


class $996bf9fcd377de50$export$f885b95b3f0be76d {
    constructor(){
        this.enable = true;
        this.zIndex = 0;
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.zIndex !== undefined) this.zIndex = data.zIndex;
    }
}


class $d93afd7b93e9aaa6$export$8d82f6df2d02cd91 {
    constructor(){
        this.enable = false;
        this.mode = [];
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.mode !== undefined) this.mode = data.mode;
    }
}


var $c7511144a05e00a9$export$9e83d65c7ba90739;
(function(DivType) {
    DivType["circle"] = "circle";
    DivType["rectangle"] = "rectangle";
})($c7511144a05e00a9$export$9e83d65c7ba90739 || ($c7511144a05e00a9$export$9e83d65c7ba90739 = {}));


class $2337d56bbfbe3ac9$export$54136f11f358067a {
    constructor(){
        this.selectors = [];
        this.enable = false;
        this.mode = [];
        this.type = (0, $c7511144a05e00a9$export$9e83d65c7ba90739).circle;
    }
    load(data) {
        if (!data) return;
        if (data.selectors !== undefined) this.selectors = data.selectors;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.mode !== undefined) this.mode = data.mode;
        if (data.type !== undefined) this.type = data.type;
    }
}


class $35ba52649dc615d8$export$1bc430945f060dd1 {
    constructor(){
        this.enable = false;
        this.force = 2;
        this.smooth = 10;
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.force !== undefined) this.force = data.force;
        if (data.smooth !== undefined) this.smooth = data.smooth;
    }
}


class $e4fb816e584f2ee7$export$2f13ede603111372 {
    constructor(){
        this.enable = false;
        this.mode = [];
        this.parallax = new (0, $35ba52649dc615d8$export$1bc430945f060dd1)();
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.mode !== undefined) this.mode = data.mode;
        this.parallax.load(data.parallax);
    }
}


class $1263cae6e19fc9cb$export$4a407cdeed472cd5 {
    constructor(){
        this.delay = 0.5;
        this.enable = true;
    }
    load(data) {
        if (data === undefined) return;
        if (data.delay !== undefined) this.delay = data.delay;
        if (data.enable !== undefined) this.enable = data.enable;
    }
}



class $fa11dd4c512a594c$export$ada873a34909da65 {
    constructor(){
        this.onClick = new (0, $d93afd7b93e9aaa6$export$8d82f6df2d02cd91)();
        this.onDiv = new (0, $2337d56bbfbe3ac9$export$54136f11f358067a)();
        this.onHover = new (0, $e4fb816e584f2ee7$export$2f13ede603111372)();
        this.resize = new (0, $1263cae6e19fc9cb$export$4a407cdeed472cd5)();
    }
    load(data) {
        if (!data) return;
        this.onClick.load(data.onClick);
        const onDiv = data.onDiv;
        if (onDiv !== undefined) this.onDiv = (0, $eee2fa4b9ebe63e9$export$8e5dc47097396754)(onDiv, (t)=>{
            const tmp = new (0, $2337d56bbfbe3ac9$export$54136f11f358067a)();
            tmp.load(t);
            return tmp;
        });
        this.onHover.load(data.onHover);
        this.resize.load(data.resize);
    }
}



class $95892ecafc08cbe1$export$43660d87cb080eb {
    constructor(engine, container){
        this._engine = engine;
        this._container = container;
    }
    load(data) {
        if (!data) return;
        if (!this._container) return;
        const interactors = this._engine.interactors.get(this._container);
        if (!interactors) return;
        for (const interactor of interactors){
            if (!interactor.loadModeOptions) continue;
            interactor.loadModeOptions(this, data);
        }
    }
}


class $3fad4b788c088c43$export$865458a3ba269c4a {
    constructor(engine, container){
        this.detectsOn = (0, $e778bd14aff834f0$export$a061a4a5d124ecc0).window;
        this.events = new (0, $fa11dd4c512a594c$export$ada873a34909da65)();
        this.modes = new (0, $95892ecafc08cbe1$export$43660d87cb080eb)(engine, container);
    }
    load(data) {
        if (!data) return;
        const detectsOn = data.detectsOn;
        if (detectsOn !== undefined) this.detectsOn = detectsOn;
        this.events.load(data.events);
        this.modes.load(data.modes);
    }
}




const $bd26b66259d07932$var$defaultPosition = 50;
class $bd26b66259d07932$export$4f41a3ab9fa8cdf {
    load(data) {
        if (!data) return;
        if (data.position) this.position = {
            x: data.position.x ?? $bd26b66259d07932$var$defaultPosition,
            y: data.position.y ?? $bd26b66259d07932$var$defaultPosition,
            mode: data.position.mode ?? (0, $990956d8c795e3d5$export$1009f0178778a981).percent
        };
        if (data.options) this.options = (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)({}, data.options);
    }
}


var $2fe84892dd82177e$export$73c2705cb2da08ab;
(function(ResponsiveMode) {
    ResponsiveMode["screen"] = "screen";
    ResponsiveMode["canvas"] = "canvas";
})($2fe84892dd82177e$export$73c2705cb2da08ab || ($2fe84892dd82177e$export$73c2705cb2da08ab = {}));



class $a46333df372819ed$export$49b67f1c7ac91d9b {
    constructor(){
        this.maxWidth = Infinity;
        this.options = {};
        this.mode = (0, $2fe84892dd82177e$export$73c2705cb2da08ab).canvas;
    }
    load(data) {
        if (!data) return;
        if (data.maxWidth !== undefined) this.maxWidth = data.maxWidth;
        if (data.mode !== undefined) {
            if (data.mode === (0, $2fe84892dd82177e$export$73c2705cb2da08ab).screen) this.mode = (0, $2fe84892dd82177e$export$73c2705cb2da08ab).screen;
            else this.mode = (0, $2fe84892dd82177e$export$73c2705cb2da08ab).canvas;
        }
        if (data.options !== undefined) this.options = (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)({}, data.options);
    }
}



var $f3af37c83b18f871$export$cd01a11ba097c64c;
(function(ThemeMode) {
    ThemeMode["any"] = "any";
    ThemeMode["dark"] = "dark";
    ThemeMode["light"] = "light";
})($f3af37c83b18f871$export$cd01a11ba097c64c || ($f3af37c83b18f871$export$cd01a11ba097c64c = {}));


class $9455b9619034873e$export$4bc81bcab6354024 {
    constructor(){
        this.auto = false;
        this.mode = (0, $f3af37c83b18f871$export$cd01a11ba097c64c).any;
        this.value = false;
    }
    load(data) {
        if (!data) return;
        if (data.auto !== undefined) this.auto = data.auto;
        if (data.mode !== undefined) this.mode = data.mode;
        if (data.value !== undefined) this.value = data.value;
    }
}



class $9f71ce2859793e3f$export$14faa19a0f3bbeb2 {
    constructor(){
        this.name = "";
        this.default = new (0, $9455b9619034873e$export$4bc81bcab6354024)();
    }
    load(data) {
        if (!data) return;
        if (data.name !== undefined) this.name = data.name;
        this.default.load(data.default);
        if (data.options !== undefined) this.options = (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)({}, data.options);
    }
}









class $2919e8e0f12c2264$export$e293c31e7176ae39 {
    constructor(){
        this.count = 0;
        this.enable = false;
        this.speed = 1;
        this.decay = 0;
        this.delay = 0;
        this.sync = false;
    }
    load(data) {
        if (!data) return;
        if (data.count !== undefined) this.count = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.count);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.speed !== undefined) this.speed = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.speed);
        if (data.decay !== undefined) this.decay = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.decay);
        if (data.delay !== undefined) this.delay = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.delay);
        if (data.sync !== undefined) this.sync = data.sync;
    }
}
class $2919e8e0f12c2264$export$664e182a9c83d6f5 extends $2919e8e0f12c2264$export$e293c31e7176ae39 {
    constructor(){
        super();
        this.mode = (0, $f2542365babf2329$export$6bf57c7f0219f07d).auto;
        this.startValue = (0, $2cd6de34519be269$export$5385b9a82993d2c8).random;
    }
    load(data) {
        super.load(data);
        if (!data) return;
        if (data.mode !== undefined) this.mode = data.mode;
        if (data.startValue !== undefined) this.startValue = data.startValue;
    }
}



class $58b73d0e00f24dec$export$3cc8aa7a0c621de0 extends (0, $2919e8e0f12c2264$export$e293c31e7176ae39) {
    constructor(){
        super();
        this.offset = 0;
        this.sync = true;
    }
    load(data) {
        super.load(data);
        if (!data) return;
        if (data.offset !== undefined) this.offset = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.offset);
    }
}


class $f683733ef557ea79$export$b4c56f18acc5f2f4 {
    constructor(){
        this.h = new (0, $58b73d0e00f24dec$export$3cc8aa7a0c621de0)();
        this.s = new (0, $58b73d0e00f24dec$export$3cc8aa7a0c621de0)();
        this.l = new (0, $58b73d0e00f24dec$export$3cc8aa7a0c621de0)();
    }
    load(data) {
        if (!data) return;
        this.h.load(data.h);
        this.s.load(data.s);
        this.l.load(data.l);
    }
}



class $c2c78a2702851717$export$6f79b6ff75533155 extends (0, $c86524210cdfad1b$export$c2b08aa25660fcaa) {
    constructor(){
        super();
        this.animation = new (0, $f683733ef557ea79$export$b4c56f18acc5f2f4)();
    }
    static create(source, data) {
        const color = new $c2c78a2702851717$export$6f79b6ff75533155();
        color.load(source);
        if (data !== undefined) {
            if ((0, $ad25b6e319f6df8c$export$844ec244b1367d54)(data) || (0, $ad25b6e319f6df8c$export$43bee75e5e14138e)(data)) color.load({
                value: data
            });
            else color.load(data);
        }
        return color;
    }
    load(data) {
        super.load(data);
        if (!data) return;
        const colorAnimation = data.animation;
        if (colorAnimation !== undefined) {
            if (colorAnimation.enable !== undefined) this.animation.h.load(colorAnimation);
            else this.animation.load(data.animation);
        }
    }
}


var $7e6ea8d40d0c807d$export$c17cb29bf4746ec8;
(function(CollisionMode) {
    CollisionMode["absorb"] = "absorb";
    CollisionMode["bounce"] = "bounce";
    CollisionMode["destroy"] = "destroy";
})($7e6ea8d40d0c807d$export$c17cb29bf4746ec8 || ($7e6ea8d40d0c807d$export$c17cb29bf4746ec8 = {}));


class $42210af27222f08c$export$dbafb70800ee3f9b {
    constructor(){
        this.speed = 2;
    }
    load(data) {
        if (!data) return;
        if (data.speed !== undefined) this.speed = data.speed;
    }
}


class $cdc143e455a2855b$export$7dac291125fc16da {
    constructor(){
        this.enable = true;
        this.retries = 0;
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.retries !== undefined) this.retries = data.retries;
    }
}




class $49613bee1189cd15$export$2f74c042fca0b66d {
    constructor(){
        this.value = 0;
    }
    load(data) {
        if (!data) return;
        if (data.value !== undefined) this.value = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.value);
    }
}
class $49613bee1189cd15$export$a0fda83b6e14e586 extends $49613bee1189cd15$export$2f74c042fca0b66d {
    constructor(){
        super();
        this.animation = new (0, $2919e8e0f12c2264$export$e293c31e7176ae39)();
    }
    load(data) {
        super.load(data);
        if (!data) return;
        const animation = data.animation;
        if (animation !== undefined) this.animation.load(animation);
    }
}
class $49613bee1189cd15$export$8d0da1142c209427 extends $49613bee1189cd15$export$a0fda83b6e14e586 {
    constructor(){
        super();
        this.animation = new (0, $2919e8e0f12c2264$export$664e182a9c83d6f5)();
    }
    load(data) {
        super.load(data);
    }
}


class $80e2891de2c8db04$export$855823db9a0085c extends (0, $49613bee1189cd15$export$2f74c042fca0b66d) {
    constructor(){
        super();
        this.value = 1;
    }
}


class $76f76518b2080906$export$e6dd54c89cd6ac88 {
    constructor(){
        this.horizontal = new (0, $80e2891de2c8db04$export$855823db9a0085c)();
        this.vertical = new (0, $80e2891de2c8db04$export$855823db9a0085c)();
    }
    load(data) {
        if (!data) return;
        this.horizontal.load(data.horizontal);
        this.vertical.load(data.vertical);
    }
}



class $aa7c1a03fcad9e14$export$97ff58b0eb9a5ed0 {
    constructor(){
        this.absorb = new (0, $42210af27222f08c$export$dbafb70800ee3f9b)();
        this.bounce = new (0, $76f76518b2080906$export$e6dd54c89cd6ac88)();
        this.enable = false;
        this.maxSpeed = 50;
        this.mode = (0, $7e6ea8d40d0c807d$export$c17cb29bf4746ec8).bounce;
        this.overlap = new (0, $cdc143e455a2855b$export$7dac291125fc16da)();
    }
    load(data) {
        if (!data) return;
        this.absorb.load(data.absorb);
        this.bounce.load(data.bounce);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.maxSpeed !== undefined) this.maxSpeed = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.maxSpeed);
        if (data.mode !== undefined) this.mode = data.mode;
        this.overlap.load(data.overlap);
    }
}



class $a30c4054bd0e8ebe$export$a32b0b1c1ac59d04 {
    constructor(){
        this.close = true;
        this.fill = true;
        this.options = {};
        this.type = [];
    }
    load(data) {
        if (!data) return;
        const options = data.options;
        if (options !== undefined) for(const effect in options){
            const item = options[effect];
            if (item) this.options[effect] = (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)(this.options[effect] ?? {}, item);
        }
        if (data.close !== undefined) this.close = data.close;
        if (data.fill !== undefined) this.fill = data.fill;
        if (data.type !== undefined) this.type = data.type;
    }
}





class $d4b32efe30ad19f1$export$128f6c8d329dc399 {
    constructor(){
        this.offset = 0;
        this.value = 90;
    }
    load(data) {
        if (!data) return;
        if (data.offset !== undefined) this.offset = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.offset);
        if (data.value !== undefined) this.value = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.value);
    }
}



class $85b98824567a8d3c$export$6c54633883102b4b {
    constructor(){
        this.distance = 200;
        this.enable = false;
        this.rotate = {
            x: 3000,
            y: 3000
        };
    }
    load(data) {
        if (!data) return;
        if (data.distance !== undefined) this.distance = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.distance);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.rotate) {
            const rotateX = data.rotate.x;
            if (rotateX !== undefined) this.rotate.x = rotateX;
            const rotateY = data.rotate.y;
            if (rotateY !== undefined) this.rotate.y = rotateY;
        }
    }
}



class $7f7d42875f4617b5$export$7b60622f06eeec06 {
    constructor(){
        this.x = 50;
        this.y = 50;
        this.mode = (0, $990956d8c795e3d5$export$1009f0178778a981).percent;
        this.radius = 0;
    }
    load(data) {
        if (!data) return;
        if (data.x !== undefined) this.x = data.x;
        if (data.y !== undefined) this.y = data.y;
        if (data.mode !== undefined) this.mode = data.mode;
        if (data.radius !== undefined) this.radius = data.radius;
    }
}



class $f436a50e2bfce959$export$c6d1f1b3593b164c {
    constructor(){
        this.acceleration = 9.81;
        this.enable = false;
        this.inverse = false;
        this.maxSpeed = 50;
    }
    load(data) {
        if (!data) return;
        if (data.acceleration !== undefined) this.acceleration = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.acceleration);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.inverse !== undefined) this.inverse = data.inverse;
        if (data.maxSpeed !== undefined) this.maxSpeed = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.maxSpeed);
    }
}




class $344516ec179f1add$export$bcc70636a6a97e73 {
    constructor(){
        this.clamp = true;
        this.delay = new (0, $49613bee1189cd15$export$2f74c042fca0b66d)();
        this.enable = false;
        this.options = {};
    }
    load(data) {
        if (!data) return;
        if (data.clamp !== undefined) this.clamp = data.clamp;
        this.delay.load(data.delay);
        if (data.enable !== undefined) this.enable = data.enable;
        this.generator = data.generator;
        if (data.options) this.options = (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)(this.options, data.options);
    }
}



class $f96369e9e62218ce$export$7518c5bd39f0f31a {
    load(data) {
        if (!data) return;
        if (data.color !== undefined) this.color = (0, $c86524210cdfad1b$export$c2b08aa25660fcaa).create(this.color, data.color);
        if (data.image !== undefined) this.image = data.image;
    }
}


class $30d518dcf5f66307$export$e428bb3fcf53809d {
    constructor(){
        this.enable = false;
        this.length = 10;
        this.fill = new (0, $f96369e9e62218ce$export$7518c5bd39f0f31a)();
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.fill !== undefined) this.fill.load(data.fill);
        if (data.length !== undefined) this.length = data.length;
    }
}


var $ad0d94f2e36d5a6b$export$cf5942d9a76b7ae2;
(function(OutMode) {
    OutMode["bounce"] = "bounce";
    OutMode["none"] = "none";
    OutMode["out"] = "out";
    OutMode["destroy"] = "destroy";
    OutMode["split"] = "split";
})($ad0d94f2e36d5a6b$export$cf5942d9a76b7ae2 || ($ad0d94f2e36d5a6b$export$cf5942d9a76b7ae2 = {}));


class $b38fae9fca7feb68$export$647cf31ffff2d3 {
    constructor(){
        this.default = (0, $ad0d94f2e36d5a6b$export$cf5942d9a76b7ae2).out;
    }
    load(data) {
        if (!data) return;
        if (data.default !== undefined) this.default = data.default;
        this.bottom = data.bottom ?? data.default;
        this.left = data.left ?? data.default;
        this.right = data.right ?? data.default;
        this.top = data.top ?? data.default;
    }
}




class $288905bbf9d4c7e1$export$fcd783eeafc305c0 {
    constructor(){
        this.acceleration = 0;
        this.enable = false;
    }
    load(data) {
        if (!data) return;
        if (data.acceleration !== undefined) this.acceleration = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.acceleration);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.position) this.position = (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)({}, data.position);
    }
}



class $a0a6bf29d9488107$export$e49a5ad3dd6df925 {
    constructor(){
        this.angle = new (0, $d4b32efe30ad19f1$export$128f6c8d329dc399)();
        this.attract = new (0, $85b98824567a8d3c$export$6c54633883102b4b)();
        this.center = new (0, $7f7d42875f4617b5$export$7b60622f06eeec06)();
        this.decay = 0;
        this.distance = {};
        this.direction = (0, $aeeeb4a954ef988f$export$cc1a246adca07dd4).none;
        this.drift = 0;
        this.enable = false;
        this.gravity = new (0, $f436a50e2bfce959$export$c6d1f1b3593b164c)();
        this.path = new (0, $344516ec179f1add$export$bcc70636a6a97e73)();
        this.outModes = new (0, $b38fae9fca7feb68$export$647cf31ffff2d3)();
        this.random = false;
        this.size = false;
        this.speed = 2;
        this.spin = new (0, $288905bbf9d4c7e1$export$fcd783eeafc305c0)();
        this.straight = false;
        this.trail = new (0, $30d518dcf5f66307$export$e428bb3fcf53809d)();
        this.vibrate = false;
        this.warp = false;
    }
    load(data) {
        if (!data) return;
        this.angle.load((0, $ad25b6e319f6df8c$export$7e4aa119212bc614)(data.angle) ? {
            value: data.angle
        } : data.angle);
        this.attract.load(data.attract);
        this.center.load(data.center);
        if (data.decay !== undefined) this.decay = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.decay);
        if (data.direction !== undefined) this.direction = data.direction;
        if (data.distance !== undefined) this.distance = (0, $ad25b6e319f6df8c$export$7e4aa119212bc614)(data.distance) ? {
            horizontal: data.distance,
            vertical: data.distance
        } : {
            ...data.distance
        };
        if (data.drift !== undefined) this.drift = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.drift);
        if (data.enable !== undefined) this.enable = data.enable;
        this.gravity.load(data.gravity);
        const outModes = data.outModes;
        if (outModes !== undefined) {
            if ((0, $ad25b6e319f6df8c$export$a6cdc56e425d0d0a)(outModes)) this.outModes.load(outModes);
            else this.outModes.load({
                default: outModes
            });
        }
        this.path.load(data.path);
        if (data.random !== undefined) this.random = data.random;
        if (data.size !== undefined) this.size = data.size;
        if (data.speed !== undefined) this.speed = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.speed);
        this.spin.load(data.spin);
        if (data.straight !== undefined) this.straight = data.straight;
        this.trail.load(data.trail);
        if (data.vibrate !== undefined) this.vibrate = data.vibrate;
        if (data.warp !== undefined) this.warp = data.warp;
    }
}




class $ecec8b2576e74ee1$export$3e55dc49e2356209 extends (0, $2919e8e0f12c2264$export$664e182a9c83d6f5) {
    constructor(){
        super();
        this.destroy = (0, $a06b3f24e43fa14b$export$41a461248611663e).none;
        this.speed = 2;
    }
    load(data) {
        super.load(data);
        if (!data) return;
        if (data.destroy !== undefined) this.destroy = data.destroy;
    }
}



class $026721b5c60fb689$export$588760baa0f6108e extends (0, $49613bee1189cd15$export$8d0da1142c209427) {
    constructor(){
        super();
        this.animation = new (0, $ecec8b2576e74ee1$export$3e55dc49e2356209)();
        this.value = 1;
    }
    load(data) {
        if (!data) return;
        super.load(data);
        const animation = data.animation;
        if (animation !== undefined) this.animation.load(animation);
    }
}



class $8cbf2b3ff8e3b4a0$export$c11b1f56b7022ac8 {
    constructor(){
        this.enable = false;
        this.width = 1920;
        this.height = 1080;
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        const width = data.width;
        if (width !== undefined) this.width = width;
        const height = data.height;
        if (height !== undefined) this.height = height;
    }
}


var $a1674025ad2d29dc$export$e9c6a0495dc4055f;
(function(LimitMode) {
    LimitMode["delete"] = "delete";
    LimitMode["wait"] = "wait";
})($a1674025ad2d29dc$export$e9c6a0495dc4055f || ($a1674025ad2d29dc$export$e9c6a0495dc4055f = {}));


class $1eab7e48116685b6$export$924e931bcf950072 {
    constructor(){
        this.mode = (0, $a1674025ad2d29dc$export$e9c6a0495dc4055f).delete;
        this.value = 0;
    }
    load(data) {
        if (!data) return;
        if (data.mode !== undefined) this.mode = data.mode;
        if (data.value !== undefined) this.value = data.value;
    }
}


class $7849f93427dd891d$export$2335cf7e85f36cfd {
    constructor(){
        this.density = new (0, $8cbf2b3ff8e3b4a0$export$c11b1f56b7022ac8)();
        this.limit = new (0, $1eab7e48116685b6$export$924e931bcf950072)();
        this.value = 0;
    }
    load(data) {
        if (!data) return;
        this.density.load(data.density);
        this.limit.load(data.limit);
        if (data.value !== undefined) this.value = data.value;
    }
}



class $9c9dbac1b216d4d2$export$a24c14443968327c {
    constructor(){
        this.blur = 0;
        this.color = new (0, $c86524210cdfad1b$export$c2b08aa25660fcaa)();
        this.enable = false;
        this.offset = {
            x: 0,
            y: 0
        };
        this.color.value = "#000";
    }
    load(data) {
        if (!data) return;
        if (data.blur !== undefined) this.blur = data.blur;
        this.color = (0, $c86524210cdfad1b$export$c2b08aa25660fcaa).create(this.color, data.color);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.offset === undefined) return;
        if (data.offset.x !== undefined) this.offset.x = data.offset.x;
        if (data.offset.y !== undefined) this.offset.y = data.offset.y;
    }
}



class $8fb0ae79e0074022$export$6428a7f2611ef1fa {
    constructor(){
        this.close = true;
        this.fill = true;
        this.options = {};
        this.type = "circle";
    }
    load(data) {
        if (!data) return;
        const options = data.options;
        if (options !== undefined) for(const shape in options){
            const item = options[shape];
            if (item) this.options[shape] = (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)(this.options[shape] ?? {}, item);
        }
        if (data.close !== undefined) this.close = data.close;
        if (data.fill !== undefined) this.fill = data.fill;
        if (data.type !== undefined) this.type = data.type;
    }
}





class $6ef49f7e1c8978dc$export$231e08f1693c0669 extends (0, $2919e8e0f12c2264$export$664e182a9c83d6f5) {
    constructor(){
        super();
        this.destroy = (0, $a06b3f24e43fa14b$export$41a461248611663e).none;
        this.speed = 5;
    }
    load(data) {
        super.load(data);
        if (!data) return;
        if (data.destroy !== undefined) this.destroy = data.destroy;
    }
}


class $d6a16b4f80aca984$export$cb6da89c6af1a8ec extends (0, $49613bee1189cd15$export$8d0da1142c209427) {
    constructor(){
        super();
        this.animation = new (0, $6ef49f7e1c8978dc$export$231e08f1693c0669)();
        this.value = 3;
    }
    load(data) {
        super.load(data);
        if (!data) return;
        const animation = data.animation;
        if (animation !== undefined) this.animation.load(animation);
    }
}




class $f81df836cecf904c$export$18d19c7a3aa33064 {
    constructor(){
        this.width = 0;
    }
    load(data) {
        if (!data) return;
        if (data.color !== undefined) this.color = (0, $c2c78a2702851717$export$6f79b6ff75533155).create(this.color, data.color);
        if (data.width !== undefined) this.width = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.width);
        if (data.opacity !== undefined) this.opacity = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.opacity);
    }
}



class $583db5886c204b9d$export$ccb31788083e2069 extends (0, $49613bee1189cd15$export$2f74c042fca0b66d) {
    constructor(){
        super();
        this.opacityRate = 1;
        this.sizeRate = 1;
        this.velocityRate = 1;
    }
    load(data) {
        super.load(data);
        if (!data) return;
        if (data.opacityRate !== undefined) this.opacityRate = data.opacityRate;
        if (data.sizeRate !== undefined) this.sizeRate = data.sizeRate;
        if (data.velocityRate !== undefined) this.velocityRate = data.velocityRate;
    }
}


class $ca54624c8c31430c$export$b4f1619131f0bce9 {
    constructor(engine, container){
        this._engine = engine;
        this._container = container;
        this.bounce = new (0, $76f76518b2080906$export$e6dd54c89cd6ac88)();
        this.collisions = new (0, $aa7c1a03fcad9e14$export$97ff58b0eb9a5ed0)();
        this.color = new (0, $c2c78a2702851717$export$6f79b6ff75533155)();
        this.color.value = "#fff";
        this.effect = new (0, $a30c4054bd0e8ebe$export$a32b0b1c1ac59d04)();
        this.groups = {};
        this.move = new (0, $a0a6bf29d9488107$export$e49a5ad3dd6df925)();
        this.number = new (0, $7849f93427dd891d$export$2335cf7e85f36cfd)();
        this.opacity = new (0, $026721b5c60fb689$export$588760baa0f6108e)();
        this.reduceDuplicates = false;
        this.shadow = new (0, $9c9dbac1b216d4d2$export$a24c14443968327c)();
        this.shape = new (0, $8fb0ae79e0074022$export$6428a7f2611ef1fa)();
        this.size = new (0, $d6a16b4f80aca984$export$cb6da89c6af1a8ec)();
        this.stroke = new (0, $f81df836cecf904c$export$18d19c7a3aa33064)();
        this.zIndex = new (0, $583db5886c204b9d$export$ccb31788083e2069)();
    }
    load(data) {
        if (!data) return;
        if (data.groups !== undefined) for (const group of Object.keys(data.groups)){
            if (!Object.hasOwn(data.groups, group)) continue;
            const item = data.groups[group];
            if (item !== undefined) this.groups[group] = (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)(this.groups[group] ?? {}, item);
        }
        if (data.reduceDuplicates !== undefined) this.reduceDuplicates = data.reduceDuplicates;
        this.bounce.load(data.bounce);
        this.color.load((0, $c2c78a2702851717$export$6f79b6ff75533155).create(this.color, data.color));
        this.effect.load(data.effect);
        this.move.load(data.move);
        this.number.load(data.number);
        this.opacity.load(data.opacity);
        this.shape.load(data.shape);
        this.size.load(data.size);
        this.shadow.load(data.shadow);
        this.zIndex.load(data.zIndex);
        this.collisions.load(data.collisions);
        if (data.interactivity !== undefined) this.interactivity = (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)({}, data.interactivity);
        const strokeToLoad = data.stroke;
        if (strokeToLoad) this.stroke = (0, $eee2fa4b9ebe63e9$export$8e5dc47097396754)(strokeToLoad, (t)=>{
            const tmp = new (0, $f81df836cecf904c$export$18d19c7a3aa33064)();
            tmp.load(t);
            return tmp;
        });
        if (this._container) {
            const updaters = this._engine.updaters.get(this._container);
            if (updaters) {
                for (const updater of updaters)if (updater.loadOptions) updater.loadOptions(this, data);
            }
            const interactors = this._engine.interactors.get(this._container);
            if (interactors) {
                for (const interactor of interactors)if (interactor.loadParticlesOptions) interactor.loadParticlesOptions(this, data);
            }
        }
    }
}


function $8d5b97c98fc610d5$export$cad72087bded938(options, ...sourceOptionsArr) {
    for (const sourceOptions of sourceOptionsArr)options.load(sourceOptions);
}
function $8d5b97c98fc610d5$export$3e14721506027822(engine, container, ...sourceOptionsArr) {
    const options = new (0, $ca54624c8c31430c$export$b4f1619131f0bce9)(engine, container);
    $8d5b97c98fc610d5$export$cad72087bded938(options, ...sourceOptionsArr);
    return options;
}



class $fa3bed5b1d8ccc9b$export$c019608e5b5bb4cb {
    constructor(engine, container){
        this._findDefaultTheme = (mode)=>{
            return this.themes.find((theme)=>theme.default.value && theme.default.mode === mode) ?? this.themes.find((theme)=>theme.default.value && theme.default.mode === (0, $f3af37c83b18f871$export$cd01a11ba097c64c).any);
        };
        this._importPreset = (preset)=>{
            this.load(this._engine.getPreset(preset));
        };
        this._engine = engine;
        this._container = container;
        this.autoPlay = true;
        this.background = new (0, $fb28bcba41ca7c48$export$668799e4797757a8)();
        this.backgroundMask = new (0, $39ed4c62a4877755$export$36a2fa1e47ffeebc)();
        this.clear = true;
        this.defaultThemes = {};
        this.delay = 0;
        this.fullScreen = new (0, $996bf9fcd377de50$export$f885b95b3f0be76d)();
        this.detectRetina = true;
        this.duration = 0;
        this.fpsLimit = 120;
        this.interactivity = new (0, $3fad4b788c088c43$export$865458a3ba269c4a)(engine, container);
        this.manualParticles = [];
        this.particles = (0, $8d5b97c98fc610d5$export$3e14721506027822)(this._engine, this._container);
        this.pauseOnBlur = true;
        this.pauseOnOutsideViewport = true;
        this.responsive = [];
        this.smooth = false;
        this.style = {};
        this.themes = [];
        this.zLayers = 100;
    }
    load(data) {
        if (!data) return;
        if (data.preset !== undefined) (0, $eee2fa4b9ebe63e9$export$8e5dc47097396754)(data.preset, (preset)=>this._importPreset(preset));
        if (data.autoPlay !== undefined) this.autoPlay = data.autoPlay;
        if (data.clear !== undefined) this.clear = data.clear;
        if (data.key !== undefined) this.key = data.key;
        if (data.name !== undefined) this.name = data.name;
        if (data.delay !== undefined) this.delay = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.delay);
        const detectRetina = data.detectRetina;
        if (detectRetina !== undefined) this.detectRetina = detectRetina;
        if (data.duration !== undefined) this.duration = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.duration);
        const fpsLimit = data.fpsLimit;
        if (fpsLimit !== undefined) this.fpsLimit = fpsLimit;
        if (data.pauseOnBlur !== undefined) this.pauseOnBlur = data.pauseOnBlur;
        if (data.pauseOnOutsideViewport !== undefined) this.pauseOnOutsideViewport = data.pauseOnOutsideViewport;
        if (data.zLayers !== undefined) this.zLayers = data.zLayers;
        this.background.load(data.background);
        const fullScreen = data.fullScreen;
        if ((0, $ad25b6e319f6df8c$export$f9ce7b637dfbe238)(fullScreen)) this.fullScreen.enable = fullScreen;
        else this.fullScreen.load(fullScreen);
        this.backgroundMask.load(data.backgroundMask);
        this.interactivity.load(data.interactivity);
        if (data.manualParticles) this.manualParticles = data.manualParticles.map((t)=>{
            const tmp = new (0, $bd26b66259d07932$export$4f41a3ab9fa8cdf)();
            tmp.load(t);
            return tmp;
        });
        this.particles.load(data.particles);
        this.style = (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)(this.style, data.style);
        this._engine.loadOptions(this, data);
        if (data.smooth !== undefined) this.smooth = data.smooth;
        const interactors = this._engine.interactors.get(this._container);
        if (interactors) {
            for (const interactor of interactors)if (interactor.loadOptions) interactor.loadOptions(this, data);
        }
        if (data.responsive !== undefined) for (const responsive of data.responsive){
            const optResponsive = new (0, $a46333df372819ed$export$49b67f1c7ac91d9b)();
            optResponsive.load(responsive);
            this.responsive.push(optResponsive);
        }
        this.responsive.sort((a, b)=>a.maxWidth - b.maxWidth);
        if (data.themes !== undefined) for (const theme of data.themes){
            const existingTheme = this.themes.find((t)=>t.name === theme.name);
            if (!existingTheme) {
                const optTheme = new (0, $9f71ce2859793e3f$export$14faa19a0f3bbeb2)();
                optTheme.load(theme);
                this.themes.push(optTheme);
            } else existingTheme.load(theme);
        }
        this.defaultThemes.dark = this._findDefaultTheme((0, $f3af37c83b18f871$export$cd01a11ba097c64c).dark)?.name;
        this.defaultThemes.light = this._findDefaultTheme((0, $f3af37c83b18f871$export$cd01a11ba097c64c).light)?.name;
    }
    setResponsive(width, pxRatio, defaultOptions) {
        this.load(defaultOptions);
        const responsiveOptions = this.responsive.find((t)=>t.mode === (0, $2fe84892dd82177e$export$73c2705cb2da08ab).screen && screen ? t.maxWidth > screen.availWidth : t.maxWidth * pxRatio > width);
        this.load(responsiveOptions?.options);
        return responsiveOptions?.maxWidth;
    }
    setTheme(name) {
        if (name) {
            const chosenTheme = this.themes.find((theme)=>theme.name === name);
            if (chosenTheme) this.load(chosenTheme.options);
        } else {
            const mediaMatch = (0, $eee2fa4b9ebe63e9$export$db32b9574e21e00f)("(prefers-color-scheme: dark)"), clientDarkMode = mediaMatch?.matches, defaultTheme = this._findDefaultTheme(clientDarkMode ? (0, $f3af37c83b18f871$export$cd01a11ba097c64c).dark : (0, $f3af37c83b18f871$export$cd01a11ba097c64c).light);
            if (defaultTheme) this.load(defaultTheme.options);
        }
    }
}




var $73499053c45d5742$export$143a800d561d28fd;
(function(InteractorType) {
    InteractorType["external"] = "external";
    InteractorType["particles"] = "particles";
})($73499053c45d5742$export$143a800d561d28fd || ($73499053c45d5742$export$143a800d561d28fd = {}));


class $233d85ef46282a82$export$aaa80641d584351c {
    constructor(engine, container){
        this.container = container;
        this._engine = engine;
        this._interactors = [];
        this._externalInteractors = [];
        this._particleInteractors = [];
    }
    externalInteract(delta) {
        for (const interactor of this._externalInteractors)if (interactor.isEnabled()) interactor.interact(delta);
    }
    handleClickMode(mode) {
        for (const interactor of this._externalInteractors)interactor.handleClickMode?.(mode);
    }
    async init() {
        this._interactors = await this._engine.getInteractors(this.container, true);
        this._externalInteractors = [];
        this._particleInteractors = [];
        for (const interactor of this._interactors){
            switch(interactor.type){
                case (0, $73499053c45d5742$export$143a800d561d28fd).external:
                    this._externalInteractors.push(interactor);
                    break;
                case (0, $73499053c45d5742$export$143a800d561d28fd).particles:
                    this._particleInteractors.push(interactor);
                    break;
            }
            interactor.init();
        }
    }
    particlesInteract(particle, delta) {
        for (const interactor of this._externalInteractors)interactor.clear(particle, delta);
        for (const interactor of this._particleInteractors)if (interactor.isEnabled(particle)) interactor.interact(particle, delta);
    }
    reset(particle) {
        for (const interactor of this._externalInteractors)if (interactor.isEnabled()) interactor.reset(particle);
        for (const interactor of this._particleInteractors)if (interactor.isEnabled(particle)) interactor.reset(particle);
    }
}












var $28f49626d03d72c4$export$2e559b10bdb6bb80;
(function(ParticleOutType) {
    ParticleOutType["normal"] = "normal";
    ParticleOutType["inside"] = "inside";
    ParticleOutType["outside"] = "outside";
})($28f49626d03d72c4$export$2e559b10bdb6bb80 || ($28f49626d03d72c4$export$2e559b10bdb6bb80 = {}));





const $32eee928183e8487$var$defaultRetryCount = 0, $32eee928183e8487$var$double = 2, $32eee928183e8487$var$half = 0.5, $32eee928183e8487$var$squareExp = 2, $32eee928183e8487$var$randomString = "random";
function $32eee928183e8487$var$loadEffectData(effect, effectOptions, id, reduceDuplicates) {
    const effectData = effectOptions.options[effect];
    if (!effectData) return;
    return (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)({
        close: effectOptions.close,
        fill: effectOptions.fill
    }, (0, $eee2fa4b9ebe63e9$export$3fbf39566d3ee62e)(effectData, id, reduceDuplicates));
}
function $32eee928183e8487$var$loadShapeData(shape, shapeOptions, id, reduceDuplicates) {
    const shapeData = shapeOptions.options[shape];
    if (!shapeData) return;
    return (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)({
        close: shapeOptions.close,
        fill: shapeOptions.fill
    }, (0, $eee2fa4b9ebe63e9$export$3fbf39566d3ee62e)(shapeData, id, reduceDuplicates));
}
function $32eee928183e8487$var$fixOutMode(data) {
    if (!(0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)(data.outMode, data.checkModes)) return;
    const diameter = data.radius * $32eee928183e8487$var$double;
    if (data.coord > data.maxCoord - diameter) data.setCb(-data.radius);
    else if (data.coord < diameter) data.setCb(data.radius);
}
class $32eee928183e8487$export$c36c68baa13912a5 {
    constructor(engine, container){
        this.container = container;
        this._calcPosition = (container, position, zIndex, tryCount = $32eee928183e8487$var$defaultRetryCount)=>{
            for (const [, plugin] of container.plugins){
                const pluginPos = plugin.particlePosition !== undefined ? plugin.particlePosition(position, this) : undefined;
                if (pluginPos) return (0, $04697537ec8dce5b$export$ece015703618ce3d).create(pluginPos.x, pluginPos.y, zIndex);
            }
            const canvasSize = container.canvas.size, exactPosition = (0, $1ff4dfb77b7bb646$export$a3c87c98a736c457)({
                size: canvasSize,
                position: position
            }), pos = (0, $04697537ec8dce5b$export$ece015703618ce3d).create(exactPosition.x, exactPosition.y, zIndex), radius = this.getRadius(), outModes = this.options.move.outModes, fixHorizontal = (outMode)=>{
                $32eee928183e8487$var$fixOutMode({
                    outMode: outMode,
                    checkModes: [
                        (0, $ad0d94f2e36d5a6b$export$cf5942d9a76b7ae2).bounce
                    ],
                    coord: pos.x,
                    maxCoord: container.canvas.size.width,
                    setCb: (value)=>pos.x += value,
                    radius: radius
                });
            }, fixVertical = (outMode)=>{
                $32eee928183e8487$var$fixOutMode({
                    outMode: outMode,
                    checkModes: [
                        (0, $ad0d94f2e36d5a6b$export$cf5942d9a76b7ae2).bounce
                    ],
                    coord: pos.y,
                    maxCoord: container.canvas.size.height,
                    setCb: (value)=>pos.y += value,
                    radius: radius
                });
            };
            fixHorizontal(outModes.left ?? outModes.default);
            fixHorizontal(outModes.right ?? outModes.default);
            fixVertical(outModes.top ?? outModes.default);
            fixVertical(outModes.bottom ?? outModes.default);
            if (this._checkOverlap(pos, tryCount)) {
                const increment = 1;
                return this._calcPosition(container, undefined, zIndex, tryCount + increment);
            }
            return pos;
        };
        this._calculateVelocity = ()=>{
            const baseVelocity = (0, $1ff4dfb77b7bb646$export$cce6f12debc4024a)(this.direction), res = baseVelocity.copy(), moveOptions = this.options.move;
            if (moveOptions.direction === (0, $aeeeb4a954ef988f$export$cc1a246adca07dd4).inside || moveOptions.direction === (0, $aeeeb4a954ef988f$export$cc1a246adca07dd4).outside) return res;
            const rad = (0, $1ff4dfb77b7bb646$export$e6bfdeff8bfc94f9)((0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(moveOptions.angle.value)), radOffset = (0, $1ff4dfb77b7bb646$export$e6bfdeff8bfc94f9)((0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(moveOptions.angle.offset)), range = {
                left: radOffset - rad * $32eee928183e8487$var$half,
                right: radOffset + rad * $32eee928183e8487$var$half
            };
            if (!moveOptions.straight) res.angle += (0, $1ff4dfb77b7bb646$export$8b958c8ecd94a804)((0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(range.left, range.right));
            if (moveOptions.random && typeof moveOptions.speed === "number") res.length *= (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)();
            return res;
        };
        this._checkOverlap = (pos, tryCount = $32eee928183e8487$var$defaultRetryCount)=>{
            const collisionsOptions = this.options.collisions, radius = this.getRadius();
            if (!collisionsOptions.enable) return false;
            const overlapOptions = collisionsOptions.overlap;
            if (overlapOptions.enable) return false;
            const retries = overlapOptions.retries, minRetries = 0;
            if (retries >= minRetries && tryCount > retries) throw new Error(`${(0, $dec17af1c054e95f$export$adea4917e02d93dc)} particle is overlapping and can't be placed`);
            return !!this.container.particles.find((particle)=>(0, $1ff4dfb77b7bb646$export$79376507b09a66f)(pos, particle.position) < radius + particle.getRadius());
        };
        this._getRollColor = (color)=>{
            if (!color || !this.roll || !this.backColor && !this.roll.alter) return color;
            const rollFactor = 1, none = 0, backFactor = this.roll.horizontal && this.roll.vertical ? $32eee928183e8487$var$double * rollFactor : rollFactor, backSum = this.roll.horizontal ? Math.PI * $32eee928183e8487$var$half : none, rolled = Math.floor(((this.roll.angle ?? none) + backSum) / (Math.PI / backFactor)) % $32eee928183e8487$var$double;
            if (!rolled) return color;
            if (this.backColor) return this.backColor;
            if (this.roll.alter) return (0, $44906e93848638c3$export$fe1d034b0e82666)(color, this.roll.alter.type, this.roll.alter.value);
            return color;
        };
        this._initPosition = (position)=>{
            const container = this.container, zIndexValue = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(this.options.zIndex.value), minZ = 0;
            this.position = this._calcPosition(container, position, (0, $1ff4dfb77b7bb646$export$7d15b64cf5a3a4c4)(zIndexValue, minZ, container.zLayers));
            this.initialPosition = this.position.copy();
            const canvasSize = container.canvas.size, defaultRadius = 0;
            this.moveCenter = {
                ...(0, $eee2fa4b9ebe63e9$export$1690e12b840569b9)(this.options.move.center, canvasSize),
                radius: this.options.move.center.radius ?? defaultRadius,
                mode: this.options.move.center.mode ?? (0, $990956d8c795e3d5$export$1009f0178778a981).percent
            };
            this.direction = (0, $1ff4dfb77b7bb646$export$2045f76df51d18c4)(this.options.move.direction, this.position, this.moveCenter);
            switch(this.options.move.direction){
                case (0, $aeeeb4a954ef988f$export$cc1a246adca07dd4).inside:
                    this.outType = (0, $28f49626d03d72c4$export$2e559b10bdb6bb80).inside;
                    break;
                case (0, $aeeeb4a954ef988f$export$cc1a246adca07dd4).outside:
                    this.outType = (0, $28f49626d03d72c4$export$2e559b10bdb6bb80).outside;
                    break;
            }
            this.offset = (0, $04697537ec8dce5b$export$9b781de7bf37bf48).origin;
        };
        this._engine = engine;
    }
    destroy(override) {
        if (this.unbreakable || this.destroyed) return;
        this.destroyed = true;
        this.bubble.inRange = false;
        this.slow.inRange = false;
        const container = this.container, pathGenerator = this.pathGenerator, shapeDrawer = container.shapeDrawers.get(this.shape);
        shapeDrawer?.particleDestroy?.(this);
        for (const [, plugin] of container.plugins)plugin.particleDestroyed?.(this, override);
        for (const updater of container.particles.updaters)updater.particleDestroyed?.(this, override);
        pathGenerator?.reset(this);
        this._engine.dispatchEvent((0, $df94476ffe249114$export$3d7865934588d77e).particleDestroyed, {
            container: this.container,
            data: {
                particle: this
            }
        });
    }
    draw(delta) {
        const container = this.container, canvas = container.canvas;
        for (const [, plugin] of container.plugins)canvas.drawParticlePlugin(plugin, this, delta);
        canvas.drawParticle(this, delta);
    }
    getFillColor() {
        return this._getRollColor(this.bubble.color ?? (0, $fd6faa9f4e5410ac$export$c90768c73bc1d7ab)(this.color));
    }
    getMass() {
        return this.getRadius() ** $32eee928183e8487$var$squareExp * Math.PI * $32eee928183e8487$var$half;
    }
    getPosition() {
        return {
            x: this.position.x + this.offset.x,
            y: this.position.y + this.offset.y,
            z: this.position.z
        };
    }
    getRadius() {
        return this.bubble.radius ?? this.size.value;
    }
    getStrokeColor() {
        return this._getRollColor(this.bubble.color ?? (0, $fd6faa9f4e5410ac$export$c90768c73bc1d7ab)(this.strokeColor));
    }
    init(id, position, overrideOptions, group) {
        const container = this.container, engine = this._engine;
        this.id = id;
        this.group = group;
        this.effectClose = true;
        this.effectFill = true;
        this.shapeClose = true;
        this.shapeFill = true;
        this.pathRotation = false;
        this.lastPathTime = 0;
        this.destroyed = false;
        this.unbreakable = false;
        this.isRotating = false;
        this.rotation = 0;
        this.misplaced = false;
        this.retina = {
            maxDistance: {}
        };
        this.outType = (0, $28f49626d03d72c4$export$2e559b10bdb6bb80).normal;
        this.ignoresResizeRatio = true;
        const pxRatio = container.retina.pixelRatio, mainOptions = container.actualOptions, particlesOptions = (0, $8d5b97c98fc610d5$export$3e14721506027822)(this._engine, container, mainOptions.particles), { reduceDuplicates: reduceDuplicates } = particlesOptions, effectType = particlesOptions.effect.type, shapeType = particlesOptions.shape.type;
        this.effect = (0, $eee2fa4b9ebe63e9$export$3fbf39566d3ee62e)(effectType, this.id, reduceDuplicates);
        this.shape = (0, $eee2fa4b9ebe63e9$export$3fbf39566d3ee62e)(shapeType, this.id, reduceDuplicates);
        const effectOptions = particlesOptions.effect, shapeOptions = particlesOptions.shape;
        if (overrideOptions) {
            if (overrideOptions.effect?.type) {
                const overrideEffectType = overrideOptions.effect.type, effect = (0, $eee2fa4b9ebe63e9$export$3fbf39566d3ee62e)(overrideEffectType, this.id, reduceDuplicates);
                if (effect) {
                    this.effect = effect;
                    effectOptions.load(overrideOptions.effect);
                }
            }
            if (overrideOptions.shape?.type) {
                const overrideShapeType = overrideOptions.shape.type, shape = (0, $eee2fa4b9ebe63e9$export$3fbf39566d3ee62e)(overrideShapeType, this.id, reduceDuplicates);
                if (shape) {
                    this.shape = shape;
                    shapeOptions.load(overrideOptions.shape);
                }
            }
        }
        if (this.effect === $32eee928183e8487$var$randomString) {
            const availableEffects = [
                ...this.container.effectDrawers.keys()
            ];
            this.effect = availableEffects[Math.floor(Math.random() * availableEffects.length)];
        }
        if (this.shape === $32eee928183e8487$var$randomString) {
            const availableShapes = [
                ...this.container.shapeDrawers.keys()
            ];
            this.shape = availableShapes[Math.floor(Math.random() * availableShapes.length)];
        }
        this.effectData = $32eee928183e8487$var$loadEffectData(this.effect, effectOptions, this.id, reduceDuplicates);
        this.shapeData = $32eee928183e8487$var$loadShapeData(this.shape, shapeOptions, this.id, reduceDuplicates);
        particlesOptions.load(overrideOptions);
        const effectData = this.effectData;
        if (effectData) particlesOptions.load(effectData.particles);
        const shapeData = this.shapeData;
        if (shapeData) particlesOptions.load(shapeData.particles);
        const interactivity = new (0, $3fad4b788c088c43$export$865458a3ba269c4a)(engine, container);
        interactivity.load(container.actualOptions.interactivity);
        interactivity.load(particlesOptions.interactivity);
        this.interactivity = interactivity;
        this.effectFill = effectData?.fill ?? particlesOptions.effect.fill;
        this.effectClose = effectData?.close ?? particlesOptions.effect.close;
        this.shapeFill = shapeData?.fill ?? particlesOptions.shape.fill;
        this.shapeClose = shapeData?.close ?? particlesOptions.shape.close;
        this.options = particlesOptions;
        const pathOptions = this.options.move.path;
        this.pathDelay = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(pathOptions.delay.value) * (0, $dec17af1c054e95f$export$f64c3bfbc58eec0f);
        if (pathOptions.generator) {
            this.pathGenerator = this._engine.getPathGenerator(pathOptions.generator);
            if (this.pathGenerator && container.addPath(pathOptions.generator, this.pathGenerator)) this.pathGenerator.init(container);
        }
        container.retina.initParticle(this);
        this.size = (0, $eee2fa4b9ebe63e9$export$bebd78259cce4fd)(this.options.size, pxRatio);
        this.bubble = {
            inRange: false
        };
        this.slow = {
            inRange: false,
            factor: 1
        };
        this._initPosition(position);
        this.initialVelocity = this._calculateVelocity();
        this.velocity = this.initialVelocity.copy();
        const decayOffset = 1;
        this.moveDecay = decayOffset - (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(this.options.move.decay);
        const particles = container.particles;
        particles.setLastZIndex(this.position.z);
        this.zIndexFactor = this.position.z / container.zLayers;
        this.sides = 24;
        let effectDrawer = container.effectDrawers.get(this.effect);
        if (!effectDrawer) {
            effectDrawer = this._engine.getEffectDrawer(this.effect);
            if (effectDrawer) container.effectDrawers.set(this.effect, effectDrawer);
        }
        if (effectDrawer?.loadEffect) effectDrawer.loadEffect(this);
        let shapeDrawer = container.shapeDrawers.get(this.shape);
        if (!shapeDrawer) {
            shapeDrawer = this._engine.getShapeDrawer(this.shape);
            if (shapeDrawer) container.shapeDrawers.set(this.shape, shapeDrawer);
        }
        if (shapeDrawer?.loadShape) shapeDrawer.loadShape(this);
        const sideCountFunc = shapeDrawer?.getSidesCount;
        if (sideCountFunc) this.sides = sideCountFunc(this);
        this.spawning = false;
        this.shadowColor = (0, $fd6faa9f4e5410ac$export$fbf0bf3cc1fc0cc4)(this.options.shadow.color);
        for (const updater of particles.updaters)updater.init(this);
        for (const mover of particles.movers)mover.init?.(this);
        effectDrawer?.particleInit?.(container, this);
        shapeDrawer?.particleInit?.(container, this);
        for (const [, plugin] of container.plugins)plugin.particleCreated?.(this);
    }
    isInsideCanvas() {
        const radius = this.getRadius(), canvasSize = this.container.canvas.size, position = this.position;
        return position.x >= -radius && position.y >= -radius && position.y <= canvasSize.height + radius && position.x <= canvasSize.width + radius;
    }
    isVisible() {
        return !this.destroyed && !this.spawning && this.isInsideCanvas();
    }
    reset() {
        for (const updater of this.container.particles.updaters)updater.reset?.(this);
    }
}


class $f9a81b6084ab6fb2$export$baf26146a414f24a {
    constructor(position, particle){
        this.position = position;
        this.particle = particle;
    }
}


var $cc71bac77591a4ca$export$2ede450fbdbb4e4c;
(function(RangeType) {
    RangeType["circle"] = "circle";
    RangeType["rectangle"] = "rectangle";
})($cc71bac77591a4ca$export$2ede450fbdbb4e4c || ($cc71bac77591a4ca$export$2ede450fbdbb4e4c = {}));



const $1c5d1439a937867c$var$squareExp = 2;
class $1c5d1439a937867c$export$f237afe0deab98f9 {
    constructor(x, y, type){
        this.position = {
            x: x,
            y: y
        };
        this.type = type;
    }
}
class $1c5d1439a937867c$export$c89a927ffc67e6fa extends $1c5d1439a937867c$export$f237afe0deab98f9 {
    constructor(x, y, radius){
        super(x, y, (0, $cc71bac77591a4ca$export$2ede450fbdbb4e4c).circle);
        this.radius = radius;
    }
    contains(point) {
        return (0, $1ff4dfb77b7bb646$export$79376507b09a66f)(point, this.position) <= this.radius;
    }
    intersects(range) {
        const pos1 = this.position, pos2 = range.position, distPos = {
            x: Math.abs(pos2.x - pos1.x),
            y: Math.abs(pos2.y - pos1.y)
        }, r = this.radius;
        if (range instanceof $1c5d1439a937867c$export$c89a927ffc67e6fa || range.type === (0, $cc71bac77591a4ca$export$2ede450fbdbb4e4c).circle) {
            const circleRange = range, rSum = r + circleRange.radius, dist = Math.sqrt(distPos.x ** $1c5d1439a937867c$var$squareExp + distPos.y ** $1c5d1439a937867c$var$squareExp);
            return rSum > dist;
        } else if (range instanceof $1c5d1439a937867c$export$4617fb02663045ef || range.type === (0, $cc71bac77591a4ca$export$2ede450fbdbb4e4c).rectangle) {
            const rectRange = range, { width: width, height: height } = rectRange.size, edges = Math.pow(distPos.x - width, $1c5d1439a937867c$var$squareExp) + Math.pow(distPos.y - height, $1c5d1439a937867c$var$squareExp);
            return edges <= r ** $1c5d1439a937867c$var$squareExp || distPos.x <= r + width && distPos.y <= r + height || distPos.x <= width || distPos.y <= height;
        }
        return false;
    }
}
class $1c5d1439a937867c$export$4617fb02663045ef extends $1c5d1439a937867c$export$f237afe0deab98f9 {
    constructor(x, y, width, height){
        super(x, y, (0, $cc71bac77591a4ca$export$2ede450fbdbb4e4c).rectangle);
        this.size = {
            height: height,
            width: width
        };
    }
    contains(point) {
        const w = this.size.width, h = this.size.height, pos = this.position;
        return point.x >= pos.x && point.x <= pos.x + w && point.y >= pos.y && point.y <= pos.y + h;
    }
    intersects(range) {
        if (range instanceof $1c5d1439a937867c$export$c89a927ffc67e6fa) return range.intersects(this);
        const w = this.size.width, h = this.size.height, pos1 = this.position, pos2 = range.position, size2 = range instanceof $1c5d1439a937867c$export$4617fb02663045ef ? range.size : {
            width: 0,
            height: 0
        }, w2 = size2.width, h2 = size2.height;
        return pos2.x < pos1.x + w && pos2.x + w2 > pos1.x && pos2.y < pos1.y + h && pos2.y + h2 > pos1.y;
    }
}



const $64fc54ca2bc4bc2e$var$half = 0.5, $64fc54ca2bc4bc2e$var$double = 2, $64fc54ca2bc4bc2e$var$subdivideCount = 4;
class $64fc54ca2bc4bc2e$export$b82688eb02220411 {
    constructor(rectangle, capacity){
        this.rectangle = rectangle;
        this.capacity = capacity;
        this._subdivide = ()=>{
            const { x: x, y: y } = this.rectangle.position, { width: width, height: height } = this.rectangle.size, { capacity: capacity } = this;
            for(let i = 0; i < $64fc54ca2bc4bc2e$var$subdivideCount; i++){
                const fixedIndex = i % $64fc54ca2bc4bc2e$var$double;
                this._subs.push(new $64fc54ca2bc4bc2e$export$b82688eb02220411(new (0, $1c5d1439a937867c$export$4617fb02663045ef)(x + width * $64fc54ca2bc4bc2e$var$half * fixedIndex, y + height * $64fc54ca2bc4bc2e$var$half * (Math.round(i * $64fc54ca2bc4bc2e$var$half) - fixedIndex), width * $64fc54ca2bc4bc2e$var$half, height * $64fc54ca2bc4bc2e$var$half), capacity));
            }
            this._divided = true;
        };
        this._points = [];
        this._divided = false;
        this._subs = [];
    }
    insert(point) {
        if (!this.rectangle.contains(point.position)) return false;
        if (this._points.length < this.capacity) {
            this._points.push(point);
            return true;
        }
        if (!this._divided) this._subdivide();
        return this._subs.some((sub)=>sub.insert(point));
    }
    query(range, check) {
        const res = [];
        if (!range.intersects(this.rectangle)) return [];
        for (const p of this._points){
            if (!range.contains(p.position) && (0, $1ff4dfb77b7bb646$export$79376507b09a66f)(range.position, p.position) > p.particle.getRadius() && (!check || check(p.particle))) continue;
            res.push(p.particle);
        }
        if (this._divided) for (const sub of this._subs)res.push(...sub.query(range, check));
        return res;
    }
    queryCircle(position, radius, check) {
        return this.query(new (0, $1c5d1439a937867c$export$c89a927ffc67e6fa)(position.x, position.y, radius), check);
    }
    queryRectangle(position, size, check) {
        return this.query(new (0, $1c5d1439a937867c$export$4617fb02663045ef)(position.x, position.y, size.width, size.height), check);
    }
}




const $0613d6a027ef70b4$var$qTreeCapacity = 4, $0613d6a027ef70b4$var$squareExp = 2, $0613d6a027ef70b4$var$defaultRemoveQuantity = 1;
const $0613d6a027ef70b4$var$qTreeRectangle = (canvasSize)=>{
    const { height: height, width: width } = canvasSize, posOffset = -0.25, sizeFactor = 1.5;
    return new (0, $1c5d1439a937867c$export$4617fb02663045ef)(posOffset * width, posOffset * height, sizeFactor * width, sizeFactor * height);
};
class $0613d6a027ef70b4$export$ec4bceef241d2e36 {
    constructor(engine, container){
        this._addToPool = (...particles)=>{
            this._pool.push(...particles);
        };
        this._applyDensity = (options, manualCount, group)=>{
            const numberOptions = options.number;
            if (!options.number.density?.enable) {
                if (group === undefined) this._limit = numberOptions.limit.value;
                else if (numberOptions.limit) this._groupLimits.set(group, numberOptions.limit.value);
                return;
            }
            const densityFactor = this._initDensityFactor(numberOptions.density), optParticlesNumber = numberOptions.value, minLimit = 0, optParticlesLimit = numberOptions.limit.value > minLimit ? numberOptions.limit.value : optParticlesNumber, particlesNumber = Math.min(optParticlesNumber, optParticlesLimit) * densityFactor + manualCount, particlesCount = Math.min(this.count, this.filter((t)=>t.group === group).length);
            if (group === undefined) this._limit = numberOptions.limit.value * densityFactor;
            else this._groupLimits.set(group, numberOptions.limit.value * densityFactor);
            if (particlesCount < particlesNumber) this.push(Math.abs(particlesNumber - particlesCount), undefined, options, group);
            else if (particlesCount > particlesNumber) this.removeQuantity(particlesCount - particlesNumber, group);
        };
        this._initDensityFactor = (densityOptions)=>{
            const container = this._container, defaultFactor = 1;
            if (!container.canvas.element || !densityOptions.enable) return defaultFactor;
            const canvas = container.canvas.element, pxRatio = container.retina.pixelRatio;
            return canvas.width * canvas.height / (densityOptions.height * densityOptions.width * pxRatio ** $0613d6a027ef70b4$var$squareExp);
        };
        this._pushParticle = (position, overrideOptions, group, initializer)=>{
            try {
                let particle = this._pool.pop();
                if (!particle) particle = new (0, $32eee928183e8487$export$c36c68baa13912a5)(this._engine, this._container);
                particle.init(this._nextId, position, overrideOptions, group);
                let canAdd = true;
                if (initializer) canAdd = initializer(particle);
                if (!canAdd) return;
                this._array.push(particle);
                this._zArray.push(particle);
                this._nextId++;
                this._engine.dispatchEvent((0, $df94476ffe249114$export$3d7865934588d77e).particleAdded, {
                    container: this._container,
                    data: {
                        particle: particle
                    }
                });
                return particle;
            } catch (e) {
                (0, $eee2fa4b9ebe63e9$export$2b1d391cd05230fd)().warning(`${(0, $dec17af1c054e95f$export$adea4917e02d93dc)} adding particle: ${e}`);
            }
        };
        this._removeParticle = (index, group, override)=>{
            const particle = this._array[index];
            if (!particle || particle.group !== group) return false;
            const zIdx = this._zArray.indexOf(particle), deleteCount = 1;
            this._array.splice(index, deleteCount);
            this._zArray.splice(zIdx, deleteCount);
            particle.destroy(override);
            this._engine.dispatchEvent((0, $df94476ffe249114$export$3d7865934588d77e).particleRemoved, {
                container: this._container,
                data: {
                    particle: particle
                }
            });
            this._addToPool(particle);
            return true;
        };
        this._engine = engine;
        this._container = container;
        this._nextId = 0;
        this._array = [];
        this._zArray = [];
        this._pool = [];
        this._limit = 0;
        this._groupLimits = new Map();
        this._needsSort = false;
        this._lastZIndex = 0;
        this._interactionManager = new (0, $233d85ef46282a82$export$aaa80641d584351c)(engine, container);
        this._pluginsInitialized = false;
        const canvasSize = container.canvas.size;
        this.quadTree = new (0, $64fc54ca2bc4bc2e$export$b82688eb02220411)($0613d6a027ef70b4$var$qTreeRectangle(canvasSize), $0613d6a027ef70b4$var$qTreeCapacity);
        this.movers = [];
        this.updaters = [];
    }
    get count() {
        return this._array.length;
    }
    addManualParticles() {
        const container = this._container, options = container.actualOptions;
        options.manualParticles.forEach((p)=>this.addParticle(p.position ? (0, $eee2fa4b9ebe63e9$export$1690e12b840569b9)(p.position, container.canvas.size) : undefined, p.options));
    }
    addParticle(position, overrideOptions, group, initializer) {
        const limitMode = this._container.actualOptions.particles.number.limit.mode, limit = group === undefined ? this._limit : this._groupLimits.get(group) ?? this._limit, currentCount = this.count, minLimit = 0;
        if (limit > minLimit) switch(limitMode){
            case (0, $a1674025ad2d29dc$export$e9c6a0495dc4055f).delete:
                {
                    const countOffset = 1, minCount = 0, countToRemove = currentCount + countOffset - limit;
                    if (countToRemove > minCount) this.removeQuantity(countToRemove);
                    break;
                }
            case (0, $a1674025ad2d29dc$export$e9c6a0495dc4055f).wait:
                if (currentCount >= limit) return;
                break;
        }
        return this._pushParticle(position, overrideOptions, group, initializer);
    }
    clear() {
        this._array = [];
        this._zArray = [];
        this._pluginsInitialized = false;
    }
    destroy() {
        this._array = [];
        this._zArray = [];
        this.movers = [];
        this.updaters = [];
    }
    draw(delta) {
        const container = this._container, canvas = container.canvas;
        canvas.clear();
        this.update(delta);
        for (const [, plugin] of container.plugins)canvas.drawPlugin(plugin, delta);
        for (const p of this._zArray)p.draw(delta);
    }
    filter(condition) {
        return this._array.filter(condition);
    }
    find(condition) {
        return this._array.find(condition);
    }
    get(index) {
        return this._array[index];
    }
    handleClickMode(mode) {
        this._interactionManager.handleClickMode(mode);
    }
    async init() {
        const container = this._container, options = container.actualOptions;
        this._lastZIndex = 0;
        this._needsSort = false;
        await this.initPlugins();
        let handled = false;
        for (const [, plugin] of container.plugins){
            handled = plugin.particlesInitialization?.() ?? handled;
            if (handled) break;
        }
        this.addManualParticles();
        if (!handled) {
            const particlesOptions = options.particles, groups = particlesOptions.groups;
            for(const group in groups){
                const groupOptions = groups[group];
                for(let i = this.count, j = 0; j < groupOptions.number?.value && i < particlesOptions.number.value; i++, j++)this.addParticle(undefined, groupOptions, group);
            }
            for(let i = this.count; i < particlesOptions.number.value; i++)this.addParticle();
        }
    }
    async initPlugins() {
        if (this._pluginsInitialized) return;
        const container = this._container;
        this.movers = await this._engine.getMovers(container, true);
        this.updaters = await this._engine.getUpdaters(container, true);
        await this._interactionManager.init();
        for (const [, pathGenerator] of container.pathGenerators)pathGenerator.init(container);
    }
    push(nb, mouse, overrideOptions, group) {
        for(let i = 0; i < nb; i++)this.addParticle(mouse?.position, overrideOptions, group);
    }
    async redraw() {
        this.clear();
        await this.init();
        this.draw({
            value: 0,
            factor: 0
        });
    }
    remove(particle, group, override) {
        this.removeAt(this._array.indexOf(particle), undefined, group, override);
    }
    removeAt(index, quantity = $0613d6a027ef70b4$var$defaultRemoveQuantity, group, override) {
        const minIndex = 0;
        if (index < minIndex || index > this.count) return;
        let deleted = 0;
        for(let i = index; deleted < quantity && i < this.count; i++)if (this._removeParticle(i--, group, override)) deleted++;
    }
    removeQuantity(quantity, group) {
        const defaultIndex = 0;
        this.removeAt(defaultIndex, quantity, group);
    }
    setDensity() {
        const options = this._container.actualOptions, groups = options.particles.groups, manualCount = 0;
        for(const group in groups)this._applyDensity(groups[group], manualCount, group);
        this._applyDensity(options.particles, options.manualParticles.length);
    }
    setLastZIndex(zIndex) {
        this._lastZIndex = zIndex;
        this._needsSort = this._needsSort || this._lastZIndex < zIndex;
    }
    setResizeFactor(factor) {
        this._resizeFactor = factor;
    }
    update(delta) {
        const container = this._container, particlesToDelete = new Set();
        this.quadTree = new (0, $64fc54ca2bc4bc2e$export$b82688eb02220411)($0613d6a027ef70b4$var$qTreeRectangle(container.canvas.size), $0613d6a027ef70b4$var$qTreeCapacity);
        for (const [, pathGenerator] of container.pathGenerators)pathGenerator.update();
        for (const [, plugin] of container.plugins)plugin.update?.(delta);
        const resizeFactor = this._resizeFactor;
        for (const particle of this._array){
            if (resizeFactor && !particle.ignoresResizeRatio) {
                particle.position.x *= resizeFactor.width;
                particle.position.y *= resizeFactor.height;
                particle.initialPosition.x *= resizeFactor.width;
                particle.initialPosition.y *= resizeFactor.height;
            }
            particle.ignoresResizeRatio = false;
            this._interactionManager.reset(particle);
            for (const [, plugin] of this._container.plugins){
                if (particle.destroyed) break;
                plugin.particleUpdate?.(particle, delta);
            }
            for (const mover of this.movers)if (mover.isEnabled(particle)) mover.move(particle, delta);
            if (particle.destroyed) {
                particlesToDelete.add(particle);
                continue;
            }
            this.quadTree.insert(new (0, $f9a81b6084ab6fb2$export$baf26146a414f24a)(particle.getPosition(), particle));
        }
        if (particlesToDelete.size) {
            const checkDelete = (p)=>!particlesToDelete.has(p);
            this._array = this.filter(checkDelete);
            this._zArray = this._zArray.filter(checkDelete);
            for (const particle of particlesToDelete)this._engine.dispatchEvent((0, $df94476ffe249114$export$3d7865934588d77e).particleRemoved, {
                container: this._container,
                data: {
                    particle: particle
                }
            });
            this._addToPool(...particlesToDelete);
        }
        this._interactionManager.externalInteract(delta);
        for (const particle of this._array){
            for (const updater of this.updaters)updater.update(particle, delta);
            if (!particle.destroyed && !particle.spawning) this._interactionManager.particlesInteract(particle, delta);
        }
        delete this._resizeFactor;
        if (this._needsSort) {
            const zArray = this._zArray;
            zArray.sort((a, b)=>b.position.z - a.position.z || a.id - b.id);
            const lengthOffset = 1;
            this._lastZIndex = zArray[zArray.length - lengthOffset].position.z;
            this._needsSort = false;
        }
    }
}




const $78e70b9a99bddeac$var$defaultRatio = 1, $78e70b9a99bddeac$var$defaultReduceFactor = 1;
class $78e70b9a99bddeac$export$b7a992a6d33e9eff {
    constructor(container){
        this.container = container;
        this.pixelRatio = $78e70b9a99bddeac$var$defaultRatio;
        this.reduceFactor = $78e70b9a99bddeac$var$defaultReduceFactor;
    }
    init() {
        const container = this.container, options = container.actualOptions;
        this.pixelRatio = !options.detectRetina || (0, $eee2fa4b9ebe63e9$export$460b6777813d3d86)() ? $78e70b9a99bddeac$var$defaultRatio : window.devicePixelRatio;
        this.reduceFactor = $78e70b9a99bddeac$var$defaultReduceFactor;
        const ratio = this.pixelRatio, canvas = container.canvas;
        if (canvas.element) {
            const element = canvas.element;
            canvas.size.width = element.offsetWidth * ratio;
            canvas.size.height = element.offsetHeight * ratio;
        }
        const particles = options.particles, moveOptions = particles.move;
        this.maxSpeed = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(moveOptions.gravity.maxSpeed) * ratio;
        this.sizeAnimationSpeed = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(particles.size.animation.speed) * ratio;
    }
    initParticle(particle) {
        const options = particle.options, ratio = this.pixelRatio, moveOptions = options.move, moveDistance = moveOptions.distance, props = particle.retina;
        props.moveDrift = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(moveOptions.drift) * ratio;
        props.moveSpeed = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(moveOptions.speed) * ratio;
        props.sizeAnimationSpeed = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(options.size.animation.speed) * ratio;
        const maxDistance = props.maxDistance;
        maxDistance.horizontal = moveDistance.horizontal !== undefined ? moveDistance.horizontal * ratio : undefined;
        maxDistance.vertical = moveDistance.vertical !== undefined ? moveDistance.vertical * ratio : undefined;
        props.maxSpeed = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(moveOptions.gravity.maxSpeed) * ratio;
    }
}




function $ef0b7a4804361fc9$var$guardCheck(container) {
    return container && !container.destroyed;
}
const $ef0b7a4804361fc9$var$defaultFps = 60;
function $ef0b7a4804361fc9$var$initDelta(value, fpsLimit = $ef0b7a4804361fc9$var$defaultFps, smooth = false) {
    return {
        value: value,
        factor: smooth ? $ef0b7a4804361fc9$var$defaultFps / fpsLimit : $ef0b7a4804361fc9$var$defaultFps * value / (0, $dec17af1c054e95f$export$f64c3bfbc58eec0f)
    };
}
function $ef0b7a4804361fc9$var$loadContainerOptions(engine, container, ...sourceOptionsArr) {
    const options = new (0, $fa3bed5b1d8ccc9b$export$c019608e5b5bb4cb)(engine, container);
    (0, $8d5b97c98fc610d5$export$cad72087bded938)(options, ...sourceOptionsArr);
    return options;
}
class $ef0b7a4804361fc9$export$42a852a2b6b56249 {
    constructor(engine, id, sourceOptions){
        this._intersectionManager = (entries)=>{
            if (!$ef0b7a4804361fc9$var$guardCheck(this) || !this.actualOptions.pauseOnOutsideViewport) return;
            for (const entry of entries){
                if (entry.target !== this.interactivity.element) continue;
                if (entry.isIntersecting) this.play();
                else this.pause();
            }
        };
        this._nextFrame = (timestamp)=>{
            try {
                if (!this._smooth && this._lastFrameTime !== undefined && timestamp < this._lastFrameTime + (0, $dec17af1c054e95f$export$f64c3bfbc58eec0f) / this.fpsLimit) {
                    this.draw(false);
                    return;
                }
                this._lastFrameTime ??= timestamp;
                const delta = $ef0b7a4804361fc9$var$initDelta(timestamp - this._lastFrameTime, this.fpsLimit, this._smooth);
                this.addLifeTime(delta.value);
                this._lastFrameTime = timestamp;
                if (delta.value > (0, $dec17af1c054e95f$export$f64c3bfbc58eec0f)) {
                    this.draw(false);
                    return;
                }
                this.particles.draw(delta);
                if (!this.alive()) {
                    this.destroy();
                    return;
                }
                if (this.animationStatus) this.draw(false);
            } catch (e) {
                (0, $eee2fa4b9ebe63e9$export$2b1d391cd05230fd)().error(`${(0, $dec17af1c054e95f$export$adea4917e02d93dc)} in animation loop`, e);
            }
        };
        this._engine = engine;
        this.id = Symbol(id);
        this.fpsLimit = 120;
        this._smooth = false;
        this._delay = 0;
        this._duration = 0;
        this._lifeTime = 0;
        this._firstStart = true;
        this.started = false;
        this.destroyed = false;
        this._paused = true;
        this._lastFrameTime = 0;
        this.zLayers = 100;
        this.pageHidden = false;
        this._clickHandlers = new Map();
        this._sourceOptions = sourceOptions;
        this._initialSourceOptions = sourceOptions;
        this.retina = new (0, $78e70b9a99bddeac$export$b7a992a6d33e9eff)(this);
        this.canvas = new (0, $7919f78a40afc6fa$export$8d01c972ee8b14a9)(this);
        this.particles = new (0, $0613d6a027ef70b4$export$ec4bceef241d2e36)(this._engine, this);
        this.pathGenerators = new Map();
        this.interactivity = {
            mouse: {
                clicking: false,
                inside: false
            }
        };
        this.plugins = new Map();
        this.effectDrawers = new Map();
        this.shapeDrawers = new Map();
        this._options = $ef0b7a4804361fc9$var$loadContainerOptions(this._engine, this);
        this.actualOptions = $ef0b7a4804361fc9$var$loadContainerOptions(this._engine, this);
        this._eventListeners = new (0, $6ba34dc75ffe70d8$export$b20b719ec758a20f)(this);
        this._intersectionObserver = (0, $eee2fa4b9ebe63e9$export$d97d2a93dce76cc2)((entries)=>this._intersectionManager(entries));
        this._engine.dispatchEvent((0, $df94476ffe249114$export$3d7865934588d77e).containerBuilt, {
            container: this
        });
    }
    get animationStatus() {
        return !this._paused && !this.pageHidden && $ef0b7a4804361fc9$var$guardCheck(this);
    }
    get options() {
        return this._options;
    }
    get sourceOptions() {
        return this._sourceOptions;
    }
    addClickHandler(callback) {
        if (!$ef0b7a4804361fc9$var$guardCheck(this)) return;
        const el = this.interactivity.element;
        if (!el) return;
        const clickOrTouchHandler = (e, pos, radius)=>{
            if (!$ef0b7a4804361fc9$var$guardCheck(this)) return;
            const pxRatio = this.retina.pixelRatio, posRetina = {
                x: pos.x * pxRatio,
                y: pos.y * pxRatio
            }, particles = this.particles.quadTree.queryCircle(posRetina, radius * pxRatio);
            callback(e, particles);
        }, clickHandler = (e)=>{
            if (!$ef0b7a4804361fc9$var$guardCheck(this)) return;
            const mouseEvent = e, pos = {
                x: mouseEvent.offsetX || mouseEvent.clientX,
                y: mouseEvent.offsetY || mouseEvent.clientY
            }, radius = 1;
            clickOrTouchHandler(e, pos, radius);
        }, touchStartHandler = ()=>{
            if (!$ef0b7a4804361fc9$var$guardCheck(this)) return;
            touched = true;
            touchMoved = false;
        }, touchMoveHandler = ()=>{
            if (!$ef0b7a4804361fc9$var$guardCheck(this)) return;
            touchMoved = true;
        }, touchEndHandler = (e)=>{
            if (!$ef0b7a4804361fc9$var$guardCheck(this)) return;
            if (touched && !touchMoved) {
                const touchEvent = e, lengthOffset = 1;
                let lastTouch = touchEvent.touches[touchEvent.touches.length - lengthOffset];
                if (!lastTouch) {
                    lastTouch = touchEvent.changedTouches[touchEvent.changedTouches.length - lengthOffset];
                    if (!lastTouch) return;
                }
                const element = this.canvas.element, canvasRect = element ? element.getBoundingClientRect() : undefined, minCoordinate = 0, pos = {
                    x: lastTouch.clientX - (canvasRect ? canvasRect.left : minCoordinate),
                    y: lastTouch.clientY - (canvasRect ? canvasRect.top : minCoordinate)
                };
                clickOrTouchHandler(e, pos, Math.max(lastTouch.radiusX, lastTouch.radiusY));
            }
            touched = false;
            touchMoved = false;
        }, touchCancelHandler = ()=>{
            if (!$ef0b7a4804361fc9$var$guardCheck(this)) return;
            touched = false;
            touchMoved = false;
        };
        let touched = false, touchMoved = false;
        this._clickHandlers.set("click", clickHandler);
        this._clickHandlers.set("touchstart", touchStartHandler);
        this._clickHandlers.set("touchmove", touchMoveHandler);
        this._clickHandlers.set("touchend", touchEndHandler);
        this._clickHandlers.set("touchcancel", touchCancelHandler);
        for (const [key, handler] of this._clickHandlers)el.addEventListener(key, handler);
    }
    addLifeTime(value) {
        this._lifeTime += value;
    }
    addPath(key, generator, override = false) {
        if (!$ef0b7a4804361fc9$var$guardCheck(this) || !override && this.pathGenerators.has(key)) return false;
        this.pathGenerators.set(key, generator);
        return true;
    }
    alive() {
        return !this._duration || this._lifeTime <= this._duration;
    }
    clearClickHandlers() {
        if (!$ef0b7a4804361fc9$var$guardCheck(this)) return;
        for (const [key, handler] of this._clickHandlers)this.interactivity.element?.removeEventListener(key, handler);
        this._clickHandlers.clear();
    }
    destroy(remove = true) {
        if (!$ef0b7a4804361fc9$var$guardCheck(this)) return;
        this.stop();
        this.clearClickHandlers();
        this.particles.destroy();
        this.canvas.destroy();
        for (const [, effectDrawer] of this.effectDrawers)effectDrawer.destroy?.(this);
        for (const [, shapeDrawer] of this.shapeDrawers)shapeDrawer.destroy?.(this);
        for (const key of this.effectDrawers.keys())this.effectDrawers.delete(key);
        for (const key of this.shapeDrawers.keys())this.shapeDrawers.delete(key);
        this._engine.clearPlugins(this);
        this.destroyed = true;
        if (remove) {
            const mainArr = this._engine.items, idx = mainArr.findIndex((t)=>t === this), minIndex = 0;
            if (idx >= minIndex) {
                const deleteCount = 1;
                mainArr.splice(idx, deleteCount);
            }
        }
        this._engine.dispatchEvent((0, $df94476ffe249114$export$3d7865934588d77e).containerDestroyed, {
            container: this
        });
    }
    draw(force) {
        if (!$ef0b7a4804361fc9$var$guardCheck(this)) return;
        let refreshTime = force;
        const frame = (timestamp)=>{
            if (refreshTime) {
                this._lastFrameTime = undefined;
                refreshTime = false;
            }
            this._nextFrame(timestamp);
        };
        this._drawAnimationFrame = requestAnimationFrame((timestamp)=>frame(timestamp));
    }
    async export(type, options = {}) {
        for (const [, plugin] of this.plugins){
            if (!plugin.export) continue;
            const res = await plugin.export(type, options);
            if (!res.supported) continue;
            return res.blob;
        }
        (0, $eee2fa4b9ebe63e9$export$2b1d391cd05230fd)().error(`${(0, $dec17af1c054e95f$export$adea4917e02d93dc)} - Export plugin with type ${type} not found`);
    }
    handleClickMode(mode) {
        if (!$ef0b7a4804361fc9$var$guardCheck(this)) return;
        this.particles.handleClickMode(mode);
        for (const [, plugin] of this.plugins)plugin.handleClickMode?.(mode);
    }
    async init() {
        if (!$ef0b7a4804361fc9$var$guardCheck(this)) return;
        const effects = this._engine.getSupportedEffects();
        for (const type of effects){
            const drawer = this._engine.getEffectDrawer(type);
            if (drawer) this.effectDrawers.set(type, drawer);
        }
        const shapes = this._engine.getSupportedShapes();
        for (const type of shapes){
            const drawer = this._engine.getShapeDrawer(type);
            if (drawer) this.shapeDrawers.set(type, drawer);
        }
        await this.particles.initPlugins();
        this._options = $ef0b7a4804361fc9$var$loadContainerOptions(this._engine, this, this._initialSourceOptions, this.sourceOptions);
        this.actualOptions = $ef0b7a4804361fc9$var$loadContainerOptions(this._engine, this, this._options);
        const availablePlugins = await this._engine.getAvailablePlugins(this);
        for (const [id, plugin] of availablePlugins)this.plugins.set(id, plugin);
        this.retina.init();
        await this.canvas.init();
        this.updateActualOptions();
        this.canvas.initBackground();
        this.canvas.resize();
        const { zLayers: zLayers, duration: duration, delay: delay, fpsLimit: fpsLimit, smooth: smooth } = this.actualOptions;
        this.zLayers = zLayers;
        this._duration = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(duration) * (0, $dec17af1c054e95f$export$f64c3bfbc58eec0f);
        this._delay = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(delay) * (0, $dec17af1c054e95f$export$f64c3bfbc58eec0f);
        this._lifeTime = 0;
        const defaultFpsLimit = 120, minFpsLimit = 0;
        this.fpsLimit = fpsLimit > minFpsLimit ? fpsLimit : defaultFpsLimit;
        this._smooth = smooth;
        for (const [, drawer] of this.effectDrawers)await drawer.init?.(this);
        for (const [, drawer] of this.shapeDrawers)await drawer.init?.(this);
        for (const [, plugin] of this.plugins)await plugin.init?.();
        this._engine.dispatchEvent((0, $df94476ffe249114$export$3d7865934588d77e).containerInit, {
            container: this
        });
        await this.particles.init();
        this.particles.setDensity();
        for (const [, plugin] of this.plugins)plugin.particlesSetup?.();
        this._engine.dispatchEvent((0, $df94476ffe249114$export$3d7865934588d77e).particlesSetup, {
            container: this
        });
    }
    async loadTheme(name) {
        if (!$ef0b7a4804361fc9$var$guardCheck(this)) return;
        this._currentTheme = name;
        await this.refresh();
    }
    pause() {
        if (!$ef0b7a4804361fc9$var$guardCheck(this)) return;
        if (this._drawAnimationFrame !== undefined) {
            cancelAnimationFrame(this._drawAnimationFrame);
            delete this._drawAnimationFrame;
        }
        if (this._paused) return;
        for (const [, plugin] of this.plugins)plugin.pause?.();
        if (!this.pageHidden) this._paused = true;
        this._engine.dispatchEvent((0, $df94476ffe249114$export$3d7865934588d77e).containerPaused, {
            container: this
        });
    }
    play(force) {
        if (!$ef0b7a4804361fc9$var$guardCheck(this)) return;
        const needsUpdate = this._paused || force;
        if (this._firstStart && !this.actualOptions.autoPlay) {
            this._firstStart = false;
            return;
        }
        if (this._paused) this._paused = false;
        if (needsUpdate) {
            for (const [, plugin] of this.plugins)if (plugin.play) plugin.play();
        }
        this._engine.dispatchEvent((0, $df94476ffe249114$export$3d7865934588d77e).containerPlay, {
            container: this
        });
        this.draw(needsUpdate ?? false);
    }
    async refresh() {
        if (!$ef0b7a4804361fc9$var$guardCheck(this)) return;
        this.stop();
        return this.start();
    }
    async reset(sourceOptions) {
        if (!$ef0b7a4804361fc9$var$guardCheck(this)) return;
        this._initialSourceOptions = sourceOptions;
        this._sourceOptions = sourceOptions;
        this._options = $ef0b7a4804361fc9$var$loadContainerOptions(this._engine, this, this._initialSourceOptions, this.sourceOptions);
        this.actualOptions = $ef0b7a4804361fc9$var$loadContainerOptions(this._engine, this, this._options);
        return this.refresh();
    }
    async start() {
        if (!$ef0b7a4804361fc9$var$guardCheck(this) || this.started) return;
        await this.init();
        this.started = true;
        await new Promise((resolve)=>{
            const start = async ()=>{
                this._eventListeners.addListeners();
                if (this.interactivity.element instanceof HTMLElement && this._intersectionObserver) this._intersectionObserver.observe(this.interactivity.element);
                for (const [, plugin] of this.plugins)await plugin.start?.();
                this._engine.dispatchEvent((0, $df94476ffe249114$export$3d7865934588d77e).containerStarted, {
                    container: this
                });
                this.play();
                resolve();
            };
            this._delayTimeout = setTimeout(()=>void start(), this._delay);
        });
    }
    stop() {
        if (!$ef0b7a4804361fc9$var$guardCheck(this) || !this.started) return;
        if (this._delayTimeout) {
            clearTimeout(this._delayTimeout);
            delete this._delayTimeout;
        }
        this._firstStart = true;
        this.started = false;
        this._eventListeners.removeListeners();
        this.pause();
        this.particles.clear();
        this.canvas.stop();
        if (this.interactivity.element instanceof HTMLElement && this._intersectionObserver) this._intersectionObserver.unobserve(this.interactivity.element);
        for (const [, plugin] of this.plugins)plugin.stop?.();
        for (const key of this.plugins.keys())this.plugins.delete(key);
        this._sourceOptions = this._options;
        this._engine.dispatchEvent((0, $df94476ffe249114$export$3d7865934588d77e).containerStopped, {
            container: this
        });
    }
    updateActualOptions() {
        this.actualOptions.responsive = [];
        const newMaxWidth = this.actualOptions.setResponsive(this.canvas.size.width, this.retina.pixelRatio, this._options);
        this.actualOptions.setTheme(this._currentTheme);
        if (this._responsiveMaxWidth === newMaxWidth) return false;
        this._responsiveMaxWidth = newMaxWidth;
        return true;
    }
}


class $9fe369c73571dbcd$export$ec8b666c5fe2c75a {
    constructor(){
        this._listeners = new Map();
    }
    addEventListener(type, listener) {
        this.removeEventListener(type, listener);
        let arr = this._listeners.get(type);
        if (!arr) {
            arr = [];
            this._listeners.set(type, arr);
        }
        arr.push(listener);
    }
    dispatchEvent(type, args) {
        const listeners = this._listeners.get(type);
        listeners?.forEach((handler)=>handler(args));
    }
    hasEventListener(type) {
        return !!this._listeners.get(type);
    }
    removeAllEventListeners(type) {
        if (!type) this._listeners = new Map();
        else this._listeners.delete(type);
    }
    removeEventListener(type, listener) {
        const arr = this._listeners.get(type);
        if (!arr) return;
        const length = arr.length, idx = arr.indexOf(listener), minIndex = 0;
        if (idx < minIndex) return;
        const deleteCount = 1;
        if (length === deleteCount) this._listeners.delete(type);
        else arr.splice(idx, deleteCount);
    }
}




async function $c2e968b37a981a27$var$getItemsFromInitializer(container, map, initializers, force = false) {
    let res = map.get(container);
    if (!res || force) {
        res = await Promise.all([
            ...initializers.values()
        ].map((t)=>t(container)));
        map.set(container, res);
    }
    return res;
}
async function $c2e968b37a981a27$var$getDataFromUrl(data) {
    const url = (0, $eee2fa4b9ebe63e9$export$3fbf39566d3ee62e)(data.url, data.index);
    if (!url) return data.fallback;
    const response = await fetch(url);
    if (response.ok) return await response.json();
    (0, $eee2fa4b9ebe63e9$export$2b1d391cd05230fd)().error(`${(0, $dec17af1c054e95f$export$adea4917e02d93dc)} ${response.status} while retrieving config file`);
    return data.fallback;
}
const $c2e968b37a981a27$var$generatedTrue = "true", $c2e968b37a981a27$var$generatedFalse = "false", $c2e968b37a981a27$var$canvasTag = "canvas", $c2e968b37a981a27$var$getCanvasFromContainer = (domContainer)=>{
    let canvasEl;
    if (domContainer instanceof HTMLCanvasElement || domContainer.tagName.toLowerCase() === $c2e968b37a981a27$var$canvasTag) {
        canvasEl = domContainer;
        if (!canvasEl.dataset[0, $dec17af1c054e95f$export$4a278486528d5cfb]) canvasEl.dataset[0, $dec17af1c054e95f$export$4a278486528d5cfb] = $c2e968b37a981a27$var$generatedFalse;
    } else {
        const existingCanvases = domContainer.getElementsByTagName($c2e968b37a981a27$var$canvasTag);
        if (existingCanvases.length) {
            const firstIndex = 0;
            canvasEl = existingCanvases[firstIndex];
            canvasEl.dataset[0, $dec17af1c054e95f$export$4a278486528d5cfb] = $c2e968b37a981a27$var$generatedFalse;
        } else {
            canvasEl = document.createElement($c2e968b37a981a27$var$canvasTag);
            canvasEl.dataset[0, $dec17af1c054e95f$export$4a278486528d5cfb] = $c2e968b37a981a27$var$generatedTrue;
            domContainer.appendChild(canvasEl);
        }
    }
    const fullPercent = "100%";
    if (!canvasEl.style.width) canvasEl.style.width = fullPercent;
    if (!canvasEl.style.height) canvasEl.style.height = fullPercent;
    return canvasEl;
}, $c2e968b37a981a27$var$getDomContainer = (id, source)=>{
    let domContainer = source ?? document.getElementById(id);
    if (domContainer) return domContainer;
    domContainer = document.createElement("div");
    domContainer.id = id;
    domContainer.dataset[0, $dec17af1c054e95f$export$4a278486528d5cfb] = $c2e968b37a981a27$var$generatedTrue;
    document.body.append(domContainer);
    return domContainer;
};
class $c2e968b37a981a27$export$2c3b404bf3a77a1f {
    constructor(){
        this._configs = new Map();
        this._domArray = [];
        this._eventDispatcher = new (0, $9fe369c73571dbcd$export$ec8b666c5fe2c75a)();
        this._initialized = false;
        this.plugins = [];
        this._initializers = {
            interactors: new Map(),
            movers: new Map(),
            updaters: new Map()
        };
        this.interactors = new Map();
        this.movers = new Map();
        this.updaters = new Map();
        this.presets = new Map();
        this.effectDrawers = new Map();
        this.shapeDrawers = new Map();
        this.pathGenerators = new Map();
    }
    get configs() {
        const res = {};
        for (const [name, config] of this._configs)res[name] = config;
        return res;
    }
    get items() {
        return this._domArray;
    }
    get version() {
        return "3.4.0";
    }
    addConfig(config) {
        const key = config.key ?? config.name ?? "default";
        this._configs.set(key, config);
        this._eventDispatcher.dispatchEvent((0, $df94476ffe249114$export$3d7865934588d77e).configAdded, {
            data: {
                name: key,
                config: config
            }
        });
    }
    async addEffect(effect, drawer, refresh = true) {
        (0, $eee2fa4b9ebe63e9$export$8e5dc47097396754)(effect, (type)=>{
            if (!this.getEffectDrawer(type)) this.effectDrawers.set(type, drawer);
        });
        await this.refresh(refresh);
    }
    addEventListener(type, listener) {
        this._eventDispatcher.addEventListener(type, listener);
    }
    async addInteractor(name, interactorInitializer, refresh = true) {
        this._initializers.interactors.set(name, interactorInitializer);
        await this.refresh(refresh);
    }
    async addMover(name, moverInitializer, refresh = true) {
        this._initializers.movers.set(name, moverInitializer);
        await this.refresh(refresh);
    }
    async addParticleUpdater(name, updaterInitializer, refresh = true) {
        this._initializers.updaters.set(name, updaterInitializer);
        await this.refresh(refresh);
    }
    async addPathGenerator(name, generator, refresh = true) {
        if (!this.getPathGenerator(name)) this.pathGenerators.set(name, generator);
        await this.refresh(refresh);
    }
    async addPlugin(plugin, refresh = true) {
        if (!this.getPlugin(plugin.id)) this.plugins.push(plugin);
        await this.refresh(refresh);
    }
    async addPreset(preset, options, override = false, refresh = true) {
        if (override || !this.getPreset(preset)) this.presets.set(preset, options);
        await this.refresh(refresh);
    }
    async addShape(drawer, refresh = true) {
        for (const validType of drawer.validTypes){
            if (this.getShapeDrawer(validType)) continue;
            this.shapeDrawers.set(validType, drawer);
        }
        await this.refresh(refresh);
    }
    clearPlugins(container) {
        this.updaters.delete(container);
        this.movers.delete(container);
        this.interactors.delete(container);
    }
    dispatchEvent(type, args) {
        this._eventDispatcher.dispatchEvent(type, args);
    }
    dom() {
        return this.items;
    }
    domItem(index) {
        return this.item(index);
    }
    async getAvailablePlugins(container) {
        const res = new Map();
        for (const plugin of this.plugins)if (plugin.needsPlugin(container.actualOptions)) res.set(plugin.id, await plugin.getPlugin(container));
        return res;
    }
    getEffectDrawer(type) {
        return this.effectDrawers.get(type);
    }
    async getInteractors(container, force = false) {
        return $c2e968b37a981a27$var$getItemsFromInitializer(container, this.interactors, this._initializers.interactors, force);
    }
    async getMovers(container, force = false) {
        return $c2e968b37a981a27$var$getItemsFromInitializer(container, this.movers, this._initializers.movers, force);
    }
    getPathGenerator(type) {
        return this.pathGenerators.get(type);
    }
    getPlugin(plugin) {
        return this.plugins.find((t)=>t.id === plugin);
    }
    getPreset(preset) {
        return this.presets.get(preset);
    }
    getShapeDrawer(type) {
        return this.shapeDrawers.get(type);
    }
    getSupportedEffects() {
        return this.effectDrawers.keys();
    }
    getSupportedShapes() {
        return this.shapeDrawers.keys();
    }
    async getUpdaters(container, force = false) {
        return $c2e968b37a981a27$var$getItemsFromInitializer(container, this.updaters, this._initializers.updaters, force);
    }
    init() {
        if (this._initialized) return;
        this._initialized = true;
    }
    item(index) {
        const { items: items } = this, item = items[index];
        if (!item || item.destroyed) {
            const deleteCount = 1;
            items.splice(index, deleteCount);
            return;
        }
        return item;
    }
    async load(params) {
        const randomFactor = 10000, id = params.id ?? params.element?.id ?? `tsparticles${Math.floor((0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * randomFactor)}`, { index: index, url: url } = params, options = url ? await $c2e968b37a981a27$var$getDataFromUrl({
            fallback: params.options,
            url: url,
            index: index
        }) : params.options;
        const currentOptions = (0, $eee2fa4b9ebe63e9$export$3fbf39566d3ee62e)(options, index), { items: items } = this, oldIndex = items.findIndex((v)=>v.id.description === id), minIndex = 0, newItem = new (0, $ef0b7a4804361fc9$export$42a852a2b6b56249)(this, id, currentOptions);
        if (oldIndex >= minIndex) {
            const old = this.item(oldIndex), one = 1, none = 0, deleteCount = old ? one : none;
            if (old && !old.destroyed) old.destroy(false);
            items.splice(oldIndex, deleteCount, newItem);
        } else items.push(newItem);
        const domContainer = $c2e968b37a981a27$var$getDomContainer(id, params.element), canvasEl = $c2e968b37a981a27$var$getCanvasFromContainer(domContainer);
        newItem.canvas.loadCanvas(canvasEl);
        await newItem.start();
        return newItem;
    }
    loadOptions(options, sourceOptions) {
        this.plugins.forEach((plugin)=>plugin.loadOptions?.(options, sourceOptions));
    }
    loadParticlesOptions(container, options, ...sourceOptions) {
        const updaters = this.updaters.get(container);
        if (!updaters) return;
        updaters.forEach((updater)=>updater.loadOptions?.(options, ...sourceOptions));
    }
    async refresh(refresh = true) {
        if (!refresh) return;
        await Promise.all(this.items.map((t)=>t.refresh()));
    }
    removeEventListener(type, listener) {
        this._eventDispatcher.removeEventListener(type, listener);
    }
    setOnClickHandler(callback) {
        const { items: items } = this;
        if (!items.length) throw new Error(`${(0, $dec17af1c054e95f$export$adea4917e02d93dc)} can only set click handlers after calling tsParticles.load()`);
        items.forEach((item)=>item.addClickHandler(callback));
    }
}




var $6233d46b2fd2c1fc$var$HslIndexes;
(function(HslIndexes) {
    HslIndexes[HslIndexes["h"] = 1] = "h";
    HslIndexes[HslIndexes["s"] = 2] = "s";
    HslIndexes[HslIndexes["l"] = 3] = "l";
    HslIndexes[HslIndexes["a"] = 5] = "a";
})($6233d46b2fd2c1fc$var$HslIndexes || ($6233d46b2fd2c1fc$var$HslIndexes = {}));
class $6233d46b2fd2c1fc$export$a0d665b8e8138206 {
    constructor(){
        this.key = "hsl";
        this.stringPrefix = "hsl";
    }
    handleColor(color) {
        const colorValue = color.value, hslColor = colorValue.hsl ?? color.value;
        if (hslColor.h !== undefined && hslColor.s !== undefined && hslColor.l !== undefined) return (0, $fd6faa9f4e5410ac$export$29fb7152bd3f781a)(hslColor);
    }
    handleRangeColor(color) {
        const colorValue = color.value, hslColor = colorValue.hsl ?? color.value;
        if (hslColor.h !== undefined && hslColor.l !== undefined) return (0, $fd6faa9f4e5410ac$export$29fb7152bd3f781a)({
            h: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(hslColor.h),
            l: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(hslColor.l),
            s: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(hslColor.s)
        });
    }
    parseString(input) {
        if (!input.startsWith("hsl")) return;
        const regex = /hsla?\(\s*(\d+)\s*,\s*(\d+)%\s*,\s*(\d+)%\s*(,\s*([\d.%]+)\s*)?\)/i, result = regex.exec(input), minLength = 4, defaultAlpha = 1, radix = 10;
        return result ? (0, $fd6faa9f4e5410ac$export$6ae64dbcd6bfc33e)({
            a: result.length > minLength ? (0, $1ff4dfb77b7bb646$export$988633967de92230)(result[$6233d46b2fd2c1fc$var$HslIndexes.a]) : defaultAlpha,
            h: parseInt(result[$6233d46b2fd2c1fc$var$HslIndexes.h], radix),
            l: parseInt(result[$6233d46b2fd2c1fc$var$HslIndexes.l], radix),
            s: parseInt(result[$6233d46b2fd2c1fc$var$HslIndexes.s], radix)
        }) : undefined;
    }
}



var $9b921e6a41e89c80$var$RgbIndexes;
(function(RgbIndexes) {
    RgbIndexes[RgbIndexes["r"] = 1] = "r";
    RgbIndexes[RgbIndexes["g"] = 2] = "g";
    RgbIndexes[RgbIndexes["b"] = 3] = "b";
    RgbIndexes[RgbIndexes["a"] = 5] = "a";
})($9b921e6a41e89c80$var$RgbIndexes || ($9b921e6a41e89c80$var$RgbIndexes = {}));
class $9b921e6a41e89c80$export$24da4f0c4702c17e {
    constructor(){
        this.key = "rgb";
        this.stringPrefix = "rgb";
    }
    handleColor(color) {
        const colorValue = color.value, rgbColor = colorValue.rgb ?? color.value;
        if (rgbColor.r !== undefined) return rgbColor;
    }
    handleRangeColor(color) {
        const colorValue = color.value, rgbColor = colorValue.rgb ?? color.value;
        if (rgbColor.r !== undefined) return {
            r: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(rgbColor.r),
            g: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(rgbColor.g),
            b: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(rgbColor.b)
        };
    }
    parseString(input) {
        if (!input.startsWith(this.stringPrefix)) return;
        const regex = /rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(,\s*([\d.%]+)\s*)?\)/i, result = regex.exec(input), radix = 10, minLength = 4, defaultAlpha = 1;
        return result ? {
            a: result.length > minLength ? (0, $1ff4dfb77b7bb646$export$988633967de92230)(result[$9b921e6a41e89c80$var$RgbIndexes.a]) : defaultAlpha,
            b: parseInt(result[$9b921e6a41e89c80$var$RgbIndexes.b], radix),
            g: parseInt(result[$9b921e6a41e89c80$var$RgbIndexes.g], radix),
            r: parseInt(result[$9b921e6a41e89c80$var$RgbIndexes.r], radix)
        } : undefined;
    }
}



function $9c2843dbcd99df45$export$2cd8252107eb640b() {
    const rgbColorManager = new (0, $9b921e6a41e89c80$export$24da4f0c4702c17e)(), hslColorManager = new (0, $6233d46b2fd2c1fc$export$a0d665b8e8138206)();
    (0, $fd6faa9f4e5410ac$export$fac4919b23cbaf23)(rgbColorManager);
    (0, $fd6faa9f4e5410ac$export$fac4919b23cbaf23)(hslColorManager);
    const engine = new (0, $c2e968b37a981a27$export$2c3b404bf3a77a1f)();
    engine.init();
    return engine;
}





class $5825146c5282067b$export$6e252256471acc61 {
    constructor(container){
        this.type = (0, $73499053c45d5742$export$143a800d561d28fd).external;
        this.container = container;
    }
}



class $98976f88cf21c377$export$becdaab2d9289dc4 {
    constructor(container){
        this.type = (0, $73499053c45d5742$export$143a800d561d28fd).particles;
        this.container = container;
    }
}






var $c606501dd7c2dcb2$export$9506977ce2a96a5b;
(function(RotateDirection) {
    RotateDirection["clockwise"] = "clockwise";
    RotateDirection["counterClockwise"] = "counter-clockwise";
    RotateDirection["random"] = "random";
})($c606501dd7c2dcb2$export$9506977ce2a96a5b || ($c606501dd7c2dcb2$export$9506977ce2a96a5b = {}));












var $aaaec77af02bd97a$export$20d70ee9873a8ba;
(function(GradientType) {
    GradientType["linear"] = "linear";
    GradientType["radial"] = "radial";
    GradientType["random"] = "random";
})($aaaec77af02bd97a$export$20d70ee9873a8ba || ($aaaec77af02bd97a$export$20d70ee9873a8ba = {}));






var $981da57d483aae4d$export$483bfb5d033dec0c;
(function(EasingType) {
    EasingType["easeInBack"] = "ease-in-back";
    EasingType["easeInCirc"] = "ease-in-circ";
    EasingType["easeInCubic"] = "ease-in-cubic";
    EasingType["easeInLinear"] = "ease-in-linear";
    EasingType["easeInQuad"] = "ease-in-quad";
    EasingType["easeInQuart"] = "ease-in-quart";
    EasingType["easeInQuint"] = "ease-in-quint";
    EasingType["easeInExpo"] = "ease-in-expo";
    EasingType["easeInSine"] = "ease-in-sine";
    EasingType["easeOutBack"] = "ease-out-back";
    EasingType["easeOutCirc"] = "ease-out-circ";
    EasingType["easeOutCubic"] = "ease-out-cubic";
    EasingType["easeOutLinear"] = "ease-out-linear";
    EasingType["easeOutQuad"] = "ease-out-quad";
    EasingType["easeOutQuart"] = "ease-out-quart";
    EasingType["easeOutQuint"] = "ease-out-quint";
    EasingType["easeOutExpo"] = "ease-out-expo";
    EasingType["easeOutSine"] = "ease-out-sine";
    EasingType["easeInOutBack"] = "ease-in-out-back";
    EasingType["easeInOutCirc"] = "ease-in-out-circ";
    EasingType["easeInOutCubic"] = "ease-in-out-cubic";
    EasingType["easeInOutLinear"] = "ease-in-out-linear";
    EasingType["easeInOutQuad"] = "ease-in-out-quad";
    EasingType["easeInOutQuart"] = "ease-in-out-quart";
    EasingType["easeInOutQuint"] = "ease-in-out-quint";
    EasingType["easeInOutExpo"] = "ease-in-out-expo";
    EasingType["easeInOutSine"] = "ease-in-out-sine";
})($981da57d483aae4d$export$483bfb5d033dec0c || ($981da57d483aae4d$export$483bfb5d033dec0c = {}));








































































































































































































































































const $8c96b70d43d04c22$export$218c38ca7c058037 = (0, $9c2843dbcd99df45$export$2cd8252107eb640b)();
if (!(0, $eee2fa4b9ebe63e9$export$460b6777813d3d86)()) window.tsParticles = $8c96b70d43d04c22$export$218c38ca7c058037;


const $8ce47ada143f6012$var$linksMinDistance = 120, $8ce47ada143f6012$var$moveMinSpeed = 0.5, $8ce47ada143f6012$var$particlesMinCount = 100, $8ce47ada143f6012$var$sizeMinValue = 3;
class $8ce47ada143f6012$export$ec4bceef241d2e36 {
    static init(options) {
        const particles = new $8ce47ada143f6012$export$ec4bceef241d2e36(), selector = options.selector;
        if (!selector) throw new Error("No selector provided");
        const el = document.querySelector(selector);
        if (!el) throw new Error("No element found for selector");
        (0, $8c96b70d43d04c22$export$218c38ca7c058037).load({
            element: el,
            id: selector.replace(".", "").replace("!", ""),
            options: {
                fullScreen: {
                    enable: false
                },
                particles: {
                    color: {
                        value: options.color ?? "!000000"
                    },
                    links: {
                        color: "random",
                        distance: options.minDistance ?? $8ce47ada143f6012$var$linksMinDistance,
                        enable: options.connectParticles ?? false
                    },
                    move: {
                        enable: true,
                        speed: options.speed ?? $8ce47ada143f6012$var$moveMinSpeed
                    },
                    number: {
                        value: options.maxParticles ?? $8ce47ada143f6012$var$particlesMinCount
                    },
                    size: {
                        value: {
                            min: 1,
                            max: options.sizeVariations ?? $8ce47ada143f6012$var$sizeMinValue
                        }
                    }
                },
                responsive: options.responsive?.map((responsive)=>({
                        maxWidth: responsive.breakpoint,
                        options: {
                            particles: {
                                color: {
                                    value: responsive.options?.color
                                },
                                links: {
                                    distance: responsive.options?.minDistance,
                                    enable: responsive.options?.connectParticles
                                },
                                number: {
                                    value: options.maxParticles
                                },
                                move: {
                                    enable: true,
                                    speed: responsive.options?.speed
                                },
                                size: {
                                    value: responsive.options?.sizeVariations
                                }
                            }
                        }
                    }))
            }
        }).then((container)=>{
            particles._container = container;
        });
        return particles;
    }
    destroy() {
        const container = this._container;
        container?.destroy();
    }
    pauseAnimation() {
        const container = this._container;
        container?.pause();
    }
    resumeAnimation() {
        const container = this._container;
        container?.play();
    }
}



const $6f49539f8b45dad2$var$defaultMinOpacity = 0, $6f49539f8b45dad2$var$defaultMinSize = 0, $6f49539f8b45dad2$var$speedFactor = 3, $6f49539f8b45dad2$var$defaultPjsOptions = {
    particles: {
        number: {
            value: 400,
            density: {
                enable: true,
                value_area: 800
            }
        },
        color: {
            value: "#fff"
        },
        shape: {
            type: "circle",
            stroke: {
                width: 0,
                color: "#ff0000"
            },
            polygon: {
                nb_sides: 5
            },
            image: {
                src: "",
                width: 100,
                height: 100
            }
        },
        opacity: {
            value: 1,
            random: false,
            anim: {
                enable: false,
                speed: 2,
                opacity_min: 0,
                sync: false
            }
        },
        size: {
            value: 20,
            random: false,
            anim: {
                enable: false,
                speed: 20,
                size_min: 0,
                sync: false
            }
        },
        line_linked: {
            enable: true,
            distance: 100,
            color: "#fff",
            opacity: 1,
            width: 1
        },
        move: {
            enable: true,
            speed: 2,
            direction: "none",
            random: false,
            straight: false,
            out_mode: "out",
            bounce: false,
            attract: {
                enable: false,
                rotateX: 3000,
                rotateY: 3000
            }
        }
    },
    interactivity: {
        detect_on: "canvas",
        events: {
            onhover: {
                enable: true,
                mode: "grab"
            },
            onclick: {
                enable: true,
                mode: "push"
            },
            resize: true
        },
        modes: {
            grab: {
                distance: 100,
                line_linked: {
                    opacity: 1
                }
            },
            bubble: {
                distance: 200,
                size: 80,
                duration: 0.4,
                opacity: 1,
                speed: 3
            },
            repulse: {
                distance: 200,
                duration: 0.4
            },
            push: {
                particles_nb: 4
            },
            remove: {
                particles_nb: 2
            }
        }
    },
    retina_detect: false
};
const $6f49539f8b45dad2$export$761851227521c078 = (engine)=>{
    const particlesJS = (tagId, options)=>{
        const fixedOptions = (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)($6f49539f8b45dad2$var$defaultPjsOptions, options);
        return engine.load({
            id: tagId,
            options: {
                fullScreen: {
                    enable: false
                },
                detectRetina: fixedOptions.retina_detect,
                smooth: true,
                interactivity: {
                    detectsOn: fixedOptions.interactivity.detect_on,
                    events: {
                        onHover: {
                            enable: fixedOptions.interactivity.events.onhover.enable,
                            mode: fixedOptions.interactivity.events.onhover.mode
                        },
                        onClick: {
                            enable: fixedOptions.interactivity.events.onclick.enable,
                            mode: fixedOptions.interactivity.events.onclick.mode
                        },
                        resize: {
                            enable: fixedOptions.interactivity.events.resize
                        }
                    },
                    modes: {
                        grab: {
                            distance: fixedOptions.interactivity.modes.grab.distance,
                            links: {
                                opacity: fixedOptions.interactivity.modes.grab.line_linked.opacity
                            }
                        },
                        bubble: {
                            distance: fixedOptions.interactivity.modes.bubble.distance,
                            size: fixedOptions.interactivity.modes.bubble.size,
                            duration: fixedOptions.interactivity.modes.bubble.duration,
                            opacity: fixedOptions.interactivity.modes.bubble.opacity,
                            speed: fixedOptions.interactivity.modes.bubble.speed
                        },
                        repulse: {
                            distance: fixedOptions.interactivity.modes.repulse.distance,
                            duration: fixedOptions.interactivity.modes.repulse.duration
                        },
                        push: {
                            quantity: fixedOptions.interactivity.modes.push.particles_nb
                        },
                        remove: {
                            quantity: fixedOptions.interactivity.modes.remove.particles_nb
                        }
                    }
                },
                particles: {
                    collisions: {
                        enable: fixedOptions.particles.move.bounce
                    },
                    number: {
                        value: fixedOptions.particles.number.value,
                        density: {
                            enable: fixedOptions.particles.number.density.enable,
                            width: fixedOptions.particles.number.density.value_area
                        }
                    },
                    color: {
                        value: fixedOptions.particles.color.value
                    },
                    stroke: {
                        width: fixedOptions.particles.shape.stroke.width,
                        color: {
                            value: fixedOptions.particles.shape.stroke.color
                        }
                    },
                    shape: {
                        type: fixedOptions.particles.shape.type,
                        options: {
                            polygon: {
                                sides: fixedOptions.particles.shape.polygon.nb_sides
                            },
                            image: {
                                src: fixedOptions.particles.shape.image.src,
                                width: fixedOptions.particles.shape.image.width,
                                height: fixedOptions.particles.shape.image.height
                            }
                        }
                    },
                    opacity: {
                        value: fixedOptions.particles.opacity.random ? {
                            min: fixedOptions.particles.opacity.anim.enable ? fixedOptions.particles.opacity.anim.opacity_min : $6f49539f8b45dad2$var$defaultMinOpacity,
                            max: fixedOptions.particles.opacity.value
                        } : fixedOptions.particles.opacity.value,
                        animation: {
                            enable: fixedOptions.particles.opacity.anim.enable,
                            speed: fixedOptions.particles.opacity.anim.speed,
                            sync: fixedOptions.particles.opacity.anim.sync
                        }
                    },
                    size: {
                        value: fixedOptions.particles.size.random ? {
                            min: fixedOptions.particles.size.anim.enable ? fixedOptions.particles.size.anim.size_min : $6f49539f8b45dad2$var$defaultMinSize,
                            max: fixedOptions.particles.size.value
                        } : fixedOptions.particles.size.value,
                        animation: {
                            enable: fixedOptions.particles.size.anim.enable,
                            speed: fixedOptions.particles.size.anim.speed,
                            sync: fixedOptions.particles.size.anim.sync
                        }
                    },
                    links: {
                        enable: fixedOptions.particles.line_linked.enable,
                        distance: fixedOptions.particles.line_linked.distance,
                        color: fixedOptions.particles.line_linked.color,
                        opacity: fixedOptions.particles.line_linked.opacity,
                        width: fixedOptions.particles.line_linked.width
                    },
                    move: {
                        enable: fixedOptions.particles.move.enable,
                        speed: fixedOptions.particles.move.speed / $6f49539f8b45dad2$var$speedFactor,
                        direction: fixedOptions.particles.move.direction,
                        random: fixedOptions.particles.move.random,
                        straight: fixedOptions.particles.move.straight,
                        outModes: fixedOptions.particles.move.out_mode,
                        attract: {
                            enable: fixedOptions.particles.move.attract.enable,
                            rotate: {
                                x: fixedOptions.particles.move.attract.rotateX,
                                y: fixedOptions.particles.move.attract.rotateY
                            }
                        }
                    }
                }
            }
        });
    };
    particlesJS.load = (tagId, pathConfigJson, callback)=>{
        engine.load({
            id: tagId,
            url: pathConfigJson
        }).then((container)=>{
            if (container) callback(container);
        }).catch(()=>{
            callback(undefined);
        });
    };
    particlesJS.setOnClickHandler = (callback)=>{
        engine.setOnClickHandler(callback);
    };
    const pJSDom = engine.dom();
    return {
        particlesJS: particlesJS,
        pJSDom: pJSDom
    };
};


const $2591792b29c719ea$export$4948e8af77cbffab = (engine)=>{
    const { particlesJS: particlesJS, pJSDom: pJSDom } = (0, $6f49539f8b45dad2$export$761851227521c078)(engine);
    window.particlesJS = particlesJS;
    window.pJSDom = pJSDom;
    window.Particles = (0, $8ce47ada143f6012$export$ec4bceef241d2e36);
    return {
        particlesJS: particlesJS,
        pJSDom: pJSDom,
        Particles: $8ce47ada143f6012$export$ec4bceef241d2e36
    };
};



const $cfce1f7f44834bdf$var$double = 2, $cfce1f7f44834bdf$var$defaultHeightFactor = 0.5, $cfce1f7f44834bdf$var$defaultHeadWidthFactor = 0.2, $cfce1f7f44834bdf$var$defaultBodyHeightFactor = 0.5, $cfce1f7f44834bdf$var$half = 0.5, $cfce1f7f44834bdf$var$origin = {
    x: 0,
    y: 0
};
function $cfce1f7f44834bdf$export$f6d70d79295e1392(data) {
    const { context: context, particle: particle, radius: radius } = data, width = radius * $cfce1f7f44834bdf$var$double, heightFactor = particle.heightFactor ?? $cfce1f7f44834bdf$var$defaultHeightFactor, headWidthFactor = particle.headWidthFactor ?? $cfce1f7f44834bdf$var$defaultHeadWidthFactor, bodyHeightFactor = particle.bodyHeightFactor ?? $cfce1f7f44834bdf$var$defaultBodyHeightFactor, height = width * heightFactor, headWidth = width * headWidthFactor, bodyHeight = height * bodyHeightFactor;
    context.moveTo(-width * $cfce1f7f44834bdf$var$half, $cfce1f7f44834bdf$var$origin.y);
    context.lineTo(-width * $cfce1f7f44834bdf$var$half, -bodyHeight * $cfce1f7f44834bdf$var$half);
    context.lineTo(width * $cfce1f7f44834bdf$var$half - headWidth, -bodyHeight * $cfce1f7f44834bdf$var$half);
    context.lineTo(width * $cfce1f7f44834bdf$var$half - headWidth, -height * $cfce1f7f44834bdf$var$half);
    context.lineTo(width * $cfce1f7f44834bdf$var$half + headWidth, $cfce1f7f44834bdf$var$origin.y);
    context.lineTo(width * $cfce1f7f44834bdf$var$half - headWidth, height * $cfce1f7f44834bdf$var$half);
    context.lineTo(width * $cfce1f7f44834bdf$var$half - headWidth, bodyHeight * $cfce1f7f44834bdf$var$half);
    context.lineTo(-width * $cfce1f7f44834bdf$var$half, bodyHeight * $cfce1f7f44834bdf$var$half);
    context.lineTo(-width * $cfce1f7f44834bdf$var$half, $cfce1f7f44834bdf$var$origin.y);
}


const $7c59b07d5702acd7$var$defaultHeightFactor = 0.5, $7c59b07d5702acd7$var$defaultHeadWidthFactor = 0.2, $7c59b07d5702acd7$var$defaultBodyHeightFactor = 0.5;
class $7c59b07d5702acd7$export$3feb1a03a679e66 {
    constructor(){
        this.validTypes = [
            "arrow"
        ];
    }
    draw(data) {
        (0, $cfce1f7f44834bdf$export$f6d70d79295e1392)(data);
    }
    particleInit(container, particle) {
        const shapeData = particle.shapeData;
        particle.heightFactor = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(shapeData?.heightFactor ?? $7c59b07d5702acd7$var$defaultHeightFactor);
        particle.headWidthFactor = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(shapeData?.headWidthFactor ?? $7c59b07d5702acd7$var$defaultHeadWidthFactor);
        particle.bodyHeightFactor = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(shapeData?.bodyHeightFactor ?? $7c59b07d5702acd7$var$defaultBodyHeightFactor);
    }
}


async function $94bb5d4d7e177ff9$export$c9e682e002889c73(engine, refresh = true) {
    await engine.addShape(new (0, $7c59b07d5702acd7$export$3feb1a03a679e66)(), refresh);
}


const $d9eb765cc61e12e3$var$bubbleFactor = 3, $d9eb765cc61e12e3$var$minAngle = 0, $d9eb765cc61e12e3$var$double = 2, $d9eb765cc61e12e3$var$maxAngle = Math.PI * $d9eb765cc61e12e3$var$double;
class $d9eb765cc61e12e3$export$4db97dd97f232a17 {
    draw(data) {
        const { context: context, radius: radius } = data, bubbleRadius = radius / $d9eb765cc61e12e3$var$bubbleFactor;
        context.beginPath();
        context.arc(bubbleRadius, -bubbleRadius, bubbleRadius, $d9eb765cc61e12e3$var$minAngle, $d9eb765cc61e12e3$var$maxAngle, false);
        context.closePath();
        context.fillStyle = "#fff9";
        context.fill();
    }
}


async function $8bee22f8f09072ff$export$636d52385760703d(engine, refresh = true) {
    await engine.addEffect("bubble", new (0, $d9eb765cc61e12e3$export$4db97dd97f232a17)(), refresh);
}


class $40fc071112097c2a$export$132b80e403ecbcee {
    constructor(){
        this.color = true;
        this.opacity = false;
    }
    load(data) {
        if (!data) return;
        if (data.color !== undefined) this.color = data.color;
        if (data.opacity !== undefined) this.opacity = data.opacity;
    }
}



const $b5d42ccb624da5d0$var$minAlpha = 0;
class $b5d42ccb624da5d0$export$f853bd5d64973058 {
    constructor(){
        this.filter = (pixel)=>pixel.a > $b5d42ccb624da5d0$var$minAlpha;
        this.offset = 4;
    }
    load(data) {
        if (!data) return;
        if (data.filter !== undefined) {
            if ((0, $ad25b6e319f6df8c$export$844ec244b1367d54)(data.filter)) {
                if (Object.hasOwn(window, data.filter)) {
                    const filter = window[data.filter];
                    if ((0, $ad25b6e319f6df8c$export$f6e2535fb5126e54)(filter)) this.filter = filter;
                }
            } else this.filter = data.filter;
        }
        if (data.offset !== undefined) this.offset = data.offset;
    }
}


class $2ab5cd6f05eebeb1$export$266ca670de296127 {
    constructor(){
        this.src = "";
    }
    load(data) {
        if (!data) return;
        if (data.src !== undefined) this.src = data.src;
    }
}


class $b1c79f4ecd0181cc$export$e29bd83a5d29c1ef {
    constructor(){
        this.family = "sans-serif";
        this.size = 100;
    }
    load(data) {
        if (!data) return;
        if (data.family !== undefined) this.family = data.family;
        if (data.size !== undefined) this.size = data.size;
        if (data.style !== undefined) this.style = data.style;
        if (data.variant !== undefined) this.variant = data.variant;
        if (data.weight !== undefined) this.weight = data.weight;
    }
}


class $fcbe6e4e9c8f6df5$export$4dd17fcd7444ac9e {
    constructor(){
        this.separator = "\n";
        this.spacing = 10;
    }
    load(data) {
        if (!data) return;
        if (data.separator !== undefined) this.separator = data.separator;
        if (data.spacing !== undefined) this.spacing = data.spacing;
    }
}


class $e2c9ac9c36b0ba6e$export$42743c97618753db {
    constructor(){
        this.color = "#000000";
        this.font = new (0, $b1c79f4ecd0181cc$export$e29bd83a5d29c1ef)();
        this.lines = new (0, $fcbe6e4e9c8f6df5$export$4dd17fcd7444ac9e)();
        this.text = "";
    }
    load(data) {
        if (!data) return;
        if (data.color !== undefined) this.color = data.color;
        this.font.load(data.font);
        this.lines.load(data.lines);
        if (data.text !== undefined) this.text = data.text;
    }
}


class $16fcb4a73ffc896b$export$831f86c8100b98b6 {
    constructor(){
        this.enable = false;
        this.override = new (0, $40fc071112097c2a$export$132b80e403ecbcee)();
        this.pixels = new (0, $b5d42ccb624da5d0$export$f853bd5d64973058)();
        this.position = {
            x: 50,
            y: 50
        };
        this.scale = 1;
    }
    load(data) {
        if (!data) return;
        if (data.element !== undefined && data.element instanceof HTMLCanvasElement) this.element = data.element;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.image) {
            if (!this.image) this.image = new (0, $2ab5cd6f05eebeb1$export$266ca670de296127)();
            this.image.load(data.image);
        }
        this.pixels.load(data.pixels);
        if (data.position) this.position = {
            x: data.position.x ?? this.position.x,
            y: data.position.y ?? this.position.y
        };
        this.override.load(data.override);
        if (data.scale !== undefined) this.scale = data.scale;
        if (data.selector !== undefined) this.selector = data.selector;
        if (data.text) {
            if (!this.text) this.text = new (0, $e2c9ac9c36b0ba6e$export$42743c97618753db)();
            this.text.load(data.text);
        }
    }
}



const $03b4bec4b1524791$var$half = 0.5, $03b4bec4b1524791$var$origin = {
    x: 0,
    y: 0
}, $03b4bec4b1524791$var$defaultWidth = 0;
function $03b4bec4b1524791$export$5b835e5365c5e9f9(container, data, position, scale, override, filter) {
    const { height: height, width: width } = data, numPixels = height * width, indexArray = $03b4bec4b1524791$var$shuffle($03b4bec4b1524791$var$range(numPixels)), maxParticles = Math.min(numPixels, container.actualOptions.particles.number.value), canvasSize = container.canvas.size;
    let selectedPixels = 0;
    const positionOffset = {
        x: canvasSize.width * position.x / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd) - width * scale * $03b4bec4b1524791$var$half,
        y: canvasSize.height * position.y / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd) - height * scale * $03b4bec4b1524791$var$half
    };
    while(selectedPixels < maxParticles && indexArray.length){
        const defaultIndex = 0, nextIndex = indexArray.pop() ?? defaultIndex, pixelPos = {
            x: nextIndex % width,
            y: Math.floor(nextIndex / width)
        }, pixel = data.pixels[pixelPos.y][pixelPos.x], shouldCreateParticle = filter(pixel);
        if (!shouldCreateParticle) continue;
        const pos = {
            x: pixelPos.x * scale + positionOffset.x,
            y: pixelPos.y * scale + positionOffset.y
        }, pOptions = {};
        if (override.color) pOptions.color = {
            value: pixel
        };
        if (override.opacity) pOptions.opacity = {
            value: pixel.a
        };
        container.particles.addParticle(pos, pOptions);
        selectedPixels++;
    }
}
function $03b4bec4b1524791$export$6d31fcf241f37a57(ctx, size, offset, clear = true) {
    const imageData = ctx.getImageData($03b4bec4b1524791$var$origin.x, $03b4bec4b1524791$var$origin.y, size.width, size.height).data;
    if (clear) ctx.clearRect($03b4bec4b1524791$var$origin.x, $03b4bec4b1524791$var$origin.y, size.width, size.height);
    const pixels = [];
    for(let i = 0; i < imageData.length; i += offset){
        const idx = i / offset, pos = {
            x: idx % size.width,
            y: Math.floor(idx / size.width)
        };
        if (!pixels[pos.y]) pixels[pos.y] = [];
        const indexesOffset = {
            r: 0,
            g: 1,
            b: 2,
            a: 3
        }, alphaFactor = 255;
        pixels[pos.y][pos.x] = {
            r: imageData[i + indexesOffset.r],
            g: imageData[i + indexesOffset.g],
            b: imageData[i + indexesOffset.b],
            a: imageData[i + indexesOffset.a] / alphaFactor
        };
    }
    return {
        pixels: pixels,
        width: Math.min(...pixels.map((row)=>row.length)),
        height: pixels.length
    };
}
function $03b4bec4b1524791$export$d93c68e129326488(src, offset) {
    const image = new Image();
    image.crossOrigin = "Anonymous";
    const p = new Promise((resolve, reject)=>{
        image.onerror = reject;
        image.onload = ()=>{
            const canvas = document.createElement("canvas");
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext("2d");
            if (!context) return reject(new Error(`${(0, $dec17af1c054e95f$export$adea4917e02d93dc)} Could not get canvas context`));
            context.drawImage(image, $03b4bec4b1524791$var$origin.x, $03b4bec4b1524791$var$origin.y, image.width, image.height, $03b4bec4b1524791$var$origin.x, $03b4bec4b1524791$var$origin.y, canvas.width, canvas.height);
            resolve($03b4bec4b1524791$export$6d31fcf241f37a57(context, canvas, offset));
        };
    });
    image.src = src;
    return p;
}
function $03b4bec4b1524791$export$ab5b0e9c6423d9e7(textOptions, offset) {
    const canvas = document.createElement("canvas"), context = canvas.getContext("2d"), { font: font, text: text, lines: linesOptions, color: color } = textOptions;
    if (!text || !context) return;
    const lines = text.split(linesOptions.separator), fontSize = (0, $ad25b6e319f6df8c$export$7e4aa119212bc614)(font.size) ? `${font.size}px` : font.size, linesData = [];
    let maxWidth = 0, totalHeight = 0;
    for (const line of lines){
        context.font = `${font.style ?? ""} ${font.variant ?? ""} ${font.weight ?? ""} ${fontSize} ${font.family}`;
        const measure = context.measureText(line), lineData = {
            measure: measure,
            text: line,
            height: measure.actualBoundingBoxAscent + measure.actualBoundingBoxDescent,
            width: measure.width
        };
        maxWidth = Math.max(maxWidth || $03b4bec4b1524791$var$defaultWidth, lineData.width);
        totalHeight += lineData.height + linesOptions.spacing;
        linesData.push(lineData);
    }
    canvas.width = maxWidth;
    canvas.height = totalHeight;
    let currentHeight = 0;
    for (const line of linesData){
        context.font = `${font.style ?? ""} ${font.variant ?? ""} ${font.weight ?? ""} ${fontSize} ${font.family}`;
        context.fillStyle = color;
        context.fillText(line.text, $03b4bec4b1524791$var$origin.x, currentHeight + line.measure.actualBoundingBoxAscent);
        currentHeight += line.height + linesOptions.spacing;
    }
    return $03b4bec4b1524791$export$6d31fcf241f37a57(context, canvas, offset);
}
function $03b4bec4b1524791$var$shuffle(array) {
    const lengthOffset = 1, minIndex = 0;
    for(let currentIndex = array.length - lengthOffset; currentIndex >= minIndex; currentIndex--){
        const randomIndex = Math.floor((0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * currentIndex);
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex],
            array[currentIndex]
        ];
    }
    return array;
}
const $03b4bec4b1524791$var$range = (n)=>[
        ...Array(n).keys()
    ];


class $9f83ed921e9ee1eb$export$fb55504331c535ed {
    constructor(container){
        this._container = container;
    }
    async init() {
        const container = this._container, options = container.actualOptions.canvasMask;
        if (!options?.enable) return;
        let pixelData = {
            pixels: [],
            height: 0,
            width: 0
        };
        const offset = options.pixels.offset;
        if (options.image) {
            const url = options.image.src;
            if (!url) return;
            pixelData = await (0, $03b4bec4b1524791$export$d93c68e129326488)(url, offset);
        } else if (options.text) {
            const textOptions = options.text;
            const data = (0, $03b4bec4b1524791$export$ab5b0e9c6423d9e7)(textOptions, offset);
            if (!data) return;
            pixelData = data;
        } else if (options.element ?? options.selector) {
            const canvas = options.element ?? (options.selector && document.querySelector(options.selector));
            if (!canvas) return;
            const context = canvas.getContext("2d");
            if (!context) return;
            pixelData = (0, $03b4bec4b1524791$export$6d31fcf241f37a57)(context, canvas, offset);
        }
        (0, $03b4bec4b1524791$export$5b835e5365c5e9f9)(container, pixelData, options.position, options.scale, options.override, options.pixels.filter);
    }
}


class $8a93fb5e1e5eeb96$export$e908df6fe3dcdecd {
    constructor(){
        this.id = "canvasMask";
    }
    getPlugin(container) {
        return Promise.resolve(new (0, $9f83ed921e9ee1eb$export$fb55504331c535ed)(container));
    }
    loadOptions(options, source) {
        if (!this.needsPlugin(options) && !this.needsPlugin(source)) return;
        let canvasMaskOptions = options.canvasMask;
        if (canvasMaskOptions?.load === undefined) options.canvasMask = canvasMaskOptions = new (0, $16fcb4a73ffc896b$export$831f86c8100b98b6)();
        canvasMaskOptions.load(source?.canvasMask);
    }
    needsPlugin(options) {
        return options?.canvasMask?.enable ?? false;
    }
}


async function $497776f81ff8aecd$export$ff99555347c1020e(engine, refresh = true) {
    await engine.addPlugin(new (0, $8a93fb5e1e5eeb96$export$e908df6fe3dcdecd)(), refresh);
}


function $2bfbcd3c23f3f6b8$export$f89e19e593add7bd(data, path) {
    if (!path.segments.length || !path.segments[0].values.length) return;
    const { context: context, radius: radius } = data;
    context.moveTo(path.segments[0].values[0].x * radius, path.segments[0].values[0].y * radius);
    for (const segment of path.segments)context.bezierCurveTo(segment.values[1].x * radius, segment.values[1].y * radius, segment.values[2].x * radius, segment.values[2].y * radius, segment.values[3].x * radius, segment.values[3].y * radius);
    for(let i = path.segments.length - 1; i >= 0; i--){
        const segment = path.segments[i];
        context.bezierCurveTo(-segment.values[2].x * radius, segment.values[2].y * radius, -segment.values[1].x * radius, segment.values[1].y * radius, -segment.values[0].x * radius, segment.values[0].y * radius);
    }
}
const $2bfbcd3c23f3f6b8$var$n = 0.5;
const $2bfbcd3c23f3f6b8$export$595447059867920 = {
    heart: {
        segments: [
            {
                values: [
                    {
                        x: 0,
                        y: $2bfbcd3c23f3f6b8$var$n
                    },
                    {
                        x: 0,
                        y: $2bfbcd3c23f3f6b8$var$n
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n,
                        y: 0
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n,
                        y: -$2bfbcd3c23f3f6b8$var$n / 2
                    }
                ]
            },
            {
                values: [
                    {
                        x: $2bfbcd3c23f3f6b8$var$n,
                        y: -$2bfbcd3c23f3f6b8$var$n / 2
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n,
                        y: -$2bfbcd3c23f3f6b8$var$n / 2
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n,
                        y: -$2bfbcd3c23f3f6b8$var$n
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 2,
                        y: -$2bfbcd3c23f3f6b8$var$n
                    }
                ]
            },
            {
                values: [
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 2,
                        y: -$2bfbcd3c23f3f6b8$var$n
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 2,
                        y: -$2bfbcd3c23f3f6b8$var$n
                    },
                    {
                        x: 0,
                        y: -$2bfbcd3c23f3f6b8$var$n
                    },
                    {
                        x: 0,
                        y: -$2bfbcd3c23f3f6b8$var$n / 2
                    }
                ]
            }
        ]
    },
    diamond: {
        segments: [
            {
                values: [
                    {
                        x: 0,
                        y: $2bfbcd3c23f3f6b8$var$n
                    },
                    {
                        x: 0,
                        y: $2bfbcd3c23f3f6b8$var$n
                    },
                    {
                        x: 3 * $2bfbcd3c23f3f6b8$var$n / 4,
                        y: 0
                    },
                    {
                        x: 3 * $2bfbcd3c23f3f6b8$var$n / 4,
                        y: 0
                    }
                ]
            },
            {
                values: [
                    {
                        x: 3 * $2bfbcd3c23f3f6b8$var$n / 4,
                        y: 0
                    },
                    {
                        x: 3 * $2bfbcd3c23f3f6b8$var$n / 4,
                        y: 0
                    },
                    {
                        x: 0,
                        y: -$2bfbcd3c23f3f6b8$var$n
                    },
                    {
                        x: 0,
                        y: -$2bfbcd3c23f3f6b8$var$n
                    }
                ]
            }
        ]
    },
    club: {
        segments: [
            {
                values: [
                    {
                        x: 0,
                        y: -$2bfbcd3c23f3f6b8$var$n
                    },
                    {
                        x: 0,
                        y: -$2bfbcd3c23f3f6b8$var$n
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 2,
                        y: -$2bfbcd3c23f3f6b8$var$n
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 2,
                        y: -$2bfbcd3c23f3f6b8$var$n / 2
                    }
                ]
            },
            {
                values: [
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 2,
                        y: -$2bfbcd3c23f3f6b8$var$n / 2
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 2,
                        y: -$2bfbcd3c23f3f6b8$var$n / 2
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n,
                        y: -$2bfbcd3c23f3f6b8$var$n / 2
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n,
                        y: 0
                    }
                ]
            },
            {
                values: [
                    {
                        x: $2bfbcd3c23f3f6b8$var$n,
                        y: 0
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n,
                        y: 0
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n,
                        y: $2bfbcd3c23f3f6b8$var$n / 2
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 2,
                        y: $2bfbcd3c23f3f6b8$var$n / 2
                    }
                ]
            },
            {
                values: [
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 2,
                        y: $2bfbcd3c23f3f6b8$var$n / 2
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 2,
                        y: $2bfbcd3c23f3f6b8$var$n / 2
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 8,
                        y: $2bfbcd3c23f3f6b8$var$n / 2
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 8,
                        y: $2bfbcd3c23f3f6b8$var$n / 8
                    }
                ]
            },
            {
                values: [
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 8,
                        y: $2bfbcd3c23f3f6b8$var$n / 8
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 8,
                        y: $2bfbcd3c23f3f6b8$var$n / 2
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 2,
                        y: $2bfbcd3c23f3f6b8$var$n
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 2,
                        y: $2bfbcd3c23f3f6b8$var$n
                    }
                ]
            },
            {
                values: [
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 2,
                        y: $2bfbcd3c23f3f6b8$var$n
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 2,
                        y: $2bfbcd3c23f3f6b8$var$n
                    },
                    {
                        x: 0,
                        y: $2bfbcd3c23f3f6b8$var$n
                    },
                    {
                        x: 0,
                        y: $2bfbcd3c23f3f6b8$var$n
                    }
                ]
            }
        ]
    },
    spade: {
        segments: [
            {
                values: [
                    {
                        x: 0,
                        y: -$2bfbcd3c23f3f6b8$var$n
                    },
                    {
                        x: 0,
                        y: -$2bfbcd3c23f3f6b8$var$n
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n,
                        y: -$2bfbcd3c23f3f6b8$var$n / 2
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n,
                        y: 0
                    }
                ]
            },
            {
                values: [
                    {
                        x: $2bfbcd3c23f3f6b8$var$n,
                        y: 0
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n,
                        y: 0
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n,
                        y: $2bfbcd3c23f3f6b8$var$n / 2
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 2,
                        y: $2bfbcd3c23f3f6b8$var$n / 2
                    }
                ]
            },
            {
                values: [
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 2,
                        y: $2bfbcd3c23f3f6b8$var$n / 2
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 2,
                        y: $2bfbcd3c23f3f6b8$var$n / 2
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 8,
                        y: $2bfbcd3c23f3f6b8$var$n / 2
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 8,
                        y: $2bfbcd3c23f3f6b8$var$n / 8
                    }
                ]
            },
            {
                values: [
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 8,
                        y: $2bfbcd3c23f3f6b8$var$n / 8
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 8,
                        y: $2bfbcd3c23f3f6b8$var$n / 2
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 2,
                        y: $2bfbcd3c23f3f6b8$var$n
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 2,
                        y: $2bfbcd3c23f3f6b8$var$n
                    }
                ]
            },
            {
                values: [
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 2,
                        y: $2bfbcd3c23f3f6b8$var$n
                    },
                    {
                        x: $2bfbcd3c23f3f6b8$var$n / 2,
                        y: $2bfbcd3c23f3f6b8$var$n
                    },
                    {
                        x: 0,
                        y: $2bfbcd3c23f3f6b8$var$n
                    },
                    {
                        x: 0,
                        y: $2bfbcd3c23f3f6b8$var$n
                    }
                ]
            }
        ]
    }
};


class $c4ac6613c303bcfb$export$da612b2d70aeb649 {
    constructor(){
        this.validTypes = [
            "club",
            "clubs"
        ];
    }
    draw(data) {
        (0, $2bfbcd3c23f3f6b8$export$f89e19e593add7bd)(data, (0, $2bfbcd3c23f3f6b8$export$595447059867920).club);
    }
}



class $0067156a61fbf098$export$247c3c7c09c2648d {
    constructor(){
        this.validTypes = [
            "diamond",
            "diamonds"
        ];
    }
    draw(data) {
        (0, $2bfbcd3c23f3f6b8$export$f89e19e593add7bd)(data, (0, $2bfbcd3c23f3f6b8$export$595447059867920).diamond);
    }
}



class $4e3cefcbb2607d7d$export$31c1f9caabb1823e {
    constructor(){
        this.validTypes = [
            "heart",
            "hearts"
        ];
    }
    draw(data) {
        (0, $2bfbcd3c23f3f6b8$export$f89e19e593add7bd)(data, (0, $2bfbcd3c23f3f6b8$export$595447059867920).heart);
    }
}



class $9b298dade5f65548$export$8b4ff1f3da5b6db4 {
    constructor(){
        this.validTypes = [
            "spade",
            "spades"
        ];
    }
    draw(data) {
        (0, $2bfbcd3c23f3f6b8$export$f89e19e593add7bd)(data, (0, $2bfbcd3c23f3f6b8$export$595447059867920).spade);
    }
}


async function $2b8571bf2a2f9ce8$export$4b909c2789cff23(engine, refresh = true) {
    await engine.addShape(new (0, $9b298dade5f65548$export$8b4ff1f3da5b6db4)(), refresh);
    await engine.addShape(new (0, $4e3cefcbb2607d7d$export$31c1f9caabb1823e)(), refresh);
    await engine.addShape(new (0, $0067156a61fbf098$export$247c3c7c09c2648d)(), refresh);
    await engine.addShape(new (0, $c4ac6613c303bcfb$export$da612b2d70aeb649)(), refresh);
}




const $f837ee21de746bf6$var$double = 2, $f837ee21de746bf6$var$doublePI = Math.PI * $f837ee21de746bf6$var$double, $f837ee21de746bf6$var$minAngle = 0, $f837ee21de746bf6$var$origin = {
    x: 0,
    y: 0
}, $f837ee21de746bf6$var$taperFactor = 0.005;
function $f837ee21de746bf6$export$2713c7b74542cb3b(data) {
    const { context: context, particle: particle, radius: radius } = data;
    if (particle.cogHoleRadius === undefined || particle.cogInnerRadius === undefined || particle.cogInnerTaper === undefined || particle.cogNotches === undefined || particle.cogOuterTaper === undefined) return;
    const holeRadius = radius * particle.cogHoleRadius / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd);
    context.globalCompositeOperation = "destination-out";
    context.beginPath();
    context.moveTo(holeRadius, $f837ee21de746bf6$var$origin.y);
    context.arc($f837ee21de746bf6$var$origin.x, $f837ee21de746bf6$var$origin.y, holeRadius, $f837ee21de746bf6$var$minAngle, $f837ee21de746bf6$var$doublePI);
    context.closePath();
    context.fill();
    context.globalCompositeOperation = "source-over";
}
function $f837ee21de746bf6$export$cc0211a11184f089(data) {
    const { context: context, particle: particle, radius: radius } = data;
    if (particle.cogHoleRadius === undefined || particle.cogInnerRadius === undefined || particle.cogInnerTaper === undefined || particle.cogNotches === undefined || particle.cogOuterTaper === undefined) return;
    const angle = $f837ee21de746bf6$var$doublePI / (particle.cogNotches * $f837ee21de746bf6$var$double), taperAI = angle * particle.cogInnerTaper * $f837ee21de746bf6$var$taperFactor, taperAO = angle * particle.cogOuterTaper * $f837ee21de746bf6$var$taperFactor, innerRadius = radius * particle.cogInnerRadius / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd);
    let a = angle, toggle = false;
    context.moveTo(radius * Math.cos(taperAO), radius * Math.sin(taperAO));
    for(; a <= $f837ee21de746bf6$var$doublePI; a += angle){
        if (toggle) {
            context.lineTo(innerRadius * Math.cos(a - taperAI), innerRadius * Math.sin(a - taperAI));
            context.lineTo(radius * Math.cos(a + taperAO), radius * Math.sin(a + taperAO));
        } else {
            context.lineTo(radius * Math.cos(a - taperAO), radius * Math.sin(a - taperAO));
            context.lineTo(innerRadius * Math.cos(a + taperAI), innerRadius * Math.sin(a + taperAI));
        }
        toggle = !toggle;
    }
}


const $e4121565e0673f8e$var$defaultHoleRadius = 44, $e4121565e0673f8e$var$defaultInnerRadius = 72, $e4121565e0673f8e$var$defaultInnerTaper = 35, $e4121565e0673f8e$var$defaultNotches = 7, $e4121565e0673f8e$var$defaultOuterTaper = 50;
class $e4121565e0673f8e$export$68911a6a3f517409 {
    constructor(){
        this.validTypes = [
            "cog"
        ];
    }
    afterDraw(data) {
        (0, $f837ee21de746bf6$export$2713c7b74542cb3b)(data);
    }
    draw(data) {
        (0, $f837ee21de746bf6$export$cc0211a11184f089)(data);
    }
    particleInit(container, particle) {
        const shapeData = particle.shapeData;
        particle.cogHoleRadius = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(shapeData?.holeRadius ?? $e4121565e0673f8e$var$defaultHoleRadius);
        particle.cogInnerRadius = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(shapeData?.innerRadius ?? $e4121565e0673f8e$var$defaultInnerRadius);
        particle.cogInnerTaper = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(shapeData?.innerTaper ?? $e4121565e0673f8e$var$defaultInnerTaper);
        particle.cogNotches = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(shapeData?.notches ?? $e4121565e0673f8e$var$defaultNotches);
        particle.cogOuterTaper = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(shapeData?.outerTaper ?? $e4121565e0673f8e$var$defaultOuterTaper);
    }
}


async function $4fdce87f255aa872$export$d051d1bf41ebd4ca(engine, refresh = true) {
    await engine.addShape(new (0, $e4121565e0673f8e$export$68911a6a3f517409)(), refresh);
}



function $e18ec54dce7f5192$export$aa932ea13ef50a6(seed) {
    const newSeed = new Uint32Array(1);
    newSeed[0] = seed[0] * 1664525 + 1013904223;
    return newSeed;
}


class $a8be242516f2688d$export$52ab408760750b8c {
    constructor(){
        this._NORM_2D = 1.0 / 47.0;
        this._SQUISH_2D = (Math.sqrt(3) - 1) / 2;
        this._STRETCH_2D = (1 / Math.sqrt(3) - 1) / 2;
        this._base2D = [
            [
                1,
                1,
                0,
                1,
                0,
                1,
                0,
                0,
                0
            ],
            [
                1,
                1,
                0,
                1,
                0,
                1,
                2,
                1,
                1
            ]
        ];
        this._gradients2D = [
            5,
            2,
            2,
            5,
            -5,
            2,
            -2,
            5,
            5,
            -2,
            2,
            -5,
            -5,
            -2,
            -2,
            -5
        ];
        this._lookup = [];
        this._lookupPairs2D = [
            0,
            1,
            1,
            0,
            4,
            1,
            17,
            0,
            20,
            2,
            21,
            2,
            22,
            5,
            23,
            5,
            26,
            4,
            39,
            3,
            42,
            4,
            43,
            3
        ];
        this._p2D = [
            0,
            0,
            1,
            -1,
            0,
            0,
            -1,
            1,
            0,
            2,
            1,
            1,
            1,
            2,
            2,
            0,
            1,
            2,
            0,
            2,
            1,
            0,
            0,
            0
        ];
        this._perm = new Uint8Array(256);
        this._perm2D = new Uint8Array(256);
    }
    noise(x, y) {
        const { _gradients2D: _gradients2D, _NORM_2D: _NORM_2D, _SQUISH_2D: _SQUISH_2D, _STRETCH_2D: _STRETCH_2D, _lookup: _lookup, _perm: _perm, _perm2D: _perm2D } = this;
        const stretchOffset = (x + y) * _STRETCH_2D, xs = x + stretchOffset, ys = y + stretchOffset, xsb = Math.floor(xs), ysb = Math.floor(ys), squishOffset = (xsb + ysb) * _SQUISH_2D, dx0 = x - (xsb + squishOffset), dy0 = y - (ysb + squishOffset), xins = xs - xsb, yins = ys - ysb, inSum = xins + yins, hash = xins - yins + 1 | inSum << 1 | inSum + yins << 2 | inSum + xins << 4;
        let value = 0;
        for(let c = _lookup[hash]; c !== undefined; c = c.next){
            const dx = dx0 + c.dx, dy = dy0 + c.dy, attn = 2 - dx * dx - dy * dy;
            if (attn > 0) {
                const px = xsb + c.xsb, py = ysb + c.ysb, indexPartA = _perm[px & 0xff], index = _perm2D[indexPartA + py & 0xff], valuePart = _gradients2D[index] * dx + _gradients2D[index + 1] * dy;
                value += attn * attn * attn * attn * valuePart;
            }
        }
        return value * _NORM_2D;
    }
    seed(clientSeed) {
        const { _p2D: _p2D, _base2D: _base2D, _lookupPairs2D: _lookupPairs2D } = this;
        const contributions = [];
        for(let i = 0; i < _p2D.length; i += 4){
            const baseSet = _base2D[_p2D[i]];
            let previous = null, current = null;
            for(let k = 0; k < baseSet.length; k += 3){
                current = this._contribution2D(baseSet[k], baseSet[k + 1], baseSet[k + 2]);
                if (previous === null) contributions[i / 4] = current;
                else previous.next = current;
                previous = current;
            }
            if (current) current.next = this._contribution2D(_p2D[i + 1], _p2D[i + 2], _p2D[i + 3]);
        }
        this._lookup = [];
        for(let i = 0; i < _lookupPairs2D.length; i += 2)this._lookup[_lookupPairs2D[i]] = contributions[_lookupPairs2D[i + 1]];
        this._perm = new Uint8Array(256);
        this._perm2D = new Uint8Array(256);
        const source = new Uint8Array(256);
        for(let i = 0; i < 256; i++)source[i] = i;
        let seed = new Uint32Array(1);
        seed[0] = clientSeed;
        seed = (0, $e18ec54dce7f5192$export$aa932ea13ef50a6)((0, $e18ec54dce7f5192$export$aa932ea13ef50a6)((0, $e18ec54dce7f5192$export$aa932ea13ef50a6)(seed)));
        for(let i = 255; i >= 0; i--){
            seed = (0, $e18ec54dce7f5192$export$aa932ea13ef50a6)(seed);
            const r = new Uint32Array(1);
            r[0] = (seed[0] + 31) % (i + 1);
            if (r[0] < 0) r[0] += i + 1;
            this._perm[i] = source[r[0]];
            this._perm2D[i] = this._perm[i] & 0x0e;
            source[r[0]] = source[i];
        }
    }
    _contribution2D(multiplier, xsb, ysb) {
        const { _SQUISH_2D: _SQUISH_2D } = this;
        return {
            dx: -xsb - multiplier * _SQUISH_2D,
            dy: -ysb - multiplier * _SQUISH_2D,
            xsb: xsb,
            ysb: ysb
        };
    }
}



class $3b0efba3f28743d5$export$a44113dd60da2b84 {
    constructor(){
        this._NORM_3D = 1.0 / 103.0;
        this._SQUISH_3D = (Math.sqrt(4) - 1) / 3;
        this._STRETCH_3D = (1 / Math.sqrt(4) - 1) / 3;
        this._base3D = [
            [
                0,
                0,
                0,
                0,
                1,
                1,
                0,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                0,
                1
            ],
            [
                2,
                1,
                1,
                0,
                2,
                1,
                0,
                1,
                2,
                0,
                1,
                1,
                3,
                1,
                1,
                1
            ],
            [
                1,
                1,
                0,
                0,
                1,
                0,
                1,
                0,
                1,
                0,
                0,
                1,
                2,
                1,
                1,
                0,
                2,
                1,
                0,
                1,
                2,
                0,
                1,
                1
            ]
        ];
        this._gradients3D = [
            -11,
            4,
            4,
            -4,
            11,
            4,
            -4,
            4,
            11,
            11,
            4,
            4,
            4,
            11,
            4,
            4,
            4,
            11,
            -11,
            -4,
            4,
            -4,
            -11,
            4,
            -4,
            -4,
            11,
            11,
            -4,
            4,
            4,
            -11,
            4,
            4,
            -4,
            11,
            -11,
            4,
            -4,
            -4,
            11,
            -4,
            -4,
            4,
            -11,
            11,
            4,
            -4,
            4,
            11,
            -4,
            4,
            4,
            -11,
            -11,
            -4,
            -4,
            -4,
            -11,
            -4,
            -4,
            -4,
            -11,
            11,
            -4,
            -4,
            4,
            -11,
            -4,
            4,
            -4,
            -11
        ];
        this._lookup = [];
        this._lookupPairs3D = [
            0,
            2,
            1,
            1,
            2,
            2,
            5,
            1,
            6,
            0,
            7,
            0,
            32,
            2,
            34,
            2,
            129,
            1,
            133,
            1,
            160,
            5,
            161,
            5,
            518,
            0,
            519,
            0,
            546,
            4,
            550,
            4,
            645,
            3,
            647,
            3,
            672,
            5,
            673,
            5,
            674,
            4,
            677,
            3,
            678,
            4,
            679,
            3,
            680,
            13,
            681,
            13,
            682,
            12,
            685,
            14,
            686,
            12,
            687,
            14,
            712,
            20,
            714,
            18,
            809,
            21,
            813,
            23,
            840,
            20,
            841,
            21,
            1198,
            19,
            1199,
            22,
            1226,
            18,
            1230,
            19,
            1325,
            23,
            1327,
            22,
            1352,
            15,
            1353,
            17,
            1354,
            15,
            1357,
            17,
            1358,
            16,
            1359,
            16,
            1360,
            11,
            1361,
            10,
            1362,
            11,
            1365,
            10,
            1366,
            9,
            1367,
            9,
            1392,
            11,
            1394,
            11,
            1489,
            10,
            1493,
            10,
            1520,
            8,
            1521,
            8,
            1878,
            9,
            1879,
            9,
            1906,
            7,
            1910,
            7,
            2005,
            6,
            2007,
            6,
            2032,
            8,
            2033,
            8,
            2034,
            7,
            2037,
            6,
            2038,
            7,
            2039,
            6
        ];
        this._p3D = [
            0,
            0,
            1,
            -1,
            0,
            0,
            1,
            0,
            -1,
            0,
            0,
            -1,
            1,
            0,
            0,
            0,
            1,
            -1,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            -1,
            1,
            0,
            2,
            1,
            1,
            0,
            1,
            1,
            1,
            -1,
            0,
            2,
            1,
            0,
            1,
            1,
            1,
            -1,
            1,
            0,
            2,
            0,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            3,
            2,
            1,
            0,
            3,
            1,
            2,
            0,
            1,
            3,
            2,
            0,
            1,
            3,
            1,
            0,
            2,
            1,
            3,
            0,
            2,
            1,
            3,
            0,
            1,
            2,
            1,
            1,
            1,
            0,
            0,
            2,
            2,
            0,
            0,
            1,
            1,
            0,
            1,
            0,
            2,
            0,
            2,
            0,
            1,
            1,
            0,
            0,
            1,
            2,
            0,
            0,
            2,
            2,
            0,
            0,
            0,
            0,
            1,
            1,
            -1,
            1,
            2,
            0,
            0,
            0,
            0,
            1,
            -1,
            1,
            1,
            2,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            -1,
            2,
            3,
            1,
            1,
            1,
            2,
            0,
            0,
            2,
            2,
            3,
            1,
            1,
            1,
            2,
            2,
            0,
            0,
            2,
            3,
            1,
            1,
            1,
            2,
            0,
            2,
            0,
            2,
            1,
            1,
            -1,
            1,
            2,
            0,
            0,
            2,
            2,
            1,
            1,
            -1,
            1,
            2,
            2,
            0,
            0,
            2,
            1,
            -1,
            1,
            1,
            2,
            0,
            0,
            2,
            2,
            1,
            -1,
            1,
            1,
            2,
            0,
            2,
            0,
            2,
            1,
            1,
            1,
            -1,
            2,
            2,
            0,
            0,
            2,
            1,
            1,
            1,
            -1,
            2,
            0,
            2,
            0
        ];
        this._perm = new Uint8Array(256);
        this._perm3D = new Uint8Array(256);
    }
    noise(x, y, z) {
        const { _STRETCH_3D: _STRETCH_3D, _NORM_3D: _NORM_3D, _SQUISH_3D: _SQUISH_3D, _lookup: _lookup, _perm: _perm, _perm3D: _perm3D, _gradients3D: _gradients3D } = this, stretchOffset = (x + y + z) * _STRETCH_3D, xs = x + stretchOffset, ys = y + stretchOffset, zs = z + stretchOffset, xsb = Math.floor(xs), ysb = Math.floor(ys), zsb = Math.floor(zs), squishOffset = (xsb + ysb + zsb) * _SQUISH_3D, dx0 = x - (xsb + squishOffset), dy0 = y - (ysb + squishOffset), dz0 = z - (zsb + squishOffset), xins = xs - xsb, yins = ys - ysb, zins = zs - zsb, inSum = xins + yins + zins, hash = yins - zins + 1 | xins - yins + 1 << 1 | xins - zins + 1 << 2 | inSum << 3 | inSum + zins << 5 | inSum + yins << 7 | inSum + xins << 9;
        let value = 0;
        for(let c = _lookup[hash]; c !== undefined; c = c.next){
            const dx = dx0 + c.dx, dy = dy0 + c.dy, dz = dz0 + c.dz, attn = 2 - dx * dx - dy * dy - dz * dz;
            if (attn > 0) {
                const px = xsb + c.xsb, py = ysb + c.ysb, pz = zsb + c.zsb, indexPartA = _perm[px & 0xff], indexPartB = _perm[indexPartA + py & 0xff], index = _perm3D[indexPartB + pz & 0xff], valuePart = _gradients3D[index] * dx + _gradients3D[index + 1] * dy + _gradients3D[index + 2] * dz;
                value += attn * attn * attn * attn * valuePart;
            }
        }
        return value * _NORM_3D;
    }
    seed(clientSeed) {
        const { _base3D: _base3D, _lookupPairs3D: _lookupPairs3D, _p3D: _p3D } = this, contributions = [];
        for(let i = 0; i < _p3D.length; i += 9){
            const baseSet = _base3D[_p3D[i]];
            let previous = null, current = null;
            for(let k = 0; k < baseSet.length; k += 4){
                current = this._contribution3D(baseSet[k], baseSet[k + 1], baseSet[k + 2], baseSet[k + 3]);
                if (previous === null) contributions[i / 9] = current;
                else previous.next = current;
                previous = current;
            }
            if (current) {
                current.next = this._contribution3D(_p3D[i + 1], _p3D[i + 2], _p3D[i + 3], _p3D[i + 4]);
                current.next.next = this._contribution3D(_p3D[i + 5], _p3D[i + 6], _p3D[i + 7], _p3D[i + 8]);
            }
        }
        this._lookup = [];
        for(let i = 0; i < _lookupPairs3D.length; i += 2)this._lookup[_lookupPairs3D[i]] = contributions[_lookupPairs3D[i + 1]];
        this._perm = new Uint8Array(256);
        this._perm3D = new Uint8Array(256);
        const source = new Uint8Array(256);
        for(let i = 0; i < 256; i++)source[i] = i;
        let seed = new Uint32Array(1);
        seed[0] = clientSeed;
        seed = (0, $e18ec54dce7f5192$export$aa932ea13ef50a6)((0, $e18ec54dce7f5192$export$aa932ea13ef50a6)((0, $e18ec54dce7f5192$export$aa932ea13ef50a6)(seed)));
        for(let i = 255; i >= 0; i--){
            seed = (0, $e18ec54dce7f5192$export$aa932ea13ef50a6)(seed);
            const r = new Uint32Array(1);
            r[0] = (seed[0] + 31) % (i + 1);
            if (r[0] < 0) r[0] += i + 1;
            this._perm[i] = source[r[0]];
            this._perm3D[i] = this._perm[i] % 24 * 3;
            source[r[0]] = source[i];
        }
    }
    _contribution3D(multiplier, xsb, ysb, zsb) {
        const { _SQUISH_3D: _SQUISH_3D } = this;
        return {
            dx: -xsb - multiplier * _SQUISH_3D,
            dy: -ysb - multiplier * _SQUISH_3D,
            dz: -zsb - multiplier * _SQUISH_3D,
            xsb: xsb,
            ysb: ysb,
            zsb: zsb
        };
    }
}



class $9fcd36499a697f55$export$19bc27e0a2c2bb9c {
    constructor(){
        this._NORM_4D = 1.0 / 30.0;
        this._SQUISH_4D = (Math.sqrt(5) - 1) * 0.25;
        this._STRETCH_4D = (1 / Math.sqrt(5) - 1) * 0.25;
        this._lookup = [];
        this._perm = new Uint8Array(0);
        this._perm4D = new Uint8Array(0);
        this._base4D = [
            [
                0,
                0,
                0,
                0,
                0,
                1,
                1,
                0,
                0,
                0,
                1,
                0,
                1,
                0,
                0,
                1,
                0,
                0,
                1,
                0,
                1,
                0,
                0,
                0,
                1
            ],
            [
                3,
                1,
                1,
                1,
                0,
                3,
                1,
                1,
                0,
                1,
                3,
                1,
                0,
                1,
                1,
                3,
                0,
                1,
                1,
                1,
                4,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                0,
                0,
                0,
                1,
                0,
                1,
                0,
                0,
                1,
                0,
                0,
                1,
                0,
                1,
                0,
                0,
                0,
                1,
                2,
                1,
                1,
                0,
                0,
                2,
                1,
                0,
                1,
                0,
                2,
                1,
                0,
                0,
                1,
                2,
                0,
                1,
                1,
                0,
                2,
                0,
                1,
                0,
                1,
                2,
                0,
                0,
                1,
                1
            ],
            [
                3,
                1,
                1,
                1,
                0,
                3,
                1,
                1,
                0,
                1,
                3,
                1,
                0,
                1,
                1,
                3,
                0,
                1,
                1,
                1,
                2,
                1,
                1,
                0,
                0,
                2,
                1,
                0,
                1,
                0,
                2,
                1,
                0,
                0,
                1,
                2,
                0,
                1,
                1,
                0,
                2,
                0,
                1,
                0,
                1,
                2,
                0,
                0,
                1,
                1
            ]
        ];
        this._gradients4D = [
            3,
            1,
            1,
            1,
            1,
            3,
            1,
            1,
            1,
            1,
            3,
            1,
            1,
            1,
            1,
            3,
            -3,
            1,
            1,
            1,
            -1,
            3,
            1,
            1,
            -1,
            1,
            3,
            1,
            -1,
            1,
            1,
            3,
            3,
            -1,
            1,
            1,
            1,
            -3,
            1,
            1,
            1,
            -1,
            3,
            1,
            1,
            -1,
            1,
            3,
            -3,
            -1,
            1,
            1,
            -1,
            -3,
            1,
            1,
            -1,
            -1,
            3,
            1,
            -1,
            -1,
            1,
            3,
            3,
            1,
            -1,
            1,
            1,
            3,
            -1,
            1,
            1,
            1,
            -3,
            1,
            1,
            1,
            -1,
            3,
            -3,
            1,
            -1,
            1,
            -1,
            3,
            -1,
            1,
            -1,
            1,
            -3,
            1,
            -1,
            1,
            -1,
            3,
            3,
            -1,
            -1,
            1,
            1,
            -3,
            -1,
            1,
            1,
            -1,
            -3,
            1,
            1,
            -1,
            -1,
            3,
            -3,
            -1,
            -1,
            1,
            -1,
            -3,
            -1,
            1,
            -1,
            -1,
            -3,
            1,
            -1,
            -1,
            -1,
            3,
            3,
            1,
            1,
            -1,
            1,
            3,
            1,
            -1,
            1,
            1,
            3,
            -1,
            1,
            1,
            1,
            -3,
            -3,
            1,
            1,
            -1,
            -1,
            3,
            1,
            -1,
            -1,
            1,
            3,
            -1,
            -1,
            1,
            1,
            -3,
            3,
            -1,
            1,
            -1,
            1,
            -3,
            1,
            -1,
            1,
            -1,
            3,
            -1,
            1,
            -1,
            1,
            -3,
            -3,
            -1,
            1,
            -1,
            -1,
            -3,
            1,
            -1,
            -1,
            -1,
            3,
            -1,
            -1,
            -1,
            1,
            -3,
            3,
            1,
            -1,
            -1,
            1,
            3,
            -1,
            -1,
            1,
            1,
            -3,
            -1,
            1,
            1,
            -1,
            -3,
            -3,
            1,
            -1,
            -1,
            -1,
            3,
            -1,
            -1,
            -1,
            1,
            -3,
            -1,
            -1,
            1,
            -1,
            -3,
            3,
            -1,
            -1,
            -1,
            1,
            -3,
            -1,
            -1,
            1,
            -1,
            -3,
            -1,
            1,
            -1,
            -1,
            -3,
            -3,
            -1,
            -1,
            -1,
            -1,
            -3,
            -1,
            -1,
            -1,
            -1,
            -3,
            -1,
            -1,
            -1,
            -1,
            -3
        ];
        this._lookupPairs4D = [
            0,
            3,
            1,
            2,
            2,
            3,
            5,
            2,
            6,
            1,
            7,
            1,
            8,
            3,
            9,
            2,
            10,
            3,
            13,
            2,
            16,
            3,
            18,
            3,
            22,
            1,
            23,
            1,
            24,
            3,
            26,
            3,
            33,
            2,
            37,
            2,
            38,
            1,
            39,
            1,
            41,
            2,
            45,
            2,
            54,
            1,
            55,
            1,
            56,
            0,
            57,
            0,
            58,
            0,
            59,
            0,
            60,
            0,
            61,
            0,
            62,
            0,
            63,
            0,
            256,
            3,
            258,
            3,
            264,
            3,
            266,
            3,
            272,
            3,
            274,
            3,
            280,
            3,
            282,
            3,
            2049,
            2,
            2053,
            2,
            2057,
            2,
            2061,
            2,
            2081,
            2,
            2085,
            2,
            2089,
            2,
            2093,
            2,
            2304,
            9,
            2305,
            9,
            2312,
            9,
            2313,
            9,
            16390,
            1,
            16391,
            1,
            16406,
            1,
            16407,
            1,
            16422,
            1,
            16423,
            1,
            16438,
            1,
            16439,
            1,
            16642,
            8,
            16646,
            8,
            16658,
            8,
            16662,
            8,
            18437,
            6,
            18439,
            6,
            18469,
            6,
            18471,
            6,
            18688,
            9,
            18689,
            9,
            18690,
            8,
            18693,
            6,
            18694,
            8,
            18695,
            6,
            18696,
            9,
            18697,
            9,
            18706,
            8,
            18710,
            8,
            18725,
            6,
            18727,
            6,
            131128,
            0,
            131129,
            0,
            131130,
            0,
            131131,
            0,
            131132,
            0,
            131133,
            0,
            131134,
            0,
            131135,
            0,
            131352,
            7,
            131354,
            7,
            131384,
            7,
            131386,
            7,
            133161,
            5,
            133165,
            5,
            133177,
            5,
            133181,
            5,
            133376,
            9,
            133377,
            9,
            133384,
            9,
            133385,
            9,
            133400,
            7,
            133402,
            7,
            133417,
            5,
            133421,
            5,
            133432,
            7,
            133433,
            5,
            133434,
            7,
            133437,
            5,
            147510,
            4,
            147511,
            4,
            147518,
            4,
            147519,
            4,
            147714,
            8,
            147718,
            8,
            147730,
            8,
            147734,
            8,
            147736,
            7,
            147738,
            7,
            147766,
            4,
            147767,
            4,
            147768,
            7,
            147770,
            7,
            147774,
            4,
            147775,
            4,
            149509,
            6,
            149511,
            6,
            149541,
            6,
            149543,
            6,
            149545,
            5,
            149549,
            5,
            149558,
            4,
            149559,
            4,
            149561,
            5,
            149565,
            5,
            149566,
            4,
            149567,
            4,
            149760,
            9,
            149761,
            9,
            149762,
            8,
            149765,
            6,
            149766,
            8,
            149767,
            6,
            149768,
            9,
            149769,
            9,
            149778,
            8,
            149782,
            8,
            149784,
            7,
            149786,
            7,
            149797,
            6,
            149799,
            6,
            149801,
            5,
            149805,
            5,
            149814,
            4,
            149815,
            4,
            149816,
            7,
            149817,
            5,
            149818,
            7,
            149821,
            5,
            149822,
            4,
            149823,
            4,
            149824,
            37,
            149825,
            37,
            149826,
            36,
            149829,
            34,
            149830,
            36,
            149831,
            34,
            149832,
            37,
            149833,
            37,
            149842,
            36,
            149846,
            36,
            149848,
            35,
            149850,
            35,
            149861,
            34,
            149863,
            34,
            149865,
            33,
            149869,
            33,
            149878,
            32,
            149879,
            32,
            149880,
            35,
            149881,
            33,
            149882,
            35,
            149885,
            33,
            149886,
            32,
            149887,
            32,
            150080,
            49,
            150082,
            48,
            150088,
            49,
            150098,
            48,
            150104,
            47,
            150106,
            47,
            151873,
            46,
            151877,
            45,
            151881,
            46,
            151909,
            45,
            151913,
            44,
            151917,
            44,
            152128,
            49,
            152129,
            46,
            152136,
            49,
            152137,
            46,
            166214,
            43,
            166215,
            42,
            166230,
            43,
            166247,
            42,
            166262,
            41,
            166263,
            41,
            166466,
            48,
            166470,
            43,
            166482,
            48,
            166486,
            43,
            168261,
            45,
            168263,
            42,
            168293,
            45,
            168295,
            42,
            168512,
            31,
            168513,
            28,
            168514,
            31,
            168517,
            28,
            168518,
            25,
            168519,
            25,
            280952,
            40,
            280953,
            39,
            280954,
            40,
            280957,
            39,
            280958,
            38,
            280959,
            38,
            281176,
            47,
            281178,
            47,
            281208,
            40,
            281210,
            40,
            282985,
            44,
            282989,
            44,
            283001,
            39,
            283005,
            39,
            283208,
            30,
            283209,
            27,
            283224,
            30,
            283241,
            27,
            283256,
            22,
            283257,
            22,
            297334,
            41,
            297335,
            41,
            297342,
            38,
            297343,
            38,
            297554,
            29,
            297558,
            24,
            297562,
            29,
            297590,
            24,
            297594,
            21,
            297598,
            21,
            299365,
            26,
            299367,
            23,
            299373,
            26,
            299383,
            23,
            299389,
            20,
            299391,
            20,
            299584,
            31,
            299585,
            28,
            299586,
            31,
            299589,
            28,
            299590,
            25,
            299591,
            25,
            299592,
            30,
            299593,
            27,
            299602,
            29,
            299606,
            24,
            299608,
            30,
            299610,
            29,
            299621,
            26,
            299623,
            23,
            299625,
            27,
            299629,
            26,
            299638,
            24,
            299639,
            23,
            299640,
            22,
            299641,
            22,
            299642,
            21,
            299645,
            20,
            299646,
            21,
            299647,
            20,
            299648,
            61,
            299649,
            60,
            299650,
            61,
            299653,
            60,
            299654,
            59,
            299655,
            59,
            299656,
            58,
            299657,
            57,
            299666,
            55,
            299670,
            54,
            299672,
            58,
            299674,
            55,
            299685,
            52,
            299687,
            51,
            299689,
            57,
            299693,
            52,
            299702,
            54,
            299703,
            51,
            299704,
            56,
            299705,
            56,
            299706,
            53,
            299709,
            50,
            299710,
            53,
            299711,
            50,
            299904,
            61,
            299906,
            61,
            299912,
            58,
            299922,
            55,
            299928,
            58,
            299930,
            55,
            301697,
            60,
            301701,
            60,
            301705,
            57,
            301733,
            52,
            301737,
            57,
            301741,
            52,
            301952,
            79,
            301953,
            79,
            301960,
            76,
            301961,
            76,
            316038,
            59,
            316039,
            59,
            316054,
            54,
            316071,
            51,
            316086,
            54,
            316087,
            51,
            316290,
            78,
            316294,
            78,
            316306,
            73,
            316310,
            73,
            318085,
            77,
            318087,
            77,
            318117,
            70,
            318119,
            70,
            318336,
            79,
            318337,
            79,
            318338,
            78,
            318341,
            77,
            318342,
            78,
            318343,
            77,
            430776,
            56,
            430777,
            56,
            430778,
            53,
            430781,
            50,
            430782,
            53,
            430783,
            50,
            431000,
            75,
            431002,
            72,
            431032,
            75,
            431034,
            72,
            432809,
            74,
            432813,
            69,
            432825,
            74,
            432829,
            69,
            433032,
            76,
            433033,
            76,
            433048,
            75,
            433065,
            74,
            433080,
            75,
            433081,
            74,
            447158,
            71,
            447159,
            68,
            447166,
            71,
            447167,
            68,
            447378,
            73,
            447382,
            73,
            447386,
            72,
            447414,
            71,
            447418,
            72,
            447422,
            71,
            449189,
            70,
            449191,
            70,
            449197,
            69,
            449207,
            68,
            449213,
            69,
            449215,
            68,
            449408,
            67,
            449409,
            67,
            449410,
            66,
            449413,
            64,
            449414,
            66,
            449415,
            64,
            449416,
            67,
            449417,
            67,
            449426,
            66,
            449430,
            66,
            449432,
            65,
            449434,
            65,
            449445,
            64,
            449447,
            64,
            449449,
            63,
            449453,
            63,
            449462,
            62,
            449463,
            62,
            449464,
            65,
            449465,
            63,
            449466,
            65,
            449469,
            63,
            449470,
            62,
            449471,
            62,
            449472,
            19,
            449473,
            19,
            449474,
            18,
            449477,
            16,
            449478,
            18,
            449479,
            16,
            449480,
            19,
            449481,
            19,
            449490,
            18,
            449494,
            18,
            449496,
            17,
            449498,
            17,
            449509,
            16,
            449511,
            16,
            449513,
            15,
            449517,
            15,
            449526,
            14,
            449527,
            14,
            449528,
            17,
            449529,
            15,
            449530,
            17,
            449533,
            15,
            449534,
            14,
            449535,
            14,
            449728,
            19,
            449729,
            19,
            449730,
            18,
            449734,
            18,
            449736,
            19,
            449737,
            19,
            449746,
            18,
            449750,
            18,
            449752,
            17,
            449754,
            17,
            449784,
            17,
            449786,
            17,
            451520,
            19,
            451521,
            19,
            451525,
            16,
            451527,
            16,
            451528,
            19,
            451529,
            19,
            451557,
            16,
            451559,
            16,
            451561,
            15,
            451565,
            15,
            451577,
            15,
            451581,
            15,
            451776,
            19,
            451777,
            19,
            451784,
            19,
            451785,
            19,
            465858,
            18,
            465861,
            16,
            465862,
            18,
            465863,
            16,
            465874,
            18,
            465878,
            18,
            465893,
            16,
            465895,
            16,
            465910,
            14,
            465911,
            14,
            465918,
            14,
            465919,
            14,
            466114,
            18,
            466118,
            18,
            466130,
            18,
            466134,
            18,
            467909,
            16,
            467911,
            16,
            467941,
            16,
            467943,
            16,
            468160,
            13,
            468161,
            13,
            468162,
            13,
            468163,
            13,
            468164,
            13,
            468165,
            13,
            468166,
            13,
            468167,
            13,
            580568,
            17,
            580570,
            17,
            580585,
            15,
            580589,
            15,
            580598,
            14,
            580599,
            14,
            580600,
            17,
            580601,
            15,
            580602,
            17,
            580605,
            15,
            580606,
            14,
            580607,
            14,
            580824,
            17,
            580826,
            17,
            580856,
            17,
            580858,
            17,
            582633,
            15,
            582637,
            15,
            582649,
            15,
            582653,
            15,
            582856,
            12,
            582857,
            12,
            582872,
            12,
            582873,
            12,
            582888,
            12,
            582889,
            12,
            582904,
            12,
            582905,
            12,
            596982,
            14,
            596983,
            14,
            596990,
            14,
            596991,
            14,
            597202,
            11,
            597206,
            11,
            597210,
            11,
            597214,
            11,
            597234,
            11,
            597238,
            11,
            597242,
            11,
            597246,
            11,
            599013,
            10,
            599015,
            10,
            599021,
            10,
            599023,
            10,
            599029,
            10,
            599031,
            10,
            599037,
            10,
            599039,
            10,
            599232,
            13,
            599233,
            13,
            599234,
            13,
            599235,
            13,
            599236,
            13,
            599237,
            13,
            599238,
            13,
            599239,
            13,
            599240,
            12,
            599241,
            12,
            599250,
            11,
            599254,
            11,
            599256,
            12,
            599257,
            12,
            599258,
            11,
            599262,
            11,
            599269,
            10,
            599271,
            10,
            599272,
            12,
            599273,
            12,
            599277,
            10,
            599279,
            10,
            599282,
            11,
            599285,
            10,
            599286,
            11,
            599287,
            10,
            599288,
            12,
            599289,
            12,
            599290,
            11,
            599293,
            10,
            599294,
            11,
            599295,
            10
        ];
        this._p4D = [
            0,
            0,
            1,
            -1,
            0,
            0,
            0,
            1,
            0,
            -1,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            -1,
            1,
            0,
            0,
            0,
            0,
            1,
            -1,
            0,
            0,
            0,
            1,
            0,
            -1,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            -1,
            1,
            0,
            0,
            0,
            0,
            1,
            -1,
            0,
            0,
            -1,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            -1,
            1,
            0,
            2,
            1,
            1,
            0,
            0,
            1,
            1,
            1,
            -1,
            0,
            1,
            1,
            1,
            0,
            -1,
            0,
            2,
            1,
            0,
            1,
            0,
            1,
            1,
            -1,
            1,
            0,
            1,
            1,
            0,
            1,
            -1,
            0,
            2,
            0,
            1,
            1,
            0,
            1,
            -1,
            1,
            1,
            0,
            1,
            0,
            1,
            1,
            -1,
            0,
            2,
            1,
            0,
            0,
            1,
            1,
            1,
            -1,
            0,
            1,
            1,
            1,
            0,
            -1,
            1,
            0,
            2,
            0,
            1,
            0,
            1,
            1,
            -1,
            1,
            0,
            1,
            1,
            0,
            1,
            -1,
            1,
            0,
            2,
            0,
            0,
            1,
            1,
            1,
            -1,
            0,
            1,
            1,
            1,
            0,
            -1,
            1,
            1,
            1,
            4,
            2,
            1,
            1,
            0,
            4,
            1,
            2,
            1,
            0,
            4,
            1,
            1,
            2,
            0,
            1,
            4,
            2,
            1,
            0,
            1,
            4,
            1,
            2,
            0,
            1,
            4,
            1,
            1,
            0,
            2,
            1,
            4,
            2,
            0,
            1,
            1,
            4,
            1,
            0,
            2,
            1,
            4,
            1,
            0,
            1,
            2,
            1,
            4,
            0,
            2,
            1,
            1,
            4,
            0,
            1,
            2,
            1,
            4,
            0,
            1,
            1,
            2,
            1,
            2,
            1,
            1,
            0,
            0,
            3,
            2,
            1,
            0,
            0,
            3,
            1,
            2,
            0,
            0,
            1,
            2,
            1,
            0,
            1,
            0,
            3,
            2,
            0,
            1,
            0,
            3,
            1,
            0,
            2,
            0,
            1,
            2,
            0,
            1,
            1,
            0,
            3,
            0,
            2,
            1,
            0,
            3,
            0,
            1,
            2,
            0,
            1,
            2,
            1,
            0,
            0,
            1,
            3,
            2,
            0,
            0,
            1,
            3,
            1,
            0,
            0,
            2,
            1,
            2,
            0,
            1,
            0,
            1,
            3,
            0,
            2,
            0,
            1,
            3,
            0,
            1,
            0,
            2,
            1,
            2,
            0,
            0,
            1,
            1,
            3,
            0,
            0,
            2,
            1,
            3,
            0,
            0,
            1,
            2,
            2,
            3,
            1,
            1,
            1,
            0,
            2,
            1,
            1,
            1,
            -1,
            2,
            2,
            0,
            0,
            0,
            2,
            3,
            1,
            1,
            0,
            1,
            2,
            1,
            1,
            -1,
            1,
            2,
            2,
            0,
            0,
            0,
            2,
            3,
            1,
            0,
            1,
            1,
            2,
            1,
            -1,
            1,
            1,
            2,
            2,
            0,
            0,
            0,
            2,
            3,
            1,
            1,
            1,
            0,
            2,
            1,
            1,
            1,
            -1,
            2,
            0,
            2,
            0,
            0,
            2,
            3,
            1,
            1,
            0,
            1,
            2,
            1,
            1,
            -1,
            1,
            2,
            0,
            2,
            0,
            0,
            2,
            3,
            0,
            1,
            1,
            1,
            2,
            -1,
            1,
            1,
            1,
            2,
            0,
            2,
            0,
            0,
            2,
            3,
            1,
            1,
            1,
            0,
            2,
            1,
            1,
            1,
            -1,
            2,
            0,
            0,
            2,
            0,
            2,
            3,
            1,
            0,
            1,
            1,
            2,
            1,
            -1,
            1,
            1,
            2,
            0,
            0,
            2,
            0,
            2,
            3,
            0,
            1,
            1,
            1,
            2,
            -1,
            1,
            1,
            1,
            2,
            0,
            0,
            2,
            0,
            2,
            3,
            1,
            1,
            0,
            1,
            2,
            1,
            1,
            -1,
            1,
            2,
            0,
            0,
            0,
            2,
            2,
            3,
            1,
            0,
            1,
            1,
            2,
            1,
            -1,
            1,
            1,
            2,
            0,
            0,
            0,
            2,
            2,
            3,
            0,
            1,
            1,
            1,
            2,
            -1,
            1,
            1,
            1,
            2,
            0,
            0,
            0,
            2,
            2,
            1,
            1,
            1,
            -1,
            0,
            1,
            1,
            1,
            0,
            -1,
            0,
            0,
            0,
            0,
            0,
            2,
            1,
            1,
            -1,
            1,
            0,
            1,
            1,
            0,
            1,
            -1,
            0,
            0,
            0,
            0,
            0,
            2,
            1,
            -1,
            1,
            1,
            0,
            1,
            0,
            1,
            1,
            -1,
            0,
            0,
            0,
            0,
            0,
            2,
            1,
            1,
            -1,
            0,
            1,
            1,
            1,
            0,
            -1,
            1,
            0,
            0,
            0,
            0,
            0,
            2,
            1,
            -1,
            1,
            0,
            1,
            1,
            0,
            1,
            -1,
            1,
            0,
            0,
            0,
            0,
            0,
            2,
            1,
            -1,
            0,
            1,
            1,
            1,
            0,
            -1,
            1,
            1,
            0,
            0,
            0,
            0,
            0,
            2,
            1,
            1,
            1,
            -1,
            0,
            1,
            1,
            1,
            0,
            -1,
            2,
            2,
            0,
            0,
            0,
            2,
            1,
            1,
            -1,
            1,
            0,
            1,
            1,
            0,
            1,
            -1,
            2,
            2,
            0,
            0,
            0,
            2,
            1,
            1,
            -1,
            0,
            1,
            1,
            1,
            0,
            -1,
            1,
            2,
            2,
            0,
            0,
            0,
            2,
            1,
            1,
            1,
            -1,
            0,
            1,
            1,
            1,
            0,
            -1,
            2,
            0,
            2,
            0,
            0,
            2,
            1,
            -1,
            1,
            1,
            0,
            1,
            0,
            1,
            1,
            -1,
            2,
            0,
            2,
            0,
            0,
            2,
            1,
            -1,
            1,
            0,
            1,
            1,
            0,
            1,
            -1,
            1,
            2,
            0,
            2,
            0,
            0,
            2,
            1,
            1,
            -1,
            1,
            0,
            1,
            1,
            0,
            1,
            -1,
            2,
            0,
            0,
            2,
            0,
            2,
            1,
            -1,
            1,
            1,
            0,
            1,
            0,
            1,
            1,
            -1,
            2,
            0,
            0,
            2,
            0,
            2,
            1,
            -1,
            0,
            1,
            1,
            1,
            0,
            -1,
            1,
            1,
            2,
            0,
            0,
            2,
            0,
            2,
            1,
            1,
            -1,
            0,
            1,
            1,
            1,
            0,
            -1,
            1,
            2,
            0,
            0,
            0,
            2,
            2,
            1,
            -1,
            1,
            0,
            1,
            1,
            0,
            1,
            -1,
            1,
            2,
            0,
            0,
            0,
            2,
            2,
            1,
            -1,
            0,
            1,
            1,
            1,
            0,
            -1,
            1,
            1,
            2,
            0,
            0,
            0,
            2,
            3,
            1,
            1,
            0,
            0,
            0,
            2,
            2,
            0,
            0,
            0,
            2,
            1,
            1,
            1,
            -1,
            3,
            1,
            0,
            1,
            0,
            0,
            2,
            0,
            2,
            0,
            0,
            2,
            1,
            1,
            1,
            -1,
            3,
            1,
            0,
            0,
            1,
            0,
            2,
            0,
            0,
            2,
            0,
            2,
            1,
            1,
            1,
            -1,
            3,
            1,
            1,
            0,
            0,
            0,
            2,
            2,
            0,
            0,
            0,
            2,
            1,
            1,
            -1,
            1,
            3,
            1,
            0,
            1,
            0,
            0,
            2,
            0,
            2,
            0,
            0,
            2,
            1,
            1,
            -1,
            1,
            3,
            1,
            0,
            0,
            0,
            1,
            2,
            0,
            0,
            0,
            2,
            2,
            1,
            1,
            -1,
            1,
            3,
            1,
            1,
            0,
            0,
            0,
            2,
            2,
            0,
            0,
            0,
            2,
            1,
            -1,
            1,
            1,
            3,
            1,
            0,
            0,
            1,
            0,
            2,
            0,
            0,
            2,
            0,
            2,
            1,
            -1,
            1,
            1,
            3,
            1,
            0,
            0,
            0,
            1,
            2,
            0,
            0,
            0,
            2,
            2,
            1,
            -1,
            1,
            1,
            3,
            1,
            0,
            1,
            0,
            0,
            2,
            0,
            2,
            0,
            0,
            2,
            -1,
            1,
            1,
            1,
            3,
            1,
            0,
            0,
            1,
            0,
            2,
            0,
            0,
            2,
            0,
            2,
            -1,
            1,
            1,
            1,
            3,
            1,
            0,
            0,
            0,
            1,
            2,
            0,
            0,
            0,
            2,
            2,
            -1,
            1,
            1,
            1,
            3,
            3,
            2,
            1,
            0,
            0,
            3,
            1,
            2,
            0,
            0,
            4,
            1,
            1,
            1,
            1,
            3,
            3,
            2,
            0,
            1,
            0,
            3,
            1,
            0,
            2,
            0,
            4,
            1,
            1,
            1,
            1,
            3,
            3,
            0,
            2,
            1,
            0,
            3,
            0,
            1,
            2,
            0,
            4,
            1,
            1,
            1,
            1,
            3,
            3,
            2,
            0,
            0,
            1,
            3,
            1,
            0,
            0,
            2,
            4,
            1,
            1,
            1,
            1,
            3,
            3,
            0,
            2,
            0,
            1,
            3,
            0,
            1,
            0,
            2,
            4,
            1,
            1,
            1,
            1,
            3,
            3,
            0,
            0,
            2,
            1,
            3,
            0,
            0,
            1,
            2,
            4,
            1,
            1,
            1,
            1,
            3,
            3,
            2,
            1,
            0,
            0,
            3,
            1,
            2,
            0,
            0,
            2,
            1,
            1,
            1,
            -1,
            3,
            3,
            2,
            0,
            1,
            0,
            3,
            1,
            0,
            2,
            0,
            2,
            1,
            1,
            1,
            -1,
            3,
            3,
            0,
            2,
            1,
            0,
            3,
            0,
            1,
            2,
            0,
            2,
            1,
            1,
            1,
            -1,
            3,
            3,
            2,
            1,
            0,
            0,
            3,
            1,
            2,
            0,
            0,
            2,
            1,
            1,
            -1,
            1,
            3,
            3,
            2,
            0,
            0,
            1,
            3,
            1,
            0,
            0,
            2,
            2,
            1,
            1,
            -1,
            1,
            3,
            3,
            0,
            2,
            0,
            1,
            3,
            0,
            1,
            0,
            2,
            2,
            1,
            1,
            -1,
            1,
            3,
            3,
            2,
            0,
            1,
            0,
            3,
            1,
            0,
            2,
            0,
            2,
            1,
            -1,
            1,
            1,
            3,
            3,
            2,
            0,
            0,
            1,
            3,
            1,
            0,
            0,
            2,
            2,
            1,
            -1,
            1,
            1,
            3,
            3,
            0,
            0,
            2,
            1,
            3,
            0,
            0,
            1,
            2,
            2,
            1,
            -1,
            1,
            1,
            3,
            3,
            0,
            2,
            1,
            0,
            3,
            0,
            1,
            2,
            0,
            2,
            -1,
            1,
            1,
            1,
            3,
            3,
            0,
            2,
            0,
            1,
            3,
            0,
            1,
            0,
            2,
            2,
            -1,
            1,
            1,
            1,
            3,
            3,
            0,
            0,
            2,
            1,
            3,
            0,
            0,
            1,
            2,
            2,
            -1,
            1,
            1,
            1
        ];
    }
    noise(x, y, z, w) {
        const { _perm: _perm, _perm4D: _perm4D, _lookup: _lookup, _STRETCH_4D: _STRETCH_4D, _SQUISH_4D: _SQUISH_4D, _gradients4D: _gradients4D, _NORM_4D: _NORM_4D } = this;
        const stretchOffset = (x + y + z + w) * _STRETCH_4D, xs = x + stretchOffset, ys = y + stretchOffset, zs = z + stretchOffset, ws = w + stretchOffset, xsb = Math.floor(xs), ysb = Math.floor(ys), zsb = Math.floor(zs), wsb = Math.floor(ws), squishOffset = (xsb + ysb + zsb + wsb) * _SQUISH_4D, dx0 = x - (xsb + squishOffset), dy0 = y - (ysb + squishOffset), dz0 = z - (zsb + squishOffset), dw0 = w - (wsb + squishOffset), xins = xs - xsb, yins = ys - ysb, zins = zs - zsb, wins = ws - wsb, inSum = xins + yins + zins + wins, hash = zins - wins + 1 | yins - zins + 1 << 1 | yins - wins + 1 << 2 | xins - yins + 1 << 3 | xins - zins + 1 << 4 | xins - wins + 1 << 5 | inSum << 6 | inSum + wins << 8 | inSum + zins << 11 | inSum + yins << 14 | inSum + xins << 17;
        let value = 0;
        for(let c = _lookup[hash]; c !== undefined; c = c.next){
            const dx = dx0 + c.dx, dy = dy0 + c.dy, dz = dz0 + c.dz, dw = dw0 + c.dw, attn = 2 - dx * dx - dy * dy - dz * dz - dw * dw;
            if (attn > 0) {
                const px = xsb + c.xsb, py = ysb + c.ysb, pz = zsb + c.zsb, pw = wsb + c.wsb, indexPartA = _perm[px & 0xff], indexPartB = _perm[indexPartA + py & 0xff], indexPartC = _perm[indexPartB + pz & 0xff], index = _perm4D[indexPartC + pw & 0xff], valuePart = _gradients4D[index] * dx + _gradients4D[index + 1] * dy + _gradients4D[index + 2] * dz + _gradients4D[index + 3] * dw;
                value += attn * attn * attn * attn * valuePart;
            }
        }
        return value * _NORM_4D;
    }
    seed(clientSeed) {
        const { _p4D: _p4D, _base4D: _base4D, _lookupPairs4D: _lookupPairs4D } = this;
        const contributions = [];
        for(let i = 0; i < _p4D.length; i += 16){
            const baseSet = _base4D[_p4D[i]];
            let previous = null, current = null;
            for(let k = 0; k < baseSet.length; k += 5){
                current = this._contribution4D(baseSet[k], baseSet[k + 1], baseSet[k + 2], baseSet[k + 3], baseSet[k + 4]);
                if (previous === null) contributions[i / 16] = current;
                else previous.next = current;
                previous = current;
            }
            if (current) {
                current.next = this._contribution4D(_p4D[i + 1], _p4D[i + 2], _p4D[i + 3], _p4D[i + 4], _p4D[i + 5]);
                current.next.next = this._contribution4D(_p4D[i + 6], _p4D[i + 7], _p4D[i + 8], _p4D[i + 9], _p4D[i + 10]);
                current.next.next.next = this._contribution4D(_p4D[i + 11], _p4D[i + 12], _p4D[i + 13], _p4D[i + 14], _p4D[i + 15]);
            }
        }
        this._lookup = [];
        for(let i = 0; i < _lookupPairs4D.length; i += 2)this._lookup[_lookupPairs4D[i]] = contributions[_lookupPairs4D[i + 1]];
        this._perm = new Uint8Array(256);
        this._perm4D = new Uint8Array(256);
        const source = new Uint8Array(256);
        for(let i = 0; i < 256; i++)source[i] = i;
        let seed = new Uint32Array(1);
        seed[0] = clientSeed;
        seed = (0, $e18ec54dce7f5192$export$aa932ea13ef50a6)((0, $e18ec54dce7f5192$export$aa932ea13ef50a6)((0, $e18ec54dce7f5192$export$aa932ea13ef50a6)(seed)));
        for(let i = 255; i >= 0; i--){
            seed = (0, $e18ec54dce7f5192$export$aa932ea13ef50a6)(seed);
            const r = new Uint32Array(1);
            r[0] = (seed[0] + 31) % (i + 1);
            if (r[0] < 0) r[0] += i + 1;
            this._perm[i] = source[r[0]];
            this._perm4D[i] = this._perm[i] & 0xfc;
            source[r[0]] = source[i];
        }
    }
    _contribution4D(multiplier, xsb, ysb, zsb, wsb) {
        const { _SQUISH_4D: _SQUISH_4D } = this;
        return {
            dx: -xsb - multiplier * _SQUISH_4D,
            dy: -ysb - multiplier * _SQUISH_4D,
            dz: -zsb - multiplier * _SQUISH_4D,
            dw: -wsb - multiplier * _SQUISH_4D,
            xsb: xsb,
            ysb: ysb,
            zsb: zsb,
            wsb: wsb
        };
    }
}


class $0c77f4a66b14fc8f$export$7cef8d54b4fb09be {
    constructor(){
        this.noise2d = new (0, $a8be242516f2688d$export$52ab408760750b8c)();
        this.noise3d = new (0, $3b0efba3f28743d5$export$a44113dd60da2b84)();
        this.noise4d = new (0, $9fcd36499a697f55$export$19bc27e0a2c2bb9c)();
    }
}




const $4c7d9442bcfcf412$var$defaultOptions = {
    speed: 0.2,
    step: 250
}, $4c7d9442bcfcf412$var$double = 2;
class $4c7d9442bcfcf412$export$98a2b777c29c30f3 {
    constructor(){
        const simplex = new (0, $0c77f4a66b14fc8f$export$7cef8d54b4fb09be)();
        this._simplex = simplex.noise2d;
        this.options = (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)({}, $4c7d9442bcfcf412$var$defaultOptions);
    }
    generate(particle) {
        const pos = particle.getPosition(), { speed: speed, step: step } = this.options, x = pos.x / step, y = pos.y / step, eps = 0.001, n1a = this._simplex.noise(x, y + eps), n2a = this._simplex.noise(x, y - eps), a = (n1a - n2a) / ($4c7d9442bcfcf412$var$double * eps), n1b = this._simplex.noise(x + eps, y), n2b = this._simplex.noise(x - eps, y), b = (n1b - n2b) / ($4c7d9442bcfcf412$var$double * eps);
        particle.velocity.x = 0;
        particle.velocity.y = 0;
        return (0, $04697537ec8dce5b$export$9b781de7bf37bf48).create(speed * a, speed * -b);
    }
    init(container) {
        const sourceOptions = container.actualOptions.particles.move.path.options;
        this.options.seed = sourceOptions?.seed;
        this.options.speed = (sourceOptions?.speed ?? $4c7d9442bcfcf412$var$defaultOptions.speed) * container.retina.pixelRatio;
        this.options.step = sourceOptions?.step ?? $4c7d9442bcfcf412$var$defaultOptions.step;
        this._simplex.seed(this.options.seed ?? (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)());
    }
    reset() {}
    update() {}
}


const $9f069d8e63f559c7$export$1b1d56b696c2496c = "curlNoise";
async function $9f069d8e63f559c7$export$676c523f5025179f(engine, refresh = true) {
    await engine.addPathGenerator($9f069d8e63f559c7$export$1b1d56b696c2496c, new (0, $4c7d9442bcfcf412$export$98a2b777c29c30f3)(), refresh);
}




function $b3e97c2ce8b9e5e2$export$45bf684a7e304a1(rndFunc, period, nbHarmonics, attenHarmonics, lowValue = 0, highValue = 1) {
    const arP0 = [], arP1 = [], amplitudes = [], increments = [], phases = [], randomFunc = rndFunc ?? (0, $1ff4dfb77b7bb646$export$1a76347094524b3b);
    let globAmplitude = 0;
    if (nbHarmonics < 1) nbHarmonics = 1;
    for(let kh = 1; kh <= nbHarmonics; ++kh){
        arP0[kh] = randomFunc();
        arP1[kh] = randomFunc();
        amplitudes[kh] = kh === 1 ? 1 : amplitudes[kh - 1] * attenHarmonics;
        globAmplitude += amplitudes[kh];
        increments[kh] = kh / period;
        phases[kh] = randomFunc();
    }
    amplitudes.forEach((value, kh)=>amplitudes[kh] = value / globAmplitude * (highValue - lowValue));
    return ()=>{
        let pf, pfl, signal = 0;
        for(let kh = nbHarmonics; kh >= 1; --kh){
            pf = phases[kh] += increments[kh];
            if (phases[kh] >= 1) {
                pf = phases[kh] -= 1;
                arP0[kh] = arP1[kh];
                arP1[kh] = randomFunc();
            }
            pfl = pf ** 2 * (3 - 2 * pf);
            signal += (arP0[kh] * (1 - pfl) + arP1[kh] * pfl) * amplitudes[kh];
        }
        return signal + lowValue;
    };
}


const $f2db79ef1dc48b36$var$double = 2, $f2db79ef1dc48b36$var$doublePI = Math.PI * $f2db79ef1dc48b36$var$double;
function $f2db79ef1dc48b36$var$randomVelocity() {
    const offset = 0.8, factor = 0.6;
    return (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * factor + offset;
}
class $f2db79ef1dc48b36$export$8a267c9a50ca8477 {
    constructor(){
        this.options = {
            rndFunc: null,
            period: 100,
            nbHarmonics: 2,
            attenHarmonics: 0.8,
            lowValue: -0.03,
            highValue: 0.03
        };
    }
    generate(p) {
        if (!p.pathGen) {
            const options = this.options;
            p.pathGen = (0, $b3e97c2ce8b9e5e2$export$45bf684a7e304a1)(options.rndFunc, options.period, options.nbHarmonics, options.attenHarmonics, options.lowValue, options.highValue);
        }
        if (!p.curveVelocity) {
            p.curveVelocity = (0, $04697537ec8dce5b$export$9b781de7bf37bf48).origin;
            p.curveVelocity.length = $f2db79ef1dc48b36$var$randomVelocity();
            p.curveVelocity.angle = (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * $f2db79ef1dc48b36$var$doublePI;
        } else {
            p.curveVelocity.length += 0.01;
            p.curveVelocity.angle = (p.curveVelocity.angle + p.pathGen()) % $f2db79ef1dc48b36$var$doublePI;
        }
        p.velocity.x = 0;
        p.velocity.y = 0;
        return p.curveVelocity;
    }
    init(container) {
        const sourceOptions = container.actualOptions.particles.move.path.options, { options: options } = this;
        if ((0, $ad25b6e319f6df8c$export$f6e2535fb5126e54)(sourceOptions.rndFunc)) options.rndFunc = sourceOptions.rndFunc;
        else if ((0, $ad25b6e319f6df8c$export$844ec244b1367d54)(sourceOptions.rndFunc)) options.rndFunc = window[sourceOptions.rndFunc] ?? this.options.rndFunc;
        options.period = sourceOptions.period ?? options.period;
        options.nbHarmonics = sourceOptions.nbHarmonics ?? options.nbHarmonics;
        options.attenHarmonics = sourceOptions.attenHarmonics ?? options.attenHarmonics;
        options.lowValue = sourceOptions.lowValue ?? options.lowValue;
        options.highValue = sourceOptions.highValue ?? options.highValue;
    }
    reset(particle) {
        delete particle.pathGen;
        delete particle.curveVelocity;
    }
    update() {}
}


const $ec215479089ea60b$export$13f65fecd8db9155 = "curvesPathGenerator";
async function $ec215479089ea60b$export$7abb031a40616b32(engine, refresh = true) {
    await engine.addPathGenerator($ec215479089ea60b$export$13f65fecd8db9155, new (0, $f2db79ef1dc48b36$export$8a267c9a50ca8477)(), refresh);
}



async function $34d7af5227549100$export$1292eb8e57da4dca() {
    (0, $1ff4dfb77b7bb646$export$e2251c95822ce867)((0, $981da57d483aae4d$export$483bfb5d033dec0c).easeInBack, (value)=>{
        const c1 = 1.70158, c3 = c1 + 1;
        return c3 * value ** 3 - c1 * value ** 2;
    });
    (0, $1ff4dfb77b7bb646$export$e2251c95822ce867)((0, $981da57d483aae4d$export$483bfb5d033dec0c).easeOutBack, (value)=>{
        const c1 = 1.70158, c3 = c1 + 1;
        return 1 + c3 * Math.pow(value - 1, 3) + c1 * Math.pow(value - 1, 2);
    });
    (0, $1ff4dfb77b7bb646$export$e2251c95822ce867)((0, $981da57d483aae4d$export$483bfb5d033dec0c).easeInOutBack, (value)=>{
        const c1 = 1.70158, c2 = c1 * 1.525;
        return value < 0.5 ? (2 * value) ** 2 * ((c2 + 1) * 2 * value - c2) / 2 : ((2 * value - 2) ** 2 * ((c2 + 1) * (value * 2 - 2) + c2) + 2) / 2;
    });
    await Promise.resolve();
}



async function $1f50d2bd97421d53$export$b6f4c6341a3f449b() {
    (0, $1ff4dfb77b7bb646$export$e2251c95822ce867)((0, $981da57d483aae4d$export$483bfb5d033dec0c).easeInCirc, (value)=>1 - Math.sqrt(1 - value ** 2));
    (0, $1ff4dfb77b7bb646$export$e2251c95822ce867)((0, $981da57d483aae4d$export$483bfb5d033dec0c).easeOutCirc, (value)=>Math.sqrt(1 - (value - 1) ** 2));
    (0, $1ff4dfb77b7bb646$export$e2251c95822ce867)((0, $981da57d483aae4d$export$483bfb5d033dec0c).easeInOutCirc, (value)=>value < 0.5 ? (1 - Math.sqrt(1 - (2 * value) ** 2)) / 2 : (Math.sqrt(1 - (-2 * value + 2) ** 2) + 1) / 2);
    await Promise.resolve();
}



async function $1c333aa7f69cc831$export$a01549474a230bcd() {
    (0, $1ff4dfb77b7bb646$export$e2251c95822ce867)((0, $981da57d483aae4d$export$483bfb5d033dec0c).easeInCubic, (value)=>value ** 3);
    (0, $1ff4dfb77b7bb646$export$e2251c95822ce867)((0, $981da57d483aae4d$export$483bfb5d033dec0c).easeOutCubic, (value)=>1 - (1 - value) ** 3);
    (0, $1ff4dfb77b7bb646$export$e2251c95822ce867)((0, $981da57d483aae4d$export$483bfb5d033dec0c).easeInOutCubic, (value)=>value < 0.5 ? 4 * value ** 3 : 1 - (-2 * value + 2) ** 3 / 2);
    await Promise.resolve();
}



async function $d51093f94a3a099d$export$86a6aa77937f9b42() {
    (0, $1ff4dfb77b7bb646$export$e2251c95822ce867)((0, $981da57d483aae4d$export$483bfb5d033dec0c).easeInExpo, (value)=>!value ? 0 : 2 ** (10 * value - 10));
    (0, $1ff4dfb77b7bb646$export$e2251c95822ce867)((0, $981da57d483aae4d$export$483bfb5d033dec0c).easeOutExpo, (value)=>value === 1 ? 1 : 1 - Math.pow(2, -10 * value));
    (0, $1ff4dfb77b7bb646$export$e2251c95822ce867)((0, $981da57d483aae4d$export$483bfb5d033dec0c).easeInOutExpo, (value)=>{
        if (value === 1) return !value ? 0 : 1;
        else if (!value) return 0;
        else return value < 0.5 ? 2 ** (20 * value - 10) / 2 : (2 - 2 ** (-20 * value + 10)) / 2;
    });
    await Promise.resolve();
}



async function $c49c94142b42199c$export$5725066e6e60213a() {
    (0, $1ff4dfb77b7bb646$export$e2251c95822ce867)((0, $981da57d483aae4d$export$483bfb5d033dec0c).easeInLinear, (value)=>{
        return value;
    });
    (0, $1ff4dfb77b7bb646$export$e2251c95822ce867)((0, $981da57d483aae4d$export$483bfb5d033dec0c).easeOutLinear, (value)=>{
        return value;
    });
    (0, $1ff4dfb77b7bb646$export$e2251c95822ce867)((0, $981da57d483aae4d$export$483bfb5d033dec0c).easeInOutLinear, (value)=>{
        return value;
    });
    await Promise.resolve();
}



async function $fcac508d4f7ea98d$export$e742b1d10f4d5e8f() {
    (0, $1ff4dfb77b7bb646$export$e2251c95822ce867)((0, $981da57d483aae4d$export$483bfb5d033dec0c).easeInQuart, (value)=>value ** 4);
    (0, $1ff4dfb77b7bb646$export$e2251c95822ce867)((0, $981da57d483aae4d$export$483bfb5d033dec0c).easeOutQuart, (value)=>1 - (1 - value) ** 4);
    (0, $1ff4dfb77b7bb646$export$e2251c95822ce867)((0, $981da57d483aae4d$export$483bfb5d033dec0c).easeInOutQuart, (value)=>value < 0.5 ? 8 * value ** 4 : 1 - (-2 * value + 2) ** 4 / 2);
    await Promise.resolve();
}



async function $aa3626bf11063886$export$2e760541d25c06b7() {
    (0, $1ff4dfb77b7bb646$export$e2251c95822ce867)((0, $981da57d483aae4d$export$483bfb5d033dec0c).easeInQuint, (value)=>value ** 5);
    (0, $1ff4dfb77b7bb646$export$e2251c95822ce867)((0, $981da57d483aae4d$export$483bfb5d033dec0c).easeOutQuint, (value)=>1 - (1 - value) ** 5);
    (0, $1ff4dfb77b7bb646$export$e2251c95822ce867)((0, $981da57d483aae4d$export$483bfb5d033dec0c).easeInOutQuint, (value)=>value < 0.5 ? 16 * value ** 5 : 1 - (-2 * value + 2) ** 5 / 2);
    await Promise.resolve();
}



async function $d8adda34098bb3b8$export$93658ed80be028d6() {
    (0, $1ff4dfb77b7bb646$export$e2251c95822ce867)((0, $981da57d483aae4d$export$483bfb5d033dec0c).easeInSine, (value)=>1 - Math.cos(value * Math.PI / 2));
    (0, $1ff4dfb77b7bb646$export$e2251c95822ce867)((0, $981da57d483aae4d$export$483bfb5d033dec0c).easeOutSine, (value)=>Math.sin(value * Math.PI / 2));
    (0, $1ff4dfb77b7bb646$export$e2251c95822ce867)((0, $981da57d483aae4d$export$483bfb5d033dec0c).easeInOutSine, (value)=>-(Math.cos(Math.PI * value) - 1) / 2);
    await Promise.resolve();
}





class $26f962cf1fc5fa18$export$99c2b8efc08054b {
    constructor(){
        this.wait = false;
    }
    load(data) {
        if (!data) return;
        if (data.count !== undefined) this.count = data.count;
        if (data.delay !== undefined) this.delay = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.delay);
        if (data.duration !== undefined) this.duration = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.duration);
        if (data.wait !== undefined) this.wait = data.wait;
    }
}



class $77a28ec89b2646a1$export$c3191dc230acef25 {
    constructor(){
        this.quantity = 1;
        this.delay = 0.1;
    }
    load(data) {
        if (data === undefined) return;
        if (data.quantity !== undefined) this.quantity = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.quantity);
        if (data.delay !== undefined) this.delay = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.delay);
    }
}



class $1ac9dc8a8456e52b$export$2c0f13eebb2527f7 {
    constructor(){
        this.color = false;
        this.opacity = false;
    }
    load(data) {
        if (!data) return;
        if (data.color !== undefined) this.color = data.color;
        if (data.opacity !== undefined) this.opacity = data.opacity;
    }
}


class $eed618bff9afedfc$export$e0f47148d50f3ef {
    constructor(){
        this.options = {};
        this.replace = new (0, $1ac9dc8a8456e52b$export$2c0f13eebb2527f7)();
        this.type = "square";
    }
    load(data) {
        if (!data) return;
        if (data.options !== undefined) this.options = (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)({}, data.options ?? {});
        this.replace.load(data.replace);
        if (data.type !== undefined) this.type = data.type;
    }
}



class $c9d63a29c0d015bd$export$a8f8ab30882c6cf0 {
    constructor(){
        this.mode = (0, $990956d8c795e3d5$export$1009f0178778a981).percent;
        this.height = 0;
        this.width = 0;
    }
    load(data) {
        if (data === undefined) return;
        if (data.mode !== undefined) this.mode = data.mode;
        if (data.height !== undefined) this.height = data.height;
        if (data.width !== undefined) this.width = data.width;
    }
}


class $012c4bc48e9e2fa3$export$4293555f241ae35a {
    constructor(){
        this.autoPlay = true;
        this.fill = true;
        this.life = new (0, $26f962cf1fc5fa18$export$99c2b8efc08054b)();
        this.rate = new (0, $77a28ec89b2646a1$export$c3191dc230acef25)();
        this.shape = new (0, $eed618bff9afedfc$export$e0f47148d50f3ef)();
        this.startCount = 0;
    }
    load(data) {
        if (!data) return;
        if (data.autoPlay !== undefined) this.autoPlay = data.autoPlay;
        if (data.size !== undefined) {
            if (!this.size) this.size = new (0, $c9d63a29c0d015bd$export$a8f8ab30882c6cf0)();
            this.size.load(data.size);
        }
        if (data.direction !== undefined) this.direction = data.direction;
        this.domId = data.domId;
        if (data.fill !== undefined) this.fill = data.fill;
        this.life.load(data.life);
        this.name = data.name;
        this.particles = (0, $eee2fa4b9ebe63e9$export$8e5dc47097396754)(data.particles, (particles)=>{
            return (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)({}, particles);
        });
        this.rate.load(data.rate);
        this.shape.load(data.shape);
        if (data.position !== undefined) {
            this.position = {};
            if (data.position.x !== undefined) this.position.x = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.position.x);
            if (data.position.y !== undefined) this.position.y = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.position.y);
        }
        if (data.spawnColor !== undefined) {
            if (this.spawnColor === undefined) this.spawnColor = new (0, $c2c78a2702851717$export$6f79b6ff75533155)();
            this.spawnColor.load(data.spawnColor);
        }
        if (data.startCount !== undefined) this.startCount = data.startCount;
    }
}


var $e81f6a001d0554b4$export$482a07636b9d56d5;
(function(EmitterClickMode) {
    EmitterClickMode["emitter"] = "emitter";
})($e81f6a001d0554b4$export$482a07636b9d56d5 || ($e81f6a001d0554b4$export$482a07636b9d56d5 = {}));








const $f1b20fc3c8ed60c4$var$half = 0.5, $f1b20fc3c8ed60c4$var$defaultLifeDelay = 0, $f1b20fc3c8ed60c4$var$minLifeCount = 0, $f1b20fc3c8ed60c4$var$defaultSpawnDelay = 0, $f1b20fc3c8ed60c4$var$defaultEmitDelay = 0, $f1b20fc3c8ed60c4$var$defaultLifeCount = -1, $f1b20fc3c8ed60c4$var$defaultColorAnimationFactor = 1;
function $f1b20fc3c8ed60c4$var$setParticlesOptionsColor(particlesOptions, color) {
    if (particlesOptions.color) particlesOptions.color.value = color;
    else particlesOptions.color = {
        value: color
    };
}
class $f1b20fc3c8ed60c4$export$834c246832f0a6df {
    constructor(engine, emitters, container, options, position){
        this.emitters = emitters;
        this.container = container;
        this._destroy = ()=>{
            this._mutationObserver?.disconnect();
            this._mutationObserver = undefined;
            this._resizeObserver?.disconnect();
            this._resizeObserver = undefined;
            this.emitters.removeEmitter(this);
            this._engine.dispatchEvent("emitterDestroyed", {
                container: this.container,
                data: {
                    emitter: this
                }
            });
        };
        this._prepareToDie = ()=>{
            if (this._paused) return;
            const duration = this.options.life?.duration !== undefined ? (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(this.options.life.duration) : undefined, minDuration = 0, minLifeCount = 0;
            if (this.container.retina.reduceFactor && (this._lifeCount > minLifeCount || this._immortal) && duration !== undefined && duration > minDuration) this._duration = duration * (0, $dec17af1c054e95f$export$f64c3bfbc58eec0f);
        };
        this._setColorAnimation = (animation, initValue, maxValue, factor = $f1b20fc3c8ed60c4$var$defaultColorAnimationFactor)=>{
            const container = this.container;
            if (!animation.enable) return initValue;
            const colorOffset = (0, $1ff4dfb77b7bb646$export$8b958c8ecd94a804)(animation.offset), delay = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(this.options.rate.delay), emitFactor = delay * (0, $dec17af1c054e95f$export$f64c3bfbc58eec0f) / container.retina.reduceFactor, defaultColorSpeed = 0, colorSpeed = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(animation.speed ?? defaultColorSpeed);
            return (initValue + colorSpeed * container.fpsLimit / emitFactor + colorOffset * factor) % maxValue;
        };
        this._engine = engine;
        this._currentDuration = 0;
        this._currentEmitDelay = 0;
        this._currentSpawnDelay = 0;
        this._initialPosition = position;
        if (options instanceof (0, $012c4bc48e9e2fa3$export$4293555f241ae35a)) this.options = options;
        else {
            this.options = new (0, $012c4bc48e9e2fa3$export$4293555f241ae35a)();
            this.options.load(options);
        }
        this._spawnDelay = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(this.options.life.delay ?? $f1b20fc3c8ed60c4$var$defaultLifeDelay) * (0, $dec17af1c054e95f$export$f64c3bfbc58eec0f) / this.container.retina.reduceFactor;
        this.position = this._initialPosition ?? this._calcPosition();
        this.name = this.options.name;
        this.fill = this.options.fill;
        this._firstSpawn = !this.options.life.wait;
        this._startParticlesAdded = false;
        let particlesOptions = (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)({}, this.options.particles);
        particlesOptions ??= {};
        particlesOptions.move ??= {};
        particlesOptions.move.direction ??= this.options.direction;
        if (this.options.spawnColor) this.spawnColor = (0, $fd6faa9f4e5410ac$export$79a89086521c0f12)(this.options.spawnColor);
        this._paused = !this.options.autoPlay;
        this._particlesOptions = particlesOptions;
        this._size = this._calcSize();
        this.size = (0, $eee2fa4b9ebe63e9$export$31b21d0167753bb4)(this._size, this.container.canvas.size);
        this._lifeCount = this.options.life.count ?? $f1b20fc3c8ed60c4$var$defaultLifeCount;
        this._immortal = this._lifeCount <= $f1b20fc3c8ed60c4$var$minLifeCount;
        if (this.options.domId) {
            const element = document.getElementById(this.options.domId);
            if (element) {
                this._mutationObserver = new MutationObserver(()=>{
                    this.resize();
                });
                this._resizeObserver = new ResizeObserver(()=>{
                    this.resize();
                });
                this._mutationObserver.observe(element, {
                    attributes: true,
                    attributeFilter: [
                        "style",
                        "width",
                        "height"
                    ]
                });
                this._resizeObserver.observe(element);
            }
        }
        const shapeOptions = this.options.shape, shapeGenerator = this._engine.emitterShapeManager?.getShapeGenerator(shapeOptions.type);
        if (shapeGenerator) this._shape = shapeGenerator.generate(this.position, this.size, this.fill, shapeOptions.options);
        this._engine.dispatchEvent("emitterCreated", {
            container: container,
            data: {
                emitter: this
            }
        });
        this.play();
    }
    externalPause() {
        this._paused = true;
        this.pause();
    }
    externalPlay() {
        this._paused = false;
        this.play();
    }
    async init() {
        await this._shape?.init();
    }
    pause() {
        if (this._paused) return;
        delete this._emitDelay;
    }
    play() {
        if (this._paused) return;
        if (!(this.container.retina.reduceFactor && (this._lifeCount > $f1b20fc3c8ed60c4$var$minLifeCount || this._immortal || !this.options.life.count) && (this._firstSpawn || this._currentSpawnDelay >= (this._spawnDelay ?? $f1b20fc3c8ed60c4$var$defaultSpawnDelay)))) return;
        if (this._emitDelay === undefined) {
            const delay = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(this.options.rate.delay);
            this._emitDelay = delay * (0, $dec17af1c054e95f$export$f64c3bfbc58eec0f) / this.container.retina.reduceFactor;
        }
        if (this._lifeCount > $f1b20fc3c8ed60c4$var$minLifeCount || this._immortal) this._prepareToDie();
    }
    resize() {
        const initialPosition = this._initialPosition;
        this.position = initialPosition && (0, $eee2fa4b9ebe63e9$export$2ea42ef493c7076c)(initialPosition, this.container.canvas.size, (0, $04697537ec8dce5b$export$9b781de7bf37bf48).origin) ? initialPosition : this._calcPosition();
        this._size = this._calcSize();
        this.size = (0, $eee2fa4b9ebe63e9$export$31b21d0167753bb4)(this._size, this.container.canvas.size);
        this._shape?.resize(this.position, this.size);
    }
    update(delta) {
        if (this._paused) return;
        if (this._firstSpawn) {
            this._firstSpawn = false;
            this._currentSpawnDelay = this._spawnDelay ?? $f1b20fc3c8ed60c4$var$defaultSpawnDelay;
            this._currentEmitDelay = this._emitDelay ?? $f1b20fc3c8ed60c4$var$defaultEmitDelay;
        }
        if (!this._startParticlesAdded) {
            this._startParticlesAdded = true;
            this._emitParticles(this.options.startCount);
        }
        if (this._duration !== undefined) {
            this._currentDuration += delta.value;
            if (this._currentDuration >= this._duration) {
                this.pause();
                if (this._spawnDelay !== undefined) delete this._spawnDelay;
                if (!this._immortal) this._lifeCount--;
                if (this._lifeCount > $f1b20fc3c8ed60c4$var$minLifeCount || this._immortal) {
                    this.position = this._calcPosition();
                    this._shape?.resize(this.position, this.size);
                    this._spawnDelay = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(this.options.life.delay ?? $f1b20fc3c8ed60c4$var$defaultLifeDelay) * (0, $dec17af1c054e95f$export$f64c3bfbc58eec0f) / this.container.retina.reduceFactor;
                } else this._destroy();
                this._currentDuration -= this._duration;
                delete this._duration;
            }
        }
        if (this._spawnDelay !== undefined) {
            this._currentSpawnDelay += delta.value;
            if (this._currentSpawnDelay >= this._spawnDelay) {
                this._engine.dispatchEvent("emitterPlay", {
                    container: this.container
                });
                this.play();
                this._currentSpawnDelay -= this._currentSpawnDelay;
                delete this._spawnDelay;
            }
        }
        if (this._emitDelay !== undefined) {
            this._currentEmitDelay += delta.value;
            if (this._currentEmitDelay >= this._emitDelay) {
                this._emit();
                this._currentEmitDelay -= this._emitDelay;
            }
        }
    }
    _calcPosition() {
        if (this.options.domId) {
            const element = document.getElementById(this.options.domId);
            if (element) {
                const elRect = element.getBoundingClientRect(), pxRatio = this.container.retina.pixelRatio;
                return {
                    x: (elRect.x + elRect.width * $f1b20fc3c8ed60c4$var$half) * pxRatio,
                    y: (elRect.y + elRect.height * $f1b20fc3c8ed60c4$var$half) * pxRatio
                };
            }
        }
        return (0, $1ff4dfb77b7bb646$export$b6e437e0d75e3d2c)({
            size: this.container.canvas.size,
            position: this.options.position
        });
    }
    _calcSize() {
        const container = this.container;
        if (this.options.domId) {
            const element = document.getElementById(this.options.domId);
            if (element) {
                const elRect = element.getBoundingClientRect();
                return {
                    width: elRect.width * container.retina.pixelRatio,
                    height: elRect.height * container.retina.pixelRatio,
                    mode: (0, $990956d8c795e3d5$export$1009f0178778a981).precise
                };
            }
        }
        return this.options.size ?? (()=>{
            const size = new (0, $c9d63a29c0d015bd$export$a8f8ab30882c6cf0)();
            size.load({
                height: 0,
                mode: (0, $990956d8c795e3d5$export$1009f0178778a981).percent,
                width: 0
            });
            return size;
        })();
    }
    _emit() {
        if (this._paused) return;
        const quantity = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(this.options.rate.quantity);
        this._emitParticles(quantity);
    }
    _emitParticles(quantity) {
        const singleParticlesOptions = (0, $eee2fa4b9ebe63e9$export$3fbf39566d3ee62e)(this._particlesOptions);
        for(let i = 0; i < quantity; i++){
            const particlesOptions = (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)({}, singleParticlesOptions);
            if (this.spawnColor) {
                const hslAnimation = this.options.spawnColor?.animation;
                if (hslAnimation) {
                    const maxValues = {
                        h: 360,
                        s: 100,
                        l: 100
                    }, colorFactor = 3.6;
                    this.spawnColor.h = this._setColorAnimation(hslAnimation.h, this.spawnColor.h, maxValues.h, colorFactor);
                    this.spawnColor.s = this._setColorAnimation(hslAnimation.s, this.spawnColor.s, maxValues.s);
                    this.spawnColor.l = this._setColorAnimation(hslAnimation.l, this.spawnColor.l, maxValues.l);
                }
                $f1b20fc3c8ed60c4$var$setParticlesOptionsColor(particlesOptions, this.spawnColor);
            }
            const shapeOptions = this.options.shape;
            let position = this.position;
            if (this._shape) {
                const shapePosData = this._shape.randomPosition();
                if (shapePosData) {
                    position = shapePosData.position;
                    const replaceData = shapeOptions.replace;
                    if (replaceData.color && shapePosData.color) $f1b20fc3c8ed60c4$var$setParticlesOptionsColor(particlesOptions, shapePosData.color);
                    if (replaceData.opacity) {
                        if (particlesOptions.opacity) particlesOptions.opacity.value = shapePosData.opacity;
                        else particlesOptions.opacity = {
                            value: shapePosData.opacity
                        };
                    }
                } else position = null;
            }
            if (position) this.container.particles.addParticle(position, particlesOptions);
        }
    }
}


class $9cf9290939463e4c$export$774a0fdf08f5f4fd {
    constructor(engine, container){
        this.container = container;
        this._engine = engine;
        this.array = [];
        this.emitters = [];
        this.interactivityEmitters = {
            random: {
                count: 1,
                enable: false
            },
            value: []
        };
        const defaultIndex = 0;
        container.getEmitter = (idxOrName)=>idxOrName === undefined || (0, $ad25b6e319f6df8c$export$7e4aa119212bc614)(idxOrName) ? this.array[idxOrName ?? defaultIndex] : this.array.find((t)=>t.name === idxOrName);
        container.addEmitter = async (options, position)=>this.addEmitter(options, position);
        container.removeEmitter = (idxOrName)=>{
            const emitter = container.getEmitter(idxOrName);
            if (emitter) this.removeEmitter(emitter);
        };
        container.playEmitter = (idxOrName)=>{
            const emitter = container.getEmitter(idxOrName);
            if (emitter) emitter.externalPlay();
        };
        container.pauseEmitter = (idxOrName)=>{
            const emitter = container.getEmitter(idxOrName);
            if (emitter) emitter.externalPause();
        };
    }
    async addEmitter(options, position) {
        const emitterOptions = new (0, $012c4bc48e9e2fa3$export$4293555f241ae35a)();
        emitterOptions.load(options);
        const emitter = new (0, $f1b20fc3c8ed60c4$export$834c246832f0a6df)(this._engine, this, this.container, emitterOptions, position);
        await emitter.init();
        this.array.push(emitter);
        return emitter;
    }
    handleClickMode(mode) {
        const emitterOptions = this.emitters, modeEmitters = this.interactivityEmitters;
        if (mode !== (0, $e81f6a001d0554b4$export$482a07636b9d56d5).emitter) return;
        let emittersModeOptions;
        if (modeEmitters && (0, $ad25b6e319f6df8c$export$43bee75e5e14138e)(modeEmitters.value)) {
            const minLength = 0;
            if (modeEmitters.value.length > minLength && modeEmitters.random.enable) {
                emittersModeOptions = [];
                const usedIndexes = [];
                for(let i = 0; i < modeEmitters.random.count; i++){
                    const idx = (0, $eee2fa4b9ebe63e9$export$aab6d48e027939d7)(modeEmitters.value);
                    if (usedIndexes.includes(idx) && usedIndexes.length < modeEmitters.value.length) {
                        i--;
                        continue;
                    }
                    usedIndexes.push(idx);
                    emittersModeOptions.push((0, $eee2fa4b9ebe63e9$export$3a5d12ca7137122f)(modeEmitters.value, idx));
                }
            } else emittersModeOptions = modeEmitters.value;
        } else emittersModeOptions = modeEmitters?.value;
        const emittersOptions = emittersModeOptions ?? emitterOptions, ePosition = this.container.interactivity.mouse.clickPosition;
        (0, $eee2fa4b9ebe63e9$export$8e5dc47097396754)(emittersOptions, async (emitter)=>{
            await this.addEmitter(emitter, ePosition);
        });
    }
    async init() {
        this.emitters = this.container.actualOptions.emitters;
        this.interactivityEmitters = this.container.actualOptions.interactivity.modes.emitters;
        if (!this.emitters) return;
        if ((0, $ad25b6e319f6df8c$export$43bee75e5e14138e)(this.emitters)) for (const emitterOptions of this.emitters)await this.addEmitter(emitterOptions);
        else await this.addEmitter(this.emitters);
    }
    pause() {
        for (const emitter of this.array)emitter.pause();
    }
    play() {
        for (const emitter of this.array)emitter.play();
    }
    removeEmitter(emitter) {
        const index = this.array.indexOf(emitter), minIndex = 0, deleteCount = 1;
        if (index >= minIndex) this.array.splice(index, deleteCount);
    }
    resize() {
        for (const emitter of this.array)emitter.resize();
    }
    stop() {
        this.array = [];
    }
    update(delta) {
        for (const emitter of this.array)emitter.update(delta);
    }
}


class $7abbdc0aa5604449$export$e445717c82398c28 {
    constructor(engine){
        this._engine = engine;
        this.id = "emitters";
    }
    getPlugin(container) {
        return Promise.resolve(new (0, $9cf9290939463e4c$export$774a0fdf08f5f4fd)(this._engine, container));
    }
    loadOptions(options, source) {
        if (!this.needsPlugin(options) && !this.needsPlugin(source)) return;
        if (source?.emitters) options.emitters = (0, $eee2fa4b9ebe63e9$export$8e5dc47097396754)(source.emitters, (emitter)=>{
            const tmp = new (0, $012c4bc48e9e2fa3$export$4293555f241ae35a)();
            tmp.load(emitter);
            return tmp;
        });
        const interactivityEmitters = source?.interactivity?.modes?.emitters;
        if (interactivityEmitters) {
            if ((0, $ad25b6e319f6df8c$export$43bee75e5e14138e)(interactivityEmitters)) options.interactivity.modes.emitters = {
                random: {
                    count: 1,
                    enable: true
                },
                value: interactivityEmitters.map((s)=>{
                    const tmp = new (0, $012c4bc48e9e2fa3$export$4293555f241ae35a)();
                    tmp.load(s);
                    return tmp;
                })
            };
            else {
                const emitterMode = interactivityEmitters;
                if (emitterMode.value !== undefined) {
                    const defaultCount = 1;
                    if ((0, $ad25b6e319f6df8c$export$43bee75e5e14138e)(emitterMode.value)) options.interactivity.modes.emitters = {
                        random: {
                            count: emitterMode.random.count ?? defaultCount,
                            enable: emitterMode.random.enable ?? false
                        },
                        value: emitterMode.value.map((s)=>{
                            const tmp = new (0, $012c4bc48e9e2fa3$export$4293555f241ae35a)();
                            tmp.load(s);
                            return tmp;
                        })
                    };
                    else {
                        const tmp = new (0, $012c4bc48e9e2fa3$export$4293555f241ae35a)();
                        tmp.load(emitterMode.value);
                        options.interactivity.modes.emitters = {
                            random: {
                                count: emitterMode.random.count ?? defaultCount,
                                enable: emitterMode.random.enable ?? false
                            },
                            value: tmp
                        };
                    }
                } else {
                    const emitterOptions = options.interactivity.modes.emitters = {
                        random: {
                            count: 1,
                            enable: false
                        },
                        value: new (0, $012c4bc48e9e2fa3$export$4293555f241ae35a)()
                    };
                    emitterOptions.value.load(interactivityEmitters);
                }
            }
        }
    }
    needsPlugin(options) {
        if (!options) return false;
        const emitters = options.emitters;
        return (0, $ad25b6e319f6df8c$export$43bee75e5e14138e)(emitters) && !!emitters.length || emitters !== undefined || !!options.interactivity?.events?.onClick?.mode && (0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)((0, $e81f6a001d0554b4$export$482a07636b9d56d5).emitter, options.interactivity.events.onClick.mode);
    }
}


const $77253cdf198e9adf$var$shapeGeneratorss = new Map();
class $77253cdf198e9adf$export$29ab17701a3c76b1 {
    constructor(engine){
        this._engine = engine;
    }
    addShapeGenerator(name, generator) {
        if (!this.getShapeGenerator(name)) $77253cdf198e9adf$var$shapeGeneratorss.set(name, generator);
    }
    getShapeGenerator(name) {
        return $77253cdf198e9adf$var$shapeGeneratorss.get(name);
    }
    getSupportedShapeGenerators() {
        return $77253cdf198e9adf$var$shapeGeneratorss.keys();
    }
}




class $5ee3aa7dc3e7cc15$export$16a3ea651f8843c2 {
    constructor(position, size, fill, options){
        this.position = position;
        this.size = size;
        this.fill = fill;
        this.options = options;
    }
    resize(position, size) {
        this.position = position;
        this.size = size;
    }
}











async function $3cb3a297791cc556$export$e4e45ab97167d364(engine, refresh = true) {
    if (!engine.emitterShapeManager) engine.emitterShapeManager = new (0, $77253cdf198e9adf$export$29ab17701a3c76b1)(engine);
    if (!engine.addEmitterShapeGenerator) engine.addEmitterShapeGenerator = (name, generator)=>{
        engine.emitterShapeManager?.addShapeGenerator(name, generator);
    };
    const plugin = new (0, $7abbdc0aa5604449$export$e445717c82398c28)(engine);
    await engine.addPlugin(plugin, refresh);
}




const $3c7ecdf7c146caf0$var$origin = {
    x: 0,
    y: 0
}, $3c7ecdf7c146caf0$var$minWidth = 0;
function $3c7ecdf7c146caf0$export$6d31fcf241f37a57(ctx, size, offset, clear = true) {
    const imageData = ctx.getImageData($3c7ecdf7c146caf0$var$origin.x, $3c7ecdf7c146caf0$var$origin.y, size.width, size.height).data;
    if (clear) ctx.clearRect($3c7ecdf7c146caf0$var$origin.x, $3c7ecdf7c146caf0$var$origin.y, size.width, size.height);
    const pixels = [];
    for(let i = 0; i < imageData.length; i += offset){
        const idx = i / offset, pos = {
            x: idx % size.width,
            y: Math.floor(idx / size.width)
        };
        if (!pixels[pos.y]) pixels[pos.y] = [];
        const indexesOffset = {
            r: 0,
            g: 1,
            b: 2,
            a: 3
        }, alphaFactor = 255;
        pixels[pos.y][pos.x] = {
            r: imageData[i + indexesOffset.r],
            g: imageData[i + indexesOffset.g],
            b: imageData[i + indexesOffset.b],
            a: imageData[i + indexesOffset.a] / alphaFactor
        };
    }
    return {
        pixels: pixels,
        width: Math.min(...pixels.map((row)=>row.length)),
        height: pixels.length
    };
}
function $3c7ecdf7c146caf0$export$d93c68e129326488(src, offset) {
    const image = new Image();
    image.crossOrigin = "Anonymous";
    const p = new Promise((resolve, reject)=>{
        image.onerror = reject;
        image.onload = ()=>{
            const canvas = document.createElement("canvas");
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext("2d");
            if (!context) return reject(new Error(`${(0, $dec17af1c054e95f$export$adea4917e02d93dc)} Could not get canvas context`));
            context.drawImage(image, $3c7ecdf7c146caf0$var$origin.x, $3c7ecdf7c146caf0$var$origin.y, image.width, image.height, $3c7ecdf7c146caf0$var$origin.x, $3c7ecdf7c146caf0$var$origin.y, canvas.width, canvas.height);
            resolve($3c7ecdf7c146caf0$export$6d31fcf241f37a57(context, canvas, offset));
        };
    });
    image.src = src;
    return p;
}
function $3c7ecdf7c146caf0$export$ab5b0e9c6423d9e7(textOptions, offset, fill) {
    const canvas = document.createElement("canvas"), context = canvas.getContext("2d"), { font: font, text: text, lines: linesOptions, color: color } = textOptions;
    if (!text || !context) return;
    const lines = text.split(linesOptions.separator), fontSize = (0, $ad25b6e319f6df8c$export$7e4aa119212bc614)(font.size) ? `${font.size}px` : font.size, linesData = [];
    let maxWidth = 0, totalHeight = 0;
    for (const line of lines){
        context.font = `${font.style || ""} ${font.variant || ""} ${font.weight || ""} ${fontSize} ${font.family}`;
        const measure = context.measureText(line), lineData = {
            measure: measure,
            text: line,
            height: measure.actualBoundingBoxAscent + measure.actualBoundingBoxDescent,
            width: measure.width
        };
        maxWidth = Math.max(maxWidth || $3c7ecdf7c146caf0$var$minWidth, lineData.width);
        totalHeight += lineData.height + linesOptions.spacing;
        linesData.push(lineData);
    }
    canvas.width = maxWidth;
    canvas.height = totalHeight;
    let currentHeight = 0;
    for (const line of linesData){
        context.font = `${font.style || ""} ${font.variant || ""} ${font.weight || ""} ${fontSize} ${font.family}`;
        if (fill) {
            context.fillStyle = color;
            context.fillText(line.text, $3c7ecdf7c146caf0$var$origin.x, currentHeight + line.measure.actualBoundingBoxAscent);
        } else {
            context.strokeStyle = color;
            context.strokeText(line.text, $3c7ecdf7c146caf0$var$origin.x, currentHeight + line.measure.actualBoundingBoxAscent);
        }
        currentHeight += line.height + linesOptions.spacing;
    }
    return $3c7ecdf7c146caf0$export$6d31fcf241f37a57(context, canvas, offset);
}


const $f42fb733900f929a$var$maxRetries = 100, $f42fb733900f929a$var$half = 0.5;
class $f42fb733900f929a$export$d76f2b7179334770 extends (0, $5ee3aa7dc3e7cc15$export$16a3ea651f8843c2) {
    constructor(position, size, fill, options){
        super(position, size, fill, options);
        const filter = options.filter, minAlpha = 0;
        let filterFunc = (pixel)=>pixel.a > minAlpha;
        if (filter !== undefined) {
            if ((0, $ad25b6e319f6df8c$export$844ec244b1367d54)(filter)) {
                if (Object.hasOwn(window, filter)) {
                    const wndFilter = window[filter];
                    if ((0, $ad25b6e319f6df8c$export$f6e2535fb5126e54)(wndFilter)) filterFunc = wndFilter;
                }
            } else filterFunc = filter;
        }
        this.filter = filterFunc;
        this.scale = options.scale;
        this.pixelData = {
            pixels: [],
            height: 0,
            width: 0
        };
    }
    async init() {
        let pixelData;
        const options = this.options, selector = options.selector, pixels = options.pixels, image = options.image, element = options.element, text = options.text, offset = pixels.offset;
        if (image) {
            const url = image.src;
            if (!url) return;
            pixelData = await (0, $3c7ecdf7c146caf0$export$d93c68e129326488)(url, offset);
        } else if (text) {
            const data = (0, $3c7ecdf7c146caf0$export$ab5b0e9c6423d9e7)(text, offset, this.fill);
            if (!data) return;
            pixelData = data;
        } else if (element ?? selector) {
            const canvas = element ?? (selector && document.querySelector(selector));
            if (!canvas) return;
            const context = canvas.getContext("2d");
            if (!context) return;
            pixelData = (0, $3c7ecdf7c146caf0$export$6d31fcf241f37a57)(context, canvas, offset);
        }
        if (!pixelData) return;
        this.pixelData = pixelData;
    }
    randomPosition() {
        const { height: height, width: width } = this.pixelData, data = this.pixelData, position = this.position, scale = this.scale, positionOffset = {
            x: position.x - width * scale * $f42fb733900f929a$var$half,
            y: position.y - height * scale * $f42fb733900f929a$var$half
        };
        for(let i = 0; i < $f42fb733900f929a$var$maxRetries; i++){
            const nextIndex = Math.floor((0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * width * height), pixelPos = {
                x: nextIndex % width,
                y: Math.floor(nextIndex / width)
            }, pixel = data.pixels[pixelPos.y][pixelPos.x], shouldCreateParticle = this.filter(pixel);
            if (!shouldCreateParticle) continue;
            return {
                position: {
                    x: pixelPos.x * scale + positionOffset.x,
                    y: pixelPos.y * scale + positionOffset.y
                },
                color: {
                    ...pixel
                },
                opacity: pixel.a
            };
        }
        return null;
    }
    resize(position, size) {
        super.resize(position, size);
    }
}


class $62e3f64ff7afb423$export$a7c8f5236b016abd {
    constructor(){
        this.offset = 4;
    }
    load(data) {
        if (!data) return;
        if (data.offset !== undefined) this.offset = data.offset;
    }
}


class $e2b2adafcb4d950f$export$bc30c94997ee49c9 {
    constructor(){
        this.family = "Verdana";
        this.size = 32;
        this.style = "";
        this.variant = "";
        this.weight = "";
    }
    load(data) {
        if (!data) return;
        if (data.family !== undefined) this.family = data.family;
        if (data.size !== undefined) this.size = data.size;
        if (data.style !== undefined) this.style = data.style;
        if (data.variant !== undefined) this.variant = data.variant;
        if (data.weight !== undefined) this.weight = data.weight;
    }
}


class $8579747d53775baa$export$e5467889266938b3 {
    constructor(){
        this.separator = "\n";
        this.spacing = 0;
    }
    load(data) {
        if (!data) return;
        if (data.separator !== undefined) this.separator = data.separator;
        if (data.spacing !== undefined) this.spacing = data.spacing;
    }
}


class $7ba77466b5276e34$export$d7eba8c0a3c5fab3 {
    constructor(){
        this.color = "#000000";
        this.font = new (0, $e2b2adafcb4d950f$export$bc30c94997ee49c9)();
        this.lines = new (0, $8579747d53775baa$export$e5467889266938b3)();
        this.text = "";
    }
    load(data) {
        if (!data) return;
        if (data.color !== undefined) this.color = data.color;
        this.font.load(data.font);
        this.lines.load(data.lines);
        if (data.text !== undefined) this.text = data.text;
    }
}


const $f028e6d388620c98$var$minAlpha = 0;
class $f028e6d388620c98$export$2d1a56cc820752d6 {
    constructor(){
        this.filter = (pixel)=>pixel.a > $f028e6d388620c98$var$minAlpha;
        this.pixels = new (0, $62e3f64ff7afb423$export$a7c8f5236b016abd)();
        this.scale = 1;
        this.selector = "";
        this.text = new (0, $7ba77466b5276e34$export$d7eba8c0a3c5fab3)();
    }
    load(data) {
        if (!data) return;
        if (data.element !== undefined) this.element = data.element;
        if (data.filter !== undefined) this.filter = data.filter;
        this.pixels.load(data.pixels);
        if (data.scale !== undefined) this.scale = data.scale;
        if (data.selector !== undefined) this.selector = data.selector;
        if (data.image !== undefined) this.image = data.image;
        this.text.load(data.text);
    }
}


class $347daf54892700ec$export$f21c4ae23d562d83 {
    generate(position, size, fill, options) {
        const shapeOptions = new (0, $f028e6d388620c98$export$2d1a56cc820752d6)();
        shapeOptions.load(options);
        return new (0, $f42fb733900f929a$export$d76f2b7179334770)(position, size, fill, shapeOptions);
    }
}


async function $1d18efe0a688dbc7$export$1201873234d2f4b3(engine, refresh = true) {
    const emittersEngine = engine;
    emittersEngine.addEmitterShapeGenerator?.("canvas", new (0, $347daf54892700ec$export$f21c4ae23d562d83)());
    await emittersEngine.refresh(refresh);
}





const $3546277b2712a9bb$var$maxAttempts = 100, $3546277b2712a9bb$var$half = 0.5;
function $3546277b2712a9bb$export$ec43f535d29eac7f(ctx, path, center, size) {
    let randomPoint = null;
    for(let attempts = 0; attempts < $3546277b2712a9bb$var$maxAttempts; attempts++){
        const tmpPoint = {
            x: center.x + (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * size.width - size.width * $3546277b2712a9bb$var$half,
            y: center.y + (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * size.height - size.height * $3546277b2712a9bb$var$half
        };
        if (ctx.isPointInPath(path, tmpPoint.x, tmpPoint.y)) {
            randomPoint = tmpPoint;
            break;
        }
    }
    return randomPoint;
}
function $3546277b2712a9bb$export$9a611c1755449fb8(ctx, path, center, size) {
    let randomPoint = null;
    for(let attempts = 0; attempts < $3546277b2712a9bb$var$maxAttempts; attempts++){
        const tmpPoint = {
            x: center.x + (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * size.width - size.width * $3546277b2712a9bb$var$half,
            y: center.y + (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * size.height - size.height * $3546277b2712a9bb$var$half
        };
        if (ctx.isPointInStroke(path, tmpPoint.x, tmpPoint.y)) {
            randomPoint = tmpPoint;
            break;
        }
    }
    return randomPoint;
}


const $a6a3c4bb74f0345b$var$half = 0.5;
class $a6a3c4bb74f0345b$export$d9f3ec5fd21e7749 extends (0, $5ee3aa7dc3e7cc15$export$16a3ea651f8843c2) {
    constructor(position, size, fill, options){
        super(position, size, fill, options);
        const ctx = document.createElement("canvas").getContext("2d");
        if (!ctx) throw new Error(`${(0, $dec17af1c054e95f$export$adea4917e02d93dc)} No 2d context available`);
        this.checkContext = ctx;
        this.points = options.points;
        const pathData = this.points, path = new Path2D(), offset = {
            x: position.x - size.width * $a6a3c4bb74f0345b$var$half,
            y: position.y - size.height * $a6a3c4bb74f0345b$var$half
        };
        for (const [index, point] of pathData.entries()){
            const coords = {
                x: offset.x + point.x * size.width / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd),
                y: offset.y + point.y * size.height / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd)
            };
            if (!index) path.moveTo(coords.x, coords.y);
            else path.lineTo(coords.x, coords.y);
        }
        const firstIndex = 0, firstPathData = pathData[firstIndex];
        if (firstPathData) {
            const coords = {
                x: offset.x + firstPathData.x * size.width / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd),
                y: offset.y + firstPathData.y * size.height / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd)
            };
            path.lineTo(coords.x, coords.y);
        }
        this.path = path;
    }
    async init() {}
    randomPosition() {
        const ctx = this.checkContext, position = this.position, size = this.size, fill = this.fill, path = this.path, res = fill ? (0, $3546277b2712a9bb$export$ec43f535d29eac7f)(ctx, path, position, size) : (0, $3546277b2712a9bb$export$9a611c1755449fb8)(ctx, path, position, size);
        return res ? {
            position: res
        } : null;
    }
    resize(position, size) {
        super.resize(position, size);
        const pathData = this.points, path = new Path2D(), offset = {
            x: position.x - size.width * $a6a3c4bb74f0345b$var$half,
            y: position.y - size.height * $a6a3c4bb74f0345b$var$half
        };
        for (const [index, point] of pathData.entries()){
            const coords = {
                x: offset.x + point.x * size.width / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd),
                y: offset.y + point.y * size.height / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd)
            };
            if (!index) path.moveTo(coords.x, coords.y);
            else path.lineTo(coords.x, coords.y);
        }
        const firstIndex = 0, firstPathData = pathData[firstIndex];
        if (firstPathData) {
            const coords = {
                x: offset.x + firstPathData.x * size.width / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd),
                y: offset.y + firstPathData.y * size.height / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd)
            };
            path.lineTo(coords.x, coords.y);
        }
        this.path = path;
    }
}


const $4ea5fe22524fb490$var$defaultPosition = {
    x: 50,
    y: 50
};
class $4ea5fe22524fb490$export$f889d2aba97185df {
    constructor(){
        this.points = [];
    }
    load(data) {
        if (!data) return;
        if (data.points !== undefined) this.points = data.points.map((t)=>({
                x: t.x ?? $4ea5fe22524fb490$var$defaultPosition.x,
                y: t.y ?? $4ea5fe22524fb490$var$defaultPosition.y
            }));
    }
}


class $339aa4d4ae1b88c1$export$1c0acd82505ad70d {
    generate(position, size, fill, options) {
        const shapeOptions = new (0, $4ea5fe22524fb490$export$f889d2aba97185df)();
        shapeOptions.load(options);
        return new (0, $a6a3c4bb74f0345b$export$d9f3ec5fd21e7749)(position, size, fill, shapeOptions);
    }
}


async function $ff5646612369f51f$export$1e3528e6ddfcfe9e(engine, refresh = true) {
    const emittersEngine = engine;
    emittersEngine.addEmitterShapeGenerator?.("path", new (0, $339aa4d4ae1b88c1$export$1c0acd82505ad70d)());
    await emittersEngine.refresh(refresh);
}





const $39d47b57ef5ca0f5$var$double = 2, $39d47b57ef5ca0f5$var$doublePI = Math.PI * $39d47b57ef5ca0f5$var$double, $39d47b57ef5ca0f5$var$defaultRotation = 0, $39d47b57ef5ca0f5$var$maxAttempts = 100;
function $39d47b57ef5ca0f5$export$c6587b995df9a394(position, sides, radius, rotationAngle = $39d47b57ef5ca0f5$var$defaultRotation) {
    const polygon = [], angle = $39d47b57ef5ca0f5$var$doublePI / sides;
    for(let i = 0; i < sides; i++){
        const currentAngle = angle * i + rotationAngle;
        polygon.push({
            x: position.x + radius * Math.cos(currentAngle),
            y: position.y + radius * Math.sin(currentAngle)
        });
    }
    return polygon;
}
function $39d47b57ef5ca0f5$export$c8659ea70c07515a(polygon) {
    const firstIndex = 0, firstPoint = polygon[firstIndex], min = {
        ...firstPoint
    }, max = {
        ...firstPoint
    };
    for (const point of polygon){
        if (point.x < min.x) min.x = point.x;
        if (point.x > max.x) max.x = point.x;
        if (point.y < min.y) min.y = point.y;
        if (point.y > max.y) max.y = point.y;
    }
    let randomPoint = null;
    for(let attempts = 0; attempts < $39d47b57ef5ca0f5$var$maxAttempts; attempts++){
        const tmpPoint = {
            x: min.x + (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * (max.x - min.x),
            y: min.y + (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * (max.y - min.y)
        };
        if ($39d47b57ef5ca0f5$export$f1c31811357415ac(tmpPoint, polygon)) {
            randomPoint = tmpPoint;
            break;
        }
    }
    return randomPoint;
}
function $39d47b57ef5ca0f5$export$4a5a585b8cf34f97(polygon) {
    const sideIndex = Math.floor((0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * polygon.length), startPoint = polygon[sideIndex], offset = 1, endPoint = polygon[(sideIndex + offset) % polygon.length], t = (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)();
    return {
        x: startPoint.x + (endPoint.x - startPoint.x) * t,
        y: startPoint.y + (endPoint.y - startPoint.y) * t
    };
}
function $39d47b57ef5ca0f5$export$f1c31811357415ac(point, polygon) {
    let inside = false;
    const offset = 1;
    for(let i = 0, j = polygon.length - offset; i < polygon.length; j = i++){
        const pi = polygon[i], pj = polygon[j];
        const intersect = pi.y > point.y !== pj.y > point.y && point.x < (pj.x - pi.x) * (point.y - pi.y) / (pj.y - pi.y) + pi.x;
        if (intersect) inside = !inside;
    }
    return inside;
}


const $2e02f437190c8767$var$half = 0.5;
class $2e02f437190c8767$export$ae34a43e3e7aedde extends (0, $5ee3aa7dc3e7cc15$export$16a3ea651f8843c2) {
    constructor(position, size, fill, options){
        super(position, size, fill, options);
        this.sides = options.sides;
        this.angle = (0, $1ff4dfb77b7bb646$export$e6bfdeff8bfc94f9)(options.angle);
        this.polygon = (0, $39d47b57ef5ca0f5$export$c6587b995df9a394)(position, this.sides, size.width * $2e02f437190c8767$var$half, this.angle);
    }
    async init() {}
    randomPosition() {
        const fill = this.fill, polygon = this.polygon, res = fill ? (0, $39d47b57ef5ca0f5$export$c8659ea70c07515a)(polygon) : (0, $39d47b57ef5ca0f5$export$4a5a585b8cf34f97)(polygon);
        return res ? {
            position: res
        } : null;
    }
    resize(position, size) {
        super.resize(position, size);
        this.polygon = (0, $39d47b57ef5ca0f5$export$c6587b995df9a394)(position, this.sides, size.width * $2e02f437190c8767$var$half, this.angle);
    }
}


class $e25e7a2fa52843e8$export$f210b0d53a114890 {
    constructor(){
        this.angle = 0;
        this.sides = 5;
    }
    load(data) {
        if (!data) return;
        if (data.angle !== undefined) this.angle = data.angle;
        if (data.sides !== undefined) this.sides = data.sides;
    }
}


class $f77589590c4cf2bf$export$8ac53e460617a08 {
    generate(position, size, fill, options) {
        const shapeOptions = new (0, $e25e7a2fa52843e8$export$f210b0d53a114890)();
        shapeOptions.load(options);
        return new (0, $2e02f437190c8767$export$ae34a43e3e7aedde)(position, size, fill, shapeOptions);
    }
}


async function $33975798350b86d8$export$fa68ca5125f7e68b(engine, refresh = true) {
    const emittersEngine = engine;
    emittersEngine.addEmitterShapeGenerator?.("polygon", new (0, $f77589590c4cf2bf$export$8ac53e460617a08)());
    await emittersEngine.refresh(refresh);
}


class $6518e47b9be384a8$export$7becea6cbc3c9bfd {
    constructor(container, engine){
        this._exportImage = async (data)=>{
            const element = this._container.canvas.element;
            if (!element) return;
            return new Promise((resolve)=>{
                element.toBlob((blob)=>{
                    if (!blob) {
                        resolve(undefined);
                        return;
                    }
                    resolve(blob);
                }, data.type ?? "image/png", data.quality);
            });
        };
        this._container = container;
        this._engine = engine;
    }
    async export(type, data) {
        const res = {
            supported: false
        };
        switch(type){
            case "image":
                res.supported = true;
                res.blob = await this._exportImage(data);
                break;
        }
        return res;
    }
}


class $a0fe908c05db18af$export$edc395d7c4604cb0 {
    constructor(engine){
        this.id = "export-image";
        this._engine = engine;
    }
    getPlugin(container) {
        return Promise.resolve(new (0, $6518e47b9be384a8$export$7becea6cbc3c9bfd)(container, this._engine));
    }
    loadOptions() {}
    needsPlugin() {
        return true;
    }
}


async function $854ac5a4136777be$export$dbd4e9728554121e(engine, refresh = true) {
    await engine.addPlugin(new (0, $a0fe908c05db18af$export$edc395d7c4604cb0)(engine), refresh);
}


const $6c3addbdec758cd1$var$indent = 2;
class $6c3addbdec758cd1$export$5544151349783f0 {
    constructor(container, engine){
        this._exportJSON = async ()=>{
            const json = JSON.stringify(this._container.actualOptions, (key, value)=>{
                if (key.startsWith("_")) return;
                return value;
            }, $6c3addbdec758cd1$var$indent);
            return Promise.resolve(new Blob([
                json
            ], {
                type: "application/json"
            }));
        };
        this._container = container;
        this._engine = engine;
    }
    async export(type) {
        const res = {
            supported: false
        };
        switch(type){
            case "json":
                res.supported = true;
                res.blob = await this._exportJSON();
                break;
        }
        return res;
    }
}


class $6cee4996a6be786e$export$98b7779079ddf33d {
    constructor(engine){
        this.id = "export-json";
        this._engine = engine;
    }
    getPlugin(container) {
        return Promise.resolve(new (0, $6c3addbdec758cd1$export$5544151349783f0)(container, this._engine));
    }
    loadOptions() {}
    needsPlugin() {
        return true;
    }
}


async function $cc70e2aba6ea7d4b$export$98e4494e9467da53(engine, refresh = true) {
    await engine.addPlugin(new (0, $6cee4996a6be786e$export$98b7779079ddf33d)(engine), refresh);
}



const $a31451742873647e$var$videoTypes = [
    "webm",
    "ogg",
    "mp4",
    "x-matroska"
], $a31451742873647e$var$codecs = [
    "vp9",
    "vp9.0",
    "vp8",
    "vp8.0",
    "avc1",
    "av1",
    "h265",
    "h.265",
    "h264",
    "h.264",
    "opus",
    "pcm",
    "aac",
    "mpeg",
    "mp4a"
];
function $a31451742873647e$var$getVideoSupportedMimeTypes() {
    const isSupported = (type)=>MediaRecorder.isTypeSupported(type), supported = [];
    $a31451742873647e$var$videoTypes.forEach((type)=>{
        const mimeType = `video/${type}`;
        $a31451742873647e$var$codecs.forEach((codec)=>[
                `${mimeType};codecs=${codec}`,
                `${mimeType};codecs=${codec.toUpperCase()}`
            ].forEach((variation)=>{
                if (isSupported(variation)) supported.push(variation);
            }));
        if (isSupported(mimeType)) supported.push(mimeType);
    });
    return supported;
}
class $a31451742873647e$export$5a1e852f7d90404 {
    constructor(container, engine){
        this._supportedTypes = [];
        this._exportVideo = async (data)=>{
            const element = this._container.canvas.element;
            if (!element) return;
            return new Promise((resolve)=>{
                const stream = element.captureStream(data.fps ?? this._container.actualOptions.fpsLimit), firstIndex = 0, mimeType = data.mimeType ?? this._supportedTypes[firstIndex], recorder = new MediaRecorder(stream, {
                    mimeType: mimeType
                }), chunks = [], defaultDuration = 5;
                recorder.addEventListener("dataavailable", (event)=>{
                    chunks.push(event.data);
                });
                recorder.addEventListener("stop", ()=>{
                    resolve(new Blob(chunks, {
                        type: mimeType
                    }));
                });
                recorder.start();
                setTimeout(()=>{
                    recorder.stop();
                }, data.duration ?? defaultDuration * (0, $dec17af1c054e95f$export$f64c3bfbc58eec0f));
            });
        };
        this._container = container;
        this._engine = engine;
        this._supportedTypes = $a31451742873647e$var$getVideoSupportedMimeTypes();
    }
    async export(type, data) {
        const res = {
            supported: false
        };
        switch(type){
            case "video":
                res.supported = true;
                res.blob = await this._exportVideo(data);
                break;
        }
        return res;
    }
}


class $08f620274969ff74$export$e3009073211931c5 {
    constructor(engine){
        this.id = "export-video";
        this._engine = engine;
    }
    getPlugin(container) {
        return Promise.resolve(new (0, $a31451742873647e$export$5a1e852f7d90404)(container, this._engine));
    }
    loadOptions() {}
    needsPlugin() {
        return true;
    }
}


async function $acbbd11e25e5a5bd$export$889f8bbce641cc4d(engine, refresh = true) {
    await engine.addPlugin(new (0, $08f620274969ff74$export$e3009073211931c5)(engine), refresh);
}




class $88e2ac060071caf9$export$5f6d8d688c21ec32 {
    constructor(){
        this.replaceCursor = false;
        this.pauseOnStop = false;
        this.stopDelay = 0;
    }
    load(data) {
        if (!data) return;
        if (data.options !== undefined) this.options = (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)({}, data.options);
        if (data.replaceCursor !== undefined) this.replaceCursor = data.replaceCursor;
        if (data.pauseOnStop !== undefined) this.pauseOnStop = data.pauseOnStop;
        if (data.stopDelay !== undefined) this.stopDelay = data.stopDelay;
    }
}


const $336c49b9a2ba31bd$var$particleMode = "particle";
class $336c49b9a2ba31bd$export$9b4ed9281ef2a11c extends (0, $5825146c5282067b$export$6e252256471acc61) {
    constructor(container){
        super(container);
    }
    clear() {}
    init() {}
    interact() {
        const container = this.container, { interactivity: interactivity } = container, options = container.actualOptions;
        if (!container.retina.reduceFactor) return;
        const mousePos = interactivity.mouse.position, interactivityParticleOptions = options.interactivity.modes.particle;
        if (!interactivityParticleOptions) return;
        const mouseStopped = interactivityParticleOptions.pauseOnStop && (interactivity.mouse.position === this._lastPosition || interactivity.mouse.position?.x === this._lastPosition?.x && interactivity.mouse.position?.y === this._lastPosition?.y), clearDelay = interactivityParticleOptions.stopDelay;
        if (mousePos) this._lastPosition = {
            ...mousePos
        };
        else delete this._lastPosition;
        if (!this._lastPosition) return;
        if (mouseStopped) {
            if (this._clearTimeout) return;
            this._clearTimeout = setTimeout(()=>{
                if (!this._particle) return;
                if (interactivityParticleOptions.replaceCursor) {
                    const element = interactivity.element;
                    if (element) {
                        if (element instanceof Window) document.body.style.cursor = "";
                        else element.style.cursor = "";
                    }
                }
                this.container.particles.remove(this._particle, undefined, true);
                delete this._particle;
            }, clearDelay);
            return;
        }
        if (this._clearTimeout) {
            clearTimeout(this._clearTimeout);
            delete this._clearTimeout;
        }
        if (!this._particle) {
            const particleOptions = (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)(interactivityParticleOptions.options, {
                move: {
                    enable: false
                }
            });
            this._particle = container.particles.addParticle(this._lastPosition, particleOptions);
            if (interactivityParticleOptions.replaceCursor) {
                const element = interactivity.element;
                if (element) {
                    if (element instanceof Window) document.body.style.cursor = "none";
                    else element.style.cursor = "none";
                }
            }
        }
        if (!this._particle) return;
        this._particle.position.x = this._lastPosition.x;
        this._particle.position.y = this._lastPosition.y;
    }
    isEnabled(particle) {
        const container = this.container, options = container.actualOptions, mouse = container.interactivity.mouse, events = (particle?.interactivity ?? options.interactivity).events;
        return mouse.clicking && mouse.inside && !!mouse.position && (0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)($336c49b9a2ba31bd$var$particleMode, events.onClick.mode) || mouse.inside && !!mouse.position && (0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)($336c49b9a2ba31bd$var$particleMode, events.onHover.mode);
    }
    loadModeOptions(options, ...sources) {
        if (!options.particle) options.particle = new (0, $88e2ac060071caf9$export$5f6d8d688c21ec32)();
        for (const source of sources)options.particle.load(source?.particle);
    }
    reset() {}
}


async function $d2029b3aa9fc57ee$export$a60020c5bc91fd7e(engine, refresh = true) {
    await engine.addInteractor("externalParticle", (container)=>{
        return Promise.resolve(new (0, $336c49b9a2ba31bd$export$9b4ed9281ef2a11c)(container));
    }, refresh);
}



const $24b747eaca0898fb$var$popMode = "pop";
class $24b747eaca0898fb$export$badac9ada3a0bdf9 extends (0, $5825146c5282067b$export$6e252256471acc61) {
    constructor(container){
        super(container);
        this.handleClickMode = (mode)=>{
            const container = this.container;
            if (mode !== $24b747eaca0898fb$var$popMode) return;
            const clickPos = container.interactivity.mouse.clickPosition;
            if (!clickPos) return;
            const poppedParticles = container.particles.quadTree.queryCircle(clickPos, container.retina.pixelRatio);
            if (!poppedParticles.length) return;
            for (const particle of poppedParticles)container.particles.remove(particle);
        };
    }
    clear() {}
    init() {}
    interact() {}
    isEnabled() {
        return true;
    }
    reset() {}
}


async function $dc94056df980545f$export$5f6bc485a10240b7(engine, refresh = true) {
    await engine.addInteractor("externalPop", (container)=>{
        return Promise.resolve(new (0, $24b747eaca0898fb$export$badac9ada3a0bdf9)(container));
    }, refresh);
}





class $14682e8d643849c4$export$d9c489b7422f439 {
    constructor(){
        this.radius = 0;
        this.mass = 0;
    }
    load(data) {
        if (!data) return;
        if (data.mass !== undefined) this.mass = data.mass;
        if (data.radius !== undefined) this.radius = data.radius;
    }
}


class $a23caf1aaa7ade22$export$d8af9fbad354c15b extends (0, $49613bee1189cd15$export$2f74c042fca0b66d) {
    constructor(){
        super();
        this.density = 5;
        this.value = 50;
        this.limit = new (0, $14682e8d643849c4$export$d9c489b7422f439)();
    }
    load(data) {
        if (!data) return;
        super.load(data);
        if (data.density !== undefined) this.density = data.density;
        if ((0, $ad25b6e319f6df8c$export$7e4aa119212bc614)(data.limit)) this.limit.radius = data.limit;
        else this.limit.load(data.limit);
    }
}


class $464ca8d84fe01621$export$d814bc42ca06f7f3 {
    constructor(){
        this.color = new (0, $c86524210cdfad1b$export$c2b08aa25660fcaa)();
        this.color.value = "#000000";
        this.draggable = false;
        this.opacity = 1;
        this.destroy = true;
        this.orbits = false;
        this.size = new (0, $a23caf1aaa7ade22$export$d8af9fbad354c15b)();
    }
    load(data) {
        if (data === undefined) return;
        if (data.color !== undefined) this.color = (0, $c86524210cdfad1b$export$c2b08aa25660fcaa).create(this.color, data.color);
        if (data.draggable !== undefined) this.draggable = data.draggable;
        this.name = data.name;
        if (data.opacity !== undefined) this.opacity = data.opacity;
        if (data.position !== undefined) {
            this.position = {};
            if (data.position.x !== undefined) this.position.x = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.position.x);
            if (data.position.y !== undefined) this.position.y = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.position.y);
        }
        if (data.size !== undefined) this.size.load(data.size);
        if (data.destroy !== undefined) this.destroy = data.destroy;
        if (data.orbits !== undefined) this.orbits = data.orbits;
    }
}


var $e3e5e27ed2ee084d$export$d3fc3433791999a2;
(function(AbsorberClickMode) {
    AbsorberClickMode["absorber"] = "absorber";
})($e3e5e27ed2ee084d$export$d3fc3433791999a2 || ($e3e5e27ed2ee084d$export$d3fc3433791999a2 = {}));






const $f48f2924f0276ee5$var$squareExp = 2, $f48f2924f0276ee5$var$absorbFactor = 0.033, $f48f2924f0276ee5$var$minOrbitLength = 0, $f48f2924f0276ee5$var$minRadius = 0, $f48f2924f0276ee5$var$minMass = 0, $f48f2924f0276ee5$var$origin = {
    x: 0,
    y: 0
}, $f48f2924f0276ee5$var$minAngle = 0, $f48f2924f0276ee5$var$double = 2, $f48f2924f0276ee5$var$maxAngle = Math.PI * $f48f2924f0276ee5$var$double, $f48f2924f0276ee5$var$minVelocity = 0;
class $f48f2924f0276ee5$export$2b570af194d8d56d {
    constructor(absorbers, container, options, position){
        this.absorbers = absorbers;
        this.container = container;
        this._calcPosition = ()=>{
            const exactPosition = (0, $1ff4dfb77b7bb646$export$b6e437e0d75e3d2c)({
                size: this.container.canvas.size,
                position: this.options.position
            });
            return (0, $04697537ec8dce5b$export$9b781de7bf37bf48).create(exactPosition.x, exactPosition.y);
        };
        this._updateParticlePosition = (particle, v)=>{
            if (particle.destroyed) return;
            const container = this.container, canvasSize = container.canvas.size;
            if (particle.needsNewPosition) {
                const newPosition = (0, $1ff4dfb77b7bb646$export$b19bedb83d642783)({
                    size: canvasSize
                });
                particle.position.setTo(newPosition);
                particle.velocity.setTo(particle.initialVelocity);
                particle.absorberOrbit = undefined;
                particle.needsNewPosition = false;
            }
            if (this.options.orbits) {
                if (particle.absorberOrbit === undefined) {
                    particle.absorberOrbit = (0, $04697537ec8dce5b$export$9b781de7bf37bf48).origin;
                    particle.absorberOrbit.length = (0, $1ff4dfb77b7bb646$export$79376507b09a66f)(particle.getPosition(), this.position);
                    particle.absorberOrbit.angle = (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * $f48f2924f0276ee5$var$maxAngle;
                }
                if (particle.absorberOrbit.length <= this.size && !this.options.destroy) {
                    const minSize = Math.min(canvasSize.width, canvasSize.height), offset = 1, randomOffset = 0.1, randomFactor = 0.2;
                    particle.absorberOrbit.length = minSize * (offset + ((0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * randomFactor - randomOffset));
                }
                if (particle.absorberOrbitDirection === undefined) particle.absorberOrbitDirection = particle.velocity.x >= $f48f2924f0276ee5$var$minVelocity ? (0, $c606501dd7c2dcb2$export$9506977ce2a96a5b).clockwise : (0, $c606501dd7c2dcb2$export$9506977ce2a96a5b).counterClockwise;
                const orbitRadius = particle.absorberOrbit.length, orbitAngle = particle.absorberOrbit.angle, orbitDirection = particle.absorberOrbitDirection;
                particle.velocity.setTo((0, $04697537ec8dce5b$export$9b781de7bf37bf48).origin);
                const updateFunc = {
                    x: orbitDirection === (0, $c606501dd7c2dcb2$export$9506977ce2a96a5b).clockwise ? Math.cos : Math.sin,
                    y: orbitDirection === (0, $c606501dd7c2dcb2$export$9506977ce2a96a5b).clockwise ? Math.sin : Math.cos
                };
                particle.position.x = this.position.x + orbitRadius * updateFunc.x(orbitAngle);
                particle.position.y = this.position.y + orbitRadius * updateFunc.y(orbitAngle);
                particle.absorberOrbit.length -= v.length;
                particle.absorberOrbit.angle += (particle.retina.moveSpeed ?? $f48f2924f0276ee5$var$minVelocity) * container.retina.pixelRatio / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd) * container.retina.reduceFactor;
            } else {
                const addV = (0, $04697537ec8dce5b$export$9b781de7bf37bf48).origin;
                addV.length = v.length;
                addV.angle = v.angle;
                particle.velocity.addTo(addV);
            }
        };
        this.initialPosition = position ? (0, $04697537ec8dce5b$export$9b781de7bf37bf48).create(position.x, position.y) : undefined;
        if (options instanceof (0, $464ca8d84fe01621$export$d814bc42ca06f7f3)) this.options = options;
        else {
            this.options = new (0, $464ca8d84fe01621$export$d814bc42ca06f7f3)();
            this.options.load(options);
        }
        this.dragging = false;
        this.name = this.options.name;
        this.opacity = this.options.opacity;
        this.size = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(this.options.size.value) * container.retina.pixelRatio;
        this.mass = this.size * this.options.size.density * container.retina.reduceFactor;
        const limit = this.options.size.limit;
        this.limit = {
            radius: limit.radius * container.retina.pixelRatio * container.retina.reduceFactor,
            mass: limit.mass
        };
        this.color = (0, $fd6faa9f4e5410ac$export$fbf0bf3cc1fc0cc4)(this.options.color) ?? {
            b: 0,
            g: 0,
            r: 0
        };
        this.position = this.initialPosition?.copy() ?? this._calcPosition();
    }
    attract(particle) {
        const container = this.container, options = this.options;
        if (options.draggable) {
            const mouse = container.interactivity.mouse;
            if (mouse.clicking && mouse.downPosition) {
                const mouseDist = (0, $1ff4dfb77b7bb646$export$79376507b09a66f)(this.position, mouse.downPosition);
                if (mouseDist <= this.size) this.dragging = true;
            } else this.dragging = false;
            if (this.dragging && mouse.position) {
                this.position.x = mouse.position.x;
                this.position.y = mouse.position.y;
            }
        }
        const pos = particle.getPosition(), { dx: dx, dy: dy, distance: distance } = (0, $1ff4dfb77b7bb646$export$c76b58cfe053f228)(this.position, pos), v = (0, $04697537ec8dce5b$export$9b781de7bf37bf48).create(dx, dy);
        v.length = this.mass / Math.pow(distance, $f48f2924f0276ee5$var$squareExp) * container.retina.reduceFactor;
        if (distance < this.size + particle.getRadius()) {
            const sizeFactor = particle.getRadius() * $f48f2924f0276ee5$var$absorbFactor * container.retina.pixelRatio;
            if (this.size > particle.getRadius() && distance < this.size - particle.getRadius() || particle.absorberOrbit !== undefined && particle.absorberOrbit.length < $f48f2924f0276ee5$var$minOrbitLength) {
                if (options.destroy) particle.destroy();
                else {
                    particle.needsNewPosition = true;
                    this._updateParticlePosition(particle, v);
                }
            } else {
                if (options.destroy) particle.size.value -= sizeFactor;
                this._updateParticlePosition(particle, v);
            }
            if (this.limit.radius <= $f48f2924f0276ee5$var$minRadius || this.size < this.limit.radius) this.size += sizeFactor;
            if (this.limit.mass <= $f48f2924f0276ee5$var$minMass || this.mass < this.limit.mass) this.mass += sizeFactor * this.options.size.density * container.retina.reduceFactor;
        } else this._updateParticlePosition(particle, v);
    }
    draw(context) {
        context.translate(this.position.x, this.position.y);
        context.beginPath();
        context.arc($f48f2924f0276ee5$var$origin.x, $f48f2924f0276ee5$var$origin.y, this.size, $f48f2924f0276ee5$var$minAngle, $f48f2924f0276ee5$var$maxAngle, false);
        context.closePath();
        context.fillStyle = (0, $fd6faa9f4e5410ac$export$2476af37e47fcae2)(this.color, this.opacity);
        context.fill();
    }
    resize() {
        const initialPosition = this.initialPosition;
        this.position = initialPosition && (0, $eee2fa4b9ebe63e9$export$2ea42ef493c7076c)(initialPosition, this.container.canvas.size, (0, $04697537ec8dce5b$export$9b781de7bf37bf48).origin) ? initialPosition : this._calcPosition();
    }
}


const $c5c86a62cd5757ac$var$defaultIndex = 0;
class $c5c86a62cd5757ac$export$2f99069530c9fa2a {
    constructor(container){
        this.container = container;
        this.array = [];
        this.absorbers = [];
        this.interactivityAbsorbers = [];
        container.getAbsorber = (idxOrName)=>idxOrName === undefined || (0, $ad25b6e319f6df8c$export$7e4aa119212bc614)(idxOrName) ? this.array[idxOrName ?? $c5c86a62cd5757ac$var$defaultIndex] : this.array.find((t)=>t.name === idxOrName);
        container.addAbsorber = async (options, position)=>this.addAbsorber(options, position);
    }
    async addAbsorber(options, position) {
        const absorber = new (0, $f48f2924f0276ee5$export$2b570af194d8d56d)(this, this.container, options, position);
        this.array.push(absorber);
        return Promise.resolve(absorber);
    }
    draw(context) {
        for (const absorber of this.array)absorber.draw(context);
    }
    handleClickMode(mode) {
        const absorberOptions = this.absorbers, modeAbsorbers = this.interactivityAbsorbers;
        if (mode === (0, $e3e5e27ed2ee084d$export$d3fc3433791999a2).absorber) {
            const absorbersModeOptions = (0, $eee2fa4b9ebe63e9$export$3fbf39566d3ee62e)(modeAbsorbers), absorbersOptions = absorbersModeOptions ?? (0, $eee2fa4b9ebe63e9$export$3fbf39566d3ee62e)(absorberOptions), aPosition = this.container.interactivity.mouse.clickPosition;
            this.addAbsorber(absorbersOptions, aPosition);
        }
    }
    async init() {
        this.absorbers = this.container.actualOptions.absorbers;
        this.interactivityAbsorbers = this.container.actualOptions.interactivity.modes.absorbers;
        const promises = (0, $eee2fa4b9ebe63e9$export$8e5dc47097396754)(this.absorbers, async (absorber)=>{
            await this.addAbsorber(absorber);
        });
        if (promises instanceof Array) await Promise.all(promises);
        else await promises;
    }
    particleUpdate(particle) {
        for (const absorber of this.array){
            absorber.attract(particle);
            if (particle.destroyed) break;
        }
    }
    removeAbsorber(absorber) {
        const index = this.array.indexOf(absorber), deleteCount = 1;
        if (index >= $c5c86a62cd5757ac$var$defaultIndex) this.array.splice(index, deleteCount);
    }
    resize() {
        for (const absorber of this.array)absorber.resize();
    }
    stop() {
        this.array = [];
    }
}


class $12d8f6a57c19a4f7$export$32787437990ce8bc {
    constructor(){
        this.id = "absorbers";
    }
    async getPlugin(container) {
        return Promise.resolve(new (0, $c5c86a62cd5757ac$export$2f99069530c9fa2a)(container));
    }
    loadOptions(options, source) {
        if (!this.needsPlugin(options) && !this.needsPlugin(source)) return;
        if (source?.absorbers) options.absorbers = (0, $eee2fa4b9ebe63e9$export$8e5dc47097396754)(source.absorbers, (absorber)=>{
            const tmp = new (0, $464ca8d84fe01621$export$d814bc42ca06f7f3)();
            tmp.load(absorber);
            return tmp;
        });
        options.interactivity.modes.absorbers = (0, $eee2fa4b9ebe63e9$export$8e5dc47097396754)(source?.interactivity?.modes?.absorbers, (absorber)=>{
            const tmp = new (0, $464ca8d84fe01621$export$d814bc42ca06f7f3)();
            tmp.load(absorber);
            return tmp;
        });
    }
    needsPlugin(options) {
        if (!options) return false;
        const absorbers = options.absorbers;
        if ((0, $ad25b6e319f6df8c$export$43bee75e5e14138e)(absorbers)) return !!absorbers.length;
        else if (absorbers) return true;
        else if (options.interactivity?.events?.onClick?.mode && (0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)((0, $e3e5e27ed2ee084d$export$d3fc3433791999a2).absorber, options.interactivity.events.onClick.mode)) return true;
        return false;
    }
}





async function $8cdb0216c91b7204$export$c075ef8fc5389119(engine, refresh = true) {
    await engine.addPlugin(new (0, $12d8f6a57c19a4f7$export$32787437990ce8bc)(), refresh);
}




class $103586a6f0e91164$export$42db82a3e81a236 {
    load(data) {
        if (!data) return;
        if (data.bottom !== undefined) this.bottom = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.bottom);
        if (data.left !== undefined) this.left = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.left);
        if (data.right !== undefined) this.right = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.right);
        if (data.top !== undefined) this.top = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.top);
    }
}


var $26209ad77e82ed58$export$e2da284cac9acfa3;
(function(DestroyMode) {
    DestroyMode["none"] = "none";
    DestroyMode["split"] = "split";
})($26209ad77e82ed58$export$e2da284cac9acfa3 || ($26209ad77e82ed58$export$e2da284cac9acfa3 = {}));




class $438a912ff7344af0$export$f60d70cc94b5f20b extends (0, $49613bee1189cd15$export$2f74c042fca0b66d) {
    constructor(){
        super();
        this.value = 3;
    }
}



class $274b37d331b00e04$export$fb3eed84de2555ae extends (0, $49613bee1189cd15$export$2f74c042fca0b66d) {
    constructor(){
        super();
        this.value = {
            min: 4,
            max: 9
        };
    }
}


class $28dcd58c689dc263$export$f836382419f64c98 {
    constructor(){
        this.count = 1;
        this.factor = new (0, $438a912ff7344af0$export$f60d70cc94b5f20b)();
        this.rate = new (0, $274b37d331b00e04$export$fb3eed84de2555ae)();
        this.sizeOffset = true;
    }
    load(data) {
        if (!data) return;
        if (data.color !== undefined) this.color = (0, $c86524210cdfad1b$export$c2b08aa25660fcaa).create(this.color, data.color);
        if (data.count !== undefined) this.count = data.count;
        this.factor.load(data.factor);
        this.rate.load(data.rate);
        this.particles = (0, $eee2fa4b9ebe63e9$export$8e5dc47097396754)(data.particles, (particles)=>{
            return (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)({}, particles);
        });
        if (data.sizeOffset !== undefined) this.sizeOffset = data.sizeOffset;
        if (data.colorOffset) {
            this.colorOffset = this.colorOffset ?? {};
            if (data.colorOffset.h !== undefined) this.colorOffset.h = data.colorOffset.h;
            if (data.colorOffset.s !== undefined) this.colorOffset.s = data.colorOffset.s;
            if (data.colorOffset.l !== undefined) this.colorOffset.l = data.colorOffset.l;
        }
    }
}


class $95055badb61a8c4e$export$a52d062350622d8e {
    constructor(){
        this.bounds = new (0, $103586a6f0e91164$export$42db82a3e81a236)();
        this.mode = (0, $26209ad77e82ed58$export$e2da284cac9acfa3).none;
        this.split = new (0, $28dcd58c689dc263$export$f836382419f64c98)();
    }
    load(data) {
        if (!data) return;
        if (data.mode) this.mode = data.mode;
        if (data.bounds) this.bounds.load(data.bounds);
        this.split.load(data.split);
    }
}




const $c91a190fabd4d3e0$var$defaultOffset = 0, $c91a190fabd4d3e0$var$minDestroySize = 0.5, $c91a190fabd4d3e0$var$defaultSplitCount = 0, $c91a190fabd4d3e0$var$increment = 1, $c91a190fabd4d3e0$var$unbreakableTime = 500, $c91a190fabd4d3e0$var$minSplitCount = 0;
function $c91a190fabd4d3e0$var$addSplitParticle(engine, container, parent, splitParticlesOptions) {
    const destroyOptions = parent.options.destroy;
    if (!destroyOptions) return;
    const splitOptions = destroyOptions.split, options = (0, $8d5b97c98fc610d5$export$3e14721506027822)(engine, container, parent.options), factor = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(splitOptions.factor.value), parentColor = parent.getFillColor();
    if (splitOptions.color) options.color.load(splitOptions.color);
    else if (splitOptions.colorOffset && parentColor) options.color.load({
        value: {
            hsl: {
                h: parentColor.h + (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(splitOptions.colorOffset.h ?? $c91a190fabd4d3e0$var$defaultOffset),
                s: parentColor.s + (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(splitOptions.colorOffset.s ?? $c91a190fabd4d3e0$var$defaultOffset),
                l: parentColor.l + (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(splitOptions.colorOffset.l ?? $c91a190fabd4d3e0$var$defaultOffset)
            }
        }
    });
    else options.color.load({
        value: {
            hsl: parent.getFillColor()
        }
    });
    options.move.load({
        center: {
            x: parent.position.x,
            y: parent.position.y,
            mode: (0, $990956d8c795e3d5$export$1009f0178778a981).precise
        }
    });
    if ((0, $ad25b6e319f6df8c$export$7e4aa119212bc614)(options.size.value)) options.size.value /= factor;
    else {
        options.size.value.min /= factor;
        options.size.value.max /= factor;
    }
    options.load(splitParticlesOptions);
    const offset = splitOptions.sizeOffset ? (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(-parent.size.value, parent.size.value) : $c91a190fabd4d3e0$var$defaultOffset, position = {
        x: parent.position.x + (0, $1ff4dfb77b7bb646$export$8b958c8ecd94a804)(offset),
        y: parent.position.y + (0, $1ff4dfb77b7bb646$export$8b958c8ecd94a804)(offset)
    };
    return container.particles.addParticle(position, options, parent.group, (particle)=>{
        if (particle.size.value < $c91a190fabd4d3e0$var$minDestroySize) return false;
        particle.velocity.length = (0, $1ff4dfb77b7bb646$export$8b958c8ecd94a804)((0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(parent.velocity.length, particle.velocity.length));
        particle.splitCount = (parent.splitCount ?? $c91a190fabd4d3e0$var$defaultSplitCount) + $c91a190fabd4d3e0$var$increment;
        particle.unbreakable = true;
        setTimeout(()=>{
            particle.unbreakable = false;
        }, $c91a190fabd4d3e0$var$unbreakableTime);
        return true;
    });
}
function $c91a190fabd4d3e0$export$65980d18b75784e2(engine, container, particle) {
    const destroyOptions = particle.options.destroy;
    if (!destroyOptions) return;
    const splitOptions = destroyOptions.split;
    if (splitOptions.count >= $c91a190fabd4d3e0$var$minSplitCount && (particle.splitCount === undefined || particle.splitCount++ > splitOptions.count)) return;
    const rate = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(splitOptions.rate.value), particlesSplitOptions = (0, $eee2fa4b9ebe63e9$export$3fbf39566d3ee62e)(splitOptions.particles);
    for(let i = 0; i < rate; i++)$c91a190fabd4d3e0$var$addSplitParticle(engine, container, particle, particlesSplitOptions);
}


class $ba286714dfb03c44$export$fbfd6049edb6af01 {
    constructor(engine, container){
        this.container = container;
        this.engine = engine;
    }
    init(particle) {
        const container = this.container, particlesOptions = particle.options, destroyOptions = particlesOptions.destroy;
        if (!destroyOptions) return;
        particle.splitCount = 0;
        const destroyBoundsOptions = destroyOptions.bounds;
        if (!particle.destroyBounds) particle.destroyBounds = {};
        const { bottom: bottom, left: left, right: right, top: top } = destroyBoundsOptions, { destroyBounds: destroyBounds } = particle, canvasSize = container.canvas.size;
        if (bottom) destroyBounds.bottom = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(bottom) * canvasSize.height / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd);
        if (left) destroyBounds.left = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(left) * canvasSize.width / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd);
        if (right) destroyBounds.right = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(right) * canvasSize.width / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd);
        if (top) destroyBounds.top = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(top) * canvasSize.height / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd);
    }
    isEnabled(particle) {
        return !particle.destroyed;
    }
    loadOptions(options, ...sources) {
        if (!options.destroy) options.destroy = new (0, $95055badb61a8c4e$export$a52d062350622d8e)();
        for (const source of sources)options.destroy.load(source?.destroy);
    }
    particleDestroyed(particle, override) {
        if (override) return;
        const destroyOptions = particle.options.destroy;
        if (destroyOptions && destroyOptions.mode === (0, $26209ad77e82ed58$export$e2da284cac9acfa3).split) (0, $c91a190fabd4d3e0$export$65980d18b75784e2)(this.engine, this.container, particle);
    }
    update(particle) {
        if (!this.isEnabled(particle)) return;
        const position = particle.getPosition(), bounds = particle.destroyBounds;
        if (!bounds) return;
        if (bounds.bottom !== undefined && position.y >= bounds.bottom || bounds.left !== undefined && position.x <= bounds.left || bounds.right !== undefined && position.x >= bounds.right || bounds.top !== undefined && position.y <= bounds.top) particle.destroy();
    }
}


async function $e582dfa37e4f11f5$export$d6d9d65fda83a7c5(engine, refresh = true) {
    await engine.addParticleUpdater("destroy", (container)=>{
        return Promise.resolve(new (0, $ba286714dfb03c44$export$fbfd6049edb6af01)(engine, container));
    }, refresh);
}





const $9d1cb6c055974522$var$quarter = 0.25, $9d1cb6c055974522$var$double = 2, $9d1cb6c055974522$var$doublePI = Math.PI * $9d1cb6c055974522$var$double, $9d1cb6c055974522$var$squareExp = 2, $9d1cb6c055974522$var$half = 0.5;
class $9d1cb6c055974522$export$d88e33f587fbac6e extends (0, $5ee3aa7dc3e7cc15$export$16a3ea651f8843c2) {
    constructor(position, size, fill, options){
        super(position, size, fill, options);
    }
    async init() {}
    randomPosition() {
        const size = this.size, fill = this.fill, position = this.position, generateTheta = (x, y)=>{
            const u = (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * $9d1cb6c055974522$var$quarter, theta = Math.atan(y / x * Math.tan($9d1cb6c055974522$var$doublePI * u)), v = (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)();
            if (v < $9d1cb6c055974522$var$quarter) return theta;
            else if (v < $9d1cb6c055974522$var$double * $9d1cb6c055974522$var$quarter) return Math.PI - theta;
            else if (v < $9d1cb6c055974522$var$double * $9d1cb6c055974522$var$quarter + $9d1cb6c055974522$var$quarter) return Math.PI + theta;
            else return -theta;
        }, radius = (x, y, theta)=>x * y / Math.sqrt((y * Math.cos(theta)) ** $9d1cb6c055974522$var$squareExp + (x * Math.sin(theta)) ** $9d1cb6c055974522$var$squareExp), [a, b] = [
            size.width * $9d1cb6c055974522$var$half,
            size.height * $9d1cb6c055974522$var$half
        ], randomTheta = generateTheta(a, b), maxRadius = radius(a, b, randomTheta), randomRadius = fill ? maxRadius * Math.sqrt((0, $1ff4dfb77b7bb646$export$1a76347094524b3b)()) : maxRadius;
        return {
            position: {
                x: position.x + randomRadius * Math.cos(randomTheta),
                y: position.y + randomRadius * Math.sin(randomTheta)
            }
        };
    }
}


class $0b4330549093cc80$export$3b500d6539e73c36 {
    generate(position, size, fill, options) {
        return new (0, $9d1cb6c055974522$export$d88e33f587fbac6e)(position, size, fill, options);
    }
}


async function $f08249947f885b04$export$3dfd1f7f2dd5722(engine, refresh = true) {
    const emittersEngine = engine;
    emittersEngine.addEmitterShapeGenerator?.("circle", new (0, $0b4330549093cc80$export$3b500d6539e73c36)());
    await emittersEngine.refresh(refresh);
}




const $0f64fb37b2d76ec5$var$half = 0.5, $0f64fb37b2d76ec5$var$sides = 4, $0f64fb37b2d76ec5$var$double = 2;
var $0f64fb37b2d76ec5$var$Sides;
(function(Sides) {
    Sides[Sides["TopLeft"] = 0] = "TopLeft";
    Sides[Sides["TopRight"] = 1] = "TopRight";
    Sides[Sides["BottomRight"] = 2] = "BottomRight";
    Sides[Sides["BottomLeft"] = 3] = "BottomLeft";
})($0f64fb37b2d76ec5$var$Sides || ($0f64fb37b2d76ec5$var$Sides = {}));
function $0f64fb37b2d76ec5$var$randomSquareCoordinate(position, offset) {
    return position + offset * ((0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() - (0, $dec17af1c054e95f$export$fa0534be1c9f2e23));
}
class $0f64fb37b2d76ec5$export$302a099ee18ce9f8 extends (0, $5ee3aa7dc3e7cc15$export$16a3ea651f8843c2) {
    constructor(position, size, fill, options){
        super(position, size, fill, options);
    }
    async init() {}
    randomPosition() {
        const fill = this.fill, position = this.position, size = this.size;
        if (fill) return {
            position: {
                x: $0f64fb37b2d76ec5$var$randomSquareCoordinate(position.x, size.width),
                y: $0f64fb37b2d76ec5$var$randomSquareCoordinate(position.y, size.height)
            }
        };
        else {
            const halfW = size.width * $0f64fb37b2d76ec5$var$half, halfH = size.height * $0f64fb37b2d76ec5$var$half, side = Math.floor((0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * $0f64fb37b2d76ec5$var$sides), v = ((0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() - (0, $dec17af1c054e95f$export$fa0534be1c9f2e23)) * $0f64fb37b2d76ec5$var$double;
            switch(side){
                case $0f64fb37b2d76ec5$var$Sides.TopLeft:
                    return {
                        position: {
                            x: position.x + v * halfW,
                            y: position.y - halfH
                        }
                    };
                case $0f64fb37b2d76ec5$var$Sides.TopRight:
                    return {
                        position: {
                            x: position.x - halfW,
                            y: position.y + v * halfH
                        }
                    };
                case $0f64fb37b2d76ec5$var$Sides.BottomRight:
                    return {
                        position: {
                            x: position.x + v * halfW,
                            y: position.y + halfH
                        }
                    };
                case $0f64fb37b2d76ec5$var$Sides.BottomLeft:
                default:
                    return {
                        position: {
                            x: position.x + halfW,
                            y: position.y + v * halfH
                        }
                    };
            }
        }
    }
}


class $b49329309f8661f2$export$998eeece05ae15d6 {
    generate(position, size, fill, options) {
        return new (0, $0f64fb37b2d76ec5$export$302a099ee18ce9f8)(position, size, fill, options);
    }
}


async function $dead9bd3b9f4e31f$export$d7d833930c5e323b(engine, refresh = true) {
    const emittersEngine = engine;
    emittersEngine.addEmitterShapeGenerator?.("square", new (0, $b49329309f8661f2$export$998eeece05ae15d6)());
    await emittersEngine.refresh(refresh);
}




class $8ce36623bad4406c$export$3b8b9d47fbf8fd2b {
    constructor(){
        this.delay = 1;
        this.pauseOnStop = false;
        this.quantity = 1;
    }
    load(data) {
        if (!data) return;
        if (data.delay !== undefined) this.delay = data.delay;
        if (data.quantity !== undefined) this.quantity = data.quantity;
        if (data.particles !== undefined) this.particles = (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)({}, data.particles);
        if (data.pauseOnStop !== undefined) this.pauseOnStop = data.pauseOnStop;
    }
}


const $8efa3d3ba065204e$var$trailMode = "trail";
class $8efa3d3ba065204e$export$7e8e09e16f016468 extends (0, $5825146c5282067b$export$6e252256471acc61) {
    constructor(container){
        super(container);
        this._delay = 0;
    }
    clear() {}
    init() {}
    interact(delta) {
        const container = this.container, { interactivity: interactivity } = container;
        if (!container.retina.reduceFactor) return;
        const options = container.actualOptions, trailOptions = options.interactivity.modes.trail;
        if (!trailOptions) return;
        const optDelay = trailOptions.delay * (0, $dec17af1c054e95f$export$f64c3bfbc58eec0f) / this.container.retina.reduceFactor;
        if (this._delay < optDelay) this._delay += delta.value;
        if (this._delay < optDelay) return;
        const canEmit = !(trailOptions.pauseOnStop && (interactivity.mouse.position === this._lastPosition || interactivity.mouse.position?.x === this._lastPosition?.x && interactivity.mouse.position?.y === this._lastPosition?.y));
        const mousePos = container.interactivity.mouse.position;
        if (mousePos) this._lastPosition = {
            ...mousePos
        };
        else delete this._lastPosition;
        if (canEmit) container.particles.push(trailOptions.quantity, container.interactivity.mouse, trailOptions.particles);
        this._delay -= optDelay;
    }
    isEnabled(particle) {
        const container = this.container, options = container.actualOptions, mouse = container.interactivity.mouse, events = (particle?.interactivity ?? options.interactivity).events;
        return mouse.clicking && mouse.inside && !!mouse.position && (0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)($8efa3d3ba065204e$var$trailMode, events.onClick.mode) || mouse.inside && !!mouse.position && (0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)($8efa3d3ba065204e$var$trailMode, events.onHover.mode);
    }
    loadModeOptions(options, ...sources) {
        if (!options.trail) options.trail = new (0, $8ce36623bad4406c$export$3b8b9d47fbf8fd2b)();
        for (const source of sources)options.trail.load(source?.trail);
    }
    reset() {}
}





async function $314f95152c52cc06$export$9e84d16a6473365f(engine, refresh = true) {
    await engine.addInteractor("externalTrail", (container)=>{
        return Promise.resolve(new (0, $8efa3d3ba065204e$export$7e8e09e16f016468)(container));
    }, refresh);
}



var $9935b3d337b3c1bd$export$f39dbbfc5e88eacd;
(function(RollMode) {
    RollMode["both"] = "both";
    RollMode["horizontal"] = "horizontal";
    RollMode["vertical"] = "vertical";
})($9935b3d337b3c1bd$export$f39dbbfc5e88eacd || ($9935b3d337b3c1bd$export$f39dbbfc5e88eacd = {}));


const $cb141bb8198c68fb$var$double = 2, $cb141bb8198c68fb$var$doublePI = Math.PI * $cb141bb8198c68fb$var$double, $cb141bb8198c68fb$var$maxAngle = 360;
function $cb141bb8198c68fb$export$5f19b033575b4930(particle) {
    const rollOpt = particle.options.roll;
    if (!rollOpt?.enable) {
        particle.roll = {
            enable: false,
            horizontal: false,
            vertical: false,
            angle: 0,
            speed: 0
        };
        return;
    }
    particle.roll = {
        enable: rollOpt.enable,
        horizontal: rollOpt.mode === (0, $9935b3d337b3c1bd$export$f39dbbfc5e88eacd).horizontal || rollOpt.mode === (0, $9935b3d337b3c1bd$export$f39dbbfc5e88eacd).both,
        vertical: rollOpt.mode === (0, $9935b3d337b3c1bd$export$f39dbbfc5e88eacd).vertical || rollOpt.mode === (0, $9935b3d337b3c1bd$export$f39dbbfc5e88eacd).both,
        angle: (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * $cb141bb8198c68fb$var$doublePI,
        speed: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(rollOpt.speed) / $cb141bb8198c68fb$var$maxAngle
    };
    if (rollOpt.backColor) particle.backColor = (0, $fd6faa9f4e5410ac$export$79a89086521c0f12)(rollOpt.backColor);
    else if (rollOpt.darken.enable && rollOpt.enlighten.enable) {
        const alterType = (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() >= (0, $dec17af1c054e95f$export$fa0534be1c9f2e23) ? (0, $c9d3d993d79e9eed$export$d3c0448523aecc2e).darken : (0, $c9d3d993d79e9eed$export$d3c0448523aecc2e).enlighten;
        particle.roll.alter = {
            type: alterType,
            value: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(alterType === (0, $c9d3d993d79e9eed$export$d3c0448523aecc2e).darken ? rollOpt.darken.value : rollOpt.enlighten.value)
        };
    } else if (rollOpt.darken.enable) particle.roll.alter = {
        type: (0, $c9d3d993d79e9eed$export$d3c0448523aecc2e).darken,
        value: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(rollOpt.darken.value)
    };
    else if (rollOpt.enlighten.enable) particle.roll.alter = {
        type: (0, $c9d3d993d79e9eed$export$d3c0448523aecc2e).enlighten,
        value: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(rollOpt.enlighten.value)
    };
}
function $cb141bb8198c68fb$export$449a3d30f609ff1a(particle, delta) {
    const roll = particle.options.roll, data = particle.roll;
    if (!data || !roll?.enable) return;
    const speed = data.speed * delta.factor, max = $cb141bb8198c68fb$var$doublePI;
    data.angle += speed;
    if (data.angle > max) data.angle -= max;
}




class $eb6c938664f1abb8$export$16e8cbb26bb35e82 {
    constructor(){
        this.enable = false;
        this.value = 0;
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.value !== undefined) this.value = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.value);
    }
}



class $6fecb7d73e25db3d$export$aa11096b70371f74 {
    constructor(){
        this.darken = new (0, $eb6c938664f1abb8$export$16e8cbb26bb35e82)();
        this.enable = false;
        this.enlighten = new (0, $eb6c938664f1abb8$export$16e8cbb26bb35e82)();
        this.mode = (0, $9935b3d337b3c1bd$export$f39dbbfc5e88eacd).vertical;
        this.speed = 25;
    }
    load(data) {
        if (!data) return;
        if (data.backColor !== undefined) this.backColor = (0, $c86524210cdfad1b$export$c2b08aa25660fcaa).create(this.backColor, data.backColor);
        this.darken.load(data.darken);
        if (data.enable !== undefined) this.enable = data.enable;
        this.enlighten.load(data.enlighten);
        if (data.mode !== undefined) this.mode = data.mode;
        if (data.speed !== undefined) this.speed = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.speed);
    }
}


class $3d45a76f6cb440cd$export$b21adf6f4d6d0a6a {
    getTransformValues(particle) {
        const roll = particle.roll?.enable && particle.roll, rollHorizontal = roll && roll.horizontal, rollVertical = roll && roll.vertical;
        return {
            a: rollHorizontal ? Math.cos(roll.angle) : undefined,
            d: rollVertical ? Math.sin(roll.angle) : undefined
        };
    }
    init(particle) {
        (0, $cb141bb8198c68fb$export$5f19b033575b4930)(particle);
    }
    isEnabled(particle) {
        const roll = particle.options.roll;
        return !particle.destroyed && !particle.spawning && !!roll?.enable;
    }
    loadOptions(options, ...sources) {
        if (!options.roll) options.roll = new (0, $6fecb7d73e25db3d$export$aa11096b70371f74)();
        for (const source of sources)options.roll.load(source?.roll);
    }
    update(particle, delta) {
        if (!this.isEnabled(particle)) return;
        (0, $cb141bb8198c68fb$export$449a3d30f609ff1a)(particle, delta);
    }
}


async function $22056b9ac8a8030c$export$9a3fb111b9c845ed(engine, refresh = true) {
    await engine.addParticleUpdater("roll", ()=>{
        return Promise.resolve(new (0, $3d45a76f6cb440cd$export$b21adf6f4d6d0a6a)());
    }, refresh);
}




const $1898d84a9c4d3db2$var$half = 0.5, $1898d84a9c4d3db2$var$minVelocity = 0, $1898d84a9c4d3db2$var$identity = 1, $1898d84a9c4d3db2$var$moveSpeedFactor = 60, $1898d84a9c4d3db2$var$minSpinRadius = 0, $1898d84a9c4d3db2$var$spinFactor = 0.01;
function $1898d84a9c4d3db2$export$21d7e305c937fbb2(particle) {
    const initialPosition = particle.initialPosition, { dx: dx, dy: dy } = (0, $1ff4dfb77b7bb646$export$c76b58cfe053f228)(initialPosition, particle.position), dxFixed = Math.abs(dx), dyFixed = Math.abs(dy), { maxDistance: maxDistance } = particle.retina, hDistance = maxDistance.horizontal, vDistance = maxDistance.vertical;
    if (!hDistance && !vDistance) return;
    const hasHDistance = (hDistance && dxFixed >= hDistance) ?? false, hasVDistance = (vDistance && dyFixed >= vDistance) ?? false;
    if ((hasHDistance || hasVDistance) && !particle.misplaced) {
        particle.misplaced = !!hDistance && dxFixed > hDistance || !!vDistance && dyFixed > vDistance;
        if (hDistance) particle.velocity.x = particle.velocity.y * $1898d84a9c4d3db2$var$half - particle.velocity.x;
        if (vDistance) particle.velocity.y = particle.velocity.x * $1898d84a9c4d3db2$var$half - particle.velocity.y;
    } else if ((!hDistance || dxFixed < hDistance) && (!vDistance || dyFixed < vDistance) && particle.misplaced) particle.misplaced = false;
    else if (particle.misplaced) {
        const pos = particle.position, vel = particle.velocity;
        if (hDistance && (pos.x < initialPosition.x && vel.x < $1898d84a9c4d3db2$var$minVelocity || pos.x > initialPosition.x && vel.x > $1898d84a9c4d3db2$var$minVelocity)) vel.x *= -(0, $1ff4dfb77b7bb646$export$1a76347094524b3b)();
        if (vDistance && (pos.y < initialPosition.y && vel.y < $1898d84a9c4d3db2$var$minVelocity || pos.y > initialPosition.y && vel.y > $1898d84a9c4d3db2$var$minVelocity)) vel.y *= -(0, $1ff4dfb77b7bb646$export$1a76347094524b3b)();
    }
}
function $1898d84a9c4d3db2$export$d947e5f4f4c48d48(particle, moveOptions, moveSpeed, maxSpeed, moveDrift, delta) {
    $1898d84a9c4d3db2$export$2d1dd1364a451835(particle, delta);
    const gravityOptions = particle.gravity, gravityFactor = gravityOptions?.enable && gravityOptions.inverse ? -$1898d84a9c4d3db2$var$identity : $1898d84a9c4d3db2$var$identity;
    if (moveDrift && moveSpeed) particle.velocity.x += moveDrift * delta.factor / ($1898d84a9c4d3db2$var$moveSpeedFactor * moveSpeed);
    if (gravityOptions?.enable && moveSpeed) particle.velocity.y += gravityFactor * (gravityOptions.acceleration * delta.factor) / ($1898d84a9c4d3db2$var$moveSpeedFactor * moveSpeed);
    const decay = particle.moveDecay;
    particle.velocity.multTo(decay);
    const velocity = particle.velocity.mult(moveSpeed);
    if (gravityOptions?.enable && maxSpeed > $1898d84a9c4d3db2$var$minVelocity && (!gravityOptions.inverse && velocity.y >= $1898d84a9c4d3db2$var$minVelocity && velocity.y >= maxSpeed || gravityOptions.inverse && velocity.y <= $1898d84a9c4d3db2$var$minVelocity && velocity.y <= -maxSpeed)) {
        velocity.y = gravityFactor * maxSpeed;
        if (moveSpeed) particle.velocity.y = velocity.y / moveSpeed;
    }
    const zIndexOptions = particle.options.zIndex, zVelocityFactor = ($1898d84a9c4d3db2$var$identity - particle.zIndexFactor) ** zIndexOptions.velocityRate;
    velocity.multTo(zVelocityFactor);
    const { position: position } = particle;
    position.addTo(velocity);
    if (moveOptions.vibrate) {
        position.x += Math.sin(position.x * Math.cos(position.y));
        position.y += Math.cos(position.y * Math.sin(position.x));
    }
}
function $1898d84a9c4d3db2$export$c82e186cf428d56d(particle, moveSpeed) {
    const container = particle.container;
    if (!particle.spin) return;
    const updateFunc = {
        x: particle.spin.direction === (0, $c606501dd7c2dcb2$export$9506977ce2a96a5b).clockwise ? Math.cos : Math.sin,
        y: particle.spin.direction === (0, $c606501dd7c2dcb2$export$9506977ce2a96a5b).clockwise ? Math.sin : Math.cos
    };
    particle.position.x = particle.spin.center.x + particle.spin.radius * updateFunc.x(particle.spin.angle);
    particle.position.y = particle.spin.center.y + particle.spin.radius * updateFunc.y(particle.spin.angle);
    particle.spin.radius += particle.spin.acceleration;
    const maxCanvasSize = Math.max(container.canvas.size.width, container.canvas.size.height), halfMaxSize = maxCanvasSize * $1898d84a9c4d3db2$var$half;
    if (particle.spin.radius > halfMaxSize) {
        particle.spin.radius = halfMaxSize;
        particle.spin.acceleration *= -$1898d84a9c4d3db2$var$identity;
    } else if (particle.spin.radius < $1898d84a9c4d3db2$var$minSpinRadius) {
        particle.spin.radius = $1898d84a9c4d3db2$var$minSpinRadius;
        particle.spin.acceleration *= -$1898d84a9c4d3db2$var$identity;
    }
    particle.spin.angle += moveSpeed * $1898d84a9c4d3db2$var$spinFactor * ($1898d84a9c4d3db2$var$identity - particle.spin.radius / maxCanvasSize);
}
function $1898d84a9c4d3db2$export$2d1dd1364a451835(particle, delta) {
    const particlesOptions = particle.options, pathOptions = particlesOptions.move.path, pathEnabled = pathOptions.enable;
    if (!pathEnabled) return;
    if (particle.lastPathTime <= particle.pathDelay) {
        particle.lastPathTime += delta.value;
        return;
    }
    const path = particle.pathGenerator?.generate(particle, delta);
    if (path) particle.velocity.addTo(path);
    if (pathOptions.clamp) {
        particle.velocity.x = (0, $1ff4dfb77b7bb646$export$7d15b64cf5a3a4c4)(particle.velocity.x, -$1898d84a9c4d3db2$var$identity, $1898d84a9c4d3db2$var$identity);
        particle.velocity.y = (0, $1ff4dfb77b7bb646$export$7d15b64cf5a3a4c4)(particle.velocity.y, -$1898d84a9c4d3db2$var$identity, $1898d84a9c4d3db2$var$identity);
    }
    particle.lastPathTime -= particle.pathDelay;
}
function $1898d84a9c4d3db2$export$7f3cc12c83994316(particle) {
    return particle.slow.inRange ? particle.slow.factor : $1898d84a9c4d3db2$var$identity;
}
function $1898d84a9c4d3db2$export$2d310d1fc5fad1a1(particle) {
    const container = particle.container, options = particle.options, spinOptions = options.move.spin;
    if (!spinOptions.enable) return;
    const spinPos = spinOptions.position ?? {
        x: 50,
        y: 50
    }, spinFactor = 0.01, spinCenter = {
        x: spinPos.x * spinFactor * container.canvas.size.width,
        y: spinPos.y * spinFactor * container.canvas.size.height
    }, pos = particle.getPosition(), distance = (0, $1ff4dfb77b7bb646$export$79376507b09a66f)(pos, spinCenter), spinAcceleration = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(spinOptions.acceleration);
    particle.retina.spinAcceleration = spinAcceleration * container.retina.pixelRatio;
    const minVelocity = 0;
    particle.spin = {
        center: spinCenter,
        direction: particle.velocity.x >= minVelocity ? (0, $c606501dd7c2dcb2$export$9506977ce2a96a5b).clockwise : (0, $c606501dd7c2dcb2$export$9506977ce2a96a5b).counterClockwise,
        angle: particle.velocity.angle,
        radius: distance,
        acceleration: particle.retina.spinAcceleration
    };
}


const $c6c993c9015c2be6$var$diffFactor = 2, $c6c993c9015c2be6$var$defaultSizeFactor = 1, $c6c993c9015c2be6$var$defaultDeltaFactor = 1;
class $c6c993c9015c2be6$export$c506fa331d75adff {
    init(particle) {
        const options = particle.options, gravityOptions = options.move.gravity;
        particle.gravity = {
            enable: gravityOptions.enable,
            acceleration: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(gravityOptions.acceleration),
            inverse: gravityOptions.inverse
        };
        (0, $1898d84a9c4d3db2$export$2d310d1fc5fad1a1)(particle);
    }
    isEnabled(particle) {
        return !particle.destroyed && particle.options.move.enable;
    }
    move(particle, delta) {
        const particleOptions = particle.options, moveOptions = particleOptions.move;
        if (!moveOptions.enable) return;
        const container = particle.container, pxRatio = container.retina.pixelRatio;
        particle.retina.moveSpeed ??= (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(moveOptions.speed) * pxRatio;
        particle.retina.moveDrift ??= (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(particle.options.move.drift) * pxRatio;
        const slowFactor = (0, $1898d84a9c4d3db2$export$7f3cc12c83994316)(particle), baseSpeed = particle.retina.moveSpeed * container.retina.reduceFactor, moveDrift = particle.retina.moveDrift, maxSize = (0, $1ff4dfb77b7bb646$export$27d2c76f835d583d)(particleOptions.size.value) * pxRatio, sizeFactor = moveOptions.size ? particle.getRadius() / maxSize : $c6c993c9015c2be6$var$defaultSizeFactor, deltaFactor = delta.factor || $c6c993c9015c2be6$var$defaultDeltaFactor, moveSpeed = baseSpeed * sizeFactor * slowFactor * deltaFactor / $c6c993c9015c2be6$var$diffFactor, maxSpeed = particle.retina.maxSpeed ?? container.retina.maxSpeed;
        if (moveOptions.spin.enable) (0, $1898d84a9c4d3db2$export$c82e186cf428d56d)(particle, moveSpeed);
        else (0, $1898d84a9c4d3db2$export$d947e5f4f4c48d48)(particle, moveOptions, moveSpeed, maxSpeed, moveDrift, delta);
        (0, $1898d84a9c4d3db2$export$21d7e305c937fbb2)(particle);
    }
}


async function $b5d014b55830a4a4$export$8949951fd9df9397(engine, refresh = true) {
    await engine.addMover("base", ()=>{
        return Promise.resolve(new (0, $c6c993c9015c2be6$export$c506fa331d75adff)());
    }, refresh);
}



const $ca4074e020bc93e5$var$double = 2, $ca4074e020bc93e5$var$doublePI = Math.PI * $ca4074e020bc93e5$var$double, $ca4074e020bc93e5$var$minAngle = 0, $ca4074e020bc93e5$var$origin = {
    x: 0,
    y: 0
};
function $ca4074e020bc93e5$export$8daab6f91f7ff730(data) {
    const { context: context, particle: particle, radius: radius } = data;
    if (!particle.circleRange) particle.circleRange = {
        min: $ca4074e020bc93e5$var$minAngle,
        max: $ca4074e020bc93e5$var$doublePI
    };
    const circleRange = particle.circleRange;
    context.arc($ca4074e020bc93e5$var$origin.x, $ca4074e020bc93e5$var$origin.y, radius, circleRange.min, circleRange.max, false);
}


const $5902b2db3c7962fc$var$sides = 12, $5902b2db3c7962fc$var$maxAngle = 360, $5902b2db3c7962fc$var$minAngle = 0;
class $5902b2db3c7962fc$export$b29a4fa100f54972 {
    constructor(){
        this.validTypes = [
            "circle"
        ];
    }
    draw(data) {
        (0, $ca4074e020bc93e5$export$8daab6f91f7ff730)(data);
    }
    getSidesCount() {
        return $5902b2db3c7962fc$var$sides;
    }
    particleInit(container, particle) {
        const shapeData = particle.shapeData, angle = shapeData?.angle ?? {
            max: $5902b2db3c7962fc$var$maxAngle,
            min: $5902b2db3c7962fc$var$minAngle
        };
        particle.circleRange = !(0, $ad25b6e319f6df8c$export$a6cdc56e425d0d0a)(angle) ? {
            min: $5902b2db3c7962fc$var$minAngle,
            max: (0, $1ff4dfb77b7bb646$export$e6bfdeff8bfc94f9)(angle)
        } : {
            min: (0, $1ff4dfb77b7bb646$export$e6bfdeff8bfc94f9)(angle.min),
            max: (0, $1ff4dfb77b7bb646$export$e6bfdeff8bfc94f9)(angle.max)
        };
    }
}


async function $8b97416175820d97$export$66237f65cef19277(engine, refresh = true) {
    await engine.addShape(new (0, $5902b2db3c7962fc$export$b29a4fa100f54972)(), refresh);
}



class $fe3b6a8db268ad4d$export$c36bb5e4d505f205 {
    constructor(container){
        this.container = container;
    }
    init(particle) {
        const hslColor = (0, $fd6faa9f4e5410ac$export$79a89086521c0f12)(particle.options.color, particle.id, particle.options.reduceDuplicates);
        if (hslColor) particle.color = (0, $fd6faa9f4e5410ac$export$6e8a573710bea117)(hslColor, particle.options.color.animation, this.container.retina.reduceFactor);
    }
    isEnabled(particle) {
        const { h: hAnimation, s: sAnimation, l: lAnimation } = particle.options.color.animation, { color: color } = particle;
        return !particle.destroyed && !particle.spawning && (color?.h.value !== undefined && hAnimation.enable || color?.s.value !== undefined && sAnimation.enable || color?.l.value !== undefined && lAnimation.enable);
    }
    update(particle, delta) {
        (0, $fd6faa9f4e5410ac$export$649b44ac750da8e)(particle.color, delta);
    }
}


async function $e23e58a066386e61$export$bfdad36561fbf902(engine, refresh = true) {
    await engine.addParticleUpdater("color", (container)=>{
        return Promise.resolve(new (0, $fe3b6a8db268ad4d$export$c36bb5e4d505f205)(container));
    }, refresh);
}



class $94155fed6a4b08d5$export$99f6686a87b9ec6f {
    constructor(container){
        this.container = container;
    }
    init(particle) {
        const opacityOptions = particle.options.opacity, pxRatio = 1;
        particle.opacity = (0, $eee2fa4b9ebe63e9$export$bebd78259cce4fd)(opacityOptions, pxRatio);
        const opacityAnimation = opacityOptions.animation;
        if (opacityAnimation.enable) {
            particle.opacity.velocity = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(opacityAnimation.speed) / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd) * this.container.retina.reduceFactor;
            if (!opacityAnimation.sync) particle.opacity.velocity *= (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)();
        }
    }
    isEnabled(particle) {
        const none = 0;
        return !particle.destroyed && !particle.spawning && !!particle.opacity && particle.opacity.enable && ((particle.opacity.maxLoops ?? none) <= none || (particle.opacity.maxLoops ?? none) > none && (particle.opacity.loops ?? none) < (particle.opacity.maxLoops ?? none));
    }
    reset(particle) {
        if (particle.opacity) {
            particle.opacity.time = 0;
            particle.opacity.loops = 0;
        }
    }
    update(particle, delta) {
        if (!this.isEnabled(particle) || !particle.opacity) return;
        (0, $eee2fa4b9ebe63e9$export$efead17ed5dcfd2)(particle, particle.opacity, true, particle.options.opacity.animation.destroy, delta);
    }
}


async function $188e27a71d128353$export$8322e3b69c08b6eb(engine, refresh = true) {
    await engine.addParticleUpdater("opacity", (container)=>{
        return Promise.resolve(new (0, $94155fed6a4b08d5$export$99f6686a87b9ec6f)(container));
    }, refresh);
}





const $06f254b509e135fa$var$minVelocity = 0, $06f254b509e135fa$var$boundsMin = 0;
function $06f254b509e135fa$export$1def114a7da042cf(data) {
    if (data.outMode !== (0, $ad0d94f2e36d5a6b$export$cf5942d9a76b7ae2).bounce && data.outMode !== (0, $ad0d94f2e36d5a6b$export$cf5942d9a76b7ae2).split || data.direction !== (0, $0130b9f9f1247165$export$56c1e4693edf08f9).left && data.direction !== (0, $0130b9f9f1247165$export$56c1e4693edf08f9).right) return;
    if (data.bounds.right < $06f254b509e135fa$var$boundsMin && data.direction === (0, $0130b9f9f1247165$export$56c1e4693edf08f9).left) data.particle.position.x = data.size + data.offset.x;
    else if (data.bounds.left > data.canvasSize.width && data.direction === (0, $0130b9f9f1247165$export$56c1e4693edf08f9).right) data.particle.position.x = data.canvasSize.width - data.size - data.offset.x;
    const velocity = data.particle.velocity.x;
    let bounced = false;
    if (data.direction === (0, $0130b9f9f1247165$export$56c1e4693edf08f9).right && data.bounds.right >= data.canvasSize.width && velocity > $06f254b509e135fa$var$minVelocity || data.direction === (0, $0130b9f9f1247165$export$56c1e4693edf08f9).left && data.bounds.left <= $06f254b509e135fa$var$boundsMin && velocity < $06f254b509e135fa$var$minVelocity) {
        const newVelocity = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(data.particle.options.bounce.horizontal.value);
        data.particle.velocity.x *= -newVelocity;
        bounced = true;
    }
    if (!bounced) return;
    const minPos = data.offset.x + data.size;
    if (data.bounds.right >= data.canvasSize.width && data.direction === (0, $0130b9f9f1247165$export$56c1e4693edf08f9).right) data.particle.position.x = data.canvasSize.width - minPos;
    else if (data.bounds.left <= $06f254b509e135fa$var$boundsMin && data.direction === (0, $0130b9f9f1247165$export$56c1e4693edf08f9).left) data.particle.position.x = minPos;
    if (data.outMode === (0, $ad0d94f2e36d5a6b$export$cf5942d9a76b7ae2).split) data.particle.destroy();
}
function $06f254b509e135fa$export$46000c44e0211bc6(data) {
    if (data.outMode !== (0, $ad0d94f2e36d5a6b$export$cf5942d9a76b7ae2).bounce && data.outMode !== (0, $ad0d94f2e36d5a6b$export$cf5942d9a76b7ae2).split || data.direction !== (0, $0130b9f9f1247165$export$56c1e4693edf08f9).bottom && data.direction !== (0, $0130b9f9f1247165$export$56c1e4693edf08f9).top) return;
    if (data.bounds.bottom < $06f254b509e135fa$var$boundsMin && data.direction === (0, $0130b9f9f1247165$export$56c1e4693edf08f9).top) data.particle.position.y = data.size + data.offset.y;
    else if (data.bounds.top > data.canvasSize.height && data.direction === (0, $0130b9f9f1247165$export$56c1e4693edf08f9).bottom) data.particle.position.y = data.canvasSize.height - data.size - data.offset.y;
    const velocity = data.particle.velocity.y;
    let bounced = false;
    if (data.direction === (0, $0130b9f9f1247165$export$56c1e4693edf08f9).bottom && data.bounds.bottom >= data.canvasSize.height && velocity > $06f254b509e135fa$var$minVelocity || data.direction === (0, $0130b9f9f1247165$export$56c1e4693edf08f9).top && data.bounds.top <= $06f254b509e135fa$var$boundsMin && velocity < $06f254b509e135fa$var$minVelocity) {
        const newVelocity = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(data.particle.options.bounce.vertical.value);
        data.particle.velocity.y *= -newVelocity;
        bounced = true;
    }
    if (!bounced) return;
    const minPos = data.offset.y + data.size;
    if (data.bounds.bottom >= data.canvasSize.height && data.direction === (0, $0130b9f9f1247165$export$56c1e4693edf08f9).bottom) data.particle.position.y = data.canvasSize.height - minPos;
    else if (data.bounds.top <= $06f254b509e135fa$var$boundsMin && data.direction === (0, $0130b9f9f1247165$export$56c1e4693edf08f9).top) data.particle.position.y = minPos;
    if (data.outMode === (0, $ad0d94f2e36d5a6b$export$cf5942d9a76b7ae2).split) data.particle.destroy();
}


class $9f79c337ebd6b0e2$export$7a10ae135b551126 {
    constructor(container){
        this.container = container;
        this.modes = [
            (0, $ad0d94f2e36d5a6b$export$cf5942d9a76b7ae2).bounce,
            (0, $ad0d94f2e36d5a6b$export$cf5942d9a76b7ae2).split
        ];
    }
    update(particle, direction, delta, outMode) {
        if (!this.modes.includes(outMode)) return;
        const container = this.container;
        let handled = false;
        for (const [, plugin] of container.plugins){
            if (plugin.particleBounce !== undefined) handled = plugin.particleBounce(particle, delta, direction);
            if (handled) break;
        }
        if (handled) return;
        const pos = particle.getPosition(), offset = particle.offset, size = particle.getRadius(), bounds = (0, $eee2fa4b9ebe63e9$export$b0a2169b5f9d18d8)(pos, size), canvasSize = container.canvas.size;
        (0, $06f254b509e135fa$export$1def114a7da042cf)({
            particle: particle,
            outMode: outMode,
            direction: direction,
            bounds: bounds,
            canvasSize: canvasSize,
            offset: offset,
            size: size
        });
        (0, $06f254b509e135fa$export$46000c44e0211bc6)({
            particle: particle,
            outMode: outMode,
            direction: direction,
            bounds: bounds,
            canvasSize: canvasSize,
            offset: offset,
            size: size
        });
    }
}



const $69ce5492694eeb09$var$minVelocity = 0;
class $69ce5492694eeb09$export$4c86fe322e2200a {
    constructor(container){
        this.container = container;
        this.modes = [
            (0, $ad0d94f2e36d5a6b$export$cf5942d9a76b7ae2).destroy
        ];
    }
    update(particle, direction, _delta, outMode) {
        if (!this.modes.includes(outMode)) return;
        const container = this.container;
        switch(particle.outType){
            case (0, $28f49626d03d72c4$export$2e559b10bdb6bb80).normal:
            case (0, $28f49626d03d72c4$export$2e559b10bdb6bb80).outside:
                if ((0, $eee2fa4b9ebe63e9$export$2ea42ef493c7076c)(particle.position, container.canvas.size, (0, $04697537ec8dce5b$export$9b781de7bf37bf48).origin, particle.getRadius(), direction)) return;
                break;
            case (0, $28f49626d03d72c4$export$2e559b10bdb6bb80).inside:
                {
                    const { dx: dx, dy: dy } = (0, $1ff4dfb77b7bb646$export$c76b58cfe053f228)(particle.position, particle.moveCenter), { x: vx, y: vy } = particle.velocity;
                    if (vx < $69ce5492694eeb09$var$minVelocity && dx > particle.moveCenter.radius || vy < $69ce5492694eeb09$var$minVelocity && dy > particle.moveCenter.radius || vx >= $69ce5492694eeb09$var$minVelocity && dx < -particle.moveCenter.radius || vy >= $69ce5492694eeb09$var$minVelocity && dy < -particle.moveCenter.radius) return;
                    break;
                }
        }
        container.particles.remove(particle, undefined, true);
    }
}



const $b6e24b1326541bde$var$minVelocity = 0;
class $b6e24b1326541bde$export$a026dc73727d2f19 {
    constructor(container){
        this.container = container;
        this.modes = [
            (0, $ad0d94f2e36d5a6b$export$cf5942d9a76b7ae2).none
        ];
    }
    update(particle, direction, delta, outMode) {
        if (!this.modes.includes(outMode)) return;
        if ((particle.options.move.distance.horizontal && (direction === (0, $0130b9f9f1247165$export$56c1e4693edf08f9).left || direction === (0, $0130b9f9f1247165$export$56c1e4693edf08f9).right)) ?? (particle.options.move.distance.vertical && (direction === (0, $0130b9f9f1247165$export$56c1e4693edf08f9).top || direction === (0, $0130b9f9f1247165$export$56c1e4693edf08f9).bottom))) return;
        const gravityOptions = particle.options.move.gravity, container = this.container, canvasSize = container.canvas.size, pRadius = particle.getRadius();
        if (!gravityOptions.enable) {
            if (particle.velocity.y > $b6e24b1326541bde$var$minVelocity && particle.position.y <= canvasSize.height + pRadius || particle.velocity.y < $b6e24b1326541bde$var$minVelocity && particle.position.y >= -pRadius || particle.velocity.x > $b6e24b1326541bde$var$minVelocity && particle.position.x <= canvasSize.width + pRadius || particle.velocity.x < $b6e24b1326541bde$var$minVelocity && particle.position.x >= -pRadius) return;
            if (!(0, $eee2fa4b9ebe63e9$export$2ea42ef493c7076c)(particle.position, container.canvas.size, (0, $04697537ec8dce5b$export$9b781de7bf37bf48).origin, pRadius, direction)) container.particles.remove(particle);
        } else {
            const position = particle.position;
            if (!gravityOptions.inverse && position.y > canvasSize.height + pRadius && direction === (0, $0130b9f9f1247165$export$56c1e4693edf08f9).bottom || gravityOptions.inverse && position.y < -pRadius && direction === (0, $0130b9f9f1247165$export$56c1e4693edf08f9).top) container.particles.remove(particle);
        }
    }
}



const $8b2214005ef28450$var$minVelocity = 0, $8b2214005ef28450$var$minDistance = 0;
class $8b2214005ef28450$export$7300b77892783c0e {
    constructor(container){
        this.container = container;
        this.modes = [
            (0, $ad0d94f2e36d5a6b$export$cf5942d9a76b7ae2).out
        ];
    }
    update(particle, direction, delta, outMode) {
        if (!this.modes.includes(outMode)) return;
        const container = this.container;
        switch(particle.outType){
            case (0, $28f49626d03d72c4$export$2e559b10bdb6bb80).inside:
                {
                    const { x: vx, y: vy } = particle.velocity;
                    const circVec = (0, $04697537ec8dce5b$export$9b781de7bf37bf48).origin;
                    circVec.length = particle.moveCenter.radius;
                    circVec.angle = particle.velocity.angle + Math.PI;
                    circVec.addTo((0, $04697537ec8dce5b$export$9b781de7bf37bf48).create(particle.moveCenter));
                    const { dx: dx, dy: dy } = (0, $1ff4dfb77b7bb646$export$c76b58cfe053f228)(particle.position, circVec);
                    if (vx <= $8b2214005ef28450$var$minVelocity && dx >= $8b2214005ef28450$var$minDistance || vy <= $8b2214005ef28450$var$minVelocity && dy >= $8b2214005ef28450$var$minDistance || vx >= $8b2214005ef28450$var$minVelocity && dx <= $8b2214005ef28450$var$minDistance || vy >= $8b2214005ef28450$var$minVelocity && dy <= $8b2214005ef28450$var$minDistance) return;
                    particle.position.x = Math.floor((0, $1ff4dfb77b7bb646$export$8b958c8ecd94a804)({
                        min: 0,
                        max: container.canvas.size.width
                    }));
                    particle.position.y = Math.floor((0, $1ff4dfb77b7bb646$export$8b958c8ecd94a804)({
                        min: 0,
                        max: container.canvas.size.height
                    }));
                    const { dx: newDx, dy: newDy } = (0, $1ff4dfb77b7bb646$export$c76b58cfe053f228)(particle.position, particle.moveCenter);
                    particle.direction = Math.atan2(-newDy, -newDx);
                    particle.velocity.angle = particle.direction;
                    break;
                }
            default:
                if ((0, $eee2fa4b9ebe63e9$export$2ea42ef493c7076c)(particle.position, container.canvas.size, (0, $04697537ec8dce5b$export$9b781de7bf37bf48).origin, particle.getRadius(), direction)) return;
                switch(particle.outType){
                    case (0, $28f49626d03d72c4$export$2e559b10bdb6bb80).outside:
                        {
                            particle.position.x = Math.floor((0, $1ff4dfb77b7bb646$export$8b958c8ecd94a804)({
                                min: -particle.moveCenter.radius,
                                max: particle.moveCenter.radius
                            })) + particle.moveCenter.x;
                            particle.position.y = Math.floor((0, $1ff4dfb77b7bb646$export$8b958c8ecd94a804)({
                                min: -particle.moveCenter.radius,
                                max: particle.moveCenter.radius
                            })) + particle.moveCenter.y;
                            const { dx: dx, dy: dy } = (0, $1ff4dfb77b7bb646$export$c76b58cfe053f228)(particle.position, particle.moveCenter);
                            if (particle.moveCenter.radius) {
                                particle.direction = Math.atan2(dy, dx);
                                particle.velocity.angle = particle.direction;
                            }
                            break;
                        }
                    case (0, $28f49626d03d72c4$export$2e559b10bdb6bb80).normal:
                        {
                            const warp = particle.options.move.warp, canvasSize = container.canvas.size, newPos = {
                                bottom: canvasSize.height + particle.getRadius() + particle.offset.y,
                                left: -particle.getRadius() - particle.offset.x,
                                right: canvasSize.width + particle.getRadius() + particle.offset.x,
                                top: -particle.getRadius() - particle.offset.y
                            }, sizeValue = particle.getRadius(), nextBounds = (0, $eee2fa4b9ebe63e9$export$b0a2169b5f9d18d8)(particle.position, sizeValue);
                            if (direction === (0, $0130b9f9f1247165$export$56c1e4693edf08f9).right && nextBounds.left > canvasSize.width + particle.offset.x) {
                                particle.position.x = newPos.left;
                                particle.initialPosition.x = particle.position.x;
                                if (!warp) {
                                    particle.position.y = (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * canvasSize.height;
                                    particle.initialPosition.y = particle.position.y;
                                }
                            } else if (direction === (0, $0130b9f9f1247165$export$56c1e4693edf08f9).left && nextBounds.right < -particle.offset.x) {
                                particle.position.x = newPos.right;
                                particle.initialPosition.x = particle.position.x;
                                if (!warp) {
                                    particle.position.y = (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * canvasSize.height;
                                    particle.initialPosition.y = particle.position.y;
                                }
                            }
                            if (direction === (0, $0130b9f9f1247165$export$56c1e4693edf08f9).bottom && nextBounds.top > canvasSize.height + particle.offset.y) {
                                if (!warp) {
                                    particle.position.x = (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * canvasSize.width;
                                    particle.initialPosition.x = particle.position.x;
                                }
                                particle.position.y = newPos.top;
                                particle.initialPosition.y = particle.position.y;
                            } else if (direction === (0, $0130b9f9f1247165$export$56c1e4693edf08f9).top && nextBounds.bottom < -particle.offset.y) {
                                if (!warp) {
                                    particle.position.x = (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * canvasSize.width;
                                    particle.initialPosition.x = particle.position.x;
                                }
                                particle.position.y = newPos.bottom;
                                particle.initialPosition.y = particle.position.y;
                            }
                            break;
                        }
                }
                break;
        }
    }
}


const $a42030f2236facbb$var$checkOutMode = (outModes, outMode)=>{
    return outModes.default === outMode || outModes.bottom === outMode || outModes.left === outMode || outModes.right === outMode || outModes.top === outMode;
};
class $a42030f2236facbb$export$cb0990f1117a9f95 {
    constructor(container){
        this._updateOutMode = (particle, delta, outMode, direction)=>{
            for (const updater of this.updaters)updater.update(particle, direction, delta, outMode);
        };
        this.container = container;
        this.updaters = [];
    }
    init(particle) {
        this.updaters = [];
        const outModes = particle.options.move.outModes;
        if ($a42030f2236facbb$var$checkOutMode(outModes, (0, $ad0d94f2e36d5a6b$export$cf5942d9a76b7ae2).bounce)) this.updaters.push(new (0, $9f79c337ebd6b0e2$export$7a10ae135b551126)(this.container));
        else if ($a42030f2236facbb$var$checkOutMode(outModes, (0, $ad0d94f2e36d5a6b$export$cf5942d9a76b7ae2).out)) this.updaters.push(new (0, $8b2214005ef28450$export$7300b77892783c0e)(this.container));
        else if ($a42030f2236facbb$var$checkOutMode(outModes, (0, $ad0d94f2e36d5a6b$export$cf5942d9a76b7ae2).destroy)) this.updaters.push(new (0, $69ce5492694eeb09$export$4c86fe322e2200a)(this.container));
        else if ($a42030f2236facbb$var$checkOutMode(outModes, (0, $ad0d94f2e36d5a6b$export$cf5942d9a76b7ae2).none)) this.updaters.push(new (0, $b6e24b1326541bde$export$a026dc73727d2f19)(this.container));
    }
    isEnabled(particle) {
        return !particle.destroyed && !particle.spawning;
    }
    update(particle, delta) {
        const outModes = particle.options.move.outModes;
        this._updateOutMode(particle, delta, outModes.bottom ?? outModes.default, (0, $0130b9f9f1247165$export$56c1e4693edf08f9).bottom);
        this._updateOutMode(particle, delta, outModes.left ?? outModes.default, (0, $0130b9f9f1247165$export$56c1e4693edf08f9).left);
        this._updateOutMode(particle, delta, outModes.right ?? outModes.default, (0, $0130b9f9f1247165$export$56c1e4693edf08f9).right);
        this._updateOutMode(particle, delta, outModes.top ?? outModes.default, (0, $0130b9f9f1247165$export$56c1e4693edf08f9).top);
    }
}


async function $b21d8622cdd75f83$export$4cf4cb6464fcf0a1(engine, refresh = true) {
    await engine.addParticleUpdater("outModes", (container)=>{
        return Promise.resolve(new (0, $a42030f2236facbb$export$cb0990f1117a9f95)(container));
    }, refresh);
}



const $12baf4cc78b76cd0$var$minLoops = 0;
class $12baf4cc78b76cd0$export$545f3be57f54ffb6 {
    init(particle) {
        const container = particle.container, sizeOptions = particle.options.size, sizeAnimation = sizeOptions.animation;
        if (sizeAnimation.enable) {
            particle.size.velocity = (particle.retina.sizeAnimationSpeed ?? container.retina.sizeAnimationSpeed) / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd) * container.retina.reduceFactor;
            if (!sizeAnimation.sync) particle.size.velocity *= (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)();
        }
    }
    isEnabled(particle) {
        return !particle.destroyed && !particle.spawning && particle.size.enable && ((particle.size.maxLoops ?? $12baf4cc78b76cd0$var$minLoops) <= $12baf4cc78b76cd0$var$minLoops || (particle.size.maxLoops ?? $12baf4cc78b76cd0$var$minLoops) > $12baf4cc78b76cd0$var$minLoops && (particle.size.loops ?? $12baf4cc78b76cd0$var$minLoops) < (particle.size.maxLoops ?? $12baf4cc78b76cd0$var$minLoops));
    }
    reset(particle) {
        particle.size.loops = $12baf4cc78b76cd0$var$minLoops;
    }
    update(particle, delta) {
        if (!this.isEnabled(particle)) return;
        (0, $eee2fa4b9ebe63e9$export$efead17ed5dcfd2)(particle, particle.size, true, particle.options.size.animation.destroy, delta);
    }
}


async function $54f01e7e9b6ce34a$export$ca8bd803ddf2ea7e(engine, refresh = true) {
    await engine.addParticleUpdater("size", ()=>{
        return Promise.resolve(new (0, $12baf4cc78b76cd0$export$545f3be57f54ffb6)());
    }, refresh);
}


async function $daff9bde9694b13d$export$244419993531723b(engine, refresh = true) {
    await (0, $b5d014b55830a4a4$export$8949951fd9df9397)(engine, false);
    await (0, $8b97416175820d97$export$66237f65cef19277)(engine, false);
    await (0, $e23e58a066386e61$export$bfdad36561fbf902)(engine, false);
    await (0, $188e27a71d128353$export$8322e3b69c08b6eb)(engine, false);
    await (0, $b21d8622cdd75f83$export$4cf4cb6464fcf0a1)(engine, false);
    await (0, $54f01e7e9b6ce34a$export$ca8bd803ddf2ea7e)(engine, false);
    await engine.refresh(refresh);
}



async function $21ede6b40381d3fc$export$869269643d4bbdcd() {
    (0, $1ff4dfb77b7bb646$export$e2251c95822ce867)((0, $981da57d483aae4d$export$483bfb5d033dec0c).easeInQuad, (value)=>value ** 2);
    (0, $1ff4dfb77b7bb646$export$e2251c95822ce867)((0, $981da57d483aae4d$export$483bfb5d033dec0c).easeOutQuad, (value)=>1 - (1 - value) ** 2);
    (0, $1ff4dfb77b7bb646$export$e2251c95822ce867)((0, $981da57d483aae4d$export$483bfb5d033dec0c).easeInOutQuad, (value)=>value < 0.5 ? 2 * value ** 2 : 1 - (-2 * value + 2) ** 2 / 2);
    await Promise.resolve();
}



function $0863600cdd515fa3$export$fc441f4f425fe138(data) {
    const { context: context, particle: particle, radius: radius, opacity: opacity } = data, emojiData = particle.emojiData, double = 2, diameter = radius * double, previousAlpha = context.globalAlpha;
    if (!emojiData) return;
    context.globalAlpha = opacity;
    context.drawImage(emojiData, -radius, -radius, diameter, diameter);
    context.globalAlpha = previousAlpha;
}


const $682c9034ecb9be26$var$defaultFont = '"Twemoji Mozilla", Apple Color Emoji, "Segoe UI Emoji", "Noto Color Emoji", "EmojiOne Color"';
class $682c9034ecb9be26$export$54b9bca6f3f7c1c3 {
    constructor(){
        this.validTypes = [
            "emoji"
        ];
        this._emojiShapeDict = new Map();
    }
    destroy() {
        for (const [key, emojiData] of this._emojiShapeDict)if (emojiData instanceof ImageBitmap) {
            emojiData?.close();
            this._emojiShapeDict.delete(key);
        }
    }
    draw(data) {
        (0, $0863600cdd515fa3$export$fc441f4f425fe138)(data);
    }
    async init(container) {
        const options = container.actualOptions, { validTypes: validTypes } = this;
        if (!validTypes.find((t)=>(0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)(t, options.particles.shape.type))) return;
        const promises = [
            (0, $eee2fa4b9ebe63e9$export$672089c3debc1182)($682c9034ecb9be26$var$defaultFont)
        ], shapeOptions = validTypes.map((t)=>options.particles.shape.options[t]).find((t)=>!!t);
        if (shapeOptions) (0, $eee2fa4b9ebe63e9$export$8e5dc47097396754)(shapeOptions, (shape)=>{
            if (shape.font) promises.push((0, $eee2fa4b9ebe63e9$export$672089c3debc1182)(shape.font));
        });
        await Promise.all(promises);
    }
    particleDestroy(particle) {
        delete particle.emojiData;
    }
    particleInit(container, particle) {
        const double = 2, shapeData = particle.shapeData;
        if (!shapeData?.value) return;
        const emoji = (0, $eee2fa4b9ebe63e9$export$3fbf39566d3ee62e)(shapeData.value, particle.randomIndexData), font = shapeData.font ?? $682c9034ecb9be26$var$defaultFont;
        if (!emoji) return;
        const key = `${emoji}_${font}`, existingData = this._emojiShapeDict.get(key);
        if (existingData) {
            particle.emojiData = existingData;
            return;
        }
        const canvasSize = (0, $1ff4dfb77b7bb646$export$27d2c76f835d583d)(particle.size.value) * double;
        let emojiData;
        const maxSize = (0, $1ff4dfb77b7bb646$export$27d2c76f835d583d)(particle.size.value);
        if (typeof OffscreenCanvas !== "undefined") {
            const canvas = new OffscreenCanvas(canvasSize, canvasSize), context = canvas.getContext("2d");
            if (!context) return;
            context.font = `400 ${maxSize * double}px ${font}`;
            context.textBaseline = "middle";
            context.textAlign = "center";
            context.fillText(emoji, maxSize, maxSize);
            emojiData = canvas.transferToImageBitmap();
        } else {
            const canvas = document.createElement("canvas");
            canvas.width = canvasSize;
            canvas.height = canvasSize;
            const context = canvas.getContext("2d");
            if (!context) return;
            context.font = `400 ${maxSize * double}px ${font}`;
            context.textBaseline = "middle";
            context.textAlign = "center";
            context.fillText(emoji, maxSize, maxSize);
            emojiData = canvas;
        }
        this._emojiShapeDict.set(key, emojiData);
        particle.emojiData = emojiData;
    }
}


async function $c8e06abfb8ad462a$export$b3876a8a0c501bd1(engine, refresh = true) {
    await engine.addShape(new (0, $682c9034ecb9be26$export$54b9bca6f3f7c1c3)(), refresh);
}




const $32d41bc93ba3aae6$var$minFactor = 1, $32d41bc93ba3aae6$var$identity = 1, $32d41bc93ba3aae6$var$minRadius = 0;
function $32d41bc93ba3aae6$var$processAttract(container, position, attractRadius, area, queryCb) {
    const attractOptions = container.actualOptions.interactivity.modes.attract;
    if (!attractOptions) return;
    const query = container.particles.quadTree.query(area, queryCb);
    for (const particle of query){
        const { dx: dx, dy: dy, distance: distance } = (0, $1ff4dfb77b7bb646$export$c76b58cfe053f228)(particle.position, position), velocity = attractOptions.speed * attractOptions.factor, attractFactor = (0, $1ff4dfb77b7bb646$export$7d15b64cf5a3a4c4)((0, $1ff4dfb77b7bb646$export$2bbf531f74195405)(attractOptions.easing)($32d41bc93ba3aae6$var$identity - distance / attractRadius) * velocity, $32d41bc93ba3aae6$var$minFactor, attractOptions.maxSpeed), normVec = (0, $04697537ec8dce5b$export$9b781de7bf37bf48).create(!distance ? velocity : dx / distance * attractFactor, !distance ? velocity : dy / distance * attractFactor);
        particle.position.subFrom(normVec);
    }
}
function $32d41bc93ba3aae6$export$394d6bb309b28144(container, enabledCb) {
    if (!container.attract) container.attract = {
        particles: []
    };
    const { attract: attract } = container;
    if (!attract.finish) {
        if (!attract.count) attract.count = 0;
        attract.count++;
        if (attract.count === container.particles.count) attract.finish = true;
    }
    if (attract.clicking) {
        const mousePos = container.interactivity.mouse.clickPosition, attractRadius = container.retina.attractModeDistance;
        if (!attractRadius || attractRadius < $32d41bc93ba3aae6$var$minRadius || !mousePos) return;
        $32d41bc93ba3aae6$var$processAttract(container, mousePos, attractRadius, new (0, $1c5d1439a937867c$export$c89a927ffc67e6fa)(mousePos.x, mousePos.y, attractRadius), (p)=>enabledCb(p));
    } else if (attract.clicking === false) attract.particles = [];
}
function $32d41bc93ba3aae6$export$a5508b998f0bbea0(container, enabledCb) {
    const mousePos = container.interactivity.mouse.position, attractRadius = container.retina.attractModeDistance;
    if (!attractRadius || attractRadius < $32d41bc93ba3aae6$var$minRadius || !mousePos) return;
    $32d41bc93ba3aae6$var$processAttract(container, mousePos, attractRadius, new (0, $1c5d1439a937867c$export$c89a927ffc67e6fa)(mousePos.x, mousePos.y, attractRadius), (p)=>enabledCb(p));
}



class $4df6bdfdc1b21324$export$2e6bb8ee3737fcb3 {
    constructor(){
        this.distance = 200;
        this.duration = 0.4;
        this.easing = (0, $981da57d483aae4d$export$483bfb5d033dec0c).easeOutQuad;
        this.factor = 1;
        this.maxSpeed = 50;
        this.speed = 1;
    }
    load(data) {
        if (!data) return;
        if (data.distance !== undefined) this.distance = data.distance;
        if (data.duration !== undefined) this.duration = data.duration;
        if (data.easing !== undefined) this.easing = data.easing;
        if (data.factor !== undefined) this.factor = data.factor;
        if (data.maxSpeed !== undefined) this.maxSpeed = data.maxSpeed;
        if (data.speed !== undefined) this.speed = data.speed;
    }
}


const $85e2200f8fe7ba5f$var$attractMode = "attract";
class $85e2200f8fe7ba5f$export$27a51cca6e7ea831 extends (0, $5825146c5282067b$export$6e252256471acc61) {
    constructor(engine, container){
        super(container);
        this._engine = engine;
        if (!container.attract) container.attract = {
            particles: []
        };
        this.handleClickMode = (mode)=>{
            const options = this.container.actualOptions, attract = options.interactivity.modes.attract;
            if (!attract || mode !== $85e2200f8fe7ba5f$var$attractMode) return;
            if (!container.attract) container.attract = {
                particles: []
            };
            container.attract.clicking = true;
            container.attract.count = 0;
            for (const particle of container.attract.particles){
                if (!this.isEnabled(particle)) continue;
                particle.velocity.setTo(particle.initialVelocity);
            }
            container.attract.particles = [];
            container.attract.finish = false;
            setTimeout(()=>{
                if (container.destroyed) return;
                if (!container.attract) container.attract = {
                    particles: []
                };
                container.attract.clicking = false;
            }, attract.duration * (0, $dec17af1c054e95f$export$f64c3bfbc58eec0f));
        };
    }
    clear() {}
    init() {
        const container = this.container, attract = container.actualOptions.interactivity.modes.attract;
        if (!attract) return;
        container.retina.attractModeDistance = attract.distance * container.retina.pixelRatio;
    }
    interact() {
        const container = this.container, options = container.actualOptions, mouseMoveStatus = container.interactivity.status === (0, $dec17af1c054e95f$export$1ffe551d7d33cd33), events = options.interactivity.events, { enable: hoverEnabled, mode: hoverMode } = events.onHover, { enable: clickEnabled, mode: clickMode } = events.onClick;
        if (mouseMoveStatus && hoverEnabled && (0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)($85e2200f8fe7ba5f$var$attractMode, hoverMode)) (0, $32d41bc93ba3aae6$export$a5508b998f0bbea0)(this.container, (p)=>this.isEnabled(p));
        else if (clickEnabled && (0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)($85e2200f8fe7ba5f$var$attractMode, clickMode)) (0, $32d41bc93ba3aae6$export$394d6bb309b28144)(this.container, (p)=>this.isEnabled(p));
    }
    isEnabled(particle) {
        const container = this.container, options = container.actualOptions, mouse = container.interactivity.mouse, events = (particle?.interactivity ?? options.interactivity).events;
        if ((!mouse.position || !events.onHover.enable) && (!mouse.clickPosition || !events.onClick.enable)) return false;
        const hoverMode = events.onHover.mode, clickMode = events.onClick.mode;
        return (0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)($85e2200f8fe7ba5f$var$attractMode, hoverMode) || (0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)($85e2200f8fe7ba5f$var$attractMode, clickMode);
    }
    loadModeOptions(options, ...sources) {
        if (!options.attract) options.attract = new (0, $4df6bdfdc1b21324$export$2e6bb8ee3737fcb3)();
        for (const source of sources)options.attract.load(source?.attract);
    }
    reset() {}
}





async function $301f7da281258722$export$802792820c064418(engine, refresh = true) {
    await engine.addInteractor("externalAttract", (container)=>{
        return Promise.resolve(new (0, $85e2200f8fe7ba5f$export$27a51cca6e7ea831)(engine, container));
    }, refresh);
}




const $01586e10bfb2547a$var$squareExp = 2, $01586e10bfb2547a$var$half = 0.5, $01586e10bfb2547a$var$halfPI = Math.PI * $01586e10bfb2547a$var$half, $01586e10bfb2547a$var$double = 2, $01586e10bfb2547a$var$toleranceFactor = 10, $01586e10bfb2547a$var$minRadius = 0;
function $01586e10bfb2547a$var$processBounce(container, position, radius, area, enabledCb) {
    const query = container.particles.quadTree.query(area, enabledCb);
    for (const particle of query){
        if (area instanceof (0, $1c5d1439a937867c$export$c89a927ffc67e6fa)) (0, $eee2fa4b9ebe63e9$export$c6e9f28fb57ea828)((0, $eee2fa4b9ebe63e9$export$11ae16f2acc5c3ba)(particle), {
            position: position,
            radius: radius,
            mass: radius ** $01586e10bfb2547a$var$squareExp * $01586e10bfb2547a$var$halfPI,
            velocity: (0, $04697537ec8dce5b$export$9b781de7bf37bf48).origin,
            factor: (0, $04697537ec8dce5b$export$9b781de7bf37bf48).origin
        });
        else if (area instanceof (0, $1c5d1439a937867c$export$4617fb02663045ef)) (0, $eee2fa4b9ebe63e9$export$e83851ba31840182)(particle, (0, $eee2fa4b9ebe63e9$export$b0a2169b5f9d18d8)(position, radius));
    }
}
function $01586e10bfb2547a$var$singleSelectorBounce(container, selector, div, bounceCb) {
    const query = document.querySelectorAll(selector);
    if (!query.length) return;
    query.forEach((item)=>{
        const elem = item, pxRatio = container.retina.pixelRatio, pos = {
            x: (elem.offsetLeft + elem.offsetWidth * $01586e10bfb2547a$var$half) * pxRatio,
            y: (elem.offsetTop + elem.offsetHeight * $01586e10bfb2547a$var$half) * pxRatio
        }, radius = elem.offsetWidth * $01586e10bfb2547a$var$half * pxRatio, tolerance = $01586e10bfb2547a$var$toleranceFactor * pxRatio, area = div.type === (0, $c7511144a05e00a9$export$9e83d65c7ba90739).circle ? new (0, $1c5d1439a937867c$export$c89a927ffc67e6fa)(pos.x, pos.y, radius + tolerance) : new (0, $1c5d1439a937867c$export$4617fb02663045ef)(elem.offsetLeft * pxRatio - tolerance, elem.offsetTop * pxRatio - tolerance, elem.offsetWidth * pxRatio + tolerance * $01586e10bfb2547a$var$double, elem.offsetHeight * pxRatio + tolerance * $01586e10bfb2547a$var$double);
        bounceCb(pos, radius, area);
    });
}
function $01586e10bfb2547a$export$37acb2845e366ada(container, divs, bounceMode, enabledCb) {
    (0, $eee2fa4b9ebe63e9$export$194f9554360903fd)(bounceMode, divs, (selector, div)=>$01586e10bfb2547a$var$singleSelectorBounce(container, selector, div, (pos, radius, area)=>$01586e10bfb2547a$var$processBounce(container, pos, radius, area, enabledCb)));
}
function $01586e10bfb2547a$export$b45256fadef1ecdc(container, enabledCb) {
    const pxRatio = container.retina.pixelRatio, tolerance = $01586e10bfb2547a$var$toleranceFactor * pxRatio, mousePos = container.interactivity.mouse.position, radius = container.retina.bounceModeDistance;
    if (!radius || radius < $01586e10bfb2547a$var$minRadius || !mousePos) return;
    $01586e10bfb2547a$var$processBounce(container, mousePos, radius, new (0, $1c5d1439a937867c$export$c89a927ffc67e6fa)(mousePos.x, mousePos.y, radius + tolerance), enabledCb);
}


class $bb1a50c3a7b5b12d$export$d20e79fdc3899e95 {
    constructor(){
        this.distance = 200;
    }
    load(data) {
        if (!data) return;
        if (data.distance !== undefined) this.distance = data.distance;
    }
}


const $355ee7d44d0ed6f3$var$bounceMode = "bounce";
class $355ee7d44d0ed6f3$export$81812ec41a0682d1 extends (0, $5825146c5282067b$export$6e252256471acc61) {
    constructor(container){
        super(container);
    }
    clear() {}
    init() {
        const container = this.container, bounce = container.actualOptions.interactivity.modes.bounce;
        if (!bounce) return;
        container.retina.bounceModeDistance = bounce.distance * container.retina.pixelRatio;
    }
    interact() {
        const container = this.container, options = container.actualOptions, events = options.interactivity.events, mouseMoveStatus = container.interactivity.status === (0, $dec17af1c054e95f$export$1ffe551d7d33cd33), hoverEnabled = events.onHover.enable, hoverMode = events.onHover.mode, divs = events.onDiv;
        if (mouseMoveStatus && hoverEnabled && (0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)($355ee7d44d0ed6f3$var$bounceMode, hoverMode)) (0, $01586e10bfb2547a$export$b45256fadef1ecdc)(this.container, (p)=>this.isEnabled(p));
        else (0, $01586e10bfb2547a$export$37acb2845e366ada)(this.container, divs, $355ee7d44d0ed6f3$var$bounceMode, (p)=>this.isEnabled(p));
    }
    isEnabled(particle) {
        const container = this.container, options = container.actualOptions, mouse = container.interactivity.mouse, events = (particle?.interactivity ?? options.interactivity).events, divs = events.onDiv;
        return !!mouse.position && events.onHover.enable && (0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)($355ee7d44d0ed6f3$var$bounceMode, events.onHover.mode) || (0, $eee2fa4b9ebe63e9$export$5d1f020956707f4)($355ee7d44d0ed6f3$var$bounceMode, divs);
    }
    loadModeOptions(options, ...sources) {
        if (!options.bounce) options.bounce = new (0, $bb1a50c3a7b5b12d$export$d20e79fdc3899e95)();
        for (const source of sources)options.bounce.load(source?.bounce);
    }
    reset() {}
}





async function $8f7bc37920965035$export$ec1513be4b96e6ba(engine, refresh = true) {
    await engine.addInteractor("externalBounce", (container)=>{
        return Promise.resolve(new (0, $355ee7d44d0ed6f3$export$81812ec41a0682d1)(container));
    }, refresh);
}





class $cb96a9efc212e6ca$export$e71d224ed8cf00b6 {
    constructor(){
        this.distance = 200;
        this.duration = 0.4;
        this.mix = false;
    }
    load(data) {
        if (!data) return;
        if (data.distance !== undefined) this.distance = data.distance;
        if (data.duration !== undefined) this.duration = data.duration;
        if (data.mix !== undefined) this.mix = data.mix;
        if (data.opacity !== undefined) this.opacity = data.opacity;
        if (data.color !== undefined) {
            const sourceColor = (0, $ad25b6e319f6df8c$export$43bee75e5e14138e)(this.color) ? undefined : this.color;
            this.color = (0, $eee2fa4b9ebe63e9$export$8e5dc47097396754)(data.color, (color)=>{
                return (0, $c86524210cdfad1b$export$c2b08aa25660fcaa).create(sourceColor, color);
            });
        }
        if (data.size !== undefined) this.size = data.size;
    }
}



class $456c9e5aabb28b70$export$768c85074997964c extends (0, $cb96a9efc212e6ca$export$e71d224ed8cf00b6) {
    constructor(){
        super();
        this.selectors = [];
    }
    load(data) {
        super.load(data);
        if (!data) return;
        if (data.selectors !== undefined) this.selectors = data.selectors;
    }
}


class $a4de5ab860164f16$export$646feb54fbadbe06 extends (0, $cb96a9efc212e6ca$export$e71d224ed8cf00b6) {
    load(data) {
        super.load(data);
        if (!data) return;
        this.divs = (0, $eee2fa4b9ebe63e9$export$8e5dc47097396754)(data.divs, (div)=>{
            const tmp = new (0, $456c9e5aabb28b70$export$768c85074997964c)();
            tmp.load(div);
            return tmp;
        });
    }
}


var $a04078c2c8a9a938$export$62e732b6ee9b5d43;
(function(ProcessBubbleType) {
    ProcessBubbleType["color"] = "color";
    ProcessBubbleType["opacity"] = "opacity";
    ProcessBubbleType["size"] = "size";
})($a04078c2c8a9a938$export$62e732b6ee9b5d43 || ($a04078c2c8a9a938$export$62e732b6ee9b5d43 = {}));



function $72f5340737e00c98$export$144231fdd3795a95(particleValue, modeValue, optionsValue, ratio) {
    if (modeValue >= optionsValue) {
        const value = particleValue + (modeValue - optionsValue) * ratio;
        return (0, $1ff4dfb77b7bb646$export$7d15b64cf5a3a4c4)(value, particleValue, modeValue);
    } else if (modeValue < optionsValue) {
        const value = particleValue - (optionsValue - modeValue) * ratio;
        return (0, $1ff4dfb77b7bb646$export$7d15b64cf5a3a4c4)(value, modeValue, particleValue);
    }
}


const $2d221a8a33540eec$var$bubbleMode = "bubble", $2d221a8a33540eec$var$minDistance = 0, $2d221a8a33540eec$var$defaultClickTime = 0, $2d221a8a33540eec$var$double = 2, $2d221a8a33540eec$var$defaultOpacity = 1, $2d221a8a33540eec$var$ratioOffset = 1, $2d221a8a33540eec$var$defaultBubbleValue = 0, $2d221a8a33540eec$var$minRatio = 0, $2d221a8a33540eec$var$half = 0.5, $2d221a8a33540eec$var$defaultRatio = 1;
class $2d221a8a33540eec$export$6430b7804bc9fbe5 extends (0, $5825146c5282067b$export$6e252256471acc61) {
    constructor(container){
        super(container);
        this._clickBubble = ()=>{
            const container = this.container, options = container.actualOptions, mouseClickPos = container.interactivity.mouse.clickPosition, bubbleOptions = options.interactivity.modes.bubble;
            if (!bubbleOptions || !mouseClickPos) return;
            if (!container.bubble) container.bubble = {};
            const distance = container.retina.bubbleModeDistance;
            if (!distance || distance < $2d221a8a33540eec$var$minDistance) return;
            const query = container.particles.quadTree.queryCircle(mouseClickPos, distance, (p)=>this.isEnabled(p)), { bubble: bubble } = container;
            for (const particle of query){
                if (!bubble.clicking) continue;
                particle.bubble.inRange = !bubble.durationEnd;
                const pos = particle.getPosition(), distMouse = (0, $1ff4dfb77b7bb646$export$79376507b09a66f)(pos, mouseClickPos), timeSpent = (new Date().getTime() - (container.interactivity.mouse.clickTime ?? $2d221a8a33540eec$var$defaultClickTime)) / (0, $dec17af1c054e95f$export$f64c3bfbc58eec0f);
                if (timeSpent > bubbleOptions.duration) bubble.durationEnd = true;
                if (timeSpent > bubbleOptions.duration * $2d221a8a33540eec$var$double) {
                    bubble.clicking = false;
                    bubble.durationEnd = false;
                }
                const sizeData = {
                    bubbleObj: {
                        optValue: container.retina.bubbleModeSize,
                        value: particle.bubble.radius
                    },
                    particlesObj: {
                        optValue: (0, $1ff4dfb77b7bb646$export$27d2c76f835d583d)(particle.options.size.value) * container.retina.pixelRatio,
                        value: particle.size.value
                    },
                    type: (0, $a04078c2c8a9a938$export$62e732b6ee9b5d43).size
                };
                this._process(particle, distMouse, timeSpent, sizeData);
                const opacityData = {
                    bubbleObj: {
                        optValue: bubbleOptions.opacity,
                        value: particle.bubble.opacity
                    },
                    particlesObj: {
                        optValue: (0, $1ff4dfb77b7bb646$export$27d2c76f835d583d)(particle.options.opacity.value),
                        value: particle.opacity?.value ?? $2d221a8a33540eec$var$defaultOpacity
                    },
                    type: (0, $a04078c2c8a9a938$export$62e732b6ee9b5d43).opacity
                };
                this._process(particle, distMouse, timeSpent, opacityData);
                if (!bubble.durationEnd && distMouse <= distance) this._hoverBubbleColor(particle, distMouse);
                else delete particle.bubble.color;
            }
        };
        this._hoverBubble = ()=>{
            const container = this.container, mousePos = container.interactivity.mouse.position, distance = container.retina.bubbleModeDistance;
            if (!distance || distance < $2d221a8a33540eec$var$minDistance || !mousePos) return;
            const query = container.particles.quadTree.queryCircle(mousePos, distance, (p)=>this.isEnabled(p));
            for (const particle of query){
                particle.bubble.inRange = true;
                const pos = particle.getPosition(), pointDistance = (0, $1ff4dfb77b7bb646$export$79376507b09a66f)(pos, mousePos), ratio = $2d221a8a33540eec$var$ratioOffset - pointDistance / distance;
                if (pointDistance <= distance) {
                    if (ratio >= $2d221a8a33540eec$var$minRatio && container.interactivity.status === (0, $dec17af1c054e95f$export$1ffe551d7d33cd33)) {
                        this._hoverBubbleSize(particle, ratio);
                        this._hoverBubbleOpacity(particle, ratio);
                        this._hoverBubbleColor(particle, ratio);
                    }
                } else this.reset(particle);
                if (container.interactivity.status === (0, $dec17af1c054e95f$export$f4b184a85a586f8a)) this.reset(particle);
            }
        };
        this._hoverBubbleColor = (particle, ratio, divBubble)=>{
            const options = this.container.actualOptions, bubbleOptions = divBubble ?? options.interactivity.modes.bubble;
            if (!bubbleOptions) return;
            if (!particle.bubble.finalColor) {
                const modeColor = bubbleOptions.color;
                if (!modeColor) return;
                const bubbleColor = (0, $eee2fa4b9ebe63e9$export$3fbf39566d3ee62e)(modeColor);
                particle.bubble.finalColor = (0, $fd6faa9f4e5410ac$export$79a89086521c0f12)(bubbleColor);
            }
            if (!particle.bubble.finalColor) return;
            if (bubbleOptions.mix) {
                particle.bubble.color = undefined;
                const pColor = particle.getFillColor();
                particle.bubble.color = pColor ? (0, $fd6faa9f4e5410ac$export$c85ca4f4753af384)((0, $fd6faa9f4e5410ac$export$9b476054b78b89cd)(pColor, particle.bubble.finalColor, $2d221a8a33540eec$var$ratioOffset - ratio, ratio)) : particle.bubble.finalColor;
            } else particle.bubble.color = particle.bubble.finalColor;
        };
        this._hoverBubbleOpacity = (particle, ratio, divBubble)=>{
            const container = this.container, options = container.actualOptions, modeOpacity = divBubble?.opacity ?? options.interactivity.modes.bubble?.opacity;
            if (!modeOpacity) return;
            const optOpacity = particle.options.opacity.value, pOpacity = particle.opacity?.value ?? $2d221a8a33540eec$var$defaultOpacity, opacity = (0, $72f5340737e00c98$export$144231fdd3795a95)(pOpacity, modeOpacity, (0, $1ff4dfb77b7bb646$export$27d2c76f835d583d)(optOpacity), ratio);
            if (opacity !== undefined) particle.bubble.opacity = opacity;
        };
        this._hoverBubbleSize = (particle, ratio, divBubble)=>{
            const container = this.container, modeSize = divBubble?.size ? divBubble.size * container.retina.pixelRatio : container.retina.bubbleModeSize;
            if (modeSize === undefined) return;
            const optSize = (0, $1ff4dfb77b7bb646$export$27d2c76f835d583d)(particle.options.size.value) * container.retina.pixelRatio, pSize = particle.size.value, size = (0, $72f5340737e00c98$export$144231fdd3795a95)(pSize, modeSize, optSize, ratio);
            if (size !== undefined) particle.bubble.radius = size;
        };
        this._process = (particle, distMouse, timeSpent, data)=>{
            const container = this.container, bubbleParam = data.bubbleObj.optValue, options = container.actualOptions, bubbleOptions = options.interactivity.modes.bubble;
            if (!bubbleOptions || bubbleParam === undefined) return;
            const bubbleDuration = bubbleOptions.duration, bubbleDistance = container.retina.bubbleModeDistance, particlesParam = data.particlesObj.optValue, pObjBubble = data.bubbleObj.value, pObj = data.particlesObj.value ?? $2d221a8a33540eec$var$defaultBubbleValue, type = data.type;
            if (!bubbleDistance || bubbleDistance < $2d221a8a33540eec$var$minDistance || bubbleParam === particlesParam) return;
            if (!container.bubble) container.bubble = {};
            if (container.bubble.durationEnd) {
                if (pObjBubble) {
                    if (type === (0, $a04078c2c8a9a938$export$62e732b6ee9b5d43).size) delete particle.bubble.radius;
                    if (type === (0, $a04078c2c8a9a938$export$62e732b6ee9b5d43).opacity) delete particle.bubble.opacity;
                }
            } else if (distMouse <= bubbleDistance) {
                const obj = pObjBubble ?? pObj;
                if (obj !== bubbleParam) {
                    const value = pObj - timeSpent * (pObj - bubbleParam) / bubbleDuration;
                    if (type === (0, $a04078c2c8a9a938$export$62e732b6ee9b5d43).size) particle.bubble.radius = value;
                    if (type === (0, $a04078c2c8a9a938$export$62e732b6ee9b5d43).opacity) particle.bubble.opacity = value;
                }
            } else {
                if (type === (0, $a04078c2c8a9a938$export$62e732b6ee9b5d43).size) delete particle.bubble.radius;
                if (type === (0, $a04078c2c8a9a938$export$62e732b6ee9b5d43).opacity) delete particle.bubble.opacity;
            }
        };
        this._singleSelectorHover = (delta, selector, div)=>{
            const container = this.container, selectors = document.querySelectorAll(selector), bubble = container.actualOptions.interactivity.modes.bubble;
            if (!bubble || !selectors.length) return;
            selectors.forEach((item)=>{
                const elem = item, pxRatio = container.retina.pixelRatio, pos = {
                    x: (elem.offsetLeft + elem.offsetWidth * $2d221a8a33540eec$var$half) * pxRatio,
                    y: (elem.offsetTop + elem.offsetHeight * $2d221a8a33540eec$var$half) * pxRatio
                }, repulseRadius = elem.offsetWidth * $2d221a8a33540eec$var$half * pxRatio, area = div.type === (0, $c7511144a05e00a9$export$9e83d65c7ba90739).circle ? new (0, $1c5d1439a937867c$export$c89a927ffc67e6fa)(pos.x, pos.y, repulseRadius) : new (0, $1c5d1439a937867c$export$4617fb02663045ef)(elem.offsetLeft * pxRatio, elem.offsetTop * pxRatio, elem.offsetWidth * pxRatio, elem.offsetHeight * pxRatio), query = container.particles.quadTree.query(area, (p)=>this.isEnabled(p));
                for (const particle of query){
                    if (!area.contains(particle.getPosition())) continue;
                    particle.bubble.inRange = true;
                    const divs = bubble.divs, divBubble = (0, $eee2fa4b9ebe63e9$export$f7c2b83aad443adb)(divs, elem);
                    if (!particle.bubble.div || particle.bubble.div !== elem) {
                        this.clear(particle, delta, true);
                        particle.bubble.div = elem;
                    }
                    this._hoverBubbleSize(particle, $2d221a8a33540eec$var$defaultRatio, divBubble);
                    this._hoverBubbleOpacity(particle, $2d221a8a33540eec$var$defaultRatio, divBubble);
                    this._hoverBubbleColor(particle, $2d221a8a33540eec$var$defaultRatio, divBubble);
                }
            });
        };
        if (!container.bubble) container.bubble = {};
        this.handleClickMode = (mode)=>{
            if (mode !== $2d221a8a33540eec$var$bubbleMode) return;
            if (!container.bubble) container.bubble = {};
            container.bubble.clicking = true;
        };
    }
    clear(particle, delta, force) {
        if (particle.bubble.inRange && !force) return;
        delete particle.bubble.div;
        delete particle.bubble.opacity;
        delete particle.bubble.radius;
        delete particle.bubble.color;
    }
    init() {
        const container = this.container, bubble = container.actualOptions.interactivity.modes.bubble;
        if (!bubble) return;
        container.retina.bubbleModeDistance = bubble.distance * container.retina.pixelRatio;
        if (bubble.size !== undefined) container.retina.bubbleModeSize = bubble.size * container.retina.pixelRatio;
    }
    interact(delta) {
        const options = this.container.actualOptions, events = options.interactivity.events, onHover = events.onHover, onClick = events.onClick, hoverEnabled = onHover.enable, hoverMode = onHover.mode, clickEnabled = onClick.enable, clickMode = onClick.mode, divs = events.onDiv;
        if (hoverEnabled && (0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)($2d221a8a33540eec$var$bubbleMode, hoverMode)) this._hoverBubble();
        else if (clickEnabled && (0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)($2d221a8a33540eec$var$bubbleMode, clickMode)) this._clickBubble();
        else (0, $eee2fa4b9ebe63e9$export$194f9554360903fd)($2d221a8a33540eec$var$bubbleMode, divs, (selector, div)=>this._singleSelectorHover(delta, selector, div));
    }
    isEnabled(particle) {
        const container = this.container, options = container.actualOptions, mouse = container.interactivity.mouse, events = (particle?.interactivity ?? options.interactivity).events, { onClick: onClick, onDiv: onDiv, onHover: onHover } = events, divBubble = (0, $eee2fa4b9ebe63e9$export$5d1f020956707f4)($2d221a8a33540eec$var$bubbleMode, onDiv);
        if (!(divBubble || onHover.enable && !!mouse.position || onClick.enable && mouse.clickPosition)) return false;
        return (0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)($2d221a8a33540eec$var$bubbleMode, onHover.mode) || (0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)($2d221a8a33540eec$var$bubbleMode, onClick.mode) || divBubble;
    }
    loadModeOptions(options, ...sources) {
        if (!options.bubble) options.bubble = new (0, $a4de5ab860164f16$export$646feb54fbadbe06)();
        for (const source of sources)options.bubble.load(source?.bubble);
    }
    reset(particle) {
        particle.bubble.inRange = false;
    }
}











async function $579430cf799e21c9$export$38085c395e2c86d6(engine, refresh = true) {
    await engine.addInteractor("externalBubble", (container)=>{
        return Promise.resolve(new (0, $2d221a8a33540eec$export$6430b7804bc9fbe5)(container));
    }, refresh);
}



class $952336a82f598bec$export$e5eae882224f3ec7 {
    constructor(){
        this.opacity = 0.5;
    }
    load(data) {
        if (!data) return;
        if (data.opacity !== undefined) this.opacity = data.opacity;
    }
}


class $8313f42a1a84c337$export$59e6910693f047c2 {
    constructor(){
        this.distance = 80;
        this.links = new (0, $952336a82f598bec$export$e5eae882224f3ec7)();
        this.radius = 60;
    }
    load(data) {
        if (!data) return;
        if (data.distance !== undefined) this.distance = data.distance;
        this.links.load(data.links);
        if (data.radius !== undefined) this.radius = data.radius;
    }
}



const $aa332311edf94264$var$gradientMin = 0, $aa332311edf94264$var$gradientMax = 1, $aa332311edf94264$var$defaultLinksWidth = 0;
function $aa332311edf94264$export$f7d09cddc76f277f(context, p1, p2, opacity) {
    const gradStop = Math.floor(p2.getRadius() / p1.getRadius()), color1 = p1.getFillColor(), color2 = p2.getFillColor();
    if (!color1 || !color2) return;
    const sourcePos = p1.getPosition(), destPos = p2.getPosition(), midRgb = (0, $fd6faa9f4e5410ac$export$9b476054b78b89cd)(color1, color2, p1.getRadius(), p2.getRadius()), grad = context.createLinearGradient(sourcePos.x, sourcePos.y, destPos.x, destPos.y);
    grad.addColorStop($aa332311edf94264$var$gradientMin, (0, $fd6faa9f4e5410ac$export$9d057e59c7b0a82d)(color1, opacity));
    grad.addColorStop((0, $1ff4dfb77b7bb646$export$7d15b64cf5a3a4c4)(gradStop, $aa332311edf94264$var$gradientMin, $aa332311edf94264$var$gradientMax), (0, $fd6faa9f4e5410ac$export$2476af37e47fcae2)(midRgb, opacity));
    grad.addColorStop($aa332311edf94264$var$gradientMax, (0, $fd6faa9f4e5410ac$export$9d057e59c7b0a82d)(color2, opacity));
    return grad;
}
function $aa332311edf94264$export$11e612c61d71bca9(context, width, lineStyle, begin, end) {
    (0, $44906e93848638c3$export$819db45aec5fcbe5)(context, begin, end);
    context.lineWidth = width;
    context.strokeStyle = lineStyle;
    context.stroke();
}
function $aa332311edf94264$export$dae7cf860e07354f(container, ctx, p1, p2) {
    const options = container.actualOptions, connectOptions = options.interactivity.modes.connect;
    if (!connectOptions) return;
    return $aa332311edf94264$export$f7d09cddc76f277f(ctx, p1, p2, connectOptions.links.opacity);
}
function $aa332311edf94264$export$7b1cbcf336779304(container, p1, p2) {
    container.canvas.draw((ctx)=>{
        const ls = $aa332311edf94264$export$dae7cf860e07354f(container, ctx, p1, p2);
        if (!ls) return;
        const pos1 = p1.getPosition(), pos2 = p2.getPosition();
        $aa332311edf94264$export$11e612c61d71bca9(ctx, p1.retina.linksWidth ?? $aa332311edf94264$var$defaultLinksWidth, ls, pos1, pos2);
    });
}


const $212d81be487a8a8f$var$connectMode = "connect", $212d81be487a8a8f$var$minDistance = 0;
class $212d81be487a8a8f$export$b2278035370d6017 extends (0, $5825146c5282067b$export$6e252256471acc61) {
    constructor(container){
        super(container);
    }
    clear() {}
    init() {
        const container = this.container, connect = container.actualOptions.interactivity.modes.connect;
        if (!connect) return;
        container.retina.connectModeDistance = connect.distance * container.retina.pixelRatio;
        container.retina.connectModeRadius = connect.radius * container.retina.pixelRatio;
    }
    interact() {
        const container = this.container, options = container.actualOptions;
        if (options.interactivity.events.onHover.enable && container.interactivity.status === "pointermove") {
            const mousePos = container.interactivity.mouse.position, { connectModeDistance: connectModeDistance, connectModeRadius: connectModeRadius } = container.retina;
            if (!connectModeDistance || connectModeDistance < $212d81be487a8a8f$var$minDistance || !connectModeRadius || connectModeRadius < $212d81be487a8a8f$var$minDistance || !mousePos) return;
            const distance = Math.abs(connectModeRadius), query = container.particles.quadTree.queryCircle(mousePos, distance, (p)=>this.isEnabled(p));
            query.forEach((p1, i)=>{
                const pos1 = p1.getPosition(), indexOffset = 1;
                for (const p2 of query.slice(i + indexOffset)){
                    const pos2 = p2.getPosition(), distMax = Math.abs(connectModeDistance), xDiff = Math.abs(pos1.x - pos2.x), yDiff = Math.abs(pos1.y - pos2.y);
                    if (xDiff < distMax && yDiff < distMax) (0, $aa332311edf94264$export$7b1cbcf336779304)(container, p1, p2);
                }
            });
        }
    }
    isEnabled(particle) {
        const container = this.container, mouse = container.interactivity.mouse, events = (particle?.interactivity ?? container.actualOptions.interactivity).events;
        if (!(events.onHover.enable && mouse.position)) return false;
        return (0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)($212d81be487a8a8f$var$connectMode, events.onHover.mode);
    }
    loadModeOptions(options, ...sources) {
        if (!options.connect) options.connect = new (0, $8313f42a1a84c337$export$59e6910693f047c2)();
        for (const source of sources)options.connect.load(source?.connect);
    }
    reset() {}
}








async function $61bd974f65069c1d$export$6d77a62d34a75d00(engine, refresh = true) {
    await engine.addInteractor("externalConnect", (container)=>{
        return Promise.resolve(new (0, $212d81be487a8a8f$export$b2278035370d6017)(container));
    }, refresh);
}




class $e60f054509ec8125$export$18834b4d015f5981 {
    constructor(){
        this.blink = false;
        this.consent = false;
        this.opacity = 1;
    }
    load(data) {
        if (!data) return;
        if (data.blink !== undefined) this.blink = data.blink;
        if (data.color !== undefined) this.color = (0, $c86524210cdfad1b$export$c2b08aa25660fcaa).create(this.color, data.color);
        if (data.consent !== undefined) this.consent = data.consent;
        if (data.opacity !== undefined) this.opacity = data.opacity;
    }
}


class $b7a53933974ec655$export$19925e45e371d8d {
    constructor(){
        this.distance = 100;
        this.links = new (0, $e60f054509ec8125$export$18834b4d015f5981)();
    }
    load(data) {
        if (!data) return;
        if (data.distance !== undefined) this.distance = data.distance;
        this.links.load(data.links);
    }
}



const $00399052b5ba294e$var$defaultWidth = 0;
function $00399052b5ba294e$export$d5ea4ac1cc26adad(context, width, begin, end, colorLine, opacity) {
    (0, $44906e93848638c3$export$819db45aec5fcbe5)(context, begin, end);
    context.strokeStyle = (0, $fd6faa9f4e5410ac$export$2476af37e47fcae2)(colorLine, opacity);
    context.lineWidth = width;
    context.stroke();
}
function $00399052b5ba294e$export$62755b116b3b3e8(container, particle, lineColor, opacity, mousePos) {
    container.canvas.draw((ctx)=>{
        const beginPos = particle.getPosition();
        $00399052b5ba294e$export$d5ea4ac1cc26adad(ctx, particle.retina.linksWidth ?? $00399052b5ba294e$var$defaultWidth, beginPos, mousePos, lineColor, opacity);
    });
}


const $3708ce3869fe828c$var$grabMode = "grab", $3708ce3869fe828c$var$minDistance = 0, $3708ce3869fe828c$var$minOpacity = 0;
class $3708ce3869fe828c$export$b1641bf46f4bbeac extends (0, $5825146c5282067b$export$6e252256471acc61) {
    constructor(container){
        super(container);
    }
    clear() {}
    init() {
        const container = this.container, grab = container.actualOptions.interactivity.modes.grab;
        if (!grab) return;
        container.retina.grabModeDistance = grab.distance * container.retina.pixelRatio;
    }
    interact() {
        const container = this.container, options = container.actualOptions, interactivity = options.interactivity;
        if (!interactivity.modes.grab || !interactivity.events.onHover.enable || container.interactivity.status !== (0, $dec17af1c054e95f$export$1ffe551d7d33cd33)) return;
        const mousePos = container.interactivity.mouse.position;
        if (!mousePos) return;
        const distance = container.retina.grabModeDistance;
        if (!distance || distance < $3708ce3869fe828c$var$minDistance) return;
        const query = container.particles.quadTree.queryCircle(mousePos, distance, (p)=>this.isEnabled(p));
        for (const particle of query){
            const pos = particle.getPosition(), pointDistance = (0, $1ff4dfb77b7bb646$export$79376507b09a66f)(pos, mousePos);
            if (pointDistance > distance) continue;
            const grabLineOptions = interactivity.modes.grab.links, lineOpacity = grabLineOptions.opacity, opacityLine = lineOpacity - pointDistance * lineOpacity / distance;
            if (opacityLine <= $3708ce3869fe828c$var$minOpacity) continue;
            const optColor = grabLineOptions.color ?? particle.options.links?.color;
            if (!container.particles.grabLineColor && optColor) {
                const linksOptions = interactivity.modes.grab.links;
                container.particles.grabLineColor = (0, $fd6faa9f4e5410ac$export$cf0e5a4ae26bdcdc)(optColor, linksOptions.blink, linksOptions.consent);
            }
            const colorLine = (0, $fd6faa9f4e5410ac$export$b676eb46c472d7df)(particle, undefined, container.particles.grabLineColor);
            if (!colorLine) continue;
            (0, $00399052b5ba294e$export$62755b116b3b3e8)(container, particle, colorLine, opacityLine, mousePos);
        }
    }
    isEnabled(particle) {
        const container = this.container, mouse = container.interactivity.mouse, events = (particle?.interactivity ?? container.actualOptions.interactivity).events;
        return events.onHover.enable && !!mouse.position && (0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)($3708ce3869fe828c$var$grabMode, events.onHover.mode);
    }
    loadModeOptions(options, ...sources) {
        if (!options.grab) options.grab = new (0, $b7a53933974ec655$export$19925e45e371d8d)();
        for (const source of sources)options.grab.load(source?.grab);
    }
    reset() {}
}








async function $eaa1537268dc3401$export$919b2e865378f034(engine, refresh = true) {
    await engine.addInteractor("externalGrab", (container)=>{
        return Promise.resolve(new (0, $3708ce3869fe828c$export$b1641bf46f4bbeac)(container));
    }, refresh);
}



const $b19efb0e1103e5d3$var$pauseMode = "pause";
class $b19efb0e1103e5d3$export$193ea5a420bb5c41 extends (0, $5825146c5282067b$export$6e252256471acc61) {
    constructor(container){
        super(container);
        this.handleClickMode = (mode)=>{
            if (mode !== $b19efb0e1103e5d3$var$pauseMode) return;
            const container = this.container;
            if (container.animationStatus) container.pause();
            else container.play();
        };
    }
    clear() {}
    init() {}
    interact() {}
    isEnabled() {
        return true;
    }
    reset() {}
}


async function $c1340f0fe71a2180$export$bbbab73b3aee4f94(engine, refresh = true) {
    await engine.addInteractor("externalPause", (container)=>{
        return Promise.resolve(new (0, $b19efb0e1103e5d3$export$193ea5a420bb5c41)(container));
    }, refresh);
}




class $4c956637afa27ef6$export$fb87db22c6b0e2ba {
    constructor(){
        this.default = true;
        this.groups = [];
        this.quantity = 4;
    }
    load(data) {
        if (!data) return;
        if (data.default !== undefined) this.default = data.default;
        if (data.groups !== undefined) this.groups = data.groups.map((t)=>t);
        if (!this.groups.length) this.default = true;
        const quantity = data.quantity;
        if (quantity !== undefined) this.quantity = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(quantity);
    }
}


const $a6afef7b23b88a91$var$pushMode = "push", $a6afef7b23b88a91$var$minQuantity = 0;
class $a6afef7b23b88a91$export$3f362fabca57c3b4 extends (0, $5825146c5282067b$export$6e252256471acc61) {
    constructor(container){
        super(container);
        this.handleClickMode = (mode)=>{
            if (mode !== $a6afef7b23b88a91$var$pushMode) return;
            const container = this.container, options = container.actualOptions, pushOptions = options.interactivity.modes.push;
            if (!pushOptions) return;
            const quantity = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(pushOptions.quantity);
            if (quantity <= $a6afef7b23b88a91$var$minQuantity) return;
            const group = (0, $eee2fa4b9ebe63e9$export$3a5d12ca7137122f)([
                undefined,
                ...pushOptions.groups
            ]), groupOptions = group !== undefined ? container.actualOptions.particles.groups[group] : undefined;
            container.particles.push(quantity, container.interactivity.mouse, groupOptions, group);
        };
    }
    clear() {}
    init() {}
    interact() {}
    isEnabled() {
        return true;
    }
    loadModeOptions(options, ...sources) {
        if (!options.push) options.push = new (0, $4c956637afa27ef6$export$fb87db22c6b0e2ba)();
        for (const source of sources)options.push.load(source?.push);
    }
    reset() {}
}





async function $a9763cef7769cd26$export$38a8d49241950f5a(engine, refresh = true) {
    await engine.addInteractor("externalPush", (container)=>{
        return Promise.resolve(new (0, $a6afef7b23b88a91$export$3f362fabca57c3b4)(container));
    }, refresh);
}




class $a75f299c733d5f71$export$6072865765515195 {
    constructor(){
        this.quantity = 2;
    }
    load(data) {
        if (!data) return;
        const quantity = data.quantity;
        if (quantity !== undefined) this.quantity = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(quantity);
    }
}


const $d2131a9872f881e3$var$removeMode = "remove";
class $d2131a9872f881e3$export$8772d4256fea677e extends (0, $5825146c5282067b$export$6e252256471acc61) {
    constructor(container){
        super(container);
        this.handleClickMode = (mode)=>{
            const container = this.container, options = container.actualOptions;
            if (!options.interactivity.modes.remove || mode !== $d2131a9872f881e3$var$removeMode) return;
            const removeNb = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(options.interactivity.modes.remove.quantity);
            container.particles.removeQuantity(removeNb);
        };
    }
    clear() {}
    init() {}
    interact() {}
    isEnabled() {
        return true;
    }
    loadModeOptions(options, ...sources) {
        if (!options.remove) options.remove = new (0, $a75f299c733d5f71$export$6072865765515195)();
        for (const source of sources)options.remove.load(source?.remove);
    }
    reset() {}
}





async function $bda2b9cf15999d01$export$7eeb8763dff0d815(engine, refresh = true) {
    await engine.addInteractor("externalRemove", (container)=>{
        return Promise.resolve(new (0, $d2131a9872f881e3$export$8772d4256fea677e)(container));
    }, refresh);
}





class $95588dc91f0b7691$export$45e7d1e8b677a8c1 {
    constructor(){
        this.distance = 200;
        this.duration = 0.4;
        this.factor = 100;
        this.speed = 1;
        this.maxSpeed = 50;
        this.easing = (0, $981da57d483aae4d$export$483bfb5d033dec0c).easeOutQuad;
    }
    load(data) {
        if (!data) return;
        if (data.distance !== undefined) this.distance = data.distance;
        if (data.duration !== undefined) this.duration = data.duration;
        if (data.easing !== undefined) this.easing = data.easing;
        if (data.factor !== undefined) this.factor = data.factor;
        if (data.speed !== undefined) this.speed = data.speed;
        if (data.maxSpeed !== undefined) this.maxSpeed = data.maxSpeed;
    }
}



class $75d356eff13dc57e$export$4a5cb954c5b3580d extends (0, $95588dc91f0b7691$export$45e7d1e8b677a8c1) {
    constructor(){
        super();
        this.selectors = [];
    }
    load(data) {
        super.load(data);
        if (!data) return;
        if (data.selectors !== undefined) this.selectors = data.selectors;
    }
}


class $ac3183d713493ab4$export$12e904dcff83f5f9 extends (0, $95588dc91f0b7691$export$45e7d1e8b677a8c1) {
    load(data) {
        super.load(data);
        if (!data) return;
        this.divs = (0, $eee2fa4b9ebe63e9$export$8e5dc47097396754)(data.divs, (div)=>{
            const tmp = new (0, $75d356eff13dc57e$export$4a5cb954c5b3580d)();
            tmp.load(div);
            return tmp;
        });
    }
}


const $76012882d7f7b6b2$var$repulseMode = "repulse", $76012882d7f7b6b2$var$minDistance = 0, $76012882d7f7b6b2$var$repulseRadiusFactor = 6, $76012882d7f7b6b2$var$repulseRadiusPower = 3, $76012882d7f7b6b2$var$squarePower = 2, $76012882d7f7b6b2$var$minRadius = 0, $76012882d7f7b6b2$var$minSpeed = 0, $76012882d7f7b6b2$var$easingOffset = 1, $76012882d7f7b6b2$var$half = 0.5;
class $76012882d7f7b6b2$export$4d442f40198e66c4 extends (0, $5825146c5282067b$export$6e252256471acc61) {
    constructor(engine, container){
        super(container);
        this._clickRepulse = ()=>{
            const container = this.container, repulseOptions = container.actualOptions.interactivity.modes.repulse;
            if (!repulseOptions) return;
            const repulse = container.repulse ?? {
                particles: []
            };
            if (!repulse.finish) {
                if (!repulse.count) repulse.count = 0;
                repulse.count++;
                if (repulse.count === container.particles.count) repulse.finish = true;
            }
            if (repulse.clicking) {
                const repulseDistance = container.retina.repulseModeDistance;
                if (!repulseDistance || repulseDistance < $76012882d7f7b6b2$var$minDistance) return;
                const repulseRadius = Math.pow(repulseDistance / $76012882d7f7b6b2$var$repulseRadiusFactor, $76012882d7f7b6b2$var$repulseRadiusPower), mouseClickPos = container.interactivity.mouse.clickPosition;
                if (mouseClickPos === undefined) return;
                const range = new (0, $1c5d1439a937867c$export$c89a927ffc67e6fa)(mouseClickPos.x, mouseClickPos.y, repulseRadius), query = container.particles.quadTree.query(range, (p)=>this.isEnabled(p));
                for (const particle of query){
                    const { dx: dx, dy: dy, distance: distance } = (0, $1ff4dfb77b7bb646$export$c76b58cfe053f228)(mouseClickPos, particle.position), d = distance ** $76012882d7f7b6b2$var$squarePower, velocity = repulseOptions.speed, force = -repulseRadius * velocity / d;
                    if (d <= repulseRadius) {
                        repulse.particles.push(particle);
                        const vect = (0, $04697537ec8dce5b$export$9b781de7bf37bf48).create(dx, dy);
                        vect.length = force;
                        particle.velocity.setTo(vect);
                    }
                }
            } else if (repulse.clicking === false) {
                for (const particle of repulse.particles)particle.velocity.setTo(particle.initialVelocity);
                repulse.particles = [];
            }
        };
        this._hoverRepulse = ()=>{
            const container = this.container, mousePos = container.interactivity.mouse.position, repulseRadius = container.retina.repulseModeDistance;
            if (!repulseRadius || repulseRadius < $76012882d7f7b6b2$var$minRadius || !mousePos) return;
            this._processRepulse(mousePos, repulseRadius, new (0, $1c5d1439a937867c$export$c89a927ffc67e6fa)(mousePos.x, mousePos.y, repulseRadius));
        };
        this._processRepulse = (position, repulseRadius, area, divRepulse)=>{
            const container = this.container, query = container.particles.quadTree.query(area, (p)=>this.isEnabled(p)), repulseOptions = container.actualOptions.interactivity.modes.repulse;
            if (!repulseOptions) return;
            const { easing: easing, speed: speed, factor: factor, maxSpeed: maxSpeed } = repulseOptions, easingFunc = (0, $1ff4dfb77b7bb646$export$2bbf531f74195405)(easing), velocity = (divRepulse?.speed ?? speed) * factor;
            for (const particle of query){
                const { dx: dx, dy: dy, distance: distance } = (0, $1ff4dfb77b7bb646$export$c76b58cfe053f228)(particle.position, position), repulseFactor = (0, $1ff4dfb77b7bb646$export$7d15b64cf5a3a4c4)(easingFunc($76012882d7f7b6b2$var$easingOffset - distance / repulseRadius) * velocity, $76012882d7f7b6b2$var$minSpeed, maxSpeed), normVec = (0, $04697537ec8dce5b$export$9b781de7bf37bf48).create(!distance ? velocity : dx / distance * repulseFactor, !distance ? velocity : dy / distance * repulseFactor);
                particle.position.addTo(normVec);
            }
        };
        this._singleSelectorRepulse = (selector, div)=>{
            const container = this.container, repulse = container.actualOptions.interactivity.modes.repulse;
            if (!repulse) return;
            const query = document.querySelectorAll(selector);
            if (!query.length) return;
            query.forEach((item)=>{
                const elem = item, pxRatio = container.retina.pixelRatio, pos = {
                    x: (elem.offsetLeft + elem.offsetWidth * $76012882d7f7b6b2$var$half) * pxRatio,
                    y: (elem.offsetTop + elem.offsetHeight * $76012882d7f7b6b2$var$half) * pxRatio
                }, repulseRadius = elem.offsetWidth * $76012882d7f7b6b2$var$half * pxRatio, area = div.type === (0, $c7511144a05e00a9$export$9e83d65c7ba90739).circle ? new (0, $1c5d1439a937867c$export$c89a927ffc67e6fa)(pos.x, pos.y, repulseRadius) : new (0, $1c5d1439a937867c$export$4617fb02663045ef)(elem.offsetLeft * pxRatio, elem.offsetTop * pxRatio, elem.offsetWidth * pxRatio, elem.offsetHeight * pxRatio), divs = repulse.divs, divRepulse = (0, $eee2fa4b9ebe63e9$export$f7c2b83aad443adb)(divs, elem);
                this._processRepulse(pos, repulseRadius, area, divRepulse);
            });
        };
        this._engine = engine;
        if (!container.repulse) container.repulse = {
            particles: []
        };
        this.handleClickMode = (mode)=>{
            const options = this.container.actualOptions, repulseOpts = options.interactivity.modes.repulse;
            if (!repulseOpts || mode !== $76012882d7f7b6b2$var$repulseMode) return;
            if (!container.repulse) container.repulse = {
                particles: []
            };
            const repulse = container.repulse;
            repulse.clicking = true;
            repulse.count = 0;
            for (const particle of container.repulse.particles){
                if (!this.isEnabled(particle)) continue;
                particle.velocity.setTo(particle.initialVelocity);
            }
            repulse.particles = [];
            repulse.finish = false;
            setTimeout(()=>{
                if (container.destroyed) return;
                repulse.clicking = false;
            }, repulseOpts.duration * (0, $dec17af1c054e95f$export$f64c3bfbc58eec0f));
        };
    }
    clear() {}
    init() {
        const container = this.container, repulse = container.actualOptions.interactivity.modes.repulse;
        if (!repulse) return;
        container.retina.repulseModeDistance = repulse.distance * container.retina.pixelRatio;
    }
    interact() {
        const container = this.container, options = container.actualOptions, mouseMoveStatus = container.interactivity.status === (0, $dec17af1c054e95f$export$1ffe551d7d33cd33), events = options.interactivity.events, hover = events.onHover, hoverEnabled = hover.enable, hoverMode = hover.mode, click = events.onClick, clickEnabled = click.enable, clickMode = click.mode, divs = events.onDiv;
        if (mouseMoveStatus && hoverEnabled && (0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)($76012882d7f7b6b2$var$repulseMode, hoverMode)) this._hoverRepulse();
        else if (clickEnabled && (0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)($76012882d7f7b6b2$var$repulseMode, clickMode)) this._clickRepulse();
        else (0, $eee2fa4b9ebe63e9$export$194f9554360903fd)($76012882d7f7b6b2$var$repulseMode, divs, (selector, div)=>this._singleSelectorRepulse(selector, div));
    }
    isEnabled(particle) {
        const container = this.container, options = container.actualOptions, mouse = container.interactivity.mouse, events = (particle?.interactivity ?? options.interactivity).events, divs = events.onDiv, hover = events.onHover, click = events.onClick, divRepulse = (0, $eee2fa4b9ebe63e9$export$5d1f020956707f4)($76012882d7f7b6b2$var$repulseMode, divs);
        if (!(divRepulse || hover.enable && !!mouse.position || click.enable && mouse.clickPosition)) return false;
        const hoverMode = hover.mode, clickMode = click.mode;
        return (0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)($76012882d7f7b6b2$var$repulseMode, hoverMode) || (0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)($76012882d7f7b6b2$var$repulseMode, clickMode) || divRepulse;
    }
    loadModeOptions(options, ...sources) {
        if (!options.repulse) options.repulse = new (0, $ac3183d713493ab4$export$12e904dcff83f5f9)();
        for (const source of sources)options.repulse.load(source?.repulse);
    }
    reset() {}
}











async function $dffec3d420047f3a$export$5ff7a4cab01244f4(engine, refresh = true) {
    await engine.addInteractor("externalRepulse", (container)=>{
        return Promise.resolve(new (0, $76012882d7f7b6b2$export$4d442f40198e66c4)(engine, container));
    }, refresh);
}



class $48491a852e6bbcbf$export$b417a3b6f3fd58ad {
    constructor(){
        this.factor = 3;
        this.radius = 200;
    }
    load(data) {
        if (!data) return;
        if (data.factor !== undefined) this.factor = data.factor;
        if (data.radius !== undefined) this.radius = data.radius;
    }
}


const $03b5a4146ce18fa4$var$slowMode = "slow", $03b5a4146ce18fa4$var$minRadius = 0;
class $03b5a4146ce18fa4$export$16a733526f31d7d extends (0, $5825146c5282067b$export$6e252256471acc61) {
    constructor(container){
        super(container);
    }
    clear(particle, delta, force) {
        if (particle.slow.inRange && !force) return;
        particle.slow.factor = 1;
    }
    init() {
        const container = this.container, slow = container.actualOptions.interactivity.modes.slow;
        if (!slow) return;
        container.retina.slowModeRadius = slow.radius * container.retina.pixelRatio;
    }
    interact() {}
    isEnabled(particle) {
        const container = this.container, mouse = container.interactivity.mouse, events = (particle?.interactivity ?? container.actualOptions.interactivity).events;
        return events.onHover.enable && !!mouse.position && (0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)($03b5a4146ce18fa4$var$slowMode, events.onHover.mode);
    }
    loadModeOptions(options, ...sources) {
        if (!options.slow) options.slow = new (0, $48491a852e6bbcbf$export$b417a3b6f3fd58ad)();
        for (const source of sources)options.slow.load(source?.slow);
    }
    reset(particle) {
        particle.slow.inRange = false;
        const container = this.container, options = container.actualOptions, mousePos = container.interactivity.mouse.position, radius = container.retina.slowModeRadius, slowOptions = options.interactivity.modes.slow;
        if (!slowOptions || !radius || radius < $03b5a4146ce18fa4$var$minRadius || !mousePos) return;
        const particlePos = particle.getPosition(), dist = (0, $1ff4dfb77b7bb646$export$79376507b09a66f)(mousePos, particlePos), proximityFactor = dist / radius, slowFactor = slowOptions.factor, { slow: slow } = particle;
        if (dist > radius) return;
        slow.inRange = true;
        slow.factor = proximityFactor / slowFactor;
    }
}





async function $62dc1d8e85e1cde2$export$da393a0f615758e8(engine, refresh = true) {
    await engine.addInteractor("externalSlow", (container)=>{
        return Promise.resolve(new (0, $03b5a4146ce18fa4$export$16a733526f31d7d)(container));
    }, refresh);
}



const $54c48c56b1e6cdfa$var$stringStart = 0, $54c48c56b1e6cdfa$var$defaultOpacity = 1;
const $54c48c56b1e6cdfa$var$currentColorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d.]+%?\))|currentcolor/gi;
function $54c48c56b1e6cdfa$var$replaceColorSvg(imageShape, color, opacity) {
    const { svgData: svgData } = imageShape;
    if (!svgData) return "";
    const colorStyle = (0, $fd6faa9f4e5410ac$export$9d057e59c7b0a82d)(color, opacity);
    if (svgData.includes("fill")) return svgData.replace($54c48c56b1e6cdfa$var$currentColorRegex, ()=>colorStyle);
    const preFillIndex = svgData.indexOf(">");
    return `${svgData.substring($54c48c56b1e6cdfa$var$stringStart, preFillIndex)} fill="${colorStyle}"${svgData.substring(preFillIndex)}`;
}
async function $54c48c56b1e6cdfa$export$fe58198efe02b173(image) {
    return new Promise((resolve)=>{
        image.loading = true;
        const img = new Image();
        image.element = img;
        img.addEventListener("load", ()=>{
            image.loading = false;
            resolve();
        });
        img.addEventListener("error", ()=>{
            image.element = undefined;
            image.error = true;
            image.loading = false;
            (0, $eee2fa4b9ebe63e9$export$2b1d391cd05230fd)().error(`${(0, $dec17af1c054e95f$export$adea4917e02d93dc)} loading image: ${image.source}`);
            resolve();
        });
        img.src = image.source;
    });
}
async function $54c48c56b1e6cdfa$export$4b83b5a5338ae9dc(image) {
    if (image.type !== "svg") {
        await $54c48c56b1e6cdfa$export$fe58198efe02b173(image);
        return;
    }
    image.loading = true;
    const response = await fetch(image.source);
    if (!response.ok) {
        (0, $eee2fa4b9ebe63e9$export$2b1d391cd05230fd)().error(`${(0, $dec17af1c054e95f$export$adea4917e02d93dc)} Image not found`);
        image.error = true;
    } else image.svgData = await response.text();
    image.loading = false;
}
function $54c48c56b1e6cdfa$export$49424b6b83198c61(image, imageData, color, particle) {
    const svgColoredData = $54c48c56b1e6cdfa$var$replaceColorSvg(image, color, particle.opacity?.value ?? $54c48c56b1e6cdfa$var$defaultOpacity), imageRes = {
        color: color,
        gif: imageData.gif,
        data: {
            ...image,
            svgData: svgColoredData
        },
        loaded: false,
        ratio: imageData.width / imageData.height,
        replaceColor: imageData.replaceColor,
        source: imageData.src
    };
    return new Promise((resolve)=>{
        const svg = new Blob([
            svgColoredData
        ], {
            type: "image/svg+xml"
        }), domUrl = URL || window.URL || window.webkitURL || window, url = domUrl.createObjectURL(svg), img = new Image();
        img.addEventListener("load", ()=>{
            imageRes.loaded = true;
            imageRes.element = img;
            resolve(imageRes);
            domUrl.revokeObjectURL(url);
        });
        const errorHandler = async ()=>{
            domUrl.revokeObjectURL(url);
            const img2 = {
                ...image,
                error: false,
                loading: true
            };
            await $54c48c56b1e6cdfa$export$fe58198efe02b173(img2);
            imageRes.loaded = true;
            imageRes.element = img2.element;
            resolve(imageRes);
        };
        img.addEventListener("error", ()=>void errorHandler());
        img.src = url;
    });
}





const $5543614750bc12a0$export$6e3040decbe42e1 = [
    0,
    4,
    2,
    1
];
const $5543614750bc12a0$export$a6bec62d89063364 = [
    8,
    8,
    4,
    2
];


class $3207d122435447e1$export$8130652b8df6235f {
    constructor(bytes){
        this.pos = 0;
        this.data = new Uint8ClampedArray(bytes);
    }
    getString(count) {
        const slice = this.data.slice(this.pos, this.pos + count);
        this.pos += slice.length;
        return slice.reduce((acc, curr)=>acc + String.fromCharCode(curr), "");
    }
    nextByte() {
        return this.data[this.pos++];
    }
    nextTwoBytes() {
        const increment = 2, previous = 1, shift = 8;
        this.pos += increment;
        return this.data[this.pos - increment] + (this.data[this.pos - previous] << shift);
    }
    readSubBlocks() {
        let blockString = "", size = 0;
        const minCount = 0, emptySize = 0;
        do {
            size = this.data[this.pos++];
            for(let count = size; --count >= minCount; blockString += String.fromCharCode(this.data[this.pos++]));
        }while (size !== emptySize);
        return blockString;
    }
    readSubBlocksBin() {
        let size = this.data[this.pos], len = 0;
        const emptySize = 0, increment = 1;
        for(let offset = 0; size !== emptySize; offset += size + increment, size = this.data[this.pos + offset])len += size;
        const blockData = new Uint8Array(len);
        size = this.data[this.pos++];
        for(let i = 0; size !== emptySize; size = this.data[this.pos++]){
            for(let count = size; --count >= emptySize; blockData[i++] = this.data[this.pos++]);
        }
        return blockData;
    }
    skipSubBlocks() {
        for(const increment = 1, noData = 0; this.data[this.pos] !== noData; this.pos += this.data[this.pos] + increment);
        this.pos++;
    }
}


var $b306b8791e2fdfcd$export$c783dc7c28c91aee;
(function(DisposalMethod) {
    DisposalMethod[DisposalMethod["Replace"] = 0] = "Replace";
    DisposalMethod[DisposalMethod["Combine"] = 1] = "Combine";
    DisposalMethod[DisposalMethod["RestoreBackground"] = 2] = "RestoreBackground";
    DisposalMethod[DisposalMethod["RestorePrevious"] = 3] = "RestorePrevious";
    DisposalMethod[DisposalMethod["UndefinedA"] = 4] = "UndefinedA";
    DisposalMethod[DisposalMethod["UndefinedB"] = 5] = "UndefinedB";
    DisposalMethod[DisposalMethod["UndefinedC"] = 6] = "UndefinedC";
    DisposalMethod[DisposalMethod["UndefinedD"] = 7] = "UndefinedD";
})($b306b8791e2fdfcd$export$c783dc7c28c91aee || ($b306b8791e2fdfcd$export$c783dc7c28c91aee = {}));


var $09fbf33985c20b5c$export$98c676fd8eeb66c4;
(function(GIFDataHeaders) {
    GIFDataHeaders[GIFDataHeaders["Extension"] = 33] = "Extension";
    GIFDataHeaders[GIFDataHeaders["ApplicationExtension"] = 255] = "ApplicationExtension";
    GIFDataHeaders[GIFDataHeaders["GraphicsControlExtension"] = 249] = "GraphicsControlExtension";
    GIFDataHeaders[GIFDataHeaders["PlainTextExtension"] = 1] = "PlainTextExtension";
    GIFDataHeaders[GIFDataHeaders["CommentExtension"] = 254] = "CommentExtension";
    GIFDataHeaders[GIFDataHeaders["Image"] = 44] = "Image";
    GIFDataHeaders[GIFDataHeaders["EndOfFile"] = 59] = "EndOfFile";
})($09fbf33985c20b5c$export$98c676fd8eeb66c4 || ($09fbf33985c20b5c$export$98c676fd8eeb66c4 = {}));


const $a2449c72b19691ef$var$origin = {
    x: 0,
    y: 0
}, $a2449c72b19691ef$var$defaultFrame = 0, $a2449c72b19691ef$var$half = 0.5, $a2449c72b19691ef$var$initialTime = 0, $a2449c72b19691ef$var$firstIndex = 0, $a2449c72b19691ef$var$defaultLoopCount = 0;
function $a2449c72b19691ef$var$parseColorTable(byteStream, count) {
    const colors = [];
    for(let i = 0; i < count; i++){
        colors.push({
            r: byteStream.data[byteStream.pos],
            g: byteStream.data[byteStream.pos + 1],
            b: byteStream.data[byteStream.pos + 2]
        });
        byteStream.pos += 3;
    }
    return colors;
}
function $a2449c72b19691ef$var$parseExtensionBlock(byteStream, gif, getFrameIndex, getTransparencyIndex) {
    switch(byteStream.nextByte()){
        case (0, $09fbf33985c20b5c$export$98c676fd8eeb66c4).GraphicsControlExtension:
            {
                const frame = gif.frames[getFrameIndex(false)];
                byteStream.pos++;
                const packedByte = byteStream.nextByte();
                frame.GCreserved = (packedByte & 0xe0) >>> 5;
                frame.disposalMethod = (packedByte & 0x1c) >>> 2;
                frame.userInputDelayFlag = (packedByte & 2) === 2;
                const transparencyFlag = (packedByte & 1) === 1;
                frame.delayTime = byteStream.nextTwoBytes() * 0xa;
                const transparencyIndex = byteStream.nextByte();
                if (transparencyFlag) getTransparencyIndex(transparencyIndex);
                byteStream.pos++;
                break;
            }
        case (0, $09fbf33985c20b5c$export$98c676fd8eeb66c4).ApplicationExtension:
            {
                byteStream.pos++;
                const applicationExtension = {
                    identifier: byteStream.getString(8),
                    authenticationCode: byteStream.getString(3),
                    data: byteStream.readSubBlocksBin()
                };
                gif.applicationExtensions.push(applicationExtension);
                break;
            }
        case (0, $09fbf33985c20b5c$export$98c676fd8eeb66c4).CommentExtension:
            gif.comments.push([
                getFrameIndex(false),
                byteStream.readSubBlocks()
            ]);
            break;
        case (0, $09fbf33985c20b5c$export$98c676fd8eeb66c4).PlainTextExtension:
            if (gif.globalColorTable.length === 0) throw new EvalError("plain text extension without global color table");
            byteStream.pos++;
            gif.frames[getFrameIndex(false)].plainTextData = {
                left: byteStream.nextTwoBytes(),
                top: byteStream.nextTwoBytes(),
                width: byteStream.nextTwoBytes(),
                height: byteStream.nextTwoBytes(),
                charSize: {
                    width: byteStream.nextTwoBytes(),
                    height: byteStream.nextTwoBytes()
                },
                foregroundColor: byteStream.nextByte(),
                backgroundColor: byteStream.nextByte(),
                text: byteStream.readSubBlocks()
            };
            break;
        default:
            byteStream.skipSubBlocks();
            break;
    }
}
async function $a2449c72b19691ef$var$parseImageBlock(byteStream, gif, avgAlpha, getFrameIndex, getTransparencyIndex, progressCallback) {
    const frame = gif.frames[getFrameIndex(true)];
    frame.left = byteStream.nextTwoBytes();
    frame.top = byteStream.nextTwoBytes();
    frame.width = byteStream.nextTwoBytes();
    frame.height = byteStream.nextTwoBytes();
    const packedByte = byteStream.nextByte(), localColorTableFlag = (packedByte & 0x80) === 0x80, interlacedFlag = (packedByte & 0x40) === 0x40;
    frame.sortFlag = (packedByte & 0x20) === 0x20;
    frame.reserved = (packedByte & 0x18) >>> 3;
    const localColorCount = 1 << (packedByte & 7) + 1;
    if (localColorTableFlag) frame.localColorTable = $a2449c72b19691ef$var$parseColorTable(byteStream, localColorCount);
    const getColor = (index)=>{
        const { r: r, g: g, b: b } = (localColorTableFlag ? frame.localColorTable : gif.globalColorTable)[index];
        if (index !== getTransparencyIndex(null)) return {
            r: r,
            g: g,
            b: b,
            a: 255
        };
        return {
            r: r,
            g: g,
            b: b,
            a: avgAlpha ? ~~((r + g + b) / 3) : 0
        };
    };
    const image = (()=>{
        try {
            return new ImageData(frame.width, frame.height, {
                colorSpace: "srgb"
            });
        } catch (error) {
            if (error instanceof DOMException && error.name === "IndexSizeError") return null;
            throw error;
        }
    })();
    if (image == null) throw new EvalError("GIF frame size is to large");
    const minCodeSize = byteStream.nextByte(), imageData = byteStream.readSubBlocksBin(), clearCode = 1 << minCodeSize;
    const readBits = (pos, len)=>{
        const bytePos = pos >>> 3, bitPos = pos & 7;
        return (imageData[bytePos] + (imageData[bytePos + 1] << 8) + (imageData[bytePos + 2] << 16) & (1 << len) - 1 << bitPos) >>> bitPos;
    };
    if (interlacedFlag) {
        for(let code = 0, size = minCodeSize + 1, pos = 0, dic = [
            [
                0
            ]
        ], pass = 0; pass < 4; pass++){
            if ((0, $5543614750bc12a0$export$6e3040decbe42e1)[pass] < frame.height) {
                let pixelPos = 0, lineIndex = 0, exit = false;
                while(!exit){
                    const last = code;
                    code = readBits(pos, size);
                    pos += size + 1;
                    if (code === clearCode) {
                        size = minCodeSize + 1;
                        dic.length = clearCode + 2;
                        for(let i = 0; i < dic.length; i++)dic[i] = i < clearCode ? [
                            i
                        ] : [];
                    } else {
                        if (code >= dic.length) dic.push(dic[last].concat(dic[last][0]));
                        else if (last !== clearCode) dic.push(dic[last].concat(dic[code][0]));
                        for (const item of dic[code]){
                            const { r: r, g: g, b: b, a: a } = getColor(item);
                            image.data.set([
                                r,
                                g,
                                b,
                                a
                            ], (0, $5543614750bc12a0$export$6e3040decbe42e1)[pass] * frame.width + (0, $5543614750bc12a0$export$a6bec62d89063364)[pass] * lineIndex + pixelPos % (frame.width * 4));
                            pixelPos += 4;
                        }
                        if (dic.length === 1 << size && size < 0xc) size++;
                    }
                    if (pixelPos === frame.width * 4 * (lineIndex + 1)) {
                        lineIndex++;
                        if ((0, $5543614750bc12a0$export$6e3040decbe42e1)[pass] + (0, $5543614750bc12a0$export$a6bec62d89063364)[pass] * lineIndex >= frame.height) exit = true;
                    }
                }
            }
            progressCallback?.(byteStream.pos / (byteStream.data.length - 1), getFrameIndex(false) + 1, image, {
                x: frame.left,
                y: frame.top
            }, {
                width: gif.width,
                height: gif.height
            });
        }
        frame.image = image;
        frame.bitmap = await createImageBitmap(image);
    } else {
        let code = 0, size = minCodeSize + 1, pos = 0, pixelPos = -4, exit = false;
        const dic = [
            [
                0
            ]
        ];
        while(!exit){
            const last = code;
            code = readBits(pos, size);
            pos += size;
            if (code === clearCode) {
                size = minCodeSize + 1;
                dic.length = clearCode + 2;
                for(let i = 0; i < dic.length; i++)dic[i] = i < clearCode ? [
                    i
                ] : [];
            } else {
                if (code === clearCode + 1) {
                    exit = true;
                    break;
                }
                if (code >= dic.length) dic.push(dic[last].concat(dic[last][0]));
                else if (last !== clearCode) dic.push(dic[last].concat(dic[code][0]));
                for (const item of dic[code]){
                    const { r: r, g: g, b: b, a: a } = getColor(item);
                    image.data.set([
                        r,
                        g,
                        b,
                        a
                    ], pixelPos += 4);
                }
                if (dic.length >= 1 << size && size < 0xc) size++;
            }
        }
        frame.image = image;
        frame.bitmap = await createImageBitmap(image);
        progressCallback?.((byteStream.pos + 1) / byteStream.data.length, getFrameIndex(false) + 1, frame.image, {
            x: frame.left,
            y: frame.top
        }, {
            width: gif.width,
            height: gif.height
        });
    }
}
async function $a2449c72b19691ef$var$parseBlock(byteStream, gif, avgAlpha, getFrameIndex, getTransparencyIndex, progressCallback) {
    switch(byteStream.nextByte()){
        case (0, $09fbf33985c20b5c$export$98c676fd8eeb66c4).EndOfFile:
            return true;
        case (0, $09fbf33985c20b5c$export$98c676fd8eeb66c4).Image:
            await $a2449c72b19691ef$var$parseImageBlock(byteStream, gif, avgAlpha, getFrameIndex, getTransparencyIndex, progressCallback);
            break;
        case (0, $09fbf33985c20b5c$export$98c676fd8eeb66c4).Extension:
            $a2449c72b19691ef$var$parseExtensionBlock(byteStream, gif, getFrameIndex, getTransparencyIndex);
            break;
        default:
            throw new EvalError("undefined block found");
    }
    return false;
}
function $a2449c72b19691ef$export$67ac3d66f3062195(gif) {
    for (const extension of gif.applicationExtensions){
        if (extension.identifier + extension.authenticationCode !== "NETSCAPE2.0") continue;
        return extension.data[1] + (extension.data[2] << 8);
    }
    return NaN;
}
async function $a2449c72b19691ef$export$242c765bf39e1a4e(gifURL, progressCallback, avgAlpha) {
    if (!avgAlpha) avgAlpha = false;
    const res = await fetch(gifURL);
    if (!res.ok && res.status === 404) throw new EvalError("file not found");
    const buffer = await res.arrayBuffer();
    const gif = {
        width: 0,
        height: 0,
        totalTime: 0,
        colorRes: 0,
        pixelAspectRatio: 0,
        frames: [],
        sortFlag: false,
        globalColorTable: [],
        backgroundImage: new ImageData(1, 1, {
            colorSpace: "srgb"
        }),
        comments: [],
        applicationExtensions: []
    }, byteStream = new (0, $3207d122435447e1$export$8130652b8df6235f)(new Uint8ClampedArray(buffer));
    if (byteStream.getString(6) !== "GIF89a") throw new Error("not a supported GIF file");
    gif.width = byteStream.nextTwoBytes();
    gif.height = byteStream.nextTwoBytes();
    const packedByte = byteStream.nextByte(), globalColorTableFlag = (packedByte & 0x80) === 0x80;
    gif.colorRes = (packedByte & 0x70) >>> 4;
    gif.sortFlag = (packedByte & 8) === 8;
    const globalColorCount = 1 << (packedByte & 7) + 1, backgroundColorIndex = byteStream.nextByte();
    gif.pixelAspectRatio = byteStream.nextByte();
    if (gif.pixelAspectRatio !== 0) gif.pixelAspectRatio = (gif.pixelAspectRatio + 0xf) / 0x40;
    if (globalColorTableFlag) gif.globalColorTable = $a2449c72b19691ef$var$parseColorTable(byteStream, globalColorCount);
    const backgroundImage = (()=>{
        try {
            return new ImageData(gif.width, gif.height, {
                colorSpace: "srgb"
            });
        } catch (error) {
            if (error instanceof DOMException && error.name === "IndexSizeError") return null;
            throw error;
        }
    })();
    if (backgroundImage == null) throw new Error("GIF frame size is to large");
    const { r: r, g: g, b: b } = gif.globalColorTable[backgroundColorIndex];
    backgroundImage.data.set(globalColorTableFlag ? [
        r,
        g,
        b,
        255
    ] : [
        0,
        0,
        0,
        0
    ]);
    for(let i = 4; i < backgroundImage.data.length; i *= 2)backgroundImage.data.copyWithin(i, 0, i);
    gif.backgroundImage = backgroundImage;
    let frameIndex = -1, incrementFrameIndex = true, transparencyIndex = -1;
    const getframeIndex = (increment)=>{
        if (increment) incrementFrameIndex = true;
        return frameIndex;
    };
    const getTransparencyIndex = (newValue)=>{
        if (newValue != null) transparencyIndex = newValue;
        return transparencyIndex;
    };
    try {
        do if (incrementFrameIndex) {
            gif.frames.push({
                left: 0,
                top: 0,
                width: 0,
                height: 0,
                disposalMethod: (0, $b306b8791e2fdfcd$export$c783dc7c28c91aee).Replace,
                image: new ImageData(1, 1, {
                    colorSpace: "srgb"
                }),
                plainTextData: null,
                userInputDelayFlag: false,
                delayTime: 0,
                sortFlag: false,
                localColorTable: [],
                reserved: 0,
                GCreserved: 0
            });
            frameIndex++;
            transparencyIndex = -1;
            incrementFrameIndex = false;
        }
        while (!await $a2449c72b19691ef$var$parseBlock(byteStream, gif, avgAlpha, getframeIndex, getTransparencyIndex, progressCallback));
        gif.frames.length--;
        for (const frame of gif.frames){
            if (frame.userInputDelayFlag && frame.delayTime === 0) {
                gif.totalTime = Infinity;
                break;
            }
            gif.totalTime += frame.delayTime;
        }
        return gif;
    } catch (error) {
        if (error instanceof EvalError) throw new Error(`error while parsing frame ${frameIndex} "${error.message}"`);
        throw error;
    }
}
function $a2449c72b19691ef$export$c51fba8f2ab263bd(data) {
    const { context: context, radius: radius, particle: particle, delta: delta } = data, image = particle.image;
    if (!image?.gifData || !image.gif) return;
    const offscreenCanvas = new OffscreenCanvas(image.gifData.width, image.gifData.height), offscreenContext = offscreenCanvas.getContext("2d");
    if (!offscreenContext) throw new Error("could not create offscreen canvas context");
    offscreenContext.imageSmoothingQuality = "low";
    offscreenContext.imageSmoothingEnabled = false;
    offscreenContext.clearRect($a2449c72b19691ef$var$origin.x, $a2449c72b19691ef$var$origin.y, offscreenCanvas.width, offscreenCanvas.height);
    if (particle.gifLoopCount === undefined) particle.gifLoopCount = image.gifLoopCount ?? $a2449c72b19691ef$var$defaultLoopCount;
    let frameIndex = particle.gifFrame ?? $a2449c72b19691ef$var$defaultFrame;
    const pos = {
        x: -image.gifData.width * $a2449c72b19691ef$var$half,
        y: -image.gifData.height * $a2449c72b19691ef$var$half
    }, frame = image.gifData.frames[frameIndex];
    if (particle.gifTime === undefined) particle.gifTime = $a2449c72b19691ef$var$initialTime;
    if (!frame.bitmap) return;
    context.scale(radius / image.gifData.width, radius / image.gifData.height);
    switch(frame.disposalMethod){
        case (0, $b306b8791e2fdfcd$export$c783dc7c28c91aee).UndefinedA:
        case (0, $b306b8791e2fdfcd$export$c783dc7c28c91aee).UndefinedB:
        case (0, $b306b8791e2fdfcd$export$c783dc7c28c91aee).UndefinedC:
        case (0, $b306b8791e2fdfcd$export$c783dc7c28c91aee).UndefinedD:
        case (0, $b306b8791e2fdfcd$export$c783dc7c28c91aee).Replace:
            offscreenContext.drawImage(frame.bitmap, frame.left, frame.top);
            context.drawImage(offscreenCanvas, pos.x, pos.y);
            offscreenContext.clearRect($a2449c72b19691ef$var$origin.x, $a2449c72b19691ef$var$origin.y, offscreenCanvas.width, offscreenCanvas.height);
            break;
        case (0, $b306b8791e2fdfcd$export$c783dc7c28c91aee).Combine:
            offscreenContext.drawImage(frame.bitmap, frame.left, frame.top);
            context.drawImage(offscreenCanvas, pos.x, pos.y);
            break;
        case (0, $b306b8791e2fdfcd$export$c783dc7c28c91aee).RestoreBackground:
            offscreenContext.drawImage(frame.bitmap, frame.left, frame.top);
            context.drawImage(offscreenCanvas, pos.x, pos.y);
            offscreenContext.clearRect($a2449c72b19691ef$var$origin.x, $a2449c72b19691ef$var$origin.y, offscreenCanvas.width, offscreenCanvas.height);
            if (!image.gifData.globalColorTable.length) offscreenContext.putImageData(image.gifData.frames[$a2449c72b19691ef$var$firstIndex].image, pos.x + frame.left, pos.y + frame.top);
            else offscreenContext.putImageData(image.gifData.backgroundImage, pos.x, pos.y);
            break;
        case (0, $b306b8791e2fdfcd$export$c783dc7c28c91aee).RestorePrevious:
            {
                const previousImageData = offscreenContext.getImageData($a2449c72b19691ef$var$origin.x, $a2449c72b19691ef$var$origin.y, offscreenCanvas.width, offscreenCanvas.height);
                offscreenContext.drawImage(frame.bitmap, frame.left, frame.top);
                context.drawImage(offscreenCanvas, pos.x, pos.y);
                offscreenContext.clearRect($a2449c72b19691ef$var$origin.x, $a2449c72b19691ef$var$origin.y, offscreenCanvas.width, offscreenCanvas.height);
                offscreenContext.putImageData(previousImageData, $a2449c72b19691ef$var$origin.x, $a2449c72b19691ef$var$origin.y);
            }
            break;
    }
    particle.gifTime += delta.value;
    if (particle.gifTime > frame.delayTime) {
        particle.gifTime -= frame.delayTime;
        if (++frameIndex >= image.gifData.frames.length) {
            if (--particle.gifLoopCount <= $a2449c72b19691ef$var$defaultLoopCount) return;
            frameIndex = $a2449c72b19691ef$var$firstIndex;
            offscreenContext.clearRect($a2449c72b19691ef$var$origin.x, $a2449c72b19691ef$var$origin.y, offscreenCanvas.width, offscreenCanvas.height);
        }
        particle.gifFrame = frameIndex;
    }
    context.scale(image.gifData.width / radius, image.gifData.height / radius);
}
async function $a2449c72b19691ef$export$745ee5fd99d9f9d8(image) {
    if (image.type !== "gif") {
        await (0, $54c48c56b1e6cdfa$export$fe58198efe02b173)(image);
        return;
    }
    image.loading = true;
    try {
        image.gifData = await $a2449c72b19691ef$export$242c765bf39e1a4e(image.source);
        image.gifLoopCount = $a2449c72b19691ef$export$67ac3d66f3062195(image.gifData) ?? $a2449c72b19691ef$var$defaultLoopCount;
        if (!image.gifLoopCount) image.gifLoopCount = Infinity;
    } catch  {
        image.error = true;
    }
    image.loading = false;
}


const $c988bbcf833bd76e$var$double = 2, $c988bbcf833bd76e$var$defaultAlpha = 1, $c988bbcf833bd76e$var$sides = 12, $c988bbcf833bd76e$var$defaultRatio = 1;
class $c988bbcf833bd76e$export$b1e5f9a9161ef3b1 {
    constructor(engine){
        this.validTypes = [
            "image",
            "images"
        ];
        this.loadImageShape = async (imageShape)=>{
            if (!this._engine.loadImage) throw new Error(`${(0, $dec17af1c054e95f$export$adea4917e02d93dc)} image shape not initialized`);
            await this._engine.loadImage({
                gif: imageShape.gif,
                name: imageShape.name,
                replaceColor: imageShape.replaceColor ?? false,
                src: imageShape.src
            });
        };
        this._engine = engine;
    }
    addImage(image) {
        if (!this._engine.images) this._engine.images = [];
        this._engine.images.push(image);
    }
    draw(data) {
        const { context: context, radius: radius, particle: particle, opacity: opacity } = data, image = particle.image, element = image?.element;
        if (!image) return;
        context.globalAlpha = opacity;
        if (image.gif && image.gifData) (0, $a2449c72b19691ef$export$c51fba8f2ab263bd)(data);
        else if (element) {
            const ratio = image.ratio, pos = {
                x: -radius,
                y: -radius
            }, diameter = radius * $c988bbcf833bd76e$var$double;
            context.drawImage(element, pos.x, pos.y, diameter, diameter / ratio);
        }
        context.globalAlpha = $c988bbcf833bd76e$var$defaultAlpha;
    }
    getSidesCount() {
        return $c988bbcf833bd76e$var$sides;
    }
    async init(container) {
        const options = container.actualOptions;
        if (!options.preload || !this._engine.loadImage) return;
        for (const imageData of options.preload)await this._engine.loadImage(imageData);
    }
    loadShape(particle) {
        if (particle.shape !== "image" && particle.shape !== "images") return;
        if (!this._engine.images) this._engine.images = [];
        const imageData = particle.shapeData;
        if (!imageData) return;
        const image = this._engine.images.find((t)=>t.name === imageData.name || t.source === imageData.src);
        if (!image) this.loadImageShape(imageData).then(()=>{
            this.loadShape(particle);
        });
    }
    particleInit(container, particle) {
        if (particle.shape !== "image" && particle.shape !== "images") return;
        if (!this._engine.images) this._engine.images = [];
        const images = this._engine.images, imageData = particle.shapeData;
        if (!imageData) return;
        const color = particle.getFillColor(), image = images.find((t)=>t.name === imageData.name || t.source === imageData.src);
        if (!image) return;
        const replaceColor = imageData.replaceColor ?? image.replaceColor;
        if (image.loading) {
            setTimeout(()=>{
                this.particleInit(container, particle);
            });
            return;
        }
        (async ()=>{
            let imageRes;
            if (image.svgData && color) imageRes = await (0, $54c48c56b1e6cdfa$export$49424b6b83198c61)(image, imageData, color, particle);
            else imageRes = {
                color: color,
                data: image,
                element: image.element,
                gif: image.gif,
                gifData: image.gifData,
                gifLoopCount: image.gifLoopCount,
                loaded: true,
                ratio: imageData.width && imageData.height ? imageData.width / imageData.height : image.ratio ?? $c988bbcf833bd76e$var$defaultRatio,
                replaceColor: replaceColor,
                source: imageData.src
            };
            if (!imageRes.ratio) imageRes.ratio = 1;
            const fill = imageData.fill ?? particle.shapeFill, close = imageData.close ?? particle.shapeClose, imageShape = {
                image: imageRes,
                fill: fill,
                close: close
            };
            particle.image = imageShape.image;
            particle.shapeFill = imageShape.fill;
            particle.shapeClose = imageShape.close;
        })();
    }
}


class $e7654eb0a0e7bc65$export$62ec7f5fcda483d7 {
    constructor(){
        this.src = "";
        this.gif = false;
    }
    load(data) {
        if (!data) return;
        if (data.gif !== undefined) this.gif = data.gif;
        if (data.height !== undefined) this.height = data.height;
        if (data.name !== undefined) this.name = data.name;
        if (data.replaceColor !== undefined) this.replaceColor = data.replaceColor;
        if (data.src !== undefined) this.src = data.src;
        if (data.width !== undefined) this.width = data.width;
    }
}


class $77c042e28e351f96$export$9ecd7cd0f869b77e {
    constructor(engine){
        this.id = "imagePreloader";
        this._engine = engine;
    }
    async getPlugin() {
        await Promise.resolve();
        return {};
    }
    loadOptions(options, source) {
        if (!source?.preload) return;
        if (!options.preload) options.preload = [];
        const preloadOptions = options.preload;
        for (const item of source.preload){
            const existing = preloadOptions.find((t)=>t.name === item.name || t.src === item.src);
            if (existing) existing.load(item);
            else {
                const preload = new (0, $e7654eb0a0e7bc65$export$62ec7f5fcda483d7)();
                preload.load(item);
                preloadOptions.push(preload);
            }
        }
    }
    needsPlugin() {
        return true;
    }
}




const $837a5f6d406c8d4d$var$extLength = 3;
function $837a5f6d406c8d4d$var$addLoadImageToEngine(engine) {
    if (engine.loadImage) return;
    engine.loadImage = async (data)=>{
        if (!data.name && !data.src) throw new Error(`${(0, $dec17af1c054e95f$export$adea4917e02d93dc)} no image source provided`);
        if (!engine.images) engine.images = [];
        if (engine.images.find((t)=>t.name === data.name || t.source === data.src)) return;
        try {
            const image = {
                gif: data.gif ?? false,
                name: data.name ?? data.src,
                source: data.src,
                type: data.src.substring(data.src.length - $837a5f6d406c8d4d$var$extLength),
                error: false,
                loading: true,
                replaceColor: data.replaceColor,
                ratio: data.width && data.height ? data.width / data.height : undefined
            };
            engine.images.push(image);
            let imageFunc;
            if (data.gif) imageFunc = (0, $a2449c72b19691ef$export$745ee5fd99d9f9d8);
            else imageFunc = data.replaceColor ? (0, $54c48c56b1e6cdfa$export$4b83b5a5338ae9dc) : (0, $54c48c56b1e6cdfa$export$fe58198efe02b173);
            await imageFunc(image);
        } catch  {
            throw new Error(`${(0, $dec17af1c054e95f$export$adea4917e02d93dc)} ${data.name ?? data.src} not found`);
        }
    };
}
async function $837a5f6d406c8d4d$export$4be35e7676465a2d(engine, refresh = true) {
    $837a5f6d406c8d4d$var$addLoadImageToEngine(engine);
    const preloader = new (0, $77c042e28e351f96$export$9ecd7cd0f869b77e)(engine);
    await engine.addPlugin(preloader, refresh);
    await engine.addShape(new (0, $c988bbcf833bd76e$export$b1e5f9a9161ef3b1)(engine), refresh);
}




class $8d169f223dd12bf4$export$cfeee7551c31115e extends (0, $49613bee1189cd15$export$2f74c042fca0b66d) {
    constructor(){
        super();
        this.sync = false;
    }
    load(data) {
        if (!data) return;
        super.load(data);
        if (data.sync !== undefined) this.sync = data.sync;
    }
}



class $cd0c3a3d29a34e51$export$c09f84979931ae91 extends (0, $49613bee1189cd15$export$2f74c042fca0b66d) {
    constructor(){
        super();
        this.sync = false;
    }
    load(data) {
        if (!data) return;
        super.load(data);
        if (data.sync !== undefined) this.sync = data.sync;
    }
}


class $3535d8a46cafecc7$export$305b21c541a8d65b {
    constructor(){
        this.count = 0;
        this.delay = new (0, $8d169f223dd12bf4$export$cfeee7551c31115e)();
        this.duration = new (0, $cd0c3a3d29a34e51$export$c09f84979931ae91)();
    }
    load(data) {
        if (!data) return;
        if (data.count !== undefined) this.count = data.count;
        this.delay.load(data.delay);
        this.duration.load(data.duration);
    }
}



const $16a53de320accf18$var$noTime = 0, $16a53de320accf18$var$infiniteValue = -1, $16a53de320accf18$var$noLife = 0, $16a53de320accf18$var$minCanvasSize = 0;
function $16a53de320accf18$export$eabc7277fffd179d(particle, delta, canvasSize) {
    if (!particle.life) return;
    const life = particle.life;
    let justSpawned = false;
    if (particle.spawning) {
        life.delayTime += delta.value;
        if (life.delayTime >= particle.life.delay) {
            justSpawned = true;
            particle.spawning = false;
            life.delayTime = $16a53de320accf18$var$noTime;
            life.time = $16a53de320accf18$var$noTime;
        } else return;
    }
    if (life.duration === $16a53de320accf18$var$infiniteValue) return;
    if (particle.spawning) return;
    if (justSpawned) life.time = $16a53de320accf18$var$noTime;
    else life.time += delta.value;
    if (life.time < life.duration) return;
    life.time = $16a53de320accf18$var$noTime;
    if (particle.life.count > $16a53de320accf18$var$noLife) particle.life.count--;
    if (particle.life.count === $16a53de320accf18$var$noLife) {
        particle.destroy();
        return;
    }
    const widthRange = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)($16a53de320accf18$var$minCanvasSize, canvasSize.width), heightRange = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)($16a53de320accf18$var$minCanvasSize, canvasSize.width);
    particle.position.x = (0, $1ff4dfb77b7bb646$export$8b958c8ecd94a804)(widthRange);
    particle.position.y = (0, $1ff4dfb77b7bb646$export$8b958c8ecd94a804)(heightRange);
    particle.spawning = true;
    life.delayTime = $16a53de320accf18$var$noTime;
    life.time = $16a53de320accf18$var$noTime;
    particle.reset();
    const lifeOptions = particle.options.life;
    if (lifeOptions) {
        life.delay = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(lifeOptions.delay.value) * (0, $dec17af1c054e95f$export$f64c3bfbc58eec0f);
        life.duration = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(lifeOptions.duration.value) * (0, $dec17af1c054e95f$export$f64c3bfbc58eec0f);
    }
}


const $512f13afeb1b4568$var$noTime = 0, $512f13afeb1b4568$var$identity = 1, $512f13afeb1b4568$var$infiniteValue = -1;
class $512f13afeb1b4568$export$ba0edc0e3650d019 {
    constructor(container){
        this.container = container;
    }
    init(particle) {
        const container = this.container, particlesOptions = particle.options, lifeOptions = particlesOptions.life;
        if (!lifeOptions) return;
        particle.life = {
            delay: container.retina.reduceFactor ? (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(lifeOptions.delay.value) * (lifeOptions.delay.sync ? $512f13afeb1b4568$var$identity : (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)()) / container.retina.reduceFactor * (0, $dec17af1c054e95f$export$f64c3bfbc58eec0f) : $512f13afeb1b4568$var$noTime,
            delayTime: $512f13afeb1b4568$var$noTime,
            duration: container.retina.reduceFactor ? (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(lifeOptions.duration.value) * (lifeOptions.duration.sync ? $512f13afeb1b4568$var$identity : (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)()) / container.retina.reduceFactor * (0, $dec17af1c054e95f$export$f64c3bfbc58eec0f) : $512f13afeb1b4568$var$noTime,
            time: $512f13afeb1b4568$var$noTime,
            count: lifeOptions.count
        };
        if (particle.life.duration <= $512f13afeb1b4568$var$noTime) particle.life.duration = $512f13afeb1b4568$var$infiniteValue;
        if (particle.life.count <= $512f13afeb1b4568$var$noTime) particle.life.count = $512f13afeb1b4568$var$infiniteValue;
        if (particle.life) particle.spawning = particle.life.delay > $512f13afeb1b4568$var$noTime;
    }
    isEnabled(particle) {
        return !particle.destroyed;
    }
    loadOptions(options, ...sources) {
        if (!options.life) options.life = new (0, $3535d8a46cafecc7$export$305b21c541a8d65b)();
        for (const source of sources)options.life.load(source?.life);
    }
    update(particle, delta) {
        if (!this.isEnabled(particle) || !particle.life) return;
        (0, $16a53de320accf18$export$eabc7277fffd179d)(particle, delta, this.container.canvas.size);
    }
}


async function $39d433ba8c38f117$export$11010788d59cefed(engine, refresh = true) {
    await engine.addParticleUpdater("life", async (container)=>{
        return Promise.resolve(new (0, $512f13afeb1b4568$export$ba0edc0e3650d019)(container));
    }, refresh);
}


function $c25e2a539788e62b$export$819db45aec5fcbe5(data) {
    const { context: context, particle: particle, radius: radius } = data, shapeData = particle.shapeData, centerY = 0;
    context.moveTo(-radius, centerY);
    context.lineTo(radius, centerY);
    context.lineCap = shapeData?.cap ?? "butt";
}


const $11678eaee2def09b$var$sides = 1;
class $11678eaee2def09b$export$360e6f46aa8bdfbf {
    constructor(){
        this.validTypes = [
            "line"
        ];
    }
    draw(data) {
        (0, $c25e2a539788e62b$export$819db45aec5fcbe5)(data);
    }
    getSidesCount() {
        return $11678eaee2def09b$var$sides;
    }
}


async function $2ad3b871b5cba020$export$3e146d8abf762757(engine, refresh = true) {
    await engine.addShape(new (0, $11678eaee2def09b$export$360e6f46aa8bdfbf)(), refresh);
}



const $70efcf78769ef475$var$half = 0.5;
class $70efcf78769ef475$export$ca4210876740c02b {
    init() {}
    isEnabled(particle) {
        return !(0, $eee2fa4b9ebe63e9$export$460b6777813d3d86)() && !particle.destroyed && particle.container.actualOptions.interactivity.events.onHover.parallax.enable;
    }
    move(particle) {
        const container = particle.container, options = container.actualOptions, parallaxOptions = options.interactivity.events.onHover.parallax;
        if ((0, $eee2fa4b9ebe63e9$export$460b6777813d3d86)() || !parallaxOptions.enable) return;
        const parallaxForce = parallaxOptions.force, mousePos = container.interactivity.mouse.position;
        if (!mousePos) return;
        const canvasSize = container.canvas.size, canvasCenter = {
            x: canvasSize.width * $70efcf78769ef475$var$half,
            y: canvasSize.height * $70efcf78769ef475$var$half
        }, parallaxSmooth = parallaxOptions.smooth, factor = particle.getRadius() / parallaxForce, centerDistance = {
            x: (mousePos.x - canvasCenter.x) * factor,
            y: (mousePos.y - canvasCenter.y) * factor
        }, { offset: offset } = particle;
        offset.x += (centerDistance.x - offset.x) / parallaxSmooth;
        offset.y += (centerDistance.y - offset.y) / parallaxSmooth;
    }
}


async function $28bd6d49de31b65a$export$d0a2f1e972d040a5(engine, refresh = true) {
    await engine.addMover("parallax", ()=>{
        return Promise.resolve(new (0, $70efcf78769ef475$export$ca4210876740c02b)());
    }, refresh);
}



const $9c7d81221811cff5$var$attractFactor = 1000, $9c7d81221811cff5$var$identity = 1;
class $9c7d81221811cff5$export$27a51cca6e7ea831 extends (0, $98976f88cf21c377$export$becdaab2d9289dc4) {
    constructor(container){
        super(container);
    }
    clear() {}
    init() {}
    interact(p1) {
        const container = this.container;
        if (p1.attractDistance === undefined) p1.attractDistance = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(p1.options.move.attract.distance) * container.retina.pixelRatio;
        const distance = p1.attractDistance, pos1 = p1.getPosition(), query = container.particles.quadTree.queryCircle(pos1, distance);
        for (const p2 of query){
            if (p1 === p2 || !p2.options.move.attract.enable || p2.destroyed || p2.spawning) continue;
            const pos2 = p2.getPosition(), { dx: dx, dy: dy } = (0, $1ff4dfb77b7bb646$export$c76b58cfe053f228)(pos1, pos2), rotate = p1.options.move.attract.rotate, ax = dx / (rotate.x * $9c7d81221811cff5$var$attractFactor), ay = dy / (rotate.y * $9c7d81221811cff5$var$attractFactor), p1Factor = p2.size.value / p1.size.value, p2Factor = $9c7d81221811cff5$var$identity / p1Factor;
            p1.velocity.x -= ax * p1Factor;
            p1.velocity.y -= ay * p1Factor;
            p2.velocity.x += ax * p2Factor;
            p2.velocity.y += ay * p2Factor;
        }
    }
    isEnabled(particle) {
        return particle.options.move.attract.enable;
    }
    reset() {}
}


async function $3b8b342307dd101c$export$c74248ecb2172f71(engine, refresh = true) {
    await engine.addInteractor("particlesAttract", (container)=>{
        return Promise.resolve(new (0, $9c7d81221811cff5$export$27a51cca6e7ea831)(container));
    }, refresh);
}





const $8cd0af88d1600f1a$var$half = 0.5, $8cd0af88d1600f1a$var$absorbFactor = 10, $8cd0af88d1600f1a$var$minAbsorbFactor = 0;
function $8cd0af88d1600f1a$var$updateAbsorb(p1, r1, p2, r2, delta, pixelRatio) {
    const factor = (0, $1ff4dfb77b7bb646$export$7d15b64cf5a3a4c4)(p1.options.collisions.absorb.speed * delta.factor / $8cd0af88d1600f1a$var$absorbFactor, $8cd0af88d1600f1a$var$minAbsorbFactor, r2);
    p1.size.value += factor * $8cd0af88d1600f1a$var$half;
    p2.size.value -= factor;
    if (r2 <= pixelRatio) {
        p2.size.value = 0;
        p2.destroy();
    }
}
function $8cd0af88d1600f1a$export$be8f954d9467d61e(p1, p2, delta, pixelRatio) {
    const r1 = p1.getRadius(), r2 = p2.getRadius();
    if (r1 === undefined && r2 !== undefined) p1.destroy();
    else if (r1 !== undefined && r2 === undefined) p2.destroy();
    else if (r1 !== undefined && r2 !== undefined) {
        if (r1 >= r2) $8cd0af88d1600f1a$var$updateAbsorb(p1, r1, p2, r2, delta, pixelRatio);
        else $8cd0af88d1600f1a$var$updateAbsorb(p2, r2, p1, r1, delta, pixelRatio);
    }
}



const $a08b905f03a5d67c$var$fixBounceSpeed = (p)=>{
    if (p.collisionMaxSpeed === undefined) p.collisionMaxSpeed = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(p.options.collisions.maxSpeed);
    if (p.velocity.length > p.collisionMaxSpeed) p.velocity.length = p.collisionMaxSpeed;
};
function $a08b905f03a5d67c$export$e3ce947fb98643bf(p1, p2) {
    (0, $eee2fa4b9ebe63e9$export$c6e9f28fb57ea828)((0, $eee2fa4b9ebe63e9$export$11ae16f2acc5c3ba)(p1), (0, $eee2fa4b9ebe63e9$export$11ae16f2acc5c3ba)(p2));
    $a08b905f03a5d67c$var$fixBounceSpeed(p1);
    $a08b905f03a5d67c$var$fixBounceSpeed(p2);
}



function $cd6181cb7cc53735$export$b1fb4cac938035f7(p1, p2) {
    if (!p1.unbreakable && !p2.unbreakable) (0, $a08b905f03a5d67c$export$e3ce947fb98643bf)(p1, p2);
    if (p1.getRadius() === undefined && p2.getRadius() !== undefined) p1.destroy();
    else if (p1.getRadius() !== undefined && p2.getRadius() === undefined) p2.destroy();
    else if (p1.getRadius() !== undefined && p2.getRadius() !== undefined) {
        const deleteP = p1.getRadius() >= p2.getRadius() ? p2 : p1;
        deleteP.destroy();
    }
}


function $3f4736557176b1a5$export$3ea41c4ff8214d51(p1, p2, delta, pixelRatio) {
    switch(p1.options.collisions.mode){
        case (0, $7e6ea8d40d0c807d$export$c17cb29bf4746ec8).absorb:
            (0, $8cd0af88d1600f1a$export$be8f954d9467d61e)(p1, p2, delta, pixelRatio);
            break;
        case (0, $7e6ea8d40d0c807d$export$c17cb29bf4746ec8).bounce:
            (0, $a08b905f03a5d67c$export$e3ce947fb98643bf)(p1, p2);
            break;
        case (0, $7e6ea8d40d0c807d$export$c17cb29bf4746ec8).destroy:
            (0, $cd6181cb7cc53735$export$b1fb4cac938035f7)(p1, p2);
            break;
    }
}


const $9ef4dd01f5805baa$var$double = 2;
class $9ef4dd01f5805baa$export$b7c6eef0ebb06133 extends (0, $98976f88cf21c377$export$becdaab2d9289dc4) {
    constructor(container){
        super(container);
    }
    clear() {}
    init() {}
    interact(p1, delta) {
        if (p1.destroyed || p1.spawning) return;
        const container = this.container, pos1 = p1.getPosition(), radius1 = p1.getRadius(), query = container.particles.quadTree.queryCircle(pos1, radius1 * $9ef4dd01f5805baa$var$double);
        for (const p2 of query){
            if (p1 === p2 || !p2.options.collisions.enable || p1.options.collisions.mode !== p2.options.collisions.mode || p2.destroyed || p2.spawning) continue;
            const pos2 = p2.getPosition(), radius2 = p2.getRadius();
            if (Math.abs(Math.round(pos1.z) - Math.round(pos2.z)) > radius1 + radius2) continue;
            const dist = (0, $1ff4dfb77b7bb646$export$79376507b09a66f)(pos1, pos2), distP = radius1 + radius2;
            if (dist > distP) continue;
            (0, $3f4736557176b1a5$export$3ea41c4ff8214d51)(p1, p2, delta, container.retina.pixelRatio);
        }
    }
    isEnabled(particle) {
        return particle.options.collisions.enable;
    }
    reset() {}
}


async function $7515ef1a3157a6c6$export$2ac615e1c8d77bf3(engine, refresh = true) {
    await engine.addInteractor("particlesCollisions", (container)=>{
        return Promise.resolve(new (0, $9ef4dd01f5805baa$export$b7c6eef0ebb06133)(container));
    }, refresh);
}




const $84957127ed9a801e$var$double = 2;
class $84957127ed9a801e$export$63eeb78c14ab922 extends (0, $1c5d1439a937867c$export$c89a927ffc67e6fa) {
    constructor(x, y, radius, canvasSize){
        super(x, y, radius);
        this.canvasSize = canvasSize;
        this.canvasSize = {
            ...canvasSize
        };
    }
    contains(point) {
        const { width: width, height: height } = this.canvasSize, { x: x, y: y } = point;
        return super.contains(point) || super.contains({
            x: x - width,
            y: y
        }) || super.contains({
            x: x - width,
            y: y - height
        }) || super.contains({
            x: x,
            y: y - height
        });
    }
    intersects(range) {
        if (super.intersects(range)) return true;
        const rect = range, circle = range, newPos = {
            x: range.position.x - this.canvasSize.width,
            y: range.position.y - this.canvasSize.height
        };
        if (circle.radius !== undefined) {
            const biggerCircle = new (0, $1c5d1439a937867c$export$c89a927ffc67e6fa)(newPos.x, newPos.y, circle.radius * $84957127ed9a801e$var$double);
            return super.intersects(biggerCircle);
        } else if (rect.size !== undefined) {
            const rectSW = new (0, $1c5d1439a937867c$export$4617fb02663045ef)(newPos.x, newPos.y, rect.size.width * $84957127ed9a801e$var$double, rect.size.height * $84957127ed9a801e$var$double);
            return super.intersects(rectSW);
        }
        return false;
    }
}




class $913adf7042fad17d$export$a541b0189b16e12e {
    constructor(){
        this.blur = 5;
        this.color = new (0, $c86524210cdfad1b$export$c2b08aa25660fcaa)();
        this.color.value = "#000";
        this.enable = false;
    }
    load(data) {
        if (!data) return;
        if (data.blur !== undefined) this.blur = data.blur;
        this.color = (0, $c86524210cdfad1b$export$c2b08aa25660fcaa).create(this.color, data.color);
        if (data.enable !== undefined) this.enable = data.enable;
    }
}



class $212dcae6d0792548$export$fcc54a02c265e2fe {
    constructor(){
        this.enable = false;
        this.frequency = 1;
    }
    load(data) {
        if (!data) return;
        if (data.color !== undefined) this.color = (0, $c86524210cdfad1b$export$c2b08aa25660fcaa).create(this.color, data.color);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.frequency !== undefined) this.frequency = data.frequency;
        if (data.opacity !== undefined) this.opacity = data.opacity;
    }
}


class $6dcd39dd8a9c1536$export$b2e089eb3692b073 {
    constructor(){
        this.blink = false;
        this.color = new (0, $c86524210cdfad1b$export$c2b08aa25660fcaa)();
        this.color.value = "#fff";
        this.consent = false;
        this.distance = 100;
        this.enable = false;
        this.frequency = 1;
        this.opacity = 1;
        this.shadow = new (0, $913adf7042fad17d$export$a541b0189b16e12e)();
        this.triangles = new (0, $212dcae6d0792548$export$fcc54a02c265e2fe)();
        this.width = 1;
        this.warp = false;
    }
    load(data) {
        if (!data) return;
        if (data.id !== undefined) this.id = data.id;
        if (data.blink !== undefined) this.blink = data.blink;
        this.color = (0, $c86524210cdfad1b$export$c2b08aa25660fcaa).create(this.color, data.color);
        if (data.consent !== undefined) this.consent = data.consent;
        if (data.distance !== undefined) this.distance = data.distance;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.frequency !== undefined) this.frequency = data.frequency;
        if (data.opacity !== undefined) this.opacity = data.opacity;
        this.shadow.load(data.shadow);
        this.triangles.load(data.triangles);
        if (data.width !== undefined) this.width = data.width;
        if (data.warp !== undefined) this.warp = data.warp;
    }
}


const $f310417e6e433e7f$var$squarePower = 2, $f310417e6e433e7f$var$opacityOffset = 1, $f310417e6e433e7f$var$origin = {
    x: 0,
    y: 0
}, $f310417e6e433e7f$var$minDistance = 0;
function $f310417e6e433e7f$var$getLinkDistance(pos1, pos2, optDistance, canvasSize, warp) {
    const { dx: dx, dy: dy, distance: distance } = (0, $1ff4dfb77b7bb646$export$c76b58cfe053f228)(pos1, pos2);
    if (!warp || distance <= optDistance) return distance;
    const absDiffs = {
        x: Math.abs(dx),
        y: Math.abs(dy)
    }, warpDistances = {
        x: Math.min(absDiffs.x, canvasSize.width - absDiffs.x),
        y: Math.min(absDiffs.y, canvasSize.height - absDiffs.y)
    };
    return Math.sqrt(warpDistances.x ** $f310417e6e433e7f$var$squarePower + warpDistances.y ** $f310417e6e433e7f$var$squarePower);
}
class $f310417e6e433e7f$export$5bd94e9ac300debe extends (0, $98976f88cf21c377$export$becdaab2d9289dc4) {
    constructor(container){
        super(container);
        this._setColor = (p1)=>{
            if (!p1.options.links) return;
            const container = this.linkContainer, linksOptions = p1.options.links;
            let linkColor = linksOptions.id === undefined ? container.particles.linksColor : container.particles.linksColors.get(linksOptions.id);
            if (linkColor) return;
            const optColor = linksOptions.color;
            linkColor = (0, $fd6faa9f4e5410ac$export$cf0e5a4ae26bdcdc)(optColor, linksOptions.blink, linksOptions.consent);
            if (linksOptions.id === undefined) container.particles.linksColor = linkColor;
            else container.particles.linksColors.set(linksOptions.id, linkColor);
        };
        this.linkContainer = container;
    }
    clear() {}
    init() {
        this.linkContainer.particles.linksColor = undefined;
        this.linkContainer.particles.linksColors = new Map();
    }
    interact(p1) {
        if (!p1.options.links) return;
        p1.links = [];
        const pos1 = p1.getPosition(), container = this.container, canvasSize = container.canvas.size;
        if (pos1.x < $f310417e6e433e7f$var$origin.x || pos1.y < $f310417e6e433e7f$var$origin.y || pos1.x > canvasSize.width || pos1.y > canvasSize.height) return;
        const linkOpt1 = p1.options.links, optOpacity = linkOpt1.opacity, optDistance = p1.retina.linksDistance ?? $f310417e6e433e7f$var$minDistance, warp = linkOpt1.warp;
        let range;
        if (warp) range = new (0, $84957127ed9a801e$export$63eeb78c14ab922)(pos1.x, pos1.y, optDistance, canvasSize);
        else range = new (0, $1c5d1439a937867c$export$c89a927ffc67e6fa)(pos1.x, pos1.y, optDistance);
        const query = container.particles.quadTree.query(range);
        for (const p2 of query){
            const linkOpt2 = p2.options.links;
            if (p1 === p2 || !linkOpt2?.enable || linkOpt1.id !== linkOpt2.id || p2.spawning || p2.destroyed || !p2.links || p1.links.some((t)=>t.destination === p2) || p2.links.some((t)=>t.destination === p1)) continue;
            const pos2 = p2.getPosition();
            if (pos2.x < $f310417e6e433e7f$var$origin.x || pos2.y < $f310417e6e433e7f$var$origin.y || pos2.x > canvasSize.width || pos2.y > canvasSize.height) continue;
            const distance = $f310417e6e433e7f$var$getLinkDistance(pos1, pos2, optDistance, canvasSize, warp && linkOpt2.warp);
            if (distance > optDistance) continue;
            const opacityLine = ($f310417e6e433e7f$var$opacityOffset - distance / optDistance) * optOpacity;
            this._setColor(p1);
            p1.links.push({
                destination: p2,
                opacity: opacityLine
            });
        }
    }
    isEnabled(particle) {
        return !!particle.options.links?.enable;
    }
    loadParticlesOptions(options, ...sources) {
        if (!options.links) options.links = new (0, $6dcd39dd8a9c1536$export$b2e089eb3692b073)();
        for (const source of sources)options.links.load(source?.links);
    }
    reset() {}
}


async function $65ba051e8a3c29d9$export$ad1f96e9bde185a9(engine, refresh = true) {
    await engine.addInteractor("particlesLinks", async (container)=>{
        return Promise.resolve(new (0, $f310417e6e433e7f$export$5bd94e9ac300debe)(container));
    }, refresh);
}




function $9f5540cd79107b81$export$e6b70c7883316010(context, p1, p2, p3) {
    context.beginPath();
    context.moveTo(p1.x, p1.y);
    context.lineTo(p2.x, p2.y);
    context.lineTo(p3.x, p3.y);
    context.closePath();
}
function $9f5540cd79107b81$export$58e0e9036805c1fd(params) {
    let drawn = false;
    const { begin: begin, end: end, maxDistance: maxDistance, context: context, canvasSize: canvasSize, width: width, backgroundMask: backgroundMask, colorLine: colorLine, opacity: opacity, links: links } = params;
    if ((0, $1ff4dfb77b7bb646$export$79376507b09a66f)(begin, end) <= maxDistance) {
        (0, $44906e93848638c3$export$819db45aec5fcbe5)(context, begin, end);
        drawn = true;
    } else if (links.warp) {
        let pi1;
        let pi2;
        const endNE = {
            x: end.x - canvasSize.width,
            y: end.y
        };
        const d1 = (0, $1ff4dfb77b7bb646$export$c76b58cfe053f228)(begin, endNE);
        if (d1.distance <= maxDistance) {
            const yi = begin.y - d1.dy / d1.dx * begin.x;
            pi1 = {
                x: 0,
                y: yi
            };
            pi2 = {
                x: canvasSize.width,
                y: yi
            };
        } else {
            const endSW = {
                x: end.x,
                y: end.y - canvasSize.height
            };
            const d2 = (0, $1ff4dfb77b7bb646$export$c76b58cfe053f228)(begin, endSW);
            if (d2.distance <= maxDistance) {
                const yi = begin.y - d2.dy / d2.dx * begin.x;
                const xi = -yi / (d2.dy / d2.dx);
                pi1 = {
                    x: xi,
                    y: 0
                };
                pi2 = {
                    x: xi,
                    y: canvasSize.height
                };
            } else {
                const endSE = {
                    x: end.x - canvasSize.width,
                    y: end.y - canvasSize.height
                };
                const d3 = (0, $1ff4dfb77b7bb646$export$c76b58cfe053f228)(begin, endSE);
                if (d3.distance <= maxDistance) {
                    const yi = begin.y - d3.dy / d3.dx * begin.x;
                    const xi = -yi / (d3.dy / d3.dx);
                    pi1 = {
                        x: xi,
                        y: yi
                    };
                    pi2 = {
                        x: pi1.x + canvasSize.width,
                        y: pi1.y + canvasSize.height
                    };
                }
            }
        }
        if (pi1 && pi2) {
            (0, $44906e93848638c3$export$819db45aec5fcbe5)(context, begin, pi1);
            (0, $44906e93848638c3$export$819db45aec5fcbe5)(context, end, pi2);
            drawn = true;
        }
    }
    if (!drawn) return;
    context.lineWidth = width;
    if (backgroundMask.enable) context.globalCompositeOperation = backgroundMask.composite;
    context.strokeStyle = (0, $fd6faa9f4e5410ac$export$2476af37e47fcae2)(colorLine, opacity);
    const { shadow: shadow } = links;
    if (shadow.enable) {
        const shadowColor = (0, $fd6faa9f4e5410ac$export$fbf0bf3cc1fc0cc4)(shadow.color);
        if (shadowColor) {
            context.shadowBlur = shadow.blur;
            context.shadowColor = (0, $fd6faa9f4e5410ac$export$2476af37e47fcae2)(shadowColor);
        }
    }
    context.stroke();
}
function $9f5540cd79107b81$export$cab2f25e574d2614(params) {
    const { context: context, pos1: pos1, pos2: pos2, pos3: pos3, backgroundMask: backgroundMask, colorTriangle: colorTriangle, opacityTriangle: opacityTriangle } = params;
    $9f5540cd79107b81$export$e6b70c7883316010(context, pos1, pos2, pos3);
    if (backgroundMask.enable) context.globalCompositeOperation = backgroundMask.composite;
    context.fillStyle = (0, $fd6faa9f4e5410ac$export$2476af37e47fcae2)(colorTriangle, opacityTriangle);
    context.fill();
}
function $9f5540cd79107b81$export$4509bfc4137b425(ids) {
    ids.sort((a, b)=>a - b);
    return ids.join("_");
}
function $9f5540cd79107b81$export$1502611422f00997(particles, dictionary) {
    const key = $9f5540cd79107b81$export$4509bfc4137b425(particles.map((t)=>t.id));
    let res = dictionary.get(key);
    if (res === undefined) {
        res = (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)();
        dictionary.set(key, res);
    }
    return res;
}


const $5ba29c4e50860f57$var$minOpacity = 0, $5ba29c4e50860f57$var$minWidth = 0, $5ba29c4e50860f57$var$minDistance = 0, $5ba29c4e50860f57$var$half = 0.5, $5ba29c4e50860f57$var$maxFrequency = 1;
class $5ba29c4e50860f57$export$2ef513794a0916ce {
    constructor(container){
        this.container = container;
        this._drawLinkLine = (p1, link)=>{
            const p1LinksOptions = p1.options.links;
            if (!p1LinksOptions?.enable) return;
            const container = this.container, options = container.actualOptions, p2 = link.destination, pos1 = p1.getPosition(), pos2 = p2.getPosition();
            let opacity = link.opacity;
            container.canvas.draw((ctx)=>{
                let colorLine;
                const twinkle = p1.options.twinkle?.lines;
                if (twinkle?.enable) {
                    const twinkleFreq = twinkle.frequency, twinkleRgb = (0, $fd6faa9f4e5410ac$export$fbf0bf3cc1fc0cc4)(twinkle.color), twinkling = (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() < twinkleFreq;
                    if (twinkling && twinkleRgb) {
                        colorLine = twinkleRgb;
                        opacity = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(twinkle.opacity);
                    }
                }
                if (!colorLine) {
                    const linkColor = p1LinksOptions.id !== undefined ? container.particles.linksColors.get(p1LinksOptions.id) : container.particles.linksColor;
                    colorLine = (0, $fd6faa9f4e5410ac$export$b676eb46c472d7df)(p1, p2, linkColor);
                }
                if (!colorLine) return;
                const width = p1.retina.linksWidth ?? $5ba29c4e50860f57$var$minWidth, maxDistance = p1.retina.linksDistance ?? $5ba29c4e50860f57$var$minDistance, { backgroundMask: backgroundMask } = options;
                (0, $9f5540cd79107b81$export$58e0e9036805c1fd)({
                    context: ctx,
                    width: width,
                    begin: pos1,
                    end: pos2,
                    maxDistance: maxDistance,
                    canvasSize: container.canvas.size,
                    links: p1LinksOptions,
                    backgroundMask: backgroundMask,
                    colorLine: colorLine,
                    opacity: opacity
                });
            });
        };
        this._drawLinkTriangle = (p1, link1, link2)=>{
            const linksOptions = p1.options.links;
            if (!linksOptions?.enable) return;
            const triangleOptions = linksOptions.triangles;
            if (!triangleOptions.enable) return;
            const container = this.container, options = container.actualOptions, p2 = link1.destination, p3 = link2.destination, opacityTriangle = triangleOptions.opacity ?? (link1.opacity + link2.opacity) * $5ba29c4e50860f57$var$half;
            if (opacityTriangle <= $5ba29c4e50860f57$var$minOpacity) return;
            container.canvas.draw((ctx)=>{
                const pos1 = p1.getPosition(), pos2 = p2.getPosition(), pos3 = p3.getPosition(), linksDistance = p1.retina.linksDistance ?? $5ba29c4e50860f57$var$minDistance;
                if ((0, $1ff4dfb77b7bb646$export$79376507b09a66f)(pos1, pos2) > linksDistance || (0, $1ff4dfb77b7bb646$export$79376507b09a66f)(pos3, pos2) > linksDistance || (0, $1ff4dfb77b7bb646$export$79376507b09a66f)(pos3, pos1) > linksDistance) return;
                let colorTriangle = (0, $fd6faa9f4e5410ac$export$fbf0bf3cc1fc0cc4)(triangleOptions.color);
                if (!colorTriangle) {
                    const linkColor = linksOptions.id !== undefined ? container.particles.linksColors.get(linksOptions.id) : container.particles.linksColor;
                    colorTriangle = (0, $fd6faa9f4e5410ac$export$b676eb46c472d7df)(p1, p2, linkColor);
                }
                if (!colorTriangle) return;
                (0, $9f5540cd79107b81$export$cab2f25e574d2614)({
                    context: ctx,
                    pos1: pos1,
                    pos2: pos2,
                    pos3: pos3,
                    backgroundMask: options.backgroundMask,
                    colorTriangle: colorTriangle,
                    opacityTriangle: opacityTriangle
                });
            });
        };
        this._drawTriangles = (options, p1, link, p1Links)=>{
            const p2 = link.destination;
            if (!(options.links?.triangles.enable && p2.options.links?.triangles.enable)) return;
            const vertices = p2.links?.filter((t)=>{
                const linkFreq = this._getLinkFrequency(p2, t.destination), minCount = 0;
                return p2.options.links && linkFreq <= p2.options.links.frequency && p1Links.findIndex((l)=>l.destination === t.destination) >= minCount;
            });
            if (!vertices?.length) return;
            for (const vertex of vertices){
                const p3 = vertex.destination, triangleFreq = this._getTriangleFrequency(p1, p2, p3);
                if (triangleFreq > options.links.triangles.frequency) continue;
                this._drawLinkTriangle(p1, link, vertex);
            }
        };
        this._getLinkFrequency = (p1, p2)=>{
            return (0, $9f5540cd79107b81$export$1502611422f00997)([
                p1,
                p2
            ], this._freqs.links);
        };
        this._getTriangleFrequency = (p1, p2, p3)=>{
            return (0, $9f5540cd79107b81$export$1502611422f00997)([
                p1,
                p2,
                p3
            ], this._freqs.triangles);
        };
        this._freqs = {
            links: new Map(),
            triangles: new Map()
        };
    }
    drawParticle(context, particle) {
        const { links: links, options: options } = particle;
        if (!links?.length) return;
        const p1Links = links.filter((l)=>options.links && (options.links.frequency >= $5ba29c4e50860f57$var$maxFrequency || this._getLinkFrequency(particle, l.destination) <= options.links.frequency));
        for (const link of p1Links){
            this._drawTriangles(options, particle, link, p1Links);
            if (link.opacity > $5ba29c4e50860f57$var$minOpacity && (particle.retina.linksWidth ?? $5ba29c4e50860f57$var$minWidth) > $5ba29c4e50860f57$var$minWidth) this._drawLinkLine(particle, link);
        }
    }
    async init() {
        this._freqs.links = new Map();
        this._freqs.triangles = new Map();
        await Promise.resolve();
    }
    particleCreated(particle) {
        particle.links = [];
        if (!particle.options.links) return;
        const ratio = this.container.retina.pixelRatio, { retina: retina } = particle, { distance: distance, width: width } = particle.options.links;
        retina.linksDistance = distance * ratio;
        retina.linksWidth = width * ratio;
    }
    particleDestroyed(particle) {
        particle.links = [];
    }
}


class $9a483a889f7da8e3$export$633625ae6546c0d7 {
    constructor(){
        this.id = "links";
    }
    getPlugin(container) {
        return Promise.resolve(new (0, $5ba29c4e50860f57$export$2ef513794a0916ce)(container));
    }
    loadOptions() {}
    needsPlugin() {
        return true;
    }
}


async function $821c3434e5a6179e$export$7512928df34dbc5b(engine, refresh = true) {
    const plugin = new (0, $9a483a889f7da8e3$export$633625ae6546c0d7)();
    await engine.addPlugin(plugin, refresh);
}











async function $a270a26448d54a83$export$abcf1b8392d2aa58(engine, refresh = true) {
    await (0, $65ba051e8a3c29d9$export$ad1f96e9bde185a9)(engine, refresh);
    await (0, $821c3434e5a6179e$export$7512928df34dbc5b)(engine, refresh);
}




const $7a70b6e75c295afc$var$piDeg = 180, $7a70b6e75c295afc$var$origin = {
    x: 0,
    y: 0
}, $7a70b6e75c295afc$var$sidesOffset = 2;
function $7a70b6e75c295afc$export$643aafe079fb74b5(data, start, side) {
    const { context: context } = data, sideCount = side.count.numerator * side.count.denominator, decimalSides = side.count.numerator / side.count.denominator, interiorAngleDegrees = $7a70b6e75c295afc$var$piDeg * (decimalSides - $7a70b6e75c295afc$var$sidesOffset) / decimalSides, interiorAngle = Math.PI - (0, $1ff4dfb77b7bb646$export$e6bfdeff8bfc94f9)(interiorAngleDegrees);
    if (!context) return;
    context.beginPath();
    context.translate(start.x, start.y);
    context.moveTo($7a70b6e75c295afc$var$origin.x, $7a70b6e75c295afc$var$origin.y);
    for(let i = 0; i < sideCount; i++){
        context.lineTo(side.length, $7a70b6e75c295afc$var$origin.y);
        context.translate(side.length, $7a70b6e75c295afc$var$origin.y);
        context.rotate(interiorAngle);
    }
}


const $0754d9a9d45d05eb$var$defaultSides = 5;
class $0754d9a9d45d05eb$export$f8ea5ed53fb3a92e {
    draw(data) {
        const { particle: particle, radius: radius } = data, start = this.getCenter(particle, radius), side = this.getSidesData(particle, radius);
        (0, $7a70b6e75c295afc$export$643aafe079fb74b5)(data, start, side);
    }
    getSidesCount(particle) {
        const polygon = particle.shapeData;
        return Math.round((0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(polygon?.sides ?? $0754d9a9d45d05eb$var$defaultSides));
    }
}


const $dbae0e2c6421d4cd$var$sidesCenterFactor = 3.5, $dbae0e2c6421d4cd$var$yFactor = 2.66, $dbae0e2c6421d4cd$var$sidesFactor = 3;
class $dbae0e2c6421d4cd$export$e19799e6d95a4459 extends (0, $0754d9a9d45d05eb$export$f8ea5ed53fb3a92e) {
    constructor(){
        super(...arguments);
        this.validTypes = [
            "polygon"
        ];
    }
    getCenter(particle, radius) {
        return {
            x: -radius / (particle.sides / $dbae0e2c6421d4cd$var$sidesCenterFactor),
            y: -radius / ($dbae0e2c6421d4cd$var$yFactor / $dbae0e2c6421d4cd$var$sidesCenterFactor)
        };
    }
    getSidesData(particle, radius) {
        const sides = particle.sides;
        return {
            count: {
                denominator: 1,
                numerator: sides
            },
            length: radius * $dbae0e2c6421d4cd$var$yFactor / (sides / $dbae0e2c6421d4cd$var$sidesFactor)
        };
    }
}



const $682420a5e15898e3$var$yFactor = 1.66, $682420a5e15898e3$var$sides = 3, $682420a5e15898e3$var$double = 2;
class $682420a5e15898e3$export$f7d2d6c2da09994c extends (0, $0754d9a9d45d05eb$export$f8ea5ed53fb3a92e) {
    constructor(){
        super(...arguments);
        this.validTypes = [
            "triangle"
        ];
    }
    getCenter(particle, radius) {
        return {
            x: -radius,
            y: radius / $682420a5e15898e3$var$yFactor
        };
    }
    getSidesCount() {
        return $682420a5e15898e3$var$sides;
    }
    getSidesData(particle, radius) {
        const diameter = radius * $682420a5e15898e3$var$double;
        return {
            count: {
                denominator: 2,
                numerator: 3
            },
            length: diameter
        };
    }
}


async function $9e2177d0baca4060$export$f8596ed9bb066678(engine, refresh = true) {
    await engine.addShape(new (0, $dbae0e2c6421d4cd$export$e19799e6d95a4459)(), refresh);
}
async function $9e2177d0baca4060$export$23adca4e3d46291f(engine, refresh = true) {
    await engine.addShape(new (0, $682420a5e15898e3$export$f7d2d6c2da09994c)(), refresh);
}
async function $9e2177d0baca4060$export$2a8adcfe9fcff9a7(engine, refresh = true) {
    await $9e2177d0baca4060$export$f8596ed9bb066678(engine, refresh);
    await $9e2177d0baca4060$export$23adca4e3d46291f(engine, refresh);
}





class $fb0962ab8286a374$export$cdf8682ab8a5e20a {
    constructor(){
        this.enable = false;
        this.speed = 0;
        this.decay = 0;
        this.sync = false;
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.speed !== undefined) this.speed = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.speed);
        if (data.decay !== undefined) this.decay = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.decay);
        if (data.sync !== undefined) this.sync = data.sync;
    }
}


class $5558ce8088e18a77$export$152db69a76b6b79e extends (0, $49613bee1189cd15$export$2f74c042fca0b66d) {
    constructor(){
        super();
        this.animation = new (0, $fb0962ab8286a374$export$cdf8682ab8a5e20a)();
        this.direction = (0, $c606501dd7c2dcb2$export$9506977ce2a96a5b).clockwise;
        this.path = false;
        this.value = 0;
    }
    load(data) {
        if (!data) return;
        super.load(data);
        if (data.direction !== undefined) this.direction = data.direction;
        this.animation.load(data.animation);
        if (data.path !== undefined) this.path = data.path;
    }
}


const $329d0c97b8467ce8$var$double = 2, $329d0c97b8467ce8$var$doublePI = Math.PI * $329d0c97b8467ce8$var$double, $329d0c97b8467ce8$var$identity = 1, $329d0c97b8467ce8$var$doublePIDeg = 360;
class $329d0c97b8467ce8$export$3b9356b2fa15ee9f {
    constructor(container){
        this.container = container;
    }
    init(particle) {
        const rotateOptions = particle.options.rotate;
        if (!rotateOptions) return;
        particle.rotate = {
            enable: rotateOptions.animation.enable,
            value: (0, $1ff4dfb77b7bb646$export$e6bfdeff8bfc94f9)((0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(rotateOptions.value)),
            min: 0,
            max: $329d0c97b8467ce8$var$doublePI
        };
        particle.pathRotation = rotateOptions.path;
        let rotateDirection = rotateOptions.direction;
        if (rotateDirection === (0, $c606501dd7c2dcb2$export$9506977ce2a96a5b).random) {
            const index = Math.floor((0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * $329d0c97b8467ce8$var$double), minIndex = 0;
            rotateDirection = index > minIndex ? (0, $c606501dd7c2dcb2$export$9506977ce2a96a5b).counterClockwise : (0, $c606501dd7c2dcb2$export$9506977ce2a96a5b).clockwise;
        }
        switch(rotateDirection){
            case (0, $c606501dd7c2dcb2$export$9506977ce2a96a5b).counterClockwise:
            case "counterClockwise":
                particle.rotate.status = (0, $c443c1fece529b66$export$a2d3d93c57d16a1a).decreasing;
                break;
            case (0, $c606501dd7c2dcb2$export$9506977ce2a96a5b).clockwise:
                particle.rotate.status = (0, $c443c1fece529b66$export$a2d3d93c57d16a1a).increasing;
                break;
        }
        const rotateAnimation = rotateOptions.animation;
        if (rotateAnimation.enable) {
            particle.rotate.decay = $329d0c97b8467ce8$var$identity - (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(rotateAnimation.decay);
            particle.rotate.velocity = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(rotateAnimation.speed) / $329d0c97b8467ce8$var$doublePIDeg * this.container.retina.reduceFactor;
            if (!rotateAnimation.sync) particle.rotate.velocity *= (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)();
        }
        particle.rotation = particle.rotate.value;
    }
    isEnabled(particle) {
        const rotate = particle.options.rotate;
        if (!rotate) return false;
        return !particle.destroyed && !particle.spawning && (!!rotate.value || rotate.animation.enable || rotate.path);
    }
    loadOptions(options, ...sources) {
        if (!options.rotate) options.rotate = new (0, $5558ce8088e18a77$export$152db69a76b6b79e)();
        for (const source of sources)options.rotate.load(source?.rotate);
    }
    update(particle, delta) {
        if (!this.isEnabled(particle)) return;
        particle.isRotating = !!particle.rotate;
        if (!particle.rotate) return;
        (0, $eee2fa4b9ebe63e9$export$efead17ed5dcfd2)(particle, particle.rotate, false, (0, $a06b3f24e43fa14b$export$41a461248611663e).none, delta);
        particle.rotation = particle.rotate.value;
    }
}


async function $255dca72ee7837fa$export$4e45f5f68451ed59(engine, refresh = true) {
    await engine.addParticleUpdater("rotate", (container)=>{
        return Promise.resolve(new (0, $329d0c97b8467ce8$export$3b9356b2fa15ee9f)(container));
    }, refresh);
}


const $677d7cf632cbc688$var$fixFactorSquared = 2, $677d7cf632cbc688$var$fixFactor = Math.sqrt($677d7cf632cbc688$var$fixFactorSquared), $677d7cf632cbc688$var$double = 2;
function $677d7cf632cbc688$export$9340b6a85ea854b9(data) {
    const { context: context, radius: radius } = data, fixedRadius = radius / $677d7cf632cbc688$var$fixFactor, fixedDiameter = fixedRadius * $677d7cf632cbc688$var$double;
    context.rect(-fixedRadius, -fixedRadius, fixedDiameter, fixedDiameter);
}


const $11620cc292203944$var$sides = 4;
class $11620cc292203944$export$e0bf05a057b4a28b {
    constructor(){
        this.validTypes = [
            "edge",
            "square"
        ];
    }
    draw(data) {
        (0, $677d7cf632cbc688$export$9340b6a85ea854b9)(data);
    }
    getSidesCount() {
        return $11620cc292203944$var$sides;
    }
}


async function $cd36ef55d4e75963$export$43ae275f06aaeea(engine, refresh = true) {
    await engine.addShape(new (0, $11620cc292203944$export$e0bf05a057b4a28b)(), refresh);
}



const $3150de6cc41e7ba9$var$defaultInset = 2, $3150de6cc41e7ba9$var$origin = {
    x: 0,
    y: 0
};
function $3150de6cc41e7ba9$export$ca57b923902a3c0(data) {
    const { context: context, particle: particle, radius: radius } = data, sides = particle.sides, inset = particle.starInset ?? $3150de6cc41e7ba9$var$defaultInset;
    context.moveTo($3150de6cc41e7ba9$var$origin.x, $3150de6cc41e7ba9$var$origin.y - radius);
    for(let i = 0; i < sides; i++){
        context.rotate(Math.PI / sides);
        context.lineTo($3150de6cc41e7ba9$var$origin.x, $3150de6cc41e7ba9$var$origin.y - radius * inset);
        context.rotate(Math.PI / sides);
        context.lineTo($3150de6cc41e7ba9$var$origin.x, $3150de6cc41e7ba9$var$origin.y - radius);
    }
}


const $2d859f76acc9623b$var$defaultInset = 2, $2d859f76acc9623b$var$defaultSides = 5;
class $2d859f76acc9623b$export$9353a030aedd2caa {
    constructor(){
        this.validTypes = [
            "star"
        ];
    }
    draw(data) {
        (0, $3150de6cc41e7ba9$export$ca57b923902a3c0)(data);
    }
    getSidesCount(particle) {
        const star = particle.shapeData;
        return Math.round((0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(star?.sides ?? $2d859f76acc9623b$var$defaultSides));
    }
    particleInit(container, particle) {
        const star = particle.shapeData;
        particle.starInset = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(star?.inset ?? $2d859f76acc9623b$var$defaultInset);
    }
}


async function $1850beb24c76e684$export$f283471236cef89e(engine, refresh = true) {
    await engine.addShape(new (0, $2d859f76acc9623b$export$9353a030aedd2caa)(), refresh);
}



const $98f341be74fd9500$var$defaultOpacity = 1;
class $98f341be74fd9500$export$34b1490acfca3625 {
    constructor(container){
        this.container = container;
    }
    init(particle) {
        const container = this.container, options = particle.options;
        const stroke = (0, $eee2fa4b9ebe63e9$export$3fbf39566d3ee62e)(options.stroke, particle.id, options.reduceDuplicates);
        particle.strokeWidth = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(stroke.width) * container.retina.pixelRatio;
        particle.strokeOpacity = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(stroke.opacity ?? $98f341be74fd9500$var$defaultOpacity);
        particle.strokeAnimation = stroke.color?.animation;
        const strokeHslColor = (0, $fd6faa9f4e5410ac$export$79a89086521c0f12)(stroke.color) ?? particle.getFillColor();
        if (strokeHslColor) particle.strokeColor = (0, $fd6faa9f4e5410ac$export$6e8a573710bea117)(strokeHslColor, particle.strokeAnimation, container.retina.reduceFactor);
    }
    isEnabled(particle) {
        const color = particle.strokeAnimation, { strokeColor: strokeColor } = particle;
        return !particle.destroyed && !particle.spawning && !!color && (strokeColor?.h.value !== undefined && strokeColor.h.enable || strokeColor?.s.value !== undefined && strokeColor.s.enable || strokeColor?.l.value !== undefined && strokeColor.l.enable);
    }
    update(particle, delta) {
        if (!this.isEnabled(particle)) return;
        (0, $fd6faa9f4e5410ac$export$649b44ac750da8e)(particle.strokeColor, delta);
    }
}


async function $4f4b593ce1032584$export$3265715adf72f85b(engine, refresh = true) {
    await engine.addParticleUpdater("strokeColor", (container)=>{
        return Promise.resolve(new (0, $98f341be74fd9500$export$34b1490acfca3625)(container));
    }, refresh);
}


async function $1985e0542e1c9dc6$export$e11831a95a1ec8d5(engine, refresh = true) {
    await (0, $28bd6d49de31b65a$export$d0a2f1e972d040a5)(engine, false);
    await (0, $301f7da281258722$export$802792820c064418)(engine, false);
    await (0, $8f7bc37920965035$export$ec1513be4b96e6ba)(engine, false);
    await (0, $579430cf799e21c9$export$38085c395e2c86d6)(engine, false);
    await (0, $61bd974f65069c1d$export$6d77a62d34a75d00)(engine, false);
    await (0, $eaa1537268dc3401$export$919b2e865378f034)(engine, false);
    await (0, $c1340f0fe71a2180$export$bbbab73b3aee4f94)(engine, false);
    await (0, $a9763cef7769cd26$export$38a8d49241950f5a)(engine, false);
    await (0, $bda2b9cf15999d01$export$7eeb8763dff0d815)(engine, false);
    await (0, $dffec3d420047f3a$export$5ff7a4cab01244f4)(engine, false);
    await (0, $62dc1d8e85e1cde2$export$da393a0f615758e8)(engine, false);
    await (0, $3b8b342307dd101c$export$c74248ecb2172f71)(engine, false);
    await (0, $7515ef1a3157a6c6$export$2ac615e1c8d77bf3)(engine, false);
    await (0, $a270a26448d54a83$export$abcf1b8392d2aa58)(engine, false);
    await (0, $21ede6b40381d3fc$export$869269643d4bbdcd)();
    await (0, $c8e06abfb8ad462a$export$b3876a8a0c501bd1)(engine, false);
    await (0, $837a5f6d406c8d4d$export$4be35e7676465a2d)(engine, false);
    await (0, $2ad3b871b5cba020$export$3e146d8abf762757)(engine, false);
    await (0, $9e2177d0baca4060$export$2a8adcfe9fcff9a7)(engine, false);
    await (0, $cd36ef55d4e75963$export$43ae275f06aaeea)(engine, false);
    await (0, $1850beb24c76e684$export$f283471236cef89e)(engine, false);
    await (0, $39d433ba8c38f117$export$11010788d59cefed)(engine, false);
    await (0, $255dca72ee7837fa$export$4e45f5f68451ed59)(engine, false);
    await (0, $4f4b593ce1032584$export$3265715adf72f85b)(engine, false);
    await (0, $daff9bde9694b13d$export$244419993531723b)(engine, refresh);
}




const $3a0243e1a784f714$var$double = 2, $3a0243e1a784f714$var$half = 0.5;
function $3a0243e1a784f714$export$b11bd9a0808bdc9(data) {
    const { context: context, particle: particle, radius: radius, opacity: opacity } = data, character = particle.shapeData;
    if (!character) return;
    const textData = character.value;
    if (textData === undefined) return;
    if (particle.text === undefined) particle.text = (0, $eee2fa4b9ebe63e9$export$3fbf39566d3ee62e)(textData, particle.randomIndexData);
    const text = particle.text, style = character.style ?? "", weight = character.weight ?? "400", size = Math.round(radius) * $3a0243e1a784f714$var$double, font = character.font ?? "Verdana", fill = particle.shapeFill;
    const lines = text?.split("\n");
    if (!lines) return;
    context.font = `${style} ${weight} ${size}px "${font}"`;
    context.globalAlpha = opacity;
    for(let i = 0; i < lines.length; i++)$3a0243e1a784f714$var$drawLine(context, lines[i], radius, opacity, i, fill);
    context.globalAlpha = 1;
}
function $3a0243e1a784f714$var$drawLine(context, line, radius, opacity, index, fill) {
    const offsetX = line.length * radius * $3a0243e1a784f714$var$half, pos = {
        x: -offsetX,
        y: radius * $3a0243e1a784f714$var$half
    }, diameter = radius * $3a0243e1a784f714$var$double;
    if (fill) context.fillText(line, pos.x, pos.y + diameter * index);
    else context.strokeText(line, pos.x, pos.y + diameter * index);
}


class $61d0e3a796eb3d17$export$a007af5794c15990 {
    constructor(){
        this.validTypes = [
            "text",
            "character",
            "char",
            "multiline-text"
        ];
    }
    draw(data) {
        (0, $3a0243e1a784f714$export$b11bd9a0808bdc9)(data);
    }
    async init(container) {
        const options = container.actualOptions, { validTypes: validTypes } = this;
        if (validTypes.find((t)=>(0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)(t, options.particles.shape.type))) {
            const shapeOptions = validTypes.map((t)=>options.particles.shape.options[t]).find((t)=>!!t), promises = [];
            (0, $eee2fa4b9ebe63e9$export$8e5dc47097396754)(shapeOptions, (shape)=>{
                promises.push((0, $eee2fa4b9ebe63e9$export$672089c3debc1182)(shape.font, shape.weight));
            });
            await Promise.all(promises);
        }
    }
    particleInit(container, particle) {
        if (!particle.shape || !this.validTypes.includes(particle.shape)) return;
        const character = particle.shapeData;
        if (character === undefined) return;
        const textData = character.value;
        if (textData === undefined) return;
        particle.text = (0, $eee2fa4b9ebe63e9$export$3fbf39566d3ee62e)(textData, particle.randomIndexData);
    }
}


async function $7bddf946317a8a2d$export$da06b6ff4c270300(engine, refresh = true) {
    await engine.addShape(new (0, $61d0e3a796eb3d17$export$a007af5794c15990)(), refresh);
}




var $d67fd78ff0e74ef5$export$d4ab2ae1fdddffe;
(function(TiltDirection) {
    TiltDirection["clockwise"] = "clockwise";
    TiltDirection["counterClockwise"] = "counter-clockwise";
    TiltDirection["random"] = "random";
})($d67fd78ff0e74ef5$export$d4ab2ae1fdddffe || ($d67fd78ff0e74ef5$export$d4ab2ae1fdddffe = {}));



class $bf3dcb1be9830708$export$e573f4ca73db5908 {
    constructor(){
        this.enable = false;
        this.speed = 0;
        this.decay = 0;
        this.sync = false;
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.speed !== undefined) this.speed = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.speed);
        if (data.decay !== undefined) this.decay = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.decay);
        if (data.sync !== undefined) this.sync = data.sync;
    }
}


class $2c31cf8811e0cc38$export$7f9fd97e8e8ffd03 extends (0, $49613bee1189cd15$export$2f74c042fca0b66d) {
    constructor(){
        super();
        this.animation = new (0, $bf3dcb1be9830708$export$e573f4ca73db5908)();
        this.direction = (0, $d67fd78ff0e74ef5$export$d4ab2ae1fdddffe).clockwise;
        this.enable = false;
        this.value = 0;
    }
    load(data) {
        super.load(data);
        if (!data) return;
        this.animation.load(data.animation);
        if (data.direction !== undefined) this.direction = data.direction;
        if (data.enable !== undefined) this.enable = data.enable;
    }
}



const $fa6152d088eecc01$var$identity = 1, $fa6152d088eecc01$var$double = 2, $fa6152d088eecc01$var$doublePI = Math.PI * $fa6152d088eecc01$var$double, $fa6152d088eecc01$var$maxAngle = 360;
class $fa6152d088eecc01$export$bf10918add78aca9 {
    constructor(container){
        this.container = container;
    }
    getTransformValues(particle) {
        const tilt = particle.tilt?.enable && particle.tilt;
        return {
            b: tilt ? Math.cos(tilt.value) * tilt.cosDirection : undefined,
            c: tilt ? Math.sin(tilt.value) * tilt.sinDirection : undefined
        };
    }
    init(particle) {
        const tiltOptions = particle.options.tilt;
        if (!tiltOptions) return;
        particle.tilt = {
            enable: tiltOptions.enable,
            value: (0, $1ff4dfb77b7bb646$export$e6bfdeff8bfc94f9)((0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(tiltOptions.value)),
            sinDirection: (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() >= (0, $dec17af1c054e95f$export$fa0534be1c9f2e23) ? $fa6152d088eecc01$var$identity : -$fa6152d088eecc01$var$identity,
            cosDirection: (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() >= (0, $dec17af1c054e95f$export$fa0534be1c9f2e23) ? $fa6152d088eecc01$var$identity : -$fa6152d088eecc01$var$identity,
            min: 0,
            max: $fa6152d088eecc01$var$doublePI
        };
        let tiltDirection = tiltOptions.direction;
        if (tiltDirection === (0, $d67fd78ff0e74ef5$export$d4ab2ae1fdddffe).random) {
            const index = Math.floor((0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * $fa6152d088eecc01$var$double), minIndex = 0;
            tiltDirection = index > minIndex ? (0, $d67fd78ff0e74ef5$export$d4ab2ae1fdddffe).counterClockwise : (0, $d67fd78ff0e74ef5$export$d4ab2ae1fdddffe).clockwise;
        }
        switch(tiltDirection){
            case (0, $d67fd78ff0e74ef5$export$d4ab2ae1fdddffe).counterClockwise:
            case "counterClockwise":
                particle.tilt.status = (0, $c443c1fece529b66$export$a2d3d93c57d16a1a).decreasing;
                break;
            case (0, $d67fd78ff0e74ef5$export$d4ab2ae1fdddffe).clockwise:
                particle.tilt.status = (0, $c443c1fece529b66$export$a2d3d93c57d16a1a).increasing;
                break;
        }
        const tiltAnimation = particle.options.tilt?.animation;
        if (tiltAnimation?.enable) {
            particle.tilt.decay = $fa6152d088eecc01$var$identity - (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(tiltAnimation.decay);
            particle.tilt.velocity = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(tiltAnimation.speed) / $fa6152d088eecc01$var$maxAngle * this.container.retina.reduceFactor;
            if (!tiltAnimation.sync) particle.tilt.velocity *= (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)();
        }
    }
    isEnabled(particle) {
        const tiltAnimation = particle.options.tilt?.animation;
        return !particle.destroyed && !particle.spawning && !!tiltAnimation?.enable;
    }
    loadOptions(options, ...sources) {
        if (!options.tilt) options.tilt = new (0, $2c31cf8811e0cc38$export$7f9fd97e8e8ffd03)();
        for (const source of sources)options.tilt.load(source?.tilt);
    }
    async update(particle, delta) {
        if (!this.isEnabled(particle) || !particle.tilt) return;
        (0, $eee2fa4b9ebe63e9$export$efead17ed5dcfd2)(particle, particle.tilt, false, (0, $a06b3f24e43fa14b$export$41a461248611663e).none, delta);
        await Promise.resolve();
    }
}


async function $aed5576639be3a56$export$ad7cd7f1bf42858c(engine, refresh = true) {
    await engine.addParticleUpdater("tilt", (container)=>{
        return Promise.resolve(new (0, $fa6152d088eecc01$export$bf10918add78aca9)(container));
    }, refresh);
}




class $21736d16dfb4ebdc$export$f548b4b237268fab {
    constructor(){
        this.enable = false;
        this.frequency = 0.05;
        this.opacity = 1;
    }
    load(data) {
        if (!data) return;
        if (data.color !== undefined) this.color = (0, $c86524210cdfad1b$export$c2b08aa25660fcaa).create(this.color, data.color);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.frequency !== undefined) this.frequency = data.frequency;
        if (data.opacity !== undefined) this.opacity = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.opacity);
    }
}


class $5fc28831f93220ef$export$d2019f714f998af1 {
    constructor(){
        this.lines = new (0, $21736d16dfb4ebdc$export$f548b4b237268fab)();
        this.particles = new (0, $21736d16dfb4ebdc$export$f548b4b237268fab)();
    }
    load(data) {
        if (!data) return;
        this.lines.load(data.lines);
        this.particles.load(data.particles);
    }
}


class $b9c43405ec6ff9aa$export$ea14214ae03f2c07 {
    getColorStyles(particle, context, radius, opacity) {
        const pOptions = particle.options, twinkleOptions = pOptions.twinkle;
        if (!twinkleOptions) return {};
        const twinkle = twinkleOptions.particles, twinkling = twinkle.enable && (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() < twinkle.frequency, zIndexOptions = particle.options.zIndex, zOffset = 1, zOpacityFactor = (zOffset - particle.zIndexFactor) ** zIndexOptions.opacityRate, twinklingOpacity = twinkling ? (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(twinkle.opacity) * zOpacityFactor : opacity, twinkleRgb = (0, $fd6faa9f4e5410ac$export$79a89086521c0f12)(twinkle.color), twinkleStyle = twinkleRgb ? (0, $fd6faa9f4e5410ac$export$9d057e59c7b0a82d)(twinkleRgb, twinklingOpacity) : undefined, res = {}, needsTwinkle = twinkling && twinkleStyle;
        res.fill = needsTwinkle ? twinkleStyle : undefined;
        res.stroke = needsTwinkle ? twinkleStyle : undefined;
        return res;
    }
    async init() {
        await Promise.resolve();
    }
    isEnabled(particle) {
        const pOptions = particle.options, twinkleOptions = pOptions.twinkle;
        if (!twinkleOptions) return false;
        return twinkleOptions.particles.enable;
    }
    loadOptions(options, ...sources) {
        if (!options.twinkle) options.twinkle = new (0, $5fc28831f93220ef$export$d2019f714f998af1)();
        for (const source of sources)options.twinkle.load(source?.twinkle);
    }
    async update() {
        await Promise.resolve();
    }
}


async function $d06cae17dc7e8a4e$export$b9c8280298f659a5(engine, refresh = true) {
    await engine.addParticleUpdater("twinkle", ()=>{
        return Promise.resolve(new (0, $b9c43405ec6ff9aa$export$ea14214ae03f2c07)());
    }, refresh);
}





class $cc2ef676dc743aea$export$9d1564e235810926 {
    constructor(){
        this.angle = 50;
        this.move = 10;
    }
    load(data) {
        if (!data) return;
        if (data.angle !== undefined) this.angle = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.angle);
        if (data.move !== undefined) this.move = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.move);
    }
}


class $49b5e950c0ef1d04$export$e3332f9062c9ef49 {
    constructor(){
        this.distance = 5;
        this.enable = false;
        this.speed = new (0, $cc2ef676dc743aea$export$9d1564e235810926)();
    }
    load(data) {
        if (!data) return;
        if (data.distance !== undefined) this.distance = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.distance);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.speed !== undefined) {
            if ((0, $ad25b6e319f6df8c$export$7e4aa119212bc614)(data.speed)) this.speed.load({
                angle: data.speed
            });
            else {
                const rangeSpeed = data.speed;
                if (rangeSpeed.min !== undefined) this.speed.load({
                    angle: rangeSpeed
                });
                else this.speed.load(data.speed);
            }
        }
    }
}



const $e56b85707452538a$var$defaultDistance = 0, $e56b85707452538a$var$double = 2, $e56b85707452538a$var$doublePI = Math.PI * $e56b85707452538a$var$double, $e56b85707452538a$var$distanceFactor = 60;
function $e56b85707452538a$export$c35033201341f652(particle, delta) {
    const { wobble: wobbleOptions } = particle.options, { wobble: wobble } = particle;
    if (!wobbleOptions?.enable || !wobble) return;
    const angleSpeed = wobble.angleSpeed * delta.factor, moveSpeed = wobble.moveSpeed * delta.factor, distance = moveSpeed * ((particle.retina.wobbleDistance ?? $e56b85707452538a$var$defaultDistance) * delta.factor) / ((0, $dec17af1c054e95f$export$f64c3bfbc58eec0f) / $e56b85707452538a$var$distanceFactor), max = $e56b85707452538a$var$doublePI, { position: position } = particle;
    wobble.angle += angleSpeed;
    if (wobble.angle > max) wobble.angle -= max;
    position.x += distance * Math.cos(wobble.angle);
    position.y += distance * Math.abs(Math.sin(wobble.angle));
}


const $f6afe60fa4889c2f$var$double = 2, $f6afe60fa4889c2f$var$doublePI = Math.PI * $f6afe60fa4889c2f$var$double, $f6afe60fa4889c2f$var$maxAngle = 360, $f6afe60fa4889c2f$var$moveSpeedFactor = 10, $f6afe60fa4889c2f$var$defaultDistance = 0;
class $f6afe60fa4889c2f$export$40b8dfc901f79b9a {
    constructor(container){
        this.container = container;
    }
    init(particle) {
        const wobbleOpt = particle.options.wobble;
        if (wobbleOpt?.enable) particle.wobble = {
            angle: (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * $f6afe60fa4889c2f$var$doublePI,
            angleSpeed: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(wobbleOpt.speed.angle) / $f6afe60fa4889c2f$var$maxAngle,
            moveSpeed: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(wobbleOpt.speed.move) / $f6afe60fa4889c2f$var$moveSpeedFactor
        };
        else particle.wobble = {
            angle: 0,
            angleSpeed: 0,
            moveSpeed: 0
        };
        particle.retina.wobbleDistance = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(wobbleOpt?.distance ?? $f6afe60fa4889c2f$var$defaultDistance) * this.container.retina.pixelRatio;
    }
    isEnabled(particle) {
        return !particle.destroyed && !particle.spawning && !!particle.options.wobble?.enable;
    }
    loadOptions(options, ...sources) {
        if (!options.wobble) options.wobble = new (0, $49b5e950c0ef1d04$export$e3332f9062c9ef49)();
        for (const source of sources)options.wobble.load(source?.wobble);
    }
    update(particle, delta) {
        if (!this.isEnabled(particle)) return;
        (0, $e56b85707452538a$export$c35033201341f652)(particle, delta);
    }
}


async function $d5ed7c1006010425$export$b74f9b6304f50c00(engine, refresh = true) {
    await engine.addParticleUpdater("wobble", (container)=>{
        return Promise.resolve(new (0, $f6afe60fa4889c2f$export$40b8dfc901f79b9a)(container));
    }, refresh);
}


async function $9848ba7605c0cf1a$export$85493d8c5e7176fb(engine, refresh = true) {
    await (0, $e582dfa37e4f11f5$export$d6d9d65fda83a7c5)(engine, false);
    await (0, $22056b9ac8a8030c$export$9a3fb111b9c845ed)(engine, false);
    await (0, $aed5576639be3a56$export$ad7cd7f1bf42858c)(engine, false);
    await (0, $d06cae17dc7e8a4e$export$b9c8280298f659a5)(engine, false);
    await (0, $d5ed7c1006010425$export$b74f9b6304f50c00)(engine, false);
    await (0, $7bddf946317a8a2d$export$da06b6ff4c270300)(engine, false);
    await (0, $314f95152c52cc06$export$9e84d16a6473365f)(engine, false);
    await (0, $8cdb0216c91b7204$export$c075ef8fc5389119)(engine, false);
    await (0, $3cb3a297791cc556$export$e4e45ab97167d364)(engine, false);
    await (0, $f08249947f885b04$export$3dfd1f7f2dd5722)(engine, false);
    await (0, $dead9bd3b9f4e31f$export$d7d833930c5e323b)(engine, false);
    await (0, $1985e0542e1c9dc6$export$e11831a95a1ec8d5)(engine, refresh);
}







class $5d22630d915aa1e2$export$de79cebed327a922 {
    constructor(){
        this.count = 0;
        this.enable = false;
        this.speed = 0;
        this.decay = 0;
        this.delay = 0;
        this.sync = false;
        this.startValue = (0, $2cd6de34519be269$export$5385b9a82993d2c8).random;
    }
    load(data) {
        if (!data) return;
        if (data.count !== undefined) this.count = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.count);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.speed !== undefined) this.speed = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.speed);
        if (data.sync !== undefined) this.sync = data.sync;
        if (data.startValue !== undefined) this.startValue = data.startValue;
        if (data.decay !== undefined) this.decay = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.decay);
        if (data.delay !== undefined) this.delay = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.delay);
    }
}


class $9cc0fab9ef4d60cd$export$3f3e90540d51d94b {
    constructor(){
        this.value = 0;
        this.animation = new (0, $5d22630d915aa1e2$export$de79cebed327a922)();
    }
    load(data) {
        if (!data) return;
        this.animation.load(data.animation);
        if (data.value !== undefined) this.value = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.value);
    }
}


class $02bf22420b060ea2$export$21ecedb59b378ec7 {
    constructor(){
        this.stop = 0;
        this.value = new (0, $c2c78a2702851717$export$6f79b6ff75533155)();
    }
    load(data) {
        if (!data) return;
        if (data.stop !== undefined) this.stop = data.stop;
        this.value = (0, $c2c78a2702851717$export$6f79b6ff75533155).create(this.value, data.value);
        if (data.opacity !== undefined) {
            this.opacity = new (0, $9cc0fab9ef4d60cd$export$3f3e90540d51d94b)();
            if ((0, $ad25b6e319f6df8c$export$7e4aa119212bc614)(data.opacity)) this.opacity.value = data.opacity;
            else this.opacity.load(data.opacity);
        }
    }
}




class $535d84b17dec25c3$export$ce342d92c5071bb8 {
    constructor(){
        this.count = 0;
        this.enable = false;
        this.speed = 0;
        this.decay = 0;
        this.delay = 0;
        this.sync = false;
    }
    load(data) {
        if (!data) return;
        if (data.count !== undefined) this.count = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.count);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.speed !== undefined) this.speed = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.speed);
        if (data.decay !== undefined) this.decay = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.decay);
        if (data.delay !== undefined) this.delay = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.delay);
        if (data.sync !== undefined) this.sync = data.sync;
    }
}


class $af1d112027ce061d$export$74a0c7b62dd8262a {
    constructor(){
        this.value = 0;
        this.animation = new (0, $535d84b17dec25c3$export$ce342d92c5071bb8)();
        this.direction = (0, $c606501dd7c2dcb2$export$9506977ce2a96a5b).clockwise;
    }
    load(data) {
        if (!data) return;
        this.animation.load(data.animation);
        if (data.value !== undefined) this.value = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.value);
        if (data.direction !== undefined) this.direction = data.direction;
    }
}


class $c380c9b082a67af8$export$af6bd731a24f4aa1 {
    constructor(){
        this.angle = new (0, $af1d112027ce061d$export$74a0c7b62dd8262a)();
        this.colors = [];
        this.type = (0, $aaaec77af02bd97a$export$20d70ee9873a8ba).random;
    }
    load(data) {
        if (!data) return;
        this.angle.load(data.angle);
        if (data.colors !== undefined) this.colors = data.colors.map((s)=>{
            const tmp = new (0, $02bf22420b060ea2$export$21ecedb59b378ec7)();
            tmp.load(s);
            return tmp;
        });
        if (data.type !== undefined) this.type = data.type;
    }
}



function $7ff316acacc03ee8$export$266fe820ca0abf8c(particle, delta) {
    const { gradient: gradient } = particle;
    if (!gradient) return;
    (0, $eee2fa4b9ebe63e9$export$efead17ed5dcfd2)(particle, gradient.angle, false, (0, $a06b3f24e43fa14b$export$41a461248611663e).none, delta);
    for (const color of gradient.colors){
        (0, $fd6faa9f4e5410ac$export$649b44ac750da8e)(color.value, delta);
        if (color.opacity) (0, $eee2fa4b9ebe63e9$export$efead17ed5dcfd2)(particle, color.opacity, true, (0, $a06b3f24e43fa14b$export$41a461248611663e).none, delta);
    }
}


const $040328bb96aabd60$var$double = 2, $040328bb96aabd60$var$doublePI = Math.PI * $040328bb96aabd60$var$double;
class $040328bb96aabd60$export$a774a17ffdd0f7bd {
    getColorStyles(particle, context, radius, opacity) {
        const gradient = particle.gradient;
        if (!gradient) return {};
        const gradientAngle = gradient.angle.value, origin = {
            x: 0,
            y: 0
        }, minRadius = 0, fillGradient = gradient.type === (0, $aaaec77af02bd97a$export$20d70ee9873a8ba).radial ? context.createRadialGradient(origin.x, origin.y, minRadius, origin.x, origin.y, radius) : context.createLinearGradient(Math.cos(gradientAngle) * -radius, Math.sin(gradientAngle) * -radius, Math.cos(gradientAngle) * radius, Math.sin(gradientAngle) * radius);
        for (const { stop: stop, value: value, opacity: cOpacity } of gradient.colors)fillGradient.addColorStop(stop, (0, $fd6faa9f4e5410ac$export$9d057e59c7b0a82d)({
            h: value.h.value,
            s: value.s.value,
            l: value.l.value
        }, cOpacity?.value ?? opacity));
        return {
            fill: fillGradient
        };
    }
    init(particle) {
        const gradient = (0, $eee2fa4b9ebe63e9$export$3fbf39566d3ee62e)(particle.options.gradient);
        if (!gradient) return;
        const { angle: angle } = gradient, speedFactor = 360, delayOffset = 1;
        particle.gradient = {
            angle: {
                value: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(angle.value),
                enable: angle.animation.enable,
                velocity: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(angle.animation.speed) / speedFactor * particle.container.retina.reduceFactor,
                decay: delayOffset - (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(angle.animation.decay),
                delayTime: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(angle.animation.delay) * (0, $dec17af1c054e95f$export$f64c3bfbc58eec0f),
                max: $040328bb96aabd60$var$doublePI,
                min: 0,
                time: 0
            },
            type: gradient.type,
            colors: []
        };
        let rotateDirection = gradient.angle.direction;
        if (rotateDirection === (0, $c606501dd7c2dcb2$export$9506977ce2a96a5b).random) rotateDirection = (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() > (0, $dec17af1c054e95f$export$fa0534be1c9f2e23) ? (0, $c606501dd7c2dcb2$export$9506977ce2a96a5b).counterClockwise : (0, $c606501dd7c2dcb2$export$9506977ce2a96a5b).clockwise;
        switch(rotateDirection){
            case (0, $c606501dd7c2dcb2$export$9506977ce2a96a5b).counterClockwise:
            case "counterClockwise":
                particle.gradient.angle.status = (0, $c443c1fece529b66$export$a2d3d93c57d16a1a).decreasing;
                break;
            case (0, $c606501dd7c2dcb2$export$9506977ce2a96a5b).clockwise:
                particle.gradient.angle.status = (0, $c443c1fece529b66$export$a2d3d93c57d16a1a).increasing;
                break;
        }
        const reduceDuplicates = particle.options.reduceDuplicates;
        for (const grColor of gradient.colors){
            const grHslColor = (0, $fd6faa9f4e5410ac$export$79a89086521c0f12)(grColor.value, particle.id, reduceDuplicates);
            if (!grHslColor) continue;
            const grHslAnimation = (0, $fd6faa9f4e5410ac$export$6e8a573710bea117)(grHslColor, grColor.value.animation, particle.container.retina.reduceFactor), addColor = {
                stop: grColor.stop,
                value: grHslAnimation,
                opacity: grColor.opacity ? {
                    enable: grColor.opacity.animation.enable,
                    max: (0, $1ff4dfb77b7bb646$export$27d2c76f835d583d)(grColor.opacity.value),
                    min: (0, $1ff4dfb77b7bb646$export$71c94d28c0fa4bfe)(grColor.opacity.value),
                    status: (0, $c443c1fece529b66$export$a2d3d93c57d16a1a).increasing,
                    value: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(grColor.opacity.value),
                    velocity: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(grColor.opacity.animation.speed) / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd) * particle.container.retina.reduceFactor,
                    decay: delayOffset - (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(grColor.opacity.animation.decay),
                    delayTime: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(grColor.opacity.animation.delay) * (0, $dec17af1c054e95f$export$f64c3bfbc58eec0f),
                    time: 0
                } : undefined
            };
            const { opacity: addOpacity } = addColor;
            if (grColor.opacity && addOpacity) {
                const opacityRange = grColor.opacity.value;
                addOpacity.min = (0, $1ff4dfb77b7bb646$export$71c94d28c0fa4bfe)(opacityRange);
                addOpacity.max = (0, $1ff4dfb77b7bb646$export$27d2c76f835d583d)(opacityRange);
                const opacityAnimation = grColor.opacity.animation;
                switch(opacityAnimation.startValue){
                    case (0, $2cd6de34519be269$export$5385b9a82993d2c8).min:
                        addOpacity.value = addOpacity.min;
                        addOpacity.status = (0, $c443c1fece529b66$export$a2d3d93c57d16a1a).increasing;
                        break;
                    case (0, $2cd6de34519be269$export$5385b9a82993d2c8).max:
                        addOpacity.value = addOpacity.max;
                        addOpacity.status = (0, $c443c1fece529b66$export$a2d3d93c57d16a1a).decreasing;
                        break;
                    case (0, $2cd6de34519be269$export$5385b9a82993d2c8).random:
                    default:
                        addOpacity.value = (0, $1ff4dfb77b7bb646$export$8b958c8ecd94a804)(addOpacity);
                        addOpacity.status = (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() >= (0, $dec17af1c054e95f$export$fa0534be1c9f2e23) ? (0, $c443c1fece529b66$export$a2d3d93c57d16a1a).increasing : (0, $c443c1fece529b66$export$a2d3d93c57d16a1a).decreasing;
                        break;
                }
            }
            particle.gradient.colors.push(addColor);
        }
    }
    isEnabled(particle) {
        return !particle.destroyed && !particle.spawning && (!!particle.gradient?.angle.enable || (particle.gradient?.colors.some((c)=>c.value.h.enable || c.value.s.enable || c.value.l.enable) ?? false));
    }
    loadOptions(options, ...sources) {
        for (const source of sources){
            if (!source?.gradient) continue;
            const gradientToLoad = source.gradient;
            if (!gradientToLoad) continue;
            options.gradient = (0, $eee2fa4b9ebe63e9$export$8e5dc47097396754)(gradientToLoad, (gradient)=>{
                const tmp = new (0, $c380c9b082a67af8$export$af6bd731a24f4aa1)();
                tmp.load(gradient);
                return tmp;
            });
        }
    }
    update(particle, delta) {
        (0, $7ff316acacc03ee8$export$266fe820ca0abf8c)(particle, delta);
    }
}


async function $f6cd619e839ee383$export$c8b1a80debb89393(engine, refresh = true) {
    await engine.addParticleUpdater("gradient", ()=>{
        return Promise.resolve(new (0, $040328bb96aabd60$export$a774a17ffdd0f7bd)());
    }, refresh);
}


const $e5e79d53865cf424$var$half = 0.5, $e5e79d53865cf424$var$double = 2;
function $e5e79d53865cf424$export$1ed0c0bc398b6246(data) {
    const { context: context, radius: radius } = data, diameter = radius * $e5e79d53865cf424$var$double, halfRadius = radius * $e5e79d53865cf424$var$half, radiusAndHalf = radius + halfRadius, x = -radius, y = -radius;
    context.moveTo(x, y + halfRadius);
    context.quadraticCurveTo(x, y, x + halfRadius, y);
    context.quadraticCurveTo(x + radius, y, x + radius, y + halfRadius);
    context.quadraticCurveTo(x + radius, y, x + radiusAndHalf, y);
    context.quadraticCurveTo(x + diameter, y, x + diameter, y + halfRadius);
    context.quadraticCurveTo(x + diameter, y + radius, x + radiusAndHalf, y + radiusAndHalf);
    context.lineTo(x + radius, y + diameter);
    context.lineTo(x + halfRadius, y + radiusAndHalf);
    context.quadraticCurveTo(x, y + radius, x, y + halfRadius);
}


class $5aac53204728d636$export$31c1f9caabb1823e {
    constructor(){
        this.validTypes = [
            "heart"
        ];
    }
    draw(data) {
        (0, $e5e79d53865cf424$export$1ed0c0bc398b6246)(data);
    }
}


async function $1a9b65e1ab045f28$export$2fd8a165ac5d2fa3(engine, refresh = true) {
    await engine.addShape(new (0, $5aac53204728d636$export$31c1f9caabb1823e)(), refresh);
}



const $d08b445756cabb5f$var$rgbFactor = 255, $d08b445756cabb5f$var$double = 2, $d08b445756cabb5f$var$half = 0.5;
function $d08b445756cabb5f$export$f76e85ca00a47f5c(rgb) {
    const rgbPercent = {
        r: rgb.r / $d08b445756cabb5f$var$rgbFactor,
        g: rgb.g / $d08b445756cabb5f$var$rgbFactor,
        b: rgb.b / $d08b445756cabb5f$var$rgbFactor
    }, xMax = Math.max(rgbPercent.r, rgbPercent.g, rgbPercent.b), xMin = Math.min(rgbPercent.r, rgbPercent.g, rgbPercent.b), v = xMax, c = xMax - xMin;
    let h = 0;
    const phaseOffset = {
        r: 0,
        g: 2,
        b: 4
    }, phaseValue = 60;
    if (v === rgbPercent.r) h = phaseValue * (phaseOffset.r + (rgbPercent.g - rgbPercent.b) / c);
    else if (v === rgbPercent.g) h = phaseValue * (phaseOffset.g + (rgbPercent.b - rgbPercent.r) / c);
    else if (v === rgbPercent.b) h = phaseValue * (phaseOffset.b + (rgbPercent.r - rgbPercent.g) / c);
    const defaultSaturation = 0, s = !v ? defaultSaturation : c / v;
    return {
        h: h,
        s: s * (0, $dec17af1c054e95f$export$9519bca7a9fbeccd),
        v: v * (0, $dec17af1c054e95f$export$9519bca7a9fbeccd)
    };
}
function $d08b445756cabb5f$export$f4deeebdec6065f9(rgba) {
    return {
        a: rgba.a,
        ...$d08b445756cabb5f$export$f76e85ca00a47f5c(rgba)
    };
}
function $d08b445756cabb5f$export$5f46b232408c550f(color, opacity) {
    return (0, $fd6faa9f4e5410ac$export$9d057e59c7b0a82d)($d08b445756cabb5f$export$4f0921ab3f4919ce(color), opacity);
}
function $d08b445756cabb5f$export$eca2dde7f2894edb(hsl) {
    const l = hsl.l / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd), sl = hsl.s / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd), offset = 1, noValue = 0, v = l + sl * Math.min(l, offset - l), sv = !v ? noValue : $d08b445756cabb5f$var$double * (offset - l / v);
    return {
        h: hsl.h,
        s: sv * (0, $dec17af1c054e95f$export$9519bca7a9fbeccd),
        v: v * (0, $dec17af1c054e95f$export$9519bca7a9fbeccd)
    };
}
function $d08b445756cabb5f$export$cad8462dfe655319(hsla) {
    return {
        a: hsla.a,
        ...$d08b445756cabb5f$export$eca2dde7f2894edb(hsla)
    };
}
function $d08b445756cabb5f$export$4f0921ab3f4919ce(hsv) {
    const v = hsv.v / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd), sv = hsv.s / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd), offset = 1, noValue = 0, l = v * (offset - sv * $d08b445756cabb5f$var$half), sl = !l || l === offset ? noValue : (v - l) / Math.min(l, offset - l);
    return {
        h: hsv.h,
        l: l * (0, $dec17af1c054e95f$export$9519bca7a9fbeccd),
        s: sl * (0, $dec17af1c054e95f$export$9519bca7a9fbeccd)
    };
}
function $d08b445756cabb5f$export$ea93620c892f6b62(hsva) {
    return {
        a: hsva.a,
        ...$d08b445756cabb5f$export$4f0921ab3f4919ce(hsva)
    };
}
function $d08b445756cabb5f$export$210753cfeec758a5(hsv) {
    const result = {
        b: 0,
        g: 0,
        r: 0
    }, phase = 60, hsvPercent = {
        h: hsv.h / phase,
        s: hsv.s / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd),
        v: hsv.v / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd)
    }, offset = 1, hPercentFactor = 2, c = hsvPercent.v * hsvPercent.s, x = c * (offset - Math.abs(hsvPercent.h % hPercentFactor - offset));
    let tempRgb;
    const cxzRange = {
        min: 0,
        max: 1
    }, xczRange = {
        min: 1,
        max: 2
    }, zcxRange = {
        min: 2,
        max: 3
    }, zxcRange = {
        min: 3,
        max: 4
    }, xzcRange = {
        min: 4,
        max: 5
    }, czxRange = {
        min: 5,
        max: 6
    };
    if (hsvPercent.h >= cxzRange.min && hsvPercent.h <= cxzRange.max) tempRgb = {
        r: c,
        g: x,
        b: 0
    };
    else if (hsvPercent.h > xczRange.min && hsvPercent.h <= xczRange.max) tempRgb = {
        r: x,
        g: c,
        b: 0
    };
    else if (hsvPercent.h > zcxRange.min && hsvPercent.h <= zcxRange.max) tempRgb = {
        r: 0,
        g: c,
        b: x
    };
    else if (hsvPercent.h > zxcRange.min && hsvPercent.h <= zxcRange.max) tempRgb = {
        r: 0,
        g: x,
        b: c
    };
    else if (hsvPercent.h > xzcRange.min && hsvPercent.h <= xzcRange.max) tempRgb = {
        r: x,
        g: 0,
        b: c
    };
    else if (hsvPercent.h > czxRange.min && hsvPercent.h <= czxRange.max) tempRgb = {
        r: c,
        g: 0,
        b: x
    };
    if (tempRgb) {
        const m = hsvPercent.v - c;
        result.r = Math.floor((tempRgb.r + m) * $d08b445756cabb5f$var$rgbFactor);
        result.g = Math.floor((tempRgb.g + m) * $d08b445756cabb5f$var$rgbFactor);
        result.b = Math.floor((tempRgb.b + m) * $d08b445756cabb5f$var$rgbFactor);
    }
    return result;
}
function $d08b445756cabb5f$export$e41dcd4e52af69bc(hsva) {
    return {
        a: hsva.a,
        ...$d08b445756cabb5f$export$210753cfeec758a5(hsva)
    };
}
class $d08b445756cabb5f$export$2137a84c0d9753ef {
    constructor(){
        this.key = "hsv";
        this.stringPrefix = "hsv";
    }
    handleColor(color) {
        const colorValue = color.value, hsvColor = colorValue.hsv ?? color.value;
        if (hsvColor.h !== undefined && hsvColor.v !== undefined) return $d08b445756cabb5f$export$210753cfeec758a5(hsvColor);
    }
    handleRangeColor(color) {
        const colorValue = color.value, hsvColor = colorValue.hsv ?? color.value;
        if (hsvColor.h !== undefined && hsvColor.v !== undefined) return $d08b445756cabb5f$export$210753cfeec758a5({
            h: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(hsvColor.h),
            s: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(hsvColor.s),
            v: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(hsvColor.v)
        });
    }
    parseString(input) {
        if (!input.startsWith("hsv")) return;
        const regex = /hsva?\(\s*(\d+)°\s*,\s*(\d+)%\s*,\s*(\d+)%\s*(,\s*([\d.%]+)\s*)?\)/i, result = regex.exec(input), fullLength = 4, indexes = {
            h: 1,
            s: 2,
            v: 3,
            a: 5
        }, defaultAlpha = 1, radix = 10;
        return result ? $d08b445756cabb5f$export$e41dcd4e52af69bc({
            a: result.length > fullLength ? (0, $1ff4dfb77b7bb646$export$988633967de92230)(result[indexes.a]) : defaultAlpha,
            h: parseInt(result[indexes.h], radix),
            s: parseInt(result[indexes.s], radix),
            v: parseInt(result[indexes.v], radix)
        }) : undefined;
    }
}



function $c9a5633c6a2864f2$export$25026bf63efa4ca6() {
    (0, $fd6faa9f4e5410ac$export$fac4919b23cbaf23)(new (0, $d08b445756cabb5f$export$2137a84c0d9753ef)());
    return Promise.resolve();
}



class $8df23fc9b4a6f9d7$export$b90ab935a4d48330 {
    constructor(){
        this.color = new (0, $c86524210cdfad1b$export$c2b08aa25660fcaa)();
        this.color.value = "#ff0000";
        this.radius = 0;
        this.rate = 1;
    }
    load(data) {
        if (data === undefined) return;
        if (data.color !== undefined) this.color = (0, $c86524210cdfad1b$export$c2b08aa25660fcaa).create(this.color, data.color);
        this.duration = data.duration;
        this.infectedStage = data.infectedStage;
        if (data.radius !== undefined) this.radius = data.radius;
        if (data.rate !== undefined) this.rate = data.rate;
    }
}


class $8d0308cd0dfa25c4$export$350a5ec589644469 {
    constructor(){
        this.cure = false;
        this.delay = 0;
        this.enable = false;
        this.infections = 0;
        this.stages = [];
    }
    load(data) {
        if (data === undefined) return;
        if (data.cure !== undefined) this.cure = data.cure;
        if (data.delay !== undefined) this.delay = data.delay;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.infections !== undefined) this.infections = data.infections;
        if (data.stages === undefined) return;
        this.stages = data.stages.map((t)=>{
            const s = new (0, $8df23fc9b4a6f9d7$export$b90ab935a4d48330)();
            s.load(t);
            return s;
        });
    }
}




const $eefabf653ff29e4f$var$minStage = 0, $eefabf653ff29e4f$var$minDuration = 0;
class $eefabf653ff29e4f$export$cd9aa11d5371f6dd {
    constructor(container){
        this._nextInfectionStage = (particle)=>{
            const infectionOptions = this._container.actualOptions.infection, { infection: infection } = particle;
            if (!infectionOptions || !infection) return;
            const stagesCount = infectionOptions.stages.length;
            if (stagesCount <= $eefabf653ff29e4f$var$minStage || infection.stage === undefined) return;
            infection.time = 0;
            if (stagesCount <= ++infection.stage) {
                if (infectionOptions.cure) {
                    delete infection.stage;
                    delete infection.time;
                } else {
                    infection.stage = 0;
                    infection.time = 0;
                }
            }
        };
        this._container = container;
    }
    startInfection(particle, stage) {
        const infectionOptions = this._container.actualOptions.infection, { infection: infection } = particle;
        if (!infectionOptions || !infection) return;
        const stages = infectionOptions.stages, stagesCount = stages.length;
        if (stage > stagesCount || stage < $eefabf653ff29e4f$var$minStage) return;
        infection.delay = 0;
        infection.delayStage = stage;
    }
    updateInfection(particle, delta) {
        const infectionOptions = this._container.actualOptions.infection, { infection: infection } = particle;
        if (!infectionOptions || !infection) return;
        const stages = infectionOptions.stages, stagesCount = stages.length;
        if (infection.delay !== undefined && infection.delayStage !== undefined) {
            const stage = infection.delayStage;
            if (stage > stagesCount || stage < $eefabf653ff29e4f$var$minStage) return;
            if (infection.delay >= infectionOptions.delay * (0, $dec17af1c054e95f$export$f64c3bfbc58eec0f)) {
                infection.stage = stage;
                infection.time = 0;
                delete infection.delay;
                delete infection.delayStage;
            } else infection.delay += delta;
        } else {
            delete infection.delay;
            delete infection.delayStage;
        }
        if (infection.stage !== undefined && infection.time !== undefined) {
            const infectionStage = stages[infection.stage];
            if (infectionStage.duration !== undefined && infectionStage.duration >= $eefabf653ff29e4f$var$minDuration) {
                if (infection.time > infectionStage.duration * (0, $dec17af1c054e95f$export$f64c3bfbc58eec0f)) this._nextInfectionStage(particle);
                else infection.time += delta;
            } else infection.time += delta;
        } else {
            delete infection.stage;
            delete infection.time;
        }
    }
    updateInfectionStage(particle, stage) {
        const options = this._container.actualOptions, { infection: infection } = particle;
        if (!options.infection || !infection) return;
        const stagesCount = options.infection.stages.length;
        if (stage > stagesCount || stage < $eefabf653ff29e4f$var$minStage || infection.stage !== undefined && infection.stage > stage) return;
        infection.stage = stage;
        infection.time = 0;
    }
}


const $7ae00b86a72dee2c$var$minStage = 0;
class $7ae00b86a72dee2c$export$48f669a48488bbf8 {
    constructor(container){
        this._container = container;
        this._container.infecter = new (0, $eefabf653ff29e4f$export$cd9aa11d5371f6dd)(this._container);
    }
    particleFillColor(particle) {
        const options = this._container.actualOptions;
        if (!particle.infection || !options.infection) return;
        const infectionStage = particle.infection.stage, infection = options.infection, infectionStages = infection.stages;
        return infectionStage !== undefined ? infectionStages[infectionStage].color : undefined;
    }
    particleStrokeColor(particle) {
        return this.particleFillColor(particle);
    }
    particlesSetup() {
        const options = this._container.actualOptions;
        if (!options.infection) return;
        for(let i = 0; i < options.infection.infections; i++){
            const notInfected = this._container.particles.filter((p)=>{
                const infP = p;
                if (!infP.infection) infP.infection = {};
                return infP.infection.stage === undefined;
            });
            const infected = (0, $eee2fa4b9ebe63e9$export$3a5d12ca7137122f)(notInfected);
            this._container.infecter?.startInfection(infected, $7ae00b86a72dee2c$var$minStage);
        }
    }
}


class $f3fd0cf88749fe26$export$fdab258e0641a51a {
    constructor(){
        this.id = "infection";
    }
    getPlugin(container) {
        return Promise.resolve(new (0, $7ae00b86a72dee2c$export$48f669a48488bbf8)(container));
    }
    loadOptions(options, source) {
        if (!this.needsPlugin(options) && !this.needsPlugin(source)) return;
        let infectionOptions = options.infection;
        if (infectionOptions?.load === undefined) options.infection = infectionOptions = new (0, $8d0308cd0dfa25c4$export$350a5ec589644469)();
        infectionOptions.load(source?.infection);
    }
    needsPlugin(options) {
        return options?.infection?.enable ?? false;
    }
}



const $fd0e733f7d6545d2$var$minStagesCount = 1, $fd0e733f7d6545d2$var$double = 2;
class $fd0e733f7d6545d2$export$1a5f6425a027c891 extends (0, $98976f88cf21c377$export$becdaab2d9289dc4) {
    constructor(container){
        super(container);
    }
    clear() {}
    init() {}
    interact(p1, delta) {
        const infecter = this.container.infecter;
        if (!infecter) return;
        infecter.updateInfection(p1, delta.value);
        if (p1.infection?.stage === undefined) return;
        const container = this.container, options = container.actualOptions, infectionOptions = options.infection;
        if (!infectionOptions?.enable || infectionOptions.stages.length < $fd0e733f7d6545d2$var$minStagesCount) return;
        const infectionStage1 = infectionOptions.stages[p1.infection.stage], pxRatio = container.retina.pixelRatio, radius = p1.getRadius() * $fd0e733f7d6545d2$var$double + infectionStage1.radius * pxRatio, pos = p1.getPosition(), infectedStage1 = infectionStage1.infectedStage ?? p1.infection.stage, query = container.particles.quadTree.queryCircle(pos, radius), infections = infectionStage1.rate, neighbors = query.length;
        for (const p2 of query){
            const infP2 = p2;
            if (infP2 === p1 || infP2.destroyed || infP2.spawning || !(infP2.infection?.stage === undefined || infP2.infection.stage !== p1.infection.stage) || (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() >= infections / neighbors) continue;
            if (infP2.infection?.stage === undefined) infecter.startInfection(infP2, infectedStage1);
            else if (infP2.infection.stage < p1.infection.stage) infecter.updateInfectionStage(infP2, infectedStage1);
            else if (infP2.infection.stage > p1.infection.stage) {
                const infectionStage2 = infectionOptions.stages[infP2.infection.stage];
                const infectedStage2 = infectionStage2?.infectedStage ?? infP2.infection.stage;
                infecter.updateInfectionStage(p1, infectedStage2);
            }
        }
    }
    isEnabled() {
        return this.container.actualOptions?.infection?.enable ?? false;
    }
    reset() {}
}






async function $91cfb3d96f44a3fa$export$d49e2fd5a9e5c935(engine, refresh = true) {
    const plugin = new (0, $f3fd0cf88749fe26$export$fdab258e0641a51a)();
    await engine.addPlugin(plugin, refresh);
    await engine.addInteractor("particlesInfection", (container)=>{
        return Promise.resolve(new (0, $fd0e733f7d6545d2$export$1a5f6425a027c891)(container));
    }, refresh);
}


const $5306ef97d775cf48$var$origin = {
    x: 0,
    y: 0
}, $5306ef97d775cf48$var$loopSizeFactor = 0.55;
function $5306ef97d775cf48$export$d8872d7ebdec20cd(data) {
    const { context: context, radius: radius } = data, loopControl = radius * $5306ef97d775cf48$var$loopSizeFactor;
    context.moveTo($5306ef97d775cf48$var$origin.x, $5306ef97d775cf48$var$origin.y);
    context.bezierCurveTo(loopControl, -radius, loopControl, radius, $5306ef97d775cf48$var$origin.x, $5306ef97d775cf48$var$origin.y);
    context.moveTo($5306ef97d775cf48$var$origin.x, $5306ef97d775cf48$var$origin.y);
    context.bezierCurveTo(-loopControl, -radius, $5306ef97d775cf48$var$origin.x - loopControl, radius, $5306ef97d775cf48$var$origin.x, $5306ef97d775cf48$var$origin.y);
}


class $27d7cd8c438abf9e$export$f669682d68c3be1b {
    constructor(){
        this.validTypes = [
            "infinity"
        ];
    }
    draw(data) {
        (0, $5306ef97d775cf48$export$d8872d7ebdec20cd)(data);
    }
}


async function $c4f4158d6d97258c$export$b882071358cdf22a(engine, refresh = true) {
    await engine.addShape(new (0, $27d7cd8c438abf9e$export$f669682d68c3be1b)(), refresh);
}




const $f568714e7f872629$var$gradientPos = {
    max: 1,
    min: 0
}, $f568714e7f872629$var$half = 0.5, $f568714e7f872629$var$double = 2, $f568714e7f872629$var$halfPI = Math.PI * $f568714e7f872629$var$half, $f568714e7f872629$var$doublePI = Math.PI * $f568714e7f872629$var$double, $f568714e7f872629$var$quarter = 0.25, $f568714e7f872629$var$quarterPI = Math.PI * $f568714e7f872629$var$quarter, $f568714e7f872629$var$arcStart = 0;
const $f568714e7f872629$export$3e41f1e33fcda302 = "light";
function $f568714e7f872629$export$95f28a29884e55d1(container, context, mousePos) {
    const lightOptions = container.actualOptions.interactivity.modes.light?.area;
    if (!lightOptions) return;
    context.beginPath();
    context.arc(mousePos.x, mousePos.y, lightOptions.radius, $f568714e7f872629$var$arcStart, $f568714e7f872629$var$doublePI);
    const gradientAmbientLight = context.createRadialGradient(mousePos.x, mousePos.y, $f568714e7f872629$var$arcStart, mousePos.x, mousePos.y, lightOptions.radius);
    const gradientRgb = container.canvas.mouseLight;
    if (!gradientRgb?.start || !gradientRgb.stop) return;
    gradientAmbientLight.addColorStop($f568714e7f872629$var$gradientPos.min, (0, $fd6faa9f4e5410ac$export$2476af37e47fcae2)(gradientRgb.start));
    gradientAmbientLight.addColorStop($f568714e7f872629$var$gradientPos.max, (0, $fd6faa9f4e5410ac$export$2476af37e47fcae2)(gradientRgb.stop));
    context.fillStyle = gradientAmbientLight;
    context.fill();
}
function $f568714e7f872629$export$7f29063ff682053b(container, context, particle, mousePos) {
    const pos = particle.getPosition(), shadowOptions = container.actualOptions.interactivity.modes.light?.shadow;
    if (!shadowOptions) return;
    const shadowRgb = particle.lightShadow;
    if (!shadowRgb) return;
    const radius = particle.getRadius(), sides = particle.sides, full = $f568714e7f872629$var$doublePI / sides, angle = -particle.rotation + $f568714e7f872629$var$quarterPI, factor = 1, dots = [];
    for(let i = 0; i < sides; i++)dots.push({
        x: pos.x + radius * Math.sin(angle + full * i) * factor,
        y: pos.y + radius * Math.cos(angle + full * i) * factor
    });
    const points = [], shadowLength = shadowOptions.length;
    for (const dot of dots){
        const dotAngle = Math.atan2(mousePos.y - dot.y, mousePos.x - dot.x), end = {
            x: dot.x + shadowLength * Math.sin(-dotAngle - $f568714e7f872629$var$halfPI),
            y: dot.y + shadowLength * Math.cos(-dotAngle - $f568714e7f872629$var$halfPI)
        };
        points.push({
            end: end,
            start: dot
        });
    }
    const shadowColor = (0, $fd6faa9f4e5410ac$export$2476af37e47fcae2)(shadowRgb), lastOffset = 1, firstPos = 0, last = points.length - lastOffset;
    for(let i = last, n = 0; i >= firstPos; n = i--){
        context.beginPath();
        context.moveTo(points[i].start.x, points[i].start.y);
        context.lineTo(points[n].start.x, points[n].start.y);
        context.lineTo(points[n].end.x, points[n].end.y);
        context.lineTo(points[i].end.x, points[i].end.y);
        context.fillStyle = shadowColor;
        context.fill();
    }
}



class $848b378d66b73df5$export$c6a285a9840ea9d {
    constructor(){
        this.start = new (0, $c86524210cdfad1b$export$c2b08aa25660fcaa)();
        this.stop = new (0, $c86524210cdfad1b$export$c2b08aa25660fcaa)();
        this.start.value = "#ffffff";
        this.stop.value = "#000000";
    }
    load(data) {
        if (!data) return;
        this.start = (0, $c86524210cdfad1b$export$c2b08aa25660fcaa).create(this.start, data.start);
        this.stop = (0, $c86524210cdfad1b$export$c2b08aa25660fcaa).create(this.stop, data.stop);
    }
}


class $7485ca4e8151a36b$export$1ba21d00fe2bcd53 {
    constructor(){
        this.gradient = new (0, $848b378d66b73df5$export$c6a285a9840ea9d)();
        this.radius = 1000;
    }
    load(data) {
        if (!data) return;
        this.gradient.load(data.gradient);
        if (data.radius !== undefined) this.radius = data.radius;
    }
}



class $089cac8235270435$export$62dfae6aea7122f9 {
    constructor(){
        this.color = new (0, $c86524210cdfad1b$export$c2b08aa25660fcaa)();
        this.color.value = "#000000";
        this.length = 2000;
    }
    load(data) {
        if (!data) return;
        this.color = (0, $c86524210cdfad1b$export$c2b08aa25660fcaa).create(this.color, data.color);
        if (data.length !== undefined) this.length = data.length;
    }
}


class $9df52d2c3c5a8c8f$export$6ecadb6ed240d696 {
    constructor(){
        this.area = new (0, $7485ca4e8151a36b$export$1ba21d00fe2bcd53)();
        this.shadow = new (0, $089cac8235270435$export$62dfae6aea7122f9)();
    }
    load(data) {
        if (!data) return;
        this.area.load(data.area);
        this.shadow.load(data.shadow);
    }
}


class $c318e77a3c02d364$export$5e883446df7e77ce extends (0, $5825146c5282067b$export$6e252256471acc61) {
    constructor(container){
        super(container);
    }
    clear() {}
    init() {}
    interact() {
        const container = this.container, options = container.actualOptions, interactivity = container.interactivity;
        if (!options.interactivity.events.onHover.enable || interactivity.status !== "pointermove") return;
        const mousePos = interactivity.mouse.position;
        if (!mousePos) return;
        container.canvas.draw((ctx)=>{
            (0, $f568714e7f872629$export$95f28a29884e55d1)(container, ctx, mousePos);
        });
    }
    isEnabled(particle) {
        const container = this.container, mouse = container.interactivity.mouse, interactivity = particle?.interactivity ?? container.actualOptions.interactivity, events = interactivity.events;
        if (!(events.onHover.enable && mouse.position)) return false;
        const res = (0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)((0, $f568714e7f872629$export$3e41f1e33fcda302), events.onHover.mode);
        if (res && interactivity.modes.light) {
            const lightGradient = interactivity.modes.light.area.gradient;
            container.canvas.mouseLight = {
                start: (0, $fd6faa9f4e5410ac$export$fbf0bf3cc1fc0cc4)(lightGradient.start),
                stop: (0, $fd6faa9f4e5410ac$export$fbf0bf3cc1fc0cc4)(lightGradient.stop)
            };
        }
        return res;
    }
    loadModeOptions(options, ...sources) {
        if (!options.light) options.light = new (0, $9df52d2c3c5a8c8f$export$6ecadb6ed240d696)();
        for (const source of sources)options.light.load(source?.light);
    }
    reset() {}
}




class $ad684e1e43f5b875$export$edcca8d8e6f559cf extends (0, $98976f88cf21c377$export$becdaab2d9289dc4) {
    constructor(container){
        super(container);
    }
    clear() {}
    init() {}
    interact(particle) {
        const container = this.container, options = container.actualOptions, interactivity = container.interactivity;
        if (!options.interactivity.events.onHover.enable || interactivity.status !== "pointermove") return;
        const mousePos = interactivity.mouse.position;
        if (!mousePos) return;
        container.canvas.draw((ctx)=>{
            (0, $f568714e7f872629$export$7f29063ff682053b)(container, ctx, particle, mousePos);
        });
    }
    isEnabled(particle) {
        const container = this.container, interactivity = particle.interactivity ?? container.actualOptions.interactivity, mouse = container.interactivity.mouse, events = interactivity.events;
        if (!(events.onHover.enable && mouse.position)) return false;
        const res = (0, $eee2fa4b9ebe63e9$export$5e9bb4359042e24b)((0, $f568714e7f872629$export$3e41f1e33fcda302), events.onHover.mode);
        if (res && interactivity.modes.light) {
            const shadowOptions = interactivity.modes.light.shadow;
            particle.lightShadow = (0, $fd6faa9f4e5410ac$export$fbf0bf3cc1fc0cc4)(shadowOptions.color);
        }
        return res;
    }
    reset() {}
}














async function $8628b62569577efb$export$9e47db2a3b3d6236(engine, refresh = true) {
    await engine.addInteractor("externalLight", (container)=>{
        return Promise.resolve(new (0, $c318e77a3c02d364$export$5e883446df7e77ce)(container));
    }, refresh);
    await engine.addInteractor("particlesLight", (container)=>{
        return Promise.resolve(new (0, $ad684e1e43f5b875$export$edcca8d8e6f559cf)(container));
    }, refresh);
}


class $41fd7f40692d2282$export$e7b9aef79182aa62 {
    constructor(){
        this.factor = 4;
        this.value = true;
    }
    load(data) {
        if (!data) return;
        if (data.factor !== undefined) this.factor = data.factor;
        if (data.value !== undefined) this.value = data.value;
    }
}


class $4a66222e6252c685$export$ab7b018719e111db {
    constructor(){
        this.disable = false;
        this.reduce = new (0, $41fd7f40692d2282$export$e7b9aef79182aa62)();
    }
    load(data) {
        if (!data) return;
        if (data.disable !== undefined) this.disable = data.disable;
        this.reduce.load(data.reduce);
    }
}



const $e7064dc70631d6a4$var$defaultFactor = 1, $e7064dc70631d6a4$var$defaultReduce = 0, $e7064dc70631d6a4$var$identity = 1;
class $e7064dc70631d6a4$export$206f4a527d524eec {
    constructor(container, engine){
        this._handleMotionChange = (mediaQuery)=>{
            const container = this._container, motion = container.actualOptions.motion;
            if (!motion) return;
            if (mediaQuery.matches) {
                if (motion.disable) container.retina.reduceFactor = $e7064dc70631d6a4$var$defaultReduce;
                else container.retina.reduceFactor = motion.reduce.value ? $e7064dc70631d6a4$var$identity / motion.reduce.factor : $e7064dc70631d6a4$var$defaultFactor;
            } else container.retina.reduceFactor = 1;
        };
        this._container = container;
        this._engine = engine;
    }
    async init() {
        const container = this._container, options = container.actualOptions.motion;
        if (!(options && (options.disable || options.reduce.value))) {
            container.retina.reduceFactor = 1;
            return;
        }
        const mediaQuery = (0, $eee2fa4b9ebe63e9$export$db32b9574e21e00f)("(prefers-reduced-motion: reduce)");
        if (!mediaQuery) {
            container.retina.reduceFactor = $e7064dc70631d6a4$var$defaultFactor;
            return;
        }
        this._handleMotionChange(mediaQuery);
        const handleChange = ()=>{
            (async ()=>{
                this._handleMotionChange(mediaQuery);
                try {
                    await container.refresh();
                } catch  {}
            })();
        };
        if (mediaQuery.addEventListener !== undefined) mediaQuery.addEventListener("change", handleChange);
        else if (mediaQuery.addListener !== undefined) mediaQuery.addListener(handleChange);
        await Promise.resolve();
    }
}


class $9d5911837a3082ee$export$d4bb0e2a4a84a7d7 {
    constructor(engine){
        this.id = "motion";
        this._engine = engine;
    }
    getPlugin(container) {
        return Promise.resolve(new (0, $e7064dc70631d6a4$export$206f4a527d524eec)(container, this._engine));
    }
    loadOptions(options, source) {
        if (!this.needsPlugin()) return;
        let motionOptions = options.motion;
        if (!motionOptions?.load) options.motion = motionOptions = new (0, $4a66222e6252c685$export$ab7b018719e111db)();
        motionOptions.load(source?.motion);
    }
    needsPlugin() {
        return true;
    }
}


async function $30f79e2f10ab55a1$export$67d9c97c602a4291(engine, refresh = true) {
    await engine.addPlugin(new (0, $9d5911837a3082ee$export$d4bb0e2a4a84a7d7)(engine), refresh);
}





class $24cd0c88d96304f2$export$775a3e57c24c33bd extends (0, $49613bee1189cd15$export$2f74c042fca0b66d) {
    constructor(){
        super();
        this.value = 45;
    }
    load(data) {
        if (data === undefined) return;
        super.load(data);
    }
}


class $d6737c4f8280f36b$export$439358b35042ae9f {
    constructor(){
        this.animation = new (0, $2919e8e0f12c2264$export$e293c31e7176ae39)();
        this.enable = false;
        this.opacity = 1;
        this.rotation = new (0, $24cd0c88d96304f2$export$775a3e57c24c33bd)();
        this.width = 1;
    }
    load(data) {
        if (!data) return;
        this.animation.load(data.animation);
        this.rotation.load(data.rotation);
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.opacity !== undefined) this.opacity = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.opacity);
        if (data.width !== undefined) this.width = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.width);
        if (data.radius !== undefined) this.radius = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.radius);
        if (data.color !== undefined) this.color = (0, $c86524210cdfad1b$export$c2b08aa25660fcaa).create(this.color, data.color);
    }
}


var $41c652b76947dfb5$export$5332c3c73d77d6a1;
(function(OrbitType) {
    OrbitType["front"] = "front";
    OrbitType["back"] = "back";
})($41c652b76947dfb5$export$5332c3c73d77d6a1 || ($41c652b76947dfb5$export$5332c3c73d77d6a1 = {}));



const $bb45b36cd9808560$var$minWidth = 0, $bb45b36cd9808560$var$half = 0.5, $bb45b36cd9808560$var$double = 2;
function $bb45b36cd9808560$export$43c9e2bb0dc74582(context, particle, fillColorValue, radius, opacity, width, rotation, start, end) {
    if (width <= $bb45b36cd9808560$var$minWidth) return;
    const pos = particle.getPosition();
    if (fillColorValue) context.strokeStyle = (0, $fd6faa9f4e5410ac$export$9d057e59c7b0a82d)(fillColorValue, opacity);
    context.lineWidth = width;
    const rotationRadian = (0, $1ff4dfb77b7bb646$export$e6bfdeff8bfc94f9)(rotation);
    context.beginPath();
    context.ellipse(pos.x, pos.y, radius * $bb45b36cd9808560$var$half, radius * $bb45b36cd9808560$var$double, rotationRadian, start, end);
    context.stroke();
}


const $d6cc1ed472312499$var$double = 2, $d6cc1ed472312499$var$half = 0.5, $d6cc1ed472312499$var$doublePI = Math.PI * $d6cc1ed472312499$var$double, $d6cc1ed472312499$var$defaultOrbitSpeed = 0, $d6cc1ed472312499$var$halfPI = Math.PI * $d6cc1ed472312499$var$half, $d6cc1ed472312499$var$piAndAHalf = Math.PI + $d6cc1ed472312499$var$halfPI, $d6cc1ed472312499$var$startAngle = 0, $d6cc1ed472312499$var$defaultOpacity = 1, $d6cc1ed472312499$var$defaultWidth = 1, $d6cc1ed472312499$var$defaultRotation = 0;
class $d6cc1ed472312499$export$b3d59b310777f26 {
    constructor(container){
        this.container = container;
    }
    afterDraw(particle) {
        const orbitOptions = particle.options.orbit;
        if (orbitOptions?.enable) this.drawOrbit(particle, (0, $41c652b76947dfb5$export$5332c3c73d77d6a1).front);
    }
    beforeDraw(particle) {
        const orbitOptions = particle.options.orbit;
        if (orbitOptions?.enable) this.drawOrbit(particle, (0, $41c652b76947dfb5$export$5332c3c73d77d6a1).back);
    }
    drawOrbit(particle, type) {
        const container = this.container;
        let start, end;
        switch(type){
            case (0, $41c652b76947dfb5$export$5332c3c73d77d6a1).back:
                start = $d6cc1ed472312499$var$halfPI;
                end = $d6cc1ed472312499$var$piAndAHalf;
                break;
            case (0, $41c652b76947dfb5$export$5332c3c73d77d6a1).front:
                start = $d6cc1ed472312499$var$piAndAHalf;
                end = $d6cc1ed472312499$var$halfPI;
                break;
            default:
                start = $d6cc1ed472312499$var$startAngle;
                end = $d6cc1ed472312499$var$doublePI;
        }
        container.canvas.draw((ctx)=>{
            (0, $bb45b36cd9808560$export$43c9e2bb0dc74582)(ctx, particle, particle.orbitColor ?? particle.getFillColor(), particle.retina.orbitRadius ?? container.retina.orbitRadius ?? particle.getRadius(), particle.orbitOpacity ?? $d6cc1ed472312499$var$defaultOpacity, particle.orbitWidth ?? $d6cc1ed472312499$var$defaultWidth, (particle.orbitRotation ?? $d6cc1ed472312499$var$defaultRotation) * container.retina.pixelRatio, start, end);
        });
    }
    init(particle) {
        const container = this.container, particlesOptions = particle.options, orbitOptions = particlesOptions.orbit;
        if (!orbitOptions?.enable) return;
        particle.orbitRotation = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(orbitOptions.rotation.value);
        particle.orbitColor = (0, $fd6faa9f4e5410ac$export$79a89086521c0f12)(orbitOptions.color);
        particle.retina.orbitRadius = orbitOptions.radius !== undefined ? (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(orbitOptions.radius) * container.retina.pixelRatio : undefined;
        container.retina.orbitRadius = particle.retina.orbitRadius;
        particle.orbitAnimationSpeed = orbitOptions.animation.enable ? (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(orbitOptions.animation.speed) : $d6cc1ed472312499$var$defaultOrbitSpeed;
        particle.orbitWidth = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(orbitOptions.width);
        particle.orbitOpacity = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(orbitOptions.opacity);
    }
    isEnabled(particle) {
        const orbitAnimations = particle.options.orbit?.animation;
        return !particle.destroyed && !particle.spawning && !!orbitAnimations?.enable;
    }
    loadOptions(options, ...sources) {
        if (!options.orbit) options.orbit = new (0, $d6737c4f8280f36b$export$439358b35042ae9f)();
        for (const source of sources)options.orbit.load(source?.orbit);
    }
    update(particle, delta) {
        if (!this.isEnabled(particle)) return;
        if (particle.orbitRotation === undefined) particle.orbitRotation = $d6cc1ed472312499$var$defaultRotation;
        particle.orbitRotation += (particle.orbitAnimationSpeed ?? $d6cc1ed472312499$var$defaultOrbitSpeed / $d6cc1ed472312499$var$doublePI) * delta.factor;
    }
}


async function $ebc921caee9e3940$export$bc5d21ee1fe964a2(engine, refresh = true) {
    await engine.addParticleUpdater("orbit", (container)=>{
        return Promise.resolve(new (0, $d6cc1ed472312499$export$b3d59b310777f26)(container));
    }, refresh);
}




class $f8af584fe00480f3$export$7889bcf682cafd12 extends (0, $49613bee1189cd15$export$2f74c042fca0b66d) {
    constructor(){
        super();
        this.enabled = false;
        this.distance = 1;
        this.duration = 1;
        this.factor = 1;
        this.speed = 1;
    }
    load(data) {
        super.load(data);
        if (!data) return;
        if (data.enabled !== undefined) this.enabled = data.enabled;
        if (data.distance !== undefined) this.distance = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.distance);
        if (data.duration !== undefined) this.duration = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.duration);
        if (data.factor !== undefined) this.factor = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.factor);
        if (data.speed !== undefined) this.speed = (0, $1ff4dfb77b7bb646$export$6dcd5a07b989db7)(data.speed);
    }
}


const $f5f0862a84e56f4f$var$minDistance = 0, $f5f0862a84e56f4f$var$identity = 1, $f5f0862a84e56f4f$var$squareExp = 2, $f5f0862a84e56f4f$var$minVelocity = 0;
class $f5f0862a84e56f4f$export$4d442f40198e66c4 extends (0, $98976f88cf21c377$export$becdaab2d9289dc4) {
    constructor(container){
        super(container);
    }
    clear() {}
    init() {}
    interact(p1) {
        const container = this.container;
        if (!p1.repulse) {
            const repulseOpt1 = p1.options.repulse;
            if (!repulseOpt1) return;
            p1.repulse = {
                distance: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(repulseOpt1.distance) * container.retina.pixelRatio,
                speed: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(repulseOpt1.speed),
                factor: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(repulseOpt1.factor)
            };
        }
        const pos1 = p1.getPosition(), query = container.particles.quadTree.queryCircle(pos1, p1.repulse.distance);
        for (const p2 of query){
            if (p1 === p2 || p2.destroyed) continue;
            const pos2 = p2.getPosition(), { dx: dx, dy: dy, distance: distance } = (0, $1ff4dfb77b7bb646$export$c76b58cfe053f228)(pos2, pos1), velocity = p1.repulse.speed * p1.repulse.factor;
            if (distance > $f5f0862a84e56f4f$var$minDistance) {
                const repulseFactor = (0, $1ff4dfb77b7bb646$export$7d15b64cf5a3a4c4)(($f5f0862a84e56f4f$var$identity - Math.pow(distance / p1.repulse.distance, $f5f0862a84e56f4f$var$squareExp)) * velocity, $f5f0862a84e56f4f$var$minVelocity, velocity), normVec = (0, $04697537ec8dce5b$export$9b781de7bf37bf48).create(dx / distance * repulseFactor, dy / distance * repulseFactor);
                p2.position.addTo(normVec);
            } else {
                const velocityVec = (0, $04697537ec8dce5b$export$9b781de7bf37bf48).create(velocity, velocity);
                p2.position.addTo(velocityVec);
            }
        }
    }
    isEnabled(particle) {
        return particle.options.repulse?.enabled ?? false;
    }
    loadParticlesOptions(options, ...sources) {
        if (!options.repulse) options.repulse = new (0, $f8af584fe00480f3$export$7889bcf682cafd12)();
        for (const source of sources)options.repulse.load(source?.repulse);
    }
    reset() {}
}


async function $22567d61c1ae3141$export$5a3ef42b8266261e(engine, refresh = true) {
    await engine.addInteractor("particlesRepulse", (container)=>{
        return Promise.resolve(new (0, $f5f0862a84e56f4f$export$4d442f40198e66c4)(container));
    }, refresh);
}



var $f25aeb234844b825$export$a9fc50c2011c4fb3;
(function(SegmentType) {
    SegmentType["line"] = "line";
    SegmentType["bezier"] = "bezier";
    SegmentType["quadratic"] = "quadratic";
    SegmentType["arc"] = "arc";
    SegmentType["ellipse"] = "ellipse";
})($f25aeb234844b825$export$a9fc50c2011c4fb3 || ($f25aeb234844b825$export$a9fc50c2011c4fb3 = {}));


function $6f4f65c6258536f4$export$f89e19e593add7bd(ctx, radius, path) {
    const firstIndex = 0, firstSegment = path.segments[firstIndex], firstValue = firstSegment.values[firstIndex];
    ctx.moveTo(firstValue.x * radius, firstValue.y * radius);
    for (const segment of path.segments){
        const value = segment.values[firstIndex], index2 = 1, index3 = 2, index4 = 3;
        switch(segment.type){
            case (0, $f25aeb234844b825$export$a9fc50c2011c4fb3).line:
                ctx.lineTo(value.x * radius, value.y * radius);
                break;
            case (0, $f25aeb234844b825$export$a9fc50c2011c4fb3).bezier:
                ctx.bezierCurveTo(segment.values[index2].x * radius, segment.values[index2].y * radius, segment.values[index3].x * radius, segment.values[index3].y * radius, segment.values[index4].x * radius, segment.values[index4].y * radius);
                break;
            case (0, $f25aeb234844b825$export$a9fc50c2011c4fb3).quadratic:
                ctx.quadraticCurveTo(segment.values[index2].x * radius, segment.values[index2].y * radius, segment.values[index3].x * radius, segment.values[index3].y * radius);
                break;
            case (0, $f25aeb234844b825$export$a9fc50c2011c4fb3).arc:
                ctx.arc(value.x * radius, value.y * radius, segment.values[index2].x * radius, segment.values[index3].x, segment.values[index3].y);
                break;
            case (0, $f25aeb234844b825$export$a9fc50c2011c4fb3).ellipse:
                ctx.ellipse(value.x * radius, value.y * radius, segment.values[index2].x * radius, segment.values[index2].y * radius, segment.values[index3].x, segment.values[index4].x, segment.values[index4].y);
        }
    }
    if (!path.half) return;
    const lengthOffset = 1, minLength = 0;
    for(let i = path.segments.length - lengthOffset; i >= minLength; i--){
        const segment = path.segments[i], value = segment.values[firstIndex], index2 = 1, index3 = 2;
        switch(segment.type){
            case (0, $f25aeb234844b825$export$a9fc50c2011c4fb3).line:
                ctx.lineTo(value.x * -radius, value.y * radius);
                break;
            case (0, $f25aeb234844b825$export$a9fc50c2011c4fb3).bezier:
                ctx.bezierCurveTo(-segment.values[index3].x * radius, segment.values[index3].y * radius, -segment.values[index2].x * radius, segment.values[index2].y * radius, value.x * radius, value.y * radius);
                break;
            case (0, $f25aeb234844b825$export$a9fc50c2011c4fb3).quadratic:
                ctx.quadraticCurveTo(-segment.values[index2].x * radius, segment.values[index2].y * radius, -segment.values[index3].x * radius, segment.values[index3].y * radius);
                break;
            case (0, $f25aeb234844b825$export$a9fc50c2011c4fb3).arc:
            case (0, $f25aeb234844b825$export$a9fc50c2011c4fb3).ellipse:
            default:
                break;
        }
    }
}


class $c4ce85de95b12fdc$export$91a37eba35b8c6ea {
    constructor(){
        this.validTypes = [
            "path"
        ];
    }
    draw(data) {
        const { context: context, particle: particle, radius: radius } = data;
        if (!particle.pathData) return;
        (0, $6f4f65c6258536f4$export$f89e19e593add7bd)(context, radius, particle.pathData);
    }
    particleInit(container, particle) {
        const shape = particle.shapeData;
        if (!shape) return;
        particle.pathData = (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)({}, shape);
    }
}


async function $4c1bfbde15ab6ae0$export$4cb625f63f063ade(engine, refresh = true) {
    await engine.addShape(new (0, $c4ce85de95b12fdc$export$91a37eba35b8c6ea)(), refresh);
}



class $d18ff2443f57a812$export$767ef9b4d2ed50ea {
    constructor(x, y, z){
        this.x = x;
        this.y = y;
        this.z = z;
    }
    dot2(x, y) {
        return this.x * x + this.y * y;
    }
    dot3(x, y, z) {
        return this.dot2(x, y) + this.z * z;
    }
}


class $a28a7e72c2ba7dd8$export$4d4b63f87a613bde {
    constructor(){
        this._grad3 = [
            new (0, $d18ff2443f57a812$export$767ef9b4d2ed50ea)(1, 1, 0),
            new (0, $d18ff2443f57a812$export$767ef9b4d2ed50ea)(-1, 1, 0),
            new (0, $d18ff2443f57a812$export$767ef9b4d2ed50ea)(1, -1, 0),
            new (0, $d18ff2443f57a812$export$767ef9b4d2ed50ea)(-1, -1, 0),
            new (0, $d18ff2443f57a812$export$767ef9b4d2ed50ea)(1, 0, 1),
            new (0, $d18ff2443f57a812$export$767ef9b4d2ed50ea)(-1, 0, 1),
            new (0, $d18ff2443f57a812$export$767ef9b4d2ed50ea)(1, 0, -1),
            new (0, $d18ff2443f57a812$export$767ef9b4d2ed50ea)(-1, 0, -1),
            new (0, $d18ff2443f57a812$export$767ef9b4d2ed50ea)(0, 1, 1),
            new (0, $d18ff2443f57a812$export$767ef9b4d2ed50ea)(0, -1, 1),
            new (0, $d18ff2443f57a812$export$767ef9b4d2ed50ea)(0, 1, -1),
            new (0, $d18ff2443f57a812$export$767ef9b4d2ed50ea)(0, -1, -1)
        ];
        this._p = [
            151,
            160,
            137,
            91,
            90,
            15,
            131,
            13,
            201,
            95,
            96,
            53,
            194,
            233,
            7,
            225,
            140,
            36,
            103,
            30,
            69,
            142,
            8,
            99,
            37,
            240,
            21,
            10,
            23,
            190,
            6,
            148,
            247,
            120,
            234,
            75,
            0,
            26,
            197,
            62,
            94,
            252,
            219,
            203,
            117,
            35,
            11,
            32,
            57,
            177,
            33,
            88,
            237,
            149,
            56,
            87,
            174,
            20,
            125,
            136,
            171,
            168,
            68,
            175,
            74,
            165,
            71,
            134,
            139,
            48,
            27,
            166,
            77,
            146,
            158,
            231,
            83,
            111,
            229,
            122,
            60,
            211,
            133,
            230,
            220,
            105,
            92,
            41,
            55,
            46,
            245,
            40,
            244,
            102,
            143,
            54,
            65,
            25,
            63,
            161,
            1,
            216,
            80,
            73,
            209,
            76,
            132,
            187,
            208,
            89,
            18,
            169,
            200,
            196,
            135,
            130,
            116,
            188,
            159,
            86,
            164,
            100,
            109,
            198,
            173,
            186,
            3,
            64,
            52,
            217,
            226,
            250,
            124,
            123,
            5,
            202,
            38,
            147,
            118,
            126,
            255,
            82,
            85,
            212,
            207,
            206,
            59,
            227,
            47,
            16,
            58,
            17,
            182,
            189,
            28,
            42,
            223,
            183,
            170,
            213,
            119,
            248,
            152,
            2,
            44,
            154,
            163,
            70,
            221,
            153,
            101,
            155,
            167,
            43,
            172,
            9,
            129,
            22,
            39,
            253,
            19,
            98,
            108,
            110,
            79,
            113,
            224,
            232,
            178,
            185,
            112,
            104,
            218,
            246,
            97,
            228,
            251,
            34,
            242,
            193,
            238,
            210,
            144,
            12,
            191,
            179,
            162,
            241,
            81,
            51,
            145,
            235,
            249,
            14,
            239,
            107,
            49,
            192,
            214,
            31,
            181,
            199,
            106,
            157,
            184,
            84,
            204,
            176,
            115,
            121,
            50,
            45,
            127,
            4,
            150,
            254,
            138,
            236,
            205,
            93,
            222,
            114,
            67,
            29,
            24,
            72,
            243,
            141,
            128,
            195,
            78,
            66,
            215,
            61,
            156,
            180
        ];
        this._gradP = new Array(512);
        this._perm = new Array(512);
    }
    noise2d(x, y) {
        const { _gradP: _gradP, _perm: _perm } = this;
        let X = Math.floor(x), Y = Math.floor(y);
        x = x - X;
        y = y - Y;
        X = X & 255;
        Y = Y & 255;
        const n00 = _gradP[X + _perm[Y]].dot2(x, y), n01 = _gradP[X + _perm[Y + 1]].dot2(x, y - 1), n10 = _gradP[X + 1 + _perm[Y]].dot2(x - 1, y), n11 = _gradP[X + 1 + _perm[Y + 1]].dot2(x - 1, y - 1);
        const u = this._fade(x);
        return this._lerp(this._lerp(n00, n10, u), this._lerp(n01, n11, u), this._fade(y));
    }
    noise3d(x, y, z) {
        const { _gradP: gradP, _perm: perm } = this;
        let X = Math.floor(x), Y = Math.floor(y), Z = Math.floor(z);
        x = x - X;
        y = y - Y;
        z = z - Z;
        X = X & 255;
        Y = Y & 255;
        Z = Z & 255;
        const n000 = gradP[X + perm[Y + perm[Z]]].dot3(x, y, z), n001 = gradP[X + perm[Y + perm[Z + 1]]].dot3(x, y, z - 1), n010 = gradP[X + perm[Y + 1 + perm[Z]]].dot3(x, y - 1, z), n011 = gradP[X + perm[Y + 1 + perm[Z + 1]]].dot3(x, y - 1, z - 1), n100 = gradP[X + 1 + perm[Y + perm[Z]]].dot3(x - 1, y, z), n101 = gradP[X + 1 + perm[Y + perm[Z + 1]]].dot3(x - 1, y, z - 1), n110 = gradP[X + 1 + perm[Y + 1 + perm[Z]]].dot3(x - 1, y - 1, z), n111 = gradP[X + 1 + perm[Y + 1 + perm[Z + 1]]].dot3(x - 1, y - 1, z - 1), u = this._fade(x), v = this._fade(y), w = this._fade(z);
        return this._lerp(this._lerp(this._lerp(n000, n100, u), this._lerp(n001, n101, u), w), this._lerp(this._lerp(n010, n110, u), this._lerp(n011, n111, u), w), v);
    }
    seed(inputSeed) {
        const { _grad3: grad3, _gradP: gradP, _perm: perm, _p: p } = this;
        let seed = inputSeed;
        if (seed > 0 && seed < 1) seed *= 65536;
        seed = Math.floor(seed);
        if (seed < 256) seed |= seed << 8;
        for(let i = 0; i < 256; i++){
            const v = i & 1 ? p[i] ^ seed & 255 : p[i] ^ seed >> 8 & 255;
            perm[i] = perm[i + 256] = v;
            gradP[i] = gradP[i + 256] = grad3[v % 12];
        }
    }
    _fade(t) {
        return t * t * t * (t * (t * 6 - 15) + 10);
    }
    _lerp(a, b, t) {
        return (1 - t) * a + t * b;
    }
}




const $27063a7a513a9b63$var$double = 2, $27063a7a513a9b63$var$doublePI = Math.PI * $27063a7a513a9b63$var$double, $27063a7a513a9b63$var$defaultOptions = {
    draw: false,
    size: 20,
    increment: 0.004,
    columns: 0,
    rows: 0,
    width: 0,
    height: 0,
    factor: {
        angle: 0.02,
        length: 0.01
    },
    offset: {
        x: 40000,
        y: 40000
    }
};
class $27063a7a513a9b63$export$5df0e553ffc4cfe {
    constructor(){
        this._calculateField = ()=>{
            const { field: field, noiseGen: noiseGen, options: options } = this, lengthFactor = options.factor.length, angleFactor = options.factor.angle;
            for(let x = 0; x < options.columns; x++){
                const column = field[x];
                for(let y = 0; y < options.rows; y++){
                    const cell = column[y];
                    cell.length = noiseGen.noise3d(x * lengthFactor + options.offset.x, y * lengthFactor + options.offset.y, this.noiseZ);
                    cell.angle = noiseGen.noise3d(x * angleFactor, y * angleFactor, this.noiseZ) * $27063a7a513a9b63$var$doublePI;
                }
            }
        };
        this._drawField = (ctx)=>{
            const { field: field, options: options } = this;
            for(let x = 0; x < options.columns; x++){
                const column = field[x];
                for(let y = 0; y < options.rows; y++){
                    const cell = column[y], { angle: angle, length: length } = cell;
                    ctx.setTransform(1, 0, 0, 1, x * this.options.size, y * this.options.size);
                    ctx.rotate(angle);
                    ctx.strokeStyle = "white";
                    ctx.beginPath();
                    ctx.moveTo(0, 0);
                    ctx.lineTo(0, this.options.size * length);
                    ctx.stroke();
                    ctx.setTransform(1, 0, 0, 1, 0, 0);
                }
            }
        };
        this._initField = ()=>{
            const { columns: columns, rows: rows } = this.options;
            this.field = new Array(columns);
            for(let x = 0; x < columns; x++){
                this.field[x] = new Array(rows);
                for(let y = 0; y < rows; y++)this.field[x][y] = (0, $04697537ec8dce5b$export$9b781de7bf37bf48).origin;
            }
        };
        this.noiseGen = new (0, $a28a7e72c2ba7dd8$export$4d4b63f87a613bde)();
        this.field = [];
        this.noiseZ = 0;
        this.options = (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)({}, $27063a7a513a9b63$var$defaultOptions);
    }
    generate(particle) {
        const pos = particle.getPosition(), { size: size } = this.options, point = {
            x: Math.max(Math.floor(pos.x / size), 0),
            y: Math.max(Math.floor(pos.y / size), 0)
        }, { field: field } = this;
        return !field?.[point.x]?.[point.y] ? (0, $04697537ec8dce5b$export$9b781de7bf37bf48).origin : field[point.x][point.y].copy();
    }
    init(container) {
        this.container = container;
        this._setup();
    }
    reset() {}
    update() {
        if (!this.container) return;
        this._calculateField();
        this.noiseZ += this.options.increment;
        if (this.options.draw) this.container.canvas.draw((ctx)=>this._drawField(ctx));
    }
    _resetField() {
        const container = this.container;
        if (!container) return;
        const sourceOptions = container.actualOptions.particles.move.path.options, { options: options } = this;
        options.size = sourceOptions.size > 0 ? sourceOptions.size : $27063a7a513a9b63$var$defaultOptions.size;
        options.increment = sourceOptions.increment > 0 ? sourceOptions.increment : $27063a7a513a9b63$var$defaultOptions.increment;
        options.draw = !!sourceOptions.draw;
        const offset = sourceOptions.offset;
        options.offset.x = offset?.x ?? $27063a7a513a9b63$var$defaultOptions.offset.x;
        options.offset.y = offset?.y ?? $27063a7a513a9b63$var$defaultOptions.offset.y;
        const factor = sourceOptions.factor;
        options.factor.angle = factor?.angle ?? $27063a7a513a9b63$var$defaultOptions.factor.angle;
        options.factor.length = factor?.length ?? $27063a7a513a9b63$var$defaultOptions.factor.length;
        options.width = container.canvas.size.width;
        options.height = container.canvas.size.height;
        this.options.seed = sourceOptions.seed;
        this.noiseGen.seed(this.options.seed ?? (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)());
        options.columns = Math.floor(this.options.width / this.options.size) + 1;
        options.rows = Math.floor(this.options.height / this.options.size) + 1;
        this._initField();
    }
    _setup() {
        this.noiseZ = 0;
        this._resetField();
        window.addEventListener("resize", ()=>this._resetField());
    }
}


const $9967d8ae398d0049$export$59ab943ef89b3536 = "perlinNoise";
async function $9967d8ae398d0049$export$273036b4e93b2f7f(engine, refresh = true) {
    await engine.addPathGenerator($9967d8ae398d0049$export$59ab943ef89b3536, new (0, $27063a7a513a9b63$export$5df0e553ffc4cfe)(), refresh);
}


class $ba13ce1aaa65cc78$export$a66fd6fed4096057 {
    constructor(){
        this.enable = false;
        this.dimensions = 2;
        this.radius = 0;
        this.retries = 30;
        this.steps = 0;
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.dimensions !== undefined) this.dimensions = data.dimensions;
        if (data.radius !== undefined) this.radius = data.radius;
        if (data.retries !== undefined) this.retries = data.retries;
    }
}




const $567f26754a4c2d16$var$double = 2, $567f26754a4c2d16$var$doublePI = Math.PI * $567f26754a4c2d16$var$double;
class $567f26754a4c2d16$export$32f6a267db7d0d89 {
    constructor(size, radius, retries, dimensions, firstPoint){
        this.size = {
            ...size
        };
        this.radius = radius;
        this.retries = retries;
        this.dimensions = dimensions;
        this.cellSize = Math.floor(this.radius / Math.sqrt(this.dimensions));
        this.cols = Math.floor(this.size.width / this.cellSize);
        this.rows = Math.floor(this.size.height / this.cellSize);
        this.points = [];
        this.active = [];
        this.grid = [];
        this.firstPoint = firstPoint ? {
            ...firstPoint
        } : undefined;
        this.reset();
    }
    addPoint(inputPoint) {
        const point = {
            position: {
                ...inputPoint
            },
            gridPosition: {
                x: Math.floor(inputPoint.x / this.cellSize),
                y: Math.floor(inputPoint.y / this.cellSize)
            }
        }, pointIndex = this.points.length;
        this.points.push(point);
        this.grid[point.gridPosition.y][point.gridPosition.x] = pointIndex;
        this.active.push(pointIndex);
    }
    getRandom(min, max) {
        return Math.floor((0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * (max - min)) + min;
    }
    initialiseGrid() {
        for(let y = 0; y <= this.rows; y++){
            this.grid[y] = [];
            for(let x = 0; x <= this.cols; x++)this.grid[y][x] = -1;
        }
    }
    reset() {
        this.points = [];
        this.active = [];
        this.grid = [];
        this.initialiseGrid();
        if (this.firstPoint) this.addPoint(this.firstPoint);
        else {
            const minCoordinate = 0;
            this.addPoint({
                x: this.getRandom(minCoordinate, this.size.width),
                y: this.getRandom(minCoordinate, this.size.height)
            });
        }
    }
    async run() {
        this.reset();
        const minCount = 0, step = 1;
        while(this.active.length > minCount)await this.steps(step);
    }
    async steps(steps) {
        const minCount = 0;
        for(let i = 0; i < steps; i++){
            if (this.active.length <= minCount) continue;
            await this._step();
        }
    }
    _getNewPoint(currentPoint, tries) {
        const minCoordinate = 0, gridMinValue = 0, maxNeighbourIndex = 1, newAngle = tries * ($567f26754a4c2d16$var$doublePI / this.retries), newDist = this.getRandom(this.radius, this.radius * $567f26754a4c2d16$var$double), offset = {
            x: Math.cos(newAngle) * newDist,
            y: Math.sin(newAngle) * newDist
        }, newPoint = {
            x: Math.floor(currentPoint.position.x + offset.x),
            y: Math.floor(currentPoint.position.y + offset.y)
        }, newGridCoords = {
            x: Math.floor(newPoint.x / this.cellSize),
            y: Math.floor(newPoint.y / this.cellSize)
        };
        if (newPoint.x > minCoordinate && newPoint.x < this.size.width && newPoint.y > minCoordinate && newPoint.y < this.size.height) {
            if (this.grid[newGridCoords.y][newGridCoords.x] < gridMinValue) {
                for(let i = -1; i <= maxNeighbourIndex; i++)for(let j = -1; j <= maxNeighbourIndex; j++){
                    const neighbourGrid = {
                        x: newGridCoords.x + j,
                        y: newGridCoords.y + i
                    };
                    if (neighbourGrid.x >= minCoordinate && neighbourGrid.y >= minCoordinate && neighbourGrid.x < this.cols && neighbourGrid.y < this.rows && (neighbourGrid.x !== newGridCoords.x || neighbourGrid.y !== newGridCoords.y)) {
                        if (this.grid[neighbourGrid.y][neighbourGrid.x] >= gridMinValue) {
                            const neighbourIndex = this.grid[neighbourGrid.y][neighbourGrid.x], neighbour = this.points[neighbourIndex], dist = (0, $1ff4dfb77b7bb646$export$79376507b09a66f)(newPoint, neighbour.position);
                            if (dist < this.radius) return;
                        }
                    }
                }
            } else return;
        } else return;
        return newPoint;
    }
    async _step() {
        const minCount = 0, randomActive = this.getRandom(minCount, this.active.length);
        return new Promise((resolve)=>{
            let foundNewPoint = false;
            for(let tries = 0; tries < this.retries; tries++){
                const newPoint = this._getNewPoint(this.points[this.active[randomActive]], tries);
                if (newPoint) {
                    foundNewPoint = true;
                    this.addPoint(newPoint);
                    break;
                }
            }
            if (!foundNewPoint) {
                const deleteCount = 1;
                this.active.splice(randomActive, deleteCount);
            }
            resolve();
        });
    }
}


class $0e61fec2c9cfbd06$export$43e775eee7f99189 {
    constructor(container, engine){
        this._container = container;
        this._engine = engine;
        this._currentIndex = 0;
    }
    async init() {
        await this._initData();
    }
    particlePosition(position) {
        const container = this._container, options = container.actualOptions.poisson;
        if (!this.poissonDisc || !(options?.enable ?? false) || this._currentIndex >= this.poissonDisc.points.length) return;
        return position ?? this.poissonDisc?.points[this._currentIndex++]?.position;
    }
    resize() {
        const container = this._container, options = container.actualOptions.poisson;
        if (!(options?.enable ?? false)) return;
        if (this.redrawTimeout) clearTimeout(this.redrawTimeout);
        const timeout = 250;
        this.redrawTimeout = window.setTimeout(()=>{
            (async ()=>{
                await this._initData();
                await container.particles.redraw();
            })();
        }, timeout);
    }
    stop() {
        delete this.poissonDisc;
    }
    async _initData() {
        const container = this._container, poissonOptions = container.actualOptions.poisson, particlesOptions = container.actualOptions.particles, canvasSize = container.canvas.size, pixelRatio = container.retina.pixelRatio;
        if (!poissonOptions?.enable) return;
        this._currentIndex = 0;
        this.poissonDisc = new (0, $567f26754a4c2d16$export$32f6a267db7d0d89)(canvasSize, poissonOptions.radius ? poissonOptions.radius * pixelRatio : Math.max((0, $1ff4dfb77b7bb646$export$27d2c76f835d583d)(particlesOptions.size.value) * pixelRatio, Math.sqrt(canvasSize.width * canvasSize.height / particlesOptions.number.value)), poissonOptions.retries, poissonOptions.dimensions);
        const noSteps = 0;
        if (poissonOptions.steps > noSteps) await this.poissonDisc.steps(poissonOptions.steps);
        else await this.poissonDisc.run();
    }
}


class $4c5cd84ac71a10a1$export$8801f86abd7d945 {
    constructor(engine){
        this.id = "poisson";
        this._engine = engine;
    }
    getPlugin(container) {
        return Promise.resolve(new (0, $0e61fec2c9cfbd06$export$43e775eee7f99189)(container, this._engine));
    }
    loadOptions(options, source) {
        if (!this.needsPlugin(options) && !this.needsPlugin(source)) return;
        let poissonOptions = options.poisson;
        if (poissonOptions?.load === undefined) options.poisson = poissonOptions = new (0, $ba13ce1aaa65cc78$export$a66fd6fed4096057)();
        poissonOptions.load(source?.poisson);
    }
    needsPlugin(options) {
        return options?.poisson?.enable ?? false;
    }
}


async function $12c230f71b3cc0e1$export$4ee19d5fe7c038f2(engine, refresh = true) {
    await engine.addPlugin(new (0, $4c5cd84ac71a10a1$export$8801f86abd7d945)(engine), refresh);
}


"use strict";
(function() {
    "use strict";
    try {
        if (typeof window === "undefined") return;
        if (!("SVGPathSeg" in window)) {
            window.SVGPathSeg = function(type, typeAsLetter, owningPathSegList) {
                this.pathSegType = type;
                this.pathSegTypeAsLetter = typeAsLetter;
                this._owningPathSegList = owningPathSegList;
            };
            window.SVGPathSeg.prototype.classname = "SVGPathSeg";
            window.SVGPathSeg.PATHSEG_UNKNOWN = 0;
            window.SVGPathSeg.PATHSEG_CLOSEPATH = 1;
            window.SVGPathSeg.PATHSEG_MOVETO_ABS = 2;
            window.SVGPathSeg.PATHSEG_MOVETO_REL = 3;
            window.SVGPathSeg.PATHSEG_LINETO_ABS = 4;
            window.SVGPathSeg.PATHSEG_LINETO_REL = 5;
            window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS = 6;
            window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL = 7;
            window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS = 8;
            window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL = 9;
            window.SVGPathSeg.PATHSEG_ARC_ABS = 10;
            window.SVGPathSeg.PATHSEG_ARC_REL = 11;
            window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS = 12;
            window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL = 13;
            window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS = 14;
            window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL = 15;
            window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS = 16;
            window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL = 17;
            window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS = 18;
            window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL = 19;
            window.SVGPathSeg.prototype._segmentChanged = function() {
                if (this._owningPathSegList) this._owningPathSegList.segmentChanged(this);
            };
            window.SVGPathSegClosePath = function(owningPathSegList) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CLOSEPATH, "z", owningPathSegList);
            };
            window.SVGPathSegClosePath.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegClosePath.prototype.toString = function() {
                return "[object SVGPathSegClosePath]";
            };
            window.SVGPathSegClosePath.prototype._asPathString = function() {
                return this.pathSegTypeAsLetter;
            };
            window.SVGPathSegClosePath.prototype.clone = function() {
                return new window.SVGPathSegClosePath(undefined);
            };
            window.SVGPathSegMovetoAbs = function(owningPathSegList, x, y) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_MOVETO_ABS, "M", owningPathSegList);
                this._x = x;
                this._y = y;
            };
            window.SVGPathSegMovetoAbs.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegMovetoAbs.prototype.toString = function() {
                return "[object SVGPathSegMovetoAbs]";
            };
            window.SVGPathSegMovetoAbs.prototype._asPathString = function() {
                return `${this.pathSegTypeAsLetter} ${this._x} ${this._y}`;
            };
            window.SVGPathSegMovetoAbs.prototype.clone = function() {
                return new window.SVGPathSegMovetoAbs(undefined, this._x, this._y);
            };
            Object.defineProperty(window.SVGPathSegMovetoAbs.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegMovetoAbs.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegMovetoRel = function(owningPathSegList, x, y) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_MOVETO_REL, "m", owningPathSegList);
                this._x = x;
                this._y = y;
            };
            window.SVGPathSegMovetoRel.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegMovetoRel.prototype.toString = function() {
                return "[object SVGPathSegMovetoRel]";
            };
            window.SVGPathSegMovetoRel.prototype._asPathString = function() {
                return `${this.pathSegTypeAsLetter} ${this._x} ${this._y}`;
            };
            window.SVGPathSegMovetoRel.prototype.clone = function() {
                return new window.SVGPathSegMovetoRel(undefined, this._x, this._y);
            };
            Object.defineProperty(window.SVGPathSegMovetoRel.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegMovetoRel.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegLinetoAbs = function(owningPathSegList, x, y) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_ABS, "L", owningPathSegList);
                this._x = x;
                this._y = y;
            };
            window.SVGPathSegLinetoAbs.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegLinetoAbs.prototype.toString = function() {
                return "[object SVGPathSegLinetoAbs]";
            };
            window.SVGPathSegLinetoAbs.prototype._asPathString = function() {
                return `${this.pathSegTypeAsLetter} ${this._x} ${this._y}`;
            };
            window.SVGPathSegLinetoAbs.prototype.clone = function() {
                return new window.SVGPathSegLinetoAbs(undefined, this._x, this._y);
            };
            Object.defineProperty(window.SVGPathSegLinetoAbs.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegLinetoAbs.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegLinetoRel = function(owningPathSegList, x, y) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_REL, "l", owningPathSegList);
                this._x = x;
                this._y = y;
            };
            window.SVGPathSegLinetoRel.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegLinetoRel.prototype.toString = function() {
                return "[object SVGPathSegLinetoRel]";
            };
            window.SVGPathSegLinetoRel.prototype._asPathString = function() {
                return `${this.pathSegTypeAsLetter} ${this._x} ${this._y}`;
            };
            window.SVGPathSegLinetoRel.prototype.clone = function() {
                return new window.SVGPathSegLinetoRel(undefined, this._x, this._y);
            };
            Object.defineProperty(window.SVGPathSegLinetoRel.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegLinetoRel.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegCurvetoCubicAbs = function(owningPathSegList, x, y, x1, y1, x2, y2) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS, "C", owningPathSegList);
                this._x = x;
                this._y = y;
                this._x1 = x1;
                this._y1 = y1;
                this._x2 = x2;
                this._y2 = y2;
            };
            window.SVGPathSegCurvetoCubicAbs.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegCurvetoCubicAbs.prototype.toString = function() {
                return "[object SVGPathSegCurvetoCubicAbs]";
            };
            window.SVGPathSegCurvetoCubicAbs.prototype._asPathString = function() {
                return `${this.pathSegTypeAsLetter}  ${this._x1} ${this._y1} ${this._x2} ${this._y2} ${this._x} ${this._y}`;
            };
            window.SVGPathSegCurvetoCubicAbs.prototype.clone = function() {
                return new window.SVGPathSegCurvetoCubicAbs(undefined, this._x, this._y, this._x1, this._y1, this._x2, this._y2);
            };
            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x1", {
                get: function() {
                    return this._x1;
                },
                set: function(x1) {
                    this._x1 = x1;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y1", {
                get: function() {
                    return this._y1;
                },
                set: function(y1) {
                    this._y1 = y1;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x2", {
                get: function() {
                    return this._x2;
                },
                set: function(x2) {
                    this._x2 = x2;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y2", {
                get: function() {
                    return this._y2;
                },
                set: function(y2) {
                    this._y2 = y2;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegCurvetoCubicRel = function(owningPathSegList, x, y, x1, y1, x2, y2) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL, "c", owningPathSegList);
                this._x = x;
                this._y = y;
                this._x1 = x1;
                this._y1 = y1;
                this._x2 = x2;
                this._y2 = y2;
            };
            window.SVGPathSegCurvetoCubicRel.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegCurvetoCubicRel.prototype.toString = function() {
                return "[object SVGPathSegCurvetoCubicRel]";
            };
            window.SVGPathSegCurvetoCubicRel.prototype._asPathString = function() {
                return `${this.pathSegTypeAsLetter} ${this._x1} ${this._y1} ${this._x2} ${this._y2} ${this._x} ${this._y}`;
            };
            window.SVGPathSegCurvetoCubicRel.prototype.clone = function() {
                return new window.SVGPathSegCurvetoCubicRel(undefined, this._x, this._y, this._x1, this._y1, this._x2, this._y2);
            };
            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x1", {
                get: function() {
                    return this._x1;
                },
                set: function(x1) {
                    this._x1 = x1;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y1", {
                get: function() {
                    return this._y1;
                },
                set: function(y1) {
                    this._y1 = y1;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x2", {
                get: function() {
                    return this._x2;
                },
                set: function(x2) {
                    this._x2 = x2;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y2", {
                get: function() {
                    return this._y2;
                },
                set: function(y2) {
                    this._y2 = y2;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegCurvetoQuadraticAbs = function(owningPathSegList, x, y, x1, y1) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS, "Q", owningPathSegList);
                this._x = x;
                this._y = y;
                this._x1 = x1;
                this._y1 = y1;
            };
            window.SVGPathSegCurvetoQuadraticAbs.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegCurvetoQuadraticAbs.prototype.toString = function() {
                return "[object SVGPathSegCurvetoQuadraticAbs]";
            };
            window.SVGPathSegCurvetoQuadraticAbs.prototype._asPathString = function() {
                return `${this.pathSegTypeAsLetter} ${this._x1} ${this._y1} ${this._x} ${this._y}`;
            };
            window.SVGPathSegCurvetoQuadraticAbs.prototype.clone = function() {
                return new window.SVGPathSegCurvetoQuadraticAbs(undefined, this._x, this._y, this._x1, this._y1);
            };
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "x1", {
                get: function() {
                    return this._x1;
                },
                set: function(x1) {
                    this._x1 = x1;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "y1", {
                get: function() {
                    return this._y1;
                },
                set: function(y1) {
                    this._y1 = y1;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegCurvetoQuadraticRel = function(owningPathSegList, x, y, x1, y1) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL, "q", owningPathSegList);
                this._x = x;
                this._y = y;
                this._x1 = x1;
                this._y1 = y1;
            };
            window.SVGPathSegCurvetoQuadraticRel.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegCurvetoQuadraticRel.prototype.toString = function() {
                return "[object SVGPathSegCurvetoQuadraticRel]";
            };
            window.SVGPathSegCurvetoQuadraticRel.prototype._asPathString = function() {
                return `${this.pathSegTypeAsLetter} ${this._x1} ${this._y1} ${this._x} ${this._y}`;
            };
            window.SVGPathSegCurvetoQuadraticRel.prototype.clone = function() {
                return new window.SVGPathSegCurvetoQuadraticRel(undefined, this._x, this._y, this._x1, this._y1);
            };
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "x1", {
                get: function() {
                    return this._x1;
                },
                set: function(x1) {
                    this._x1 = x1;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "y1", {
                get: function() {
                    return this._y1;
                },
                set: function(y1) {
                    this._y1 = y1;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegArcAbs = function(owningPathSegList, x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_ARC_ABS, "A", owningPathSegList);
                this._x = x;
                this._y = y;
                this._r1 = r1;
                this._r2 = r2;
                this._angle = angle;
                this._largeArcFlag = largeArcFlag;
                this._sweepFlag = sweepFlag;
            };
            window.SVGPathSegArcAbs.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegArcAbs.prototype.toString = function() {
                return "[object SVGPathSegArcAbs]";
            };
            window.SVGPathSegArcAbs.prototype._asPathString = function() {
                return `${this.pathSegTypeAsLetter} ${this._r1} ${this._r2} ${this._angle} ${this._largeArcFlag ? "1" : "0"} ${this._sweepFlag ? "1" : "0"} ${this._x} ${this._y}`;
            };
            window.SVGPathSegArcAbs.prototype.clone = function() {
                return new window.SVGPathSegArcAbs(undefined, this._x, this._y, this._r1, this._r2, this._angle, this._largeArcFlag, this._sweepFlag);
            };
            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "r1", {
                get: function() {
                    return this._r1;
                },
                set: function(r1) {
                    this._r1 = r1;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "r2", {
                get: function() {
                    return this._r2;
                },
                set: function(r2) {
                    this._r2 = r2;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "angle", {
                get: function() {
                    return this._angle;
                },
                set: function(angle) {
                    this._angle = angle;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "largeArcFlag", {
                get: function() {
                    return this._largeArcFlag;
                },
                set: function(largeArcFlag) {
                    this._largeArcFlag = largeArcFlag;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegArcAbs.prototype, "sweepFlag", {
                get: function() {
                    return this._sweepFlag;
                },
                set: function(sweepFlag) {
                    this._sweepFlag = sweepFlag;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegArcRel = function(owningPathSegList, x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_ARC_REL, "a", owningPathSegList);
                this._x = x;
                this._y = y;
                this._r1 = r1;
                this._r2 = r2;
                this._angle = angle;
                this._largeArcFlag = largeArcFlag;
                this._sweepFlag = sweepFlag;
            };
            window.SVGPathSegArcRel.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegArcRel.prototype.toString = function() {
                return "[object SVGPathSegArcRel]";
            };
            window.SVGPathSegArcRel.prototype._asPathString = function() {
                return `${this.pathSegTypeAsLetter} ${this._r1} ${this._r2} ${this._angle} ${this._largeArcFlag ? "1" : "0"} ${this._sweepFlag ? "1" : "0"} ${this._x} ${this._y}`;
            };
            window.SVGPathSegArcRel.prototype.clone = function() {
                return new window.SVGPathSegArcRel(undefined, this._x, this._y, this._r1, this._r2, this._angle, this._largeArcFlag, this._sweepFlag);
            };
            Object.defineProperty(window.SVGPathSegArcRel.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegArcRel.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegArcRel.prototype, "r1", {
                get: function() {
                    return this._r1;
                },
                set: function(r1) {
                    this._r1 = r1;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegArcRel.prototype, "r2", {
                get: function() {
                    return this._r2;
                },
                set: function(r2) {
                    this._r2 = r2;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegArcRel.prototype, "angle", {
                get: function() {
                    return this._angle;
                },
                set: function(angle) {
                    this._angle = angle;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegArcRel.prototype, "largeArcFlag", {
                get: function() {
                    return this._largeArcFlag;
                },
                set: function(largeArcFlag) {
                    this._largeArcFlag = largeArcFlag;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegArcRel.prototype, "sweepFlag", {
                get: function() {
                    return this._sweepFlag;
                },
                set: function(sweepFlag) {
                    this._sweepFlag = sweepFlag;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegLinetoHorizontalAbs = function(owningPathSegList, x) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS, "H", owningPathSegList);
                this._x = x;
            };
            window.SVGPathSegLinetoHorizontalAbs.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegLinetoHorizontalAbs.prototype.toString = function() {
                return "[object SVGPathSegLinetoHorizontalAbs]";
            };
            window.SVGPathSegLinetoHorizontalAbs.prototype._asPathString = function() {
                return `${this.pathSegTypeAsLetter} ${this._x}`;
            };
            window.SVGPathSegLinetoHorizontalAbs.prototype.clone = function() {
                return new window.SVGPathSegLinetoHorizontalAbs(undefined, this._x);
            };
            Object.defineProperty(window.SVGPathSegLinetoHorizontalAbs.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegLinetoHorizontalRel = function(owningPathSegList, x) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL, "h", owningPathSegList);
                this._x = x;
            };
            window.SVGPathSegLinetoHorizontalRel.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegLinetoHorizontalRel.prototype.toString = function() {
                return "[object SVGPathSegLinetoHorizontalRel]";
            };
            window.SVGPathSegLinetoHorizontalRel.prototype._asPathString = function() {
                return `${this.pathSegTypeAsLetter} ${this._x}`;
            };
            window.SVGPathSegLinetoHorizontalRel.prototype.clone = function() {
                return new window.SVGPathSegLinetoHorizontalRel(undefined, this._x);
            };
            Object.defineProperty(window.SVGPathSegLinetoHorizontalRel.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegLinetoVerticalAbs = function(owningPathSegList, y) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS, "V", owningPathSegList);
                this._y = y;
            };
            window.SVGPathSegLinetoVerticalAbs.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegLinetoVerticalAbs.prototype.toString = function() {
                return "[object SVGPathSegLinetoVerticalAbs]";
            };
            window.SVGPathSegLinetoVerticalAbs.prototype._asPathString = function() {
                return `${this.pathSegTypeAsLetter} ${this._y}`;
            };
            window.SVGPathSegLinetoVerticalAbs.prototype.clone = function() {
                return new window.SVGPathSegLinetoVerticalAbs(undefined, this._y);
            };
            Object.defineProperty(window.SVGPathSegLinetoVerticalAbs.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegLinetoVerticalRel = function(owningPathSegList, y) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL, "v", owningPathSegList);
                this._y = y;
            };
            window.SVGPathSegLinetoVerticalRel.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegLinetoVerticalRel.prototype.toString = function() {
                return "[object SVGPathSegLinetoVerticalRel]";
            };
            window.SVGPathSegLinetoVerticalRel.prototype._asPathString = function() {
                return `${this.pathSegTypeAsLetter} ${this._y}`;
            };
            window.SVGPathSegLinetoVerticalRel.prototype.clone = function() {
                return new window.SVGPathSegLinetoVerticalRel(undefined, this._y);
            };
            Object.defineProperty(window.SVGPathSegLinetoVerticalRel.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegCurvetoCubicSmoothAbs = function(owningPathSegList, x, y, x2, y2) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS, "S", owningPathSegList);
                this._x = x;
                this._y = y;
                this._x2 = x2;
                this._y2 = y2;
            };
            window.SVGPathSegCurvetoCubicSmoothAbs.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegCurvetoCubicSmoothAbs.prototype.toString = function() {
                return "[object SVGPathSegCurvetoCubicSmoothAbs]";
            };
            window.SVGPathSegCurvetoCubicSmoothAbs.prototype._asPathString = function() {
                return `${this.pathSegTypeAsLetter} ${this._x2} ${this._y2} ${this._x} ${this._y}`;
            };
            window.SVGPathSegCurvetoCubicSmoothAbs.prototype.clone = function() {
                return new window.SVGPathSegCurvetoCubicSmoothAbs(undefined, this._x, this._y, this._x2, this._y2);
            };
            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "x2", {
                get: function() {
                    return this._x2;
                },
                set: function(x2) {
                    this._x2 = x2;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "y2", {
                get: function() {
                    return this._y2;
                },
                set: function(y2) {
                    this._y2 = y2;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegCurvetoCubicSmoothRel = function(owningPathSegList, x, y, x2, y2) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL, "s", owningPathSegList);
                this._x = x;
                this._y = y;
                this._x2 = x2;
                this._y2 = y2;
            };
            window.SVGPathSegCurvetoCubicSmoothRel.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegCurvetoCubicSmoothRel.prototype.toString = function() {
                return "[object SVGPathSegCurvetoCubicSmoothRel]";
            };
            window.SVGPathSegCurvetoCubicSmoothRel.prototype._asPathString = function() {
                return `${this.pathSegTypeAsLetter} ${this._x2} ${this._y2} ${this._x} ${this._y}`;
            };
            window.SVGPathSegCurvetoCubicSmoothRel.prototype.clone = function() {
                return new window.SVGPathSegCurvetoCubicSmoothRel(undefined, this._x, this._y, this._x2, this._y2);
            };
            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "x2", {
                get: function() {
                    return this._x2;
                },
                set: function(x2) {
                    this._x2 = x2;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "y2", {
                get: function() {
                    return this._y2;
                },
                set: function(y2) {
                    this._y2 = y2;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegCurvetoQuadraticSmoothAbs = function(owningPathSegList, x, y) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS, "T", owningPathSegList);
                this._x = x;
                this._y = y;
            };
            window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype.toString = function() {
                return "[object SVGPathSegCurvetoQuadraticSmoothAbs]";
            };
            window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype._asPathString = function() {
                return `${this.pathSegTypeAsLetter} ${this._x} ${this._y}`;
            };
            window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype.clone = function() {
                return new window.SVGPathSegCurvetoQuadraticSmoothAbs(undefined, this._x, this._y);
            };
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathSegCurvetoQuadraticSmoothRel = function(owningPathSegList, x, y) {
                window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL, "t", owningPathSegList);
                this._x = x;
                this._y = y;
            };
            window.SVGPathSegCurvetoQuadraticSmoothRel.prototype = Object.create(window.SVGPathSeg.prototype);
            window.SVGPathSegCurvetoQuadraticSmoothRel.prototype.toString = function() {
                return "[object SVGPathSegCurvetoQuadraticSmoothRel]";
            };
            window.SVGPathSegCurvetoQuadraticSmoothRel.prototype._asPathString = function() {
                return `${this.pathSegTypeAsLetter} ${this._x} ${this._y}`;
            };
            window.SVGPathSegCurvetoQuadraticSmoothRel.prototype.clone = function() {
                return new window.SVGPathSegCurvetoQuadraticSmoothRel(undefined, this._x, this._y);
            };
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothRel.prototype, "x", {
                get: function() {
                    return this._x;
                },
                set: function(x) {
                    this._x = x;
                    this._segmentChanged();
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothRel.prototype, "y", {
                get: function() {
                    return this._y;
                },
                set: function(y) {
                    this._y = y;
                    this._segmentChanged();
                },
                enumerable: true
            });
            window.SVGPathElement.prototype.createSVGPathSegClosePath = function() {
                return new window.SVGPathSegClosePath(undefined);
            };
            window.SVGPathElement.prototype.createSVGPathSegMovetoAbs = function(x, y) {
                return new window.SVGPathSegMovetoAbs(undefined, x, y);
            };
            window.SVGPathElement.prototype.createSVGPathSegMovetoRel = function(x, y) {
                return new window.SVGPathSegMovetoRel(undefined, x, y);
            };
            window.SVGPathElement.prototype.createSVGPathSegLinetoAbs = function(x, y) {
                return new window.SVGPathSegLinetoAbs(undefined, x, y);
            };
            window.SVGPathElement.prototype.createSVGPathSegLinetoRel = function(x, y) {
                return new window.SVGPathSegLinetoRel(undefined, x, y);
            };
            window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicAbs = function(x, y, x1, y1, x2, y2) {
                return new window.SVGPathSegCurvetoCubicAbs(undefined, x, y, x1, y1, x2, y2);
            };
            window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicRel = function(x, y, x1, y1, x2, y2) {
                return new window.SVGPathSegCurvetoCubicRel(undefined, x, y, x1, y1, x2, y2);
            };
            window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticAbs = function(x, y, x1, y1) {
                return new window.SVGPathSegCurvetoQuadraticAbs(undefined, x, y, x1, y1);
            };
            window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticRel = function(x, y, x1, y1) {
                return new window.SVGPathSegCurvetoQuadraticRel(undefined, x, y, x1, y1);
            };
            window.SVGPathElement.prototype.createSVGPathSegArcAbs = function(x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
                return new window.SVGPathSegArcAbs(undefined, x, y, r1, r2, angle, largeArcFlag, sweepFlag);
            };
            window.SVGPathElement.prototype.createSVGPathSegArcRel = function(x, y, r1, r2, angle, largeArcFlag, sweepFlag) {
                return new window.SVGPathSegArcRel(undefined, x, y, r1, r2, angle, largeArcFlag, sweepFlag);
            };
            window.SVGPathElement.prototype.createSVGPathSegLinetoHorizontalAbs = function(x) {
                return new window.SVGPathSegLinetoHorizontalAbs(undefined, x);
            };
            window.SVGPathElement.prototype.createSVGPathSegLinetoHorizontalRel = function(x) {
                return new window.SVGPathSegLinetoHorizontalRel(undefined, x);
            };
            window.SVGPathElement.prototype.createSVGPathSegLinetoVerticalAbs = function(y) {
                return new window.SVGPathSegLinetoVerticalAbs(undefined, y);
            };
            window.SVGPathElement.prototype.createSVGPathSegLinetoVerticalRel = function(y) {
                return new window.SVGPathSegLinetoVerticalRel(undefined, y);
            };
            window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicSmoothAbs = function(x, y, x2, y2) {
                return new window.SVGPathSegCurvetoCubicSmoothAbs(undefined, x, y, x2, y2);
            };
            window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicSmoothRel = function(x, y, x2, y2) {
                return new window.SVGPathSegCurvetoCubicSmoothRel(undefined, x, y, x2, y2);
            };
            window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticSmoothAbs = function(x, y) {
                return new window.SVGPathSegCurvetoQuadraticSmoothAbs(undefined, x, y);
            };
            window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticSmoothRel = function(x, y) {
                return new window.SVGPathSegCurvetoQuadraticSmoothRel(undefined, x, y);
            };
            if (!("getPathSegAtLength" in window.SVGPathElement.prototype)) window.SVGPathElement.prototype.getPathSegAtLength = function(distance) {
                if (distance === undefined || !isFinite(distance)) throw "Invalid arguments.";
                const measurementElement = document.createElementNS("http://www.w3.org/2000/svg", "path");
                measurementElement.setAttribute("d", this.getAttribute("d"));
                let lastPathSegment = measurementElement.pathSegList.numberOfItems - 1;
                if (lastPathSegment <= 0) return 0;
                do {
                    measurementElement.pathSegList.removeItem(lastPathSegment);
                    if (distance > measurementElement.getTotalLength()) break;
                    lastPathSegment--;
                }while (lastPathSegment > 0);
                return lastPathSegment;
            };
        }
        if (!("SVGPathSegList" in window) || !("appendItem" in window.SVGPathSegList.prototype)) {
            window.SVGPathSegList = function(pathElement) {
                this._pathElement = pathElement;
                this._list = this._parsePath(this._pathElement.getAttribute("d"));
                this._mutationObserverConfig = {
                    attributes: true,
                    attributeFilter: [
                        "d"
                    ]
                };
                this._pathElementMutationObserver = new MutationObserver(this._updateListFromPathMutations.bind(this));
                this._pathElementMutationObserver.observe(this._pathElement, this._mutationObserverConfig);
            };
            window.SVGPathSegList.prototype.classname = "SVGPathSegList";
            Object.defineProperty(window.SVGPathSegList.prototype, "numberOfItems", {
                get: function() {
                    this._checkPathSynchronizedToList();
                    return this._list.length;
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathSegList.prototype, "length", {
                get: function() {
                    this._checkPathSynchronizedToList();
                    return this._list.length;
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathElement.prototype, "pathSegList", {
                get: function() {
                    if (!this._pathSegList) this._pathSegList = new window.SVGPathSegList(this);
                    return this._pathSegList;
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathElement.prototype, "normalizedPathSegList", {
                get: function() {
                    return this.pathSegList;
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathElement.prototype, "animatedPathSegList", {
                get: function() {
                    return this.pathSegList;
                },
                enumerable: true
            });
            Object.defineProperty(window.SVGPathElement.prototype, "animatedNormalizedPathSegList", {
                get: function() {
                    return this.pathSegList;
                },
                enumerable: true
            });
            window.SVGPathSegList.prototype._checkPathSynchronizedToList = function() {
                this._updateListFromPathMutations(this._pathElementMutationObserver.takeRecords());
            };
            window.SVGPathSegList.prototype._updateListFromPathMutations = function(mutationRecords) {
                if (!this._pathElement) return;
                let hasPathMutations = false;
                mutationRecords.forEach(function(record) {
                    if (record.attributeName == "d") hasPathMutations = true;
                });
                if (hasPathMutations) this._list = this._parsePath(this._pathElement.getAttribute("d"));
            };
            window.SVGPathSegList.prototype._writeListToPath = function() {
                this._pathElementMutationObserver.disconnect();
                this._pathElement.setAttribute("d", window.SVGPathSegList._pathSegArrayAsString(this._list));
                this._pathElementMutationObserver.observe(this._pathElement, this._mutationObserverConfig);
            };
            window.SVGPathSegList.prototype.segmentChanged = function() {
                this._writeListToPath();
            };
            window.SVGPathSegList.prototype.clear = function() {
                this._checkPathSynchronizedToList();
                this._list.forEach(function(pathSeg) {
                    pathSeg._owningPathSegList = null;
                });
                this._list = [];
                this._writeListToPath();
            };
            window.SVGPathSegList.prototype.initialize = function(newItem) {
                this._checkPathSynchronizedToList();
                this._list = [
                    newItem
                ];
                newItem._owningPathSegList = this;
                this._writeListToPath();
                return newItem;
            };
            window.SVGPathSegList.prototype._checkValidIndex = function(index) {
                if (isNaN(index) || index < 0 || index >= this.numberOfItems) throw "INDEX_SIZE_ERR";
            };
            window.SVGPathSegList.prototype.getItem = function(index) {
                this._checkPathSynchronizedToList();
                this._checkValidIndex(index);
                return this._list[index];
            };
            window.SVGPathSegList.prototype.insertItemBefore = function(newItem, index) {
                this._checkPathSynchronizedToList();
                if (index > this.numberOfItems) index = this.numberOfItems;
                if (newItem._owningPathSegList) newItem = newItem.clone();
                this._list.splice(index, 0, newItem);
                newItem._owningPathSegList = this;
                this._writeListToPath();
                return newItem;
            };
            window.SVGPathSegList.prototype.replaceItem = function(newItem, index) {
                this._checkPathSynchronizedToList();
                if (newItem._owningPathSegList) newItem = newItem.clone();
                this._checkValidIndex(index);
                this._list[index] = newItem;
                newItem._owningPathSegList = this;
                this._writeListToPath();
                return newItem;
            };
            window.SVGPathSegList.prototype.removeItem = function(index) {
                this._checkPathSynchronizedToList();
                this._checkValidIndex(index);
                const item = this._list[index];
                this._list.splice(index, 1);
                this._writeListToPath();
                return item;
            };
            window.SVGPathSegList.prototype.appendItem = function(newItem) {
                this._checkPathSynchronizedToList();
                if (newItem._owningPathSegList) newItem = newItem.clone();
                this._list.push(newItem);
                newItem._owningPathSegList = this;
                this._writeListToPath();
                return newItem;
            };
            window.SVGPathSegList._pathSegArrayAsString = function(pathSegArray) {
                let string = "";
                let first = true;
                pathSegArray.forEach(function(pathSeg) {
                    if (first) {
                        first = false;
                        string += pathSeg._asPathString();
                    } else string += ` ${pathSeg._asPathString()}`;
                });
                return string;
            };
            window.SVGPathSegList.prototype._parsePath = function(string) {
                if (!string || !string.length) return [];
                const owningPathSegList = this;
                const Builder = function() {
                    this.pathSegList = [];
                };
                Builder.prototype.appendSegment = function(pathSeg) {
                    this.pathSegList.push(pathSeg);
                };
                const Source = function(string) {
                    this._string = string;
                    this._currentIndex = 0;
                    this._endIndex = this._string.length;
                    this._previousCommand = window.SVGPathSeg.PATHSEG_UNKNOWN;
                    this._skipOptionalSpaces();
                };
                Source.prototype._isCurrentSpace = function() {
                    const character = this._string[this._currentIndex];
                    return character <= " " && (character == " " || character == "\n" || character == "	" || character == "\r" || character == "\f");
                };
                Source.prototype._skipOptionalSpaces = function() {
                    while(this._currentIndex < this._endIndex && this._isCurrentSpace())this._currentIndex++;
                    return this._currentIndex < this._endIndex;
                };
                Source.prototype._skipOptionalSpacesOrDelimiter = function() {
                    if (this._currentIndex < this._endIndex && !this._isCurrentSpace() && this._string.charAt(this._currentIndex) != ",") return false;
                    if (this._skipOptionalSpaces()) {
                        if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == ",") {
                            this._currentIndex++;
                            this._skipOptionalSpaces();
                        }
                    }
                    return this._currentIndex < this._endIndex;
                };
                Source.prototype.hasMoreData = function() {
                    return this._currentIndex < this._endIndex;
                };
                Source.prototype.peekSegmentType = function() {
                    const lookahead = this._string[this._currentIndex];
                    return this._pathSegTypeFromChar(lookahead);
                };
                Source.prototype._pathSegTypeFromChar = function(lookahead) {
                    switch(lookahead){
                        case "Z":
                        case "z":
                            return window.SVGPathSeg.PATHSEG_CLOSEPATH;
                        case "M":
                            return window.SVGPathSeg.PATHSEG_MOVETO_ABS;
                        case "m":
                            return window.SVGPathSeg.PATHSEG_MOVETO_REL;
                        case "L":
                            return window.SVGPathSeg.PATHSEG_LINETO_ABS;
                        case "l":
                            return window.SVGPathSeg.PATHSEG_LINETO_REL;
                        case "C":
                            return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS;
                        case "c":
                            return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL;
                        case "Q":
                            return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS;
                        case "q":
                            return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL;
                        case "A":
                            return window.SVGPathSeg.PATHSEG_ARC_ABS;
                        case "a":
                            return window.SVGPathSeg.PATHSEG_ARC_REL;
                        case "H":
                            return window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS;
                        case "h":
                            return window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL;
                        case "V":
                            return window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS;
                        case "v":
                            return window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL;
                        case "S":
                            return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS;
                        case "s":
                            return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL;
                        case "T":
                            return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS;
                        case "t":
                            return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL;
                        default:
                            return window.SVGPathSeg.PATHSEG_UNKNOWN;
                    }
                };
                Source.prototype._nextCommandHelper = function(lookahead, previousCommand) {
                    if ((lookahead == "+" || lookahead == "-" || lookahead == "." || lookahead >= "0" && lookahead <= "9") && previousCommand != window.SVGPathSeg.PATHSEG_CLOSEPATH) {
                        if (previousCommand == window.SVGPathSeg.PATHSEG_MOVETO_ABS) return window.SVGPathSeg.PATHSEG_LINETO_ABS;
                        if (previousCommand == window.SVGPathSeg.PATHSEG_MOVETO_REL) return window.SVGPathSeg.PATHSEG_LINETO_REL;
                        return previousCommand;
                    }
                    return window.SVGPathSeg.PATHSEG_UNKNOWN;
                };
                Source.prototype.initialCommandIsMoveTo = function() {
                    if (!this.hasMoreData()) return true;
                    const command = this.peekSegmentType();
                    return command == window.SVGPathSeg.PATHSEG_MOVETO_ABS || command == window.SVGPathSeg.PATHSEG_MOVETO_REL;
                };
                Source.prototype._parseNumber = function() {
                    let exponent = 0;
                    let integer = 0;
                    let frac = 1;
                    let decimal = 0;
                    let sign = 1;
                    let expsign = 1;
                    const startIndex = this._currentIndex;
                    this._skipOptionalSpaces();
                    if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == "+") this._currentIndex++;
                    else if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == "-") {
                        this._currentIndex++;
                        sign = -1;
                    }
                    if (this._currentIndex == this._endIndex || (this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9") && this._string.charAt(this._currentIndex) != ".") return undefined;
                    const startIntPartIndex = this._currentIndex;
                    while(this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9")this._currentIndex++;
                    if (this._currentIndex != startIntPartIndex) {
                        let scanIntPartIndex = this._currentIndex - 1;
                        let multiplier = 1;
                        while(scanIntPartIndex >= startIntPartIndex){
                            integer += multiplier * (this._string.charAt(scanIntPartIndex--) - "0");
                            multiplier *= 10;
                        }
                    }
                    if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == ".") {
                        this._currentIndex++;
                        if (this._currentIndex >= this._endIndex || this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9") return undefined;
                        while(this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9"){
                            frac *= 10;
                            decimal += (this._string.charAt(this._currentIndex) - "0") / frac;
                            this._currentIndex += 1;
                        }
                    }
                    if (this._currentIndex != startIndex && this._currentIndex + 1 < this._endIndex && (this._string.charAt(this._currentIndex) == "e" || this._string.charAt(this._currentIndex) == "E") && this._string.charAt(this._currentIndex + 1) != "x" && this._string.charAt(this._currentIndex + 1) != "m") {
                        this._currentIndex++;
                        if (this._string.charAt(this._currentIndex) == "+") this._currentIndex++;
                        else if (this._string.charAt(this._currentIndex) == "-") {
                            this._currentIndex++;
                            expsign = -1;
                        }
                        if (this._currentIndex >= this._endIndex || this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9") return undefined;
                        while(this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9"){
                            exponent *= 10;
                            exponent += this._string.charAt(this._currentIndex) - "0";
                            this._currentIndex++;
                        }
                    }
                    let number = integer + decimal;
                    number *= sign;
                    if (exponent) number *= Math.pow(10, expsign * exponent);
                    if (startIndex == this._currentIndex) return undefined;
                    this._skipOptionalSpacesOrDelimiter();
                    return number;
                };
                Source.prototype._parseArcFlag = function() {
                    if (this._currentIndex >= this._endIndex) return undefined;
                    let flag = false;
                    const flagChar = this._string.charAt(this._currentIndex++);
                    if (flagChar == "0") flag = false;
                    else if (flagChar == "1") flag = true;
                    else return undefined;
                    this._skipOptionalSpacesOrDelimiter();
                    return flag;
                };
                Source.prototype.parseSegment = function() {
                    const lookahead = this._string[this._currentIndex];
                    let command = this._pathSegTypeFromChar(lookahead);
                    if (command == window.SVGPathSeg.PATHSEG_UNKNOWN) {
                        if (this._previousCommand == window.SVGPathSeg.PATHSEG_UNKNOWN) return null;
                        command = this._nextCommandHelper(lookahead, this._previousCommand);
                        if (command == window.SVGPathSeg.PATHSEG_UNKNOWN) return null;
                    } else this._currentIndex++;
                    this._previousCommand = command;
                    let points;
                    switch(command){
                        case window.SVGPathSeg.PATHSEG_MOVETO_REL:
                            return new window.SVGPathSegMovetoRel(owningPathSegList, this._parseNumber(), this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_MOVETO_ABS:
                            return new window.SVGPathSegMovetoAbs(owningPathSegList, this._parseNumber(), this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_LINETO_REL:
                            return new window.SVGPathSegLinetoRel(owningPathSegList, this._parseNumber(), this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_LINETO_ABS:
                            return new window.SVGPathSegLinetoAbs(owningPathSegList, this._parseNumber(), this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL:
                            return new window.SVGPathSegLinetoHorizontalRel(owningPathSegList, this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS:
                            return new window.SVGPathSegLinetoHorizontalAbs(owningPathSegList, this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL:
                            return new window.SVGPathSegLinetoVerticalRel(owningPathSegList, this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS:
                            return new window.SVGPathSegLinetoVerticalAbs(owningPathSegList, this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_CLOSEPATH:
                            this._skipOptionalSpaces();
                            return new window.SVGPathSegClosePath(owningPathSegList);
                        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL:
                            points = {
                                x1: this._parseNumber(),
                                y1: this._parseNumber(),
                                x2: this._parseNumber(),
                                y2: this._parseNumber(),
                                x: this._parseNumber(),
                                y: this._parseNumber()
                            };
                            return new window.SVGPathSegCurvetoCubicRel(owningPathSegList, points.x, points.y, points.x1, points.y1, points.x2, points.y2);
                        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS:
                            points = {
                                x1: this._parseNumber(),
                                y1: this._parseNumber(),
                                x2: this._parseNumber(),
                                y2: this._parseNumber(),
                                x: this._parseNumber(),
                                y: this._parseNumber()
                            };
                            return new window.SVGPathSegCurvetoCubicAbs(owningPathSegList, points.x, points.y, points.x1, points.y1, points.x2, points.y2);
                        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL:
                            points = {
                                x2: this._parseNumber(),
                                y2: this._parseNumber(),
                                x: this._parseNumber(),
                                y: this._parseNumber()
                            };
                            return new window.SVGPathSegCurvetoCubicSmoothRel(owningPathSegList, points.x, points.y, points.x2, points.y2);
                        case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS:
                            points = {
                                x2: this._parseNumber(),
                                y2: this._parseNumber(),
                                x: this._parseNumber(),
                                y: this._parseNumber()
                            };
                            return new window.SVGPathSegCurvetoCubicSmoothAbs(owningPathSegList, points.x, points.y, points.x2, points.y2);
                        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL:
                            points = {
                                x1: this._parseNumber(),
                                y1: this._parseNumber(),
                                x: this._parseNumber(),
                                y: this._parseNumber()
                            };
                            return new window.SVGPathSegCurvetoQuadraticRel(owningPathSegList, points.x, points.y, points.x1, points.y1);
                        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS:
                            points = {
                                x1: this._parseNumber(),
                                y1: this._parseNumber(),
                                x: this._parseNumber(),
                                y: this._parseNumber()
                            };
                            return new window.SVGPathSegCurvetoQuadraticAbs(owningPathSegList, points.x, points.y, points.x1, points.y1);
                        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL:
                            return new window.SVGPathSegCurvetoQuadraticSmoothRel(owningPathSegList, this._parseNumber(), this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS:
                            return new window.SVGPathSegCurvetoQuadraticSmoothAbs(owningPathSegList, this._parseNumber(), this._parseNumber());
                        case window.SVGPathSeg.PATHSEG_ARC_REL:
                            points = {
                                x1: this._parseNumber(),
                                y1: this._parseNumber(),
                                arcAngle: this._parseNumber(),
                                arcLarge: this._parseArcFlag(),
                                arcSweep: this._parseArcFlag(),
                                x: this._parseNumber(),
                                y: this._parseNumber()
                            };
                            return new window.SVGPathSegArcRel(owningPathSegList, points.x, points.y, points.x1, points.y1, points.arcAngle, points.arcLarge, points.arcSweep);
                        case window.SVGPathSeg.PATHSEG_ARC_ABS:
                            points = {
                                x1: this._parseNumber(),
                                y1: this._parseNumber(),
                                arcAngle: this._parseNumber(),
                                arcLarge: this._parseArcFlag(),
                                arcSweep: this._parseArcFlag(),
                                x: this._parseNumber(),
                                y: this._parseNumber()
                            };
                            return new window.SVGPathSegArcAbs(owningPathSegList, points.x, points.y, points.x1, points.y1, points.arcAngle, points.arcLarge, points.arcSweep);
                        default:
                            throw "Unknown path seg type.";
                    }
                };
                const builder = new Builder();
                const source = new Source(string);
                if (!source.initialCommandIsMoveTo()) return [];
                while(source.hasMoreData()){
                    const pathSeg = source.parseSegment();
                    if (!pathSeg) return [];
                    builder.appendSegment(pathSeg);
                }
                return builder.pathSegList;
            };
        }
    } catch (e) {
        console.warn("An error occurred in tsParticles pathseg polyfill. If the Polygon Mask is not working, please open an issue here: https://github.com/tsparticles/tsparticles", e);
    }
})();




class $3a624c531ea39b3a$export$65031851631b233f {
    constructor(){
        this.color = new (0, $c86524210cdfad1b$export$c2b08aa25660fcaa)();
        this.width = 0.5;
        this.opacity = 1;
    }
    load(data) {
        if (!data) return;
        this.color = (0, $c86524210cdfad1b$export$c2b08aa25660fcaa).create(this.color, data.color);
        if ((0, $ad25b6e319f6df8c$export$844ec244b1367d54)(this.color.value)) this.opacity = (0, $fd6faa9f4e5410ac$export$143dda7722fd213d)(this.color.value) ?? this.opacity;
        if (data.opacity !== undefined) this.opacity = data.opacity;
        if (data.width !== undefined) this.width = data.width;
    }
}


class $184b44031effd937$export$1165e476acf25e68 {
    constructor(){
        this.enable = false;
        this.stroke = new (0, $3a624c531ea39b3a$export$65031851631b233f)();
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        const stroke = data.stroke;
        this.stroke.load(stroke);
    }
}


var $f0dfb1cd20500d26$export$6cbf089632abf287;
(function(PolygonMaskInlineArrangement) {
    PolygonMaskInlineArrangement["equidistant"] = "equidistant";
    PolygonMaskInlineArrangement["onePerPoint"] = "one-per-point";
    PolygonMaskInlineArrangement["perPoint"] = "per-point";
    PolygonMaskInlineArrangement["randomLength"] = "random-length";
    PolygonMaskInlineArrangement["randomPoint"] = "random-point";
})($f0dfb1cd20500d26$export$6cbf089632abf287 || ($f0dfb1cd20500d26$export$6cbf089632abf287 = {}));


class $20a4b896fb3a1b2b$export$9c42c70b1a9ca1d5 {
    constructor(){
        this.arrangement = (0, $f0dfb1cd20500d26$export$6cbf089632abf287).onePerPoint;
    }
    load(data) {
        if (!data) return;
        if (data.arrangement !== undefined) this.arrangement = data.arrangement;
    }
}


class $3b43e0be43761810$export$b47a662e1d423ea0 {
    constructor(){
        this.path = [];
        this.size = {
            height: 0,
            width: 0
        };
    }
    load(data) {
        if (!data) return;
        if (data.path !== undefined) this.path = data.path;
        if (data.size !== undefined) {
            if (data.size.width !== undefined) this.size.width = data.size.width;
            if (data.size.height !== undefined) this.size.height = data.size.height;
        }
    }
}


var $241e3852b21e25ec$export$44e4ffab76093d09;
(function(PolygonMaskMoveType) {
    PolygonMaskMoveType["path"] = "path";
    PolygonMaskMoveType["radius"] = "radius";
})($241e3852b21e25ec$export$44e4ffab76093d09 || ($241e3852b21e25ec$export$44e4ffab76093d09 = {}));


class $f45f03426ef5f1ef$export$320efe0955a65dbd {
    constructor(){
        this.radius = 10;
        this.type = (0, $241e3852b21e25ec$export$44e4ffab76093d09).path;
    }
    load(data) {
        if (!data) return;
        if (data.radius !== undefined) this.radius = data.radius;
        if (data.type !== undefined) this.type = data.type;
    }
}


var $cb9eaf2d510804db$export$ccddd95432af39da;
(function(PolygonMaskType) {
    PolygonMaskType["inline"] = "inline";
    PolygonMaskType["inside"] = "inside";
    PolygonMaskType["outside"] = "outside";
    PolygonMaskType["none"] = "none";
})($cb9eaf2d510804db$export$ccddd95432af39da || ($cb9eaf2d510804db$export$ccddd95432af39da = {}));


class $8612b2fc3a5bb050$export$6352cd862da6d1f2 {
    constructor(){
        this.draw = new (0, $184b44031effd937$export$1165e476acf25e68)();
        this.enable = false;
        this.inline = new (0, $20a4b896fb3a1b2b$export$9c42c70b1a9ca1d5)();
        this.move = new (0, $f45f03426ef5f1ef$export$320efe0955a65dbd)();
        this.scale = 1;
        this.type = (0, $cb9eaf2d510804db$export$ccddd95432af39da).none;
    }
    load(data) {
        if (!data) return;
        this.draw.load(data.draw);
        this.inline.load(data.inline);
        this.move.load(data.move);
        if (data.scale !== undefined) this.scale = data.scale;
        if (data.type !== undefined) this.type = data.type;
        if (data.enable !== undefined) this.enable = data.enable;
        else this.enable = this.type !== (0, $cb9eaf2d510804db$export$ccddd95432af39da).none;
        if (data.url !== undefined) this.url = data.url;
        if (data.data !== undefined) {
            if ((0, $ad25b6e319f6df8c$export$844ec244b1367d54)(data.data)) this.data = data.data;
            else {
                this.data = new (0, $3b43e0be43761810$export$b47a662e1d423ea0)();
                this.data.load(data.data);
            }
        }
        if (data.position !== undefined) this.position = (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)({}, data.position);
    }
}




const $429673301a418a2a$var$squareExp = 2, $429673301a418a2a$var$inSegmentRange = {
    min: 0,
    max: 1
}, $429673301a418a2a$var$double = 2;
function $429673301a418a2a$export$5f3afb62a97b18da(context, rawData, stroke) {
    const color = (0, $fd6faa9f4e5410ac$export$fbf0bf3cc1fc0cc4)(stroke.color);
    if (!color) return;
    const firstIndex = 0, firstItem = rawData[firstIndex];
    context.beginPath();
    context.moveTo(firstItem.x, firstItem.y);
    for (const item of rawData)context.lineTo(item.x, item.y);
    context.closePath();
    context.strokeStyle = (0, $fd6faa9f4e5410ac$export$2476af37e47fcae2)(color);
    context.lineWidth = stroke.width;
    context.stroke();
}
function $429673301a418a2a$export$4bf14a4637194898(context, path, stroke, position) {
    const defaultTransform = {
        a: 1,
        b: 0,
        c: 0,
        d: 1
    };
    context.setTransform(defaultTransform.a, defaultTransform.b, defaultTransform.c, defaultTransform.d, position.x, position.y);
    const color = (0, $fd6faa9f4e5410ac$export$fbf0bf3cc1fc0cc4)(stroke.color);
    if (!color) return;
    context.strokeStyle = (0, $fd6faa9f4e5410ac$export$2476af37e47fcae2)(color, stroke.opacity);
    context.lineWidth = stroke.width;
    context.stroke(path);
    context.resetTransform();
}
function $429673301a418a2a$export$c3bde059a94bfd4d(paths, scale, offset) {
    const res = [], defaultCount = 0;
    for (const path of paths){
        const segments = path.element.pathSegList, len = segments?.numberOfItems ?? defaultCount, p = {
            x: 0,
            y: 0
        };
        for(let i = 0; i < len; i++){
            const segment = segments?.getItem(i), svgPathSeg = window.SVGPathSeg;
            switch(segment?.pathSegType){
                case svgPathSeg.PATHSEG_MOVETO_ABS:
                case svgPathSeg.PATHSEG_LINETO_ABS:
                case svgPathSeg.PATHSEG_CURVETO_CUBIC_ABS:
                case svgPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS:
                case svgPathSeg.PATHSEG_ARC_ABS:
                case svgPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS:
                case svgPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS:
                    {
                        const absSeg = segment;
                        p.x = absSeg.x;
                        p.y = absSeg.y;
                        break;
                    }
                case svgPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS:
                    p.x = segment.x;
                    break;
                case svgPathSeg.PATHSEG_LINETO_VERTICAL_ABS:
                    p.y = segment.y;
                    break;
                case svgPathSeg.PATHSEG_LINETO_REL:
                case svgPathSeg.PATHSEG_MOVETO_REL:
                case svgPathSeg.PATHSEG_CURVETO_CUBIC_REL:
                case svgPathSeg.PATHSEG_CURVETO_QUADRATIC_REL:
                case svgPathSeg.PATHSEG_ARC_REL:
                case svgPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL:
                case svgPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL:
                    {
                        const relSeg = segment;
                        p.x += relSeg.x;
                        p.y += relSeg.y;
                        break;
                    }
                case svgPathSeg.PATHSEG_LINETO_HORIZONTAL_REL:
                    p.x += segment.x;
                    break;
                case svgPathSeg.PATHSEG_LINETO_VERTICAL_REL:
                    p.y += segment.y;
                    break;
                case svgPathSeg.PATHSEG_UNKNOWN:
                case svgPathSeg.PATHSEG_CLOSEPATH:
                    continue;
            }
            res.push({
                x: p.x * scale + offset.x,
                y: p.y * scale + offset.y
            });
        }
    }
    return res;
}
function $429673301a418a2a$export$1b689e7ccdba1860(s1, s2, pos) {
    const { dx: dx1, dy: dy1 } = (0, $1ff4dfb77b7bb646$export$c76b58cfe053f228)(pos, s1), { dx: dx2, dy: dy2 } = (0, $1ff4dfb77b7bb646$export$c76b58cfe053f228)(s2, s1), t = (dx1 * dx2 + dy1 * dy2) / (dx2 ** $429673301a418a2a$var$squareExp + dy2 ** $429673301a418a2a$var$squareExp), res = {
        x: s1.x + dx2 * t,
        y: s1.y + dy2 * t,
        isOnSegment: t >= $429673301a418a2a$var$inSegmentRange.min && t <= $429673301a418a2a$var$inSegmentRange.max
    };
    if (t < $429673301a418a2a$var$inSegmentRange.min) {
        res.x = s1.x;
        res.y = s1.y;
    } else if (t > $429673301a418a2a$var$inSegmentRange.max) {
        res.x = s2.x;
        res.y = s2.y;
    }
    return res;
}
function $429673301a418a2a$export$23ef3aa79969cc55(start, stop, velocity) {
    const { dx: dx, dy: dy } = (0, $1ff4dfb77b7bb646$export$c76b58cfe053f228)(start, stop), wallAngle = Math.atan2(dy, dx), wallNormal = (0, $04697537ec8dce5b$export$9b781de7bf37bf48).create(Math.sin(wallAngle), -Math.cos(wallAngle)), d = $429673301a418a2a$var$double * (velocity.x * wallNormal.x + velocity.y * wallNormal.y);
    wallNormal.multTo(d);
    velocity.subFrom(wallNormal);
}




const $e5cb9ac354b13279$var$noPolygonDataLoaded = `${(0, $dec17af1c054e95f$export$adea4917e02d93dc)} No polygon data loaded.`, $e5cb9ac354b13279$var$noPolygonFound = `${(0, $dec17af1c054e95f$export$adea4917e02d93dc)} No polygon found, you need to specify SVG url in config.`, $e5cb9ac354b13279$var$origin = {
    x: 0,
    y: 0
}, $e5cb9ac354b13279$var$half = 0.5, $e5cb9ac354b13279$var$double = 2;
class $e5cb9ac354b13279$export$742f453799c75555 {
    constructor(container, engine){
        this._checkInsidePolygon = (position)=>{
            const container = this._container, options = container.actualOptions.polygon;
            if (!options?.enable || options.type === (0, $cb9eaf2d510804db$export$ccddd95432af39da).none || options.type === (0, $cb9eaf2d510804db$export$ccddd95432af39da).inline) return true;
            if (!this.raw) throw new Error($e5cb9ac354b13279$var$noPolygonFound);
            const canvasSize = container.canvas.size, x = position?.x ?? (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * canvasSize.width, y = position?.y ?? (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * canvasSize.height, indexOffset = 1;
            let inside = false;
            for(let i = 0, j = this.raw.length - indexOffset; i < this.raw.length; j = i++){
                const pi = this.raw[i], pj = this.raw[j], intersect = pi.y > y !== pj.y > y && x < (pj.x - pi.x) * (y - pi.y) / (pj.y - pi.y) + pi.x;
                if (intersect) inside = !inside;
            }
            if (options.type === (0, $cb9eaf2d510804db$export$ccddd95432af39da).inside) return inside;
            else return options.type === (0, $cb9eaf2d510804db$export$ccddd95432af39da).outside ? !inside : false;
        };
        this._createPath2D = ()=>{
            const container = this._container, options = container.actualOptions.polygon;
            if (!options || !this.paths?.length) return;
            for (const path of this.paths){
                const pathData = path.element?.getAttribute("d");
                if (pathData) {
                    const path2d = new Path2D(pathData), matrix = document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGMatrix(), finalPath = new Path2D(), transform = matrix.scale(this._scale);
                    if (finalPath.addPath) {
                        finalPath.addPath(path2d, transform);
                        path.path2d = finalPath;
                    } else delete path.path2d;
                } else delete path.path2d;
                if (path.path2d ?? !this.raw) continue;
                path.path2d = new Path2D();
                const firstIndex = 0, firstPoint = this.raw[firstIndex];
                path.path2d.moveTo(firstPoint.x, firstPoint.y);
                this.raw.forEach((pos, i)=>{
                    if (i > firstIndex) path.path2d?.lineTo(pos.x, pos.y);
                });
                path.path2d.closePath();
            }
        };
        this._downloadSvgPath = async (svgUrl, force)=>{
            const options = this._container.actualOptions.polygon;
            if (!options) return;
            const url = svgUrl ?? options.url, forceDownload = force ?? false;
            if (!url || this.paths !== undefined && !forceDownload) return this.raw;
            const req = await fetch(url);
            if (!req.ok) throw new Error(`${(0, $dec17af1c054e95f$export$adea4917e02d93dc)} occurred during polygon mask download`);
            return this._parseSvgPath(await req.text(), force);
        };
        this._drawPoints = ()=>{
            if (!this.raw) return;
            for (const item of this.raw)this._container.particles.addParticle({
                x: item.x,
                y: item.y
            });
        };
        this._getEquidistantPointByIndex = (index)=>{
            const container = this._container, options = container.actualOptions, polygonMaskOptions = options.polygon;
            if (!polygonMaskOptions) return;
            if (!this.raw?.length || !this.paths?.length) throw new Error($e5cb9ac354b13279$var$noPolygonDataLoaded);
            let offset = 0, point;
            const baseAccumulator = 0, totalLength = this.paths.reduce((tot, path)=>tot + path.length, baseAccumulator), distance = totalLength / options.particles.number.value;
            for (const path of this.paths){
                const pathDistance = distance * index - offset;
                if (pathDistance <= path.length) {
                    point = path.element.getPointAtLength(pathDistance);
                    break;
                } else offset += path.length;
            }
            const scale = this._scale;
            return {
                x: (point?.x ?? $e5cb9ac354b13279$var$origin.x) * scale + (this.offset?.x ?? $e5cb9ac354b13279$var$origin.x),
                y: (point?.y ?? $e5cb9ac354b13279$var$origin.y) * scale + (this.offset?.y ?? $e5cb9ac354b13279$var$origin.y)
            };
        };
        this._getPointByIndex = (index)=>{
            if (!this.raw?.length) throw new Error($e5cb9ac354b13279$var$noPolygonDataLoaded);
            const coords = this.raw[index % this.raw.length];
            return {
                x: coords.x,
                y: coords.y
            };
        };
        this._getRandomPoint = ()=>{
            if (!this.raw?.length) throw new Error($e5cb9ac354b13279$var$noPolygonDataLoaded);
            const coords = (0, $eee2fa4b9ebe63e9$export$3a5d12ca7137122f)(this.raw);
            return {
                x: coords.x,
                y: coords.y
            };
        };
        this._getRandomPointByLength = ()=>{
            const container = this._container, options = container.actualOptions.polygon;
            if (!options) return;
            if (!this.raw?.length || !this.paths?.length) throw new Error($e5cb9ac354b13279$var$noPolygonDataLoaded);
            const path = (0, $eee2fa4b9ebe63e9$export$3a5d12ca7137122f)(this.paths), offset = 1, distance = Math.floor((0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * path.length) + offset, point = path.element.getPointAtLength(distance), scale = this._scale;
            return {
                x: point.x * scale + (this.offset?.x ?? $e5cb9ac354b13279$var$origin.x),
                y: point.y * scale + (this.offset?.y ?? $e5cb9ac354b13279$var$origin.y)
            };
        };
        this._initRawData = async (force)=>{
            const options = this._container.actualOptions.polygon;
            if (!options) return;
            if (options.url) this.raw = await this._downloadSvgPath(options.url, force);
            else if (options.data) {
                const data = options.data;
                let svg;
                if ((0, $ad25b6e319f6df8c$export$844ec244b1367d54)(data)) svg = data;
                else {
                    const getPath = (p)=>`<path d="${p}" />`, path = (0, $ad25b6e319f6df8c$export$43bee75e5e14138e)(data.path) ? data.path.map(getPath).join("") : getPath(data.path);
                    const namespaces = 'xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"';
                    svg = `<svg ${namespaces} width="${data.size.width}" height="${data.size.height}">${path}</svg>`;
                }
                this.raw = this._parseSvgPath(svg, force);
            }
            this._createPath2D();
            this._engine.dispatchEvent("polygonMaskLoaded", {
                container: this._container
            });
        };
        this._parseSvgPath = (xml, force)=>{
            const forceDownload = force ?? false;
            if (this.paths !== undefined && !forceDownload) return this.raw;
            const container = this._container, options = container.actualOptions.polygon;
            if (!options) return;
            const parser = new DOMParser(), doc = parser.parseFromString(xml, "image/svg+xml"), firstIndex = 0, svg = doc.getElementsByTagName("svg")[firstIndex];
            let svgPaths = svg.getElementsByTagName("path");
            if (!svgPaths.length) svgPaths = doc.getElementsByTagName("path");
            this.paths = [];
            for(let i = 0; i < svgPaths.length; i++){
                const path = svgPaths.item(i);
                if (path) this.paths.push({
                    element: path,
                    length: path.getTotalLength()
                });
            }
            const scale = this._scale;
            this.dimension.width = parseFloat(svg.getAttribute("width") ?? "0") * scale;
            this.dimension.height = parseFloat(svg.getAttribute("height") ?? "0") * scale;
            const position = options.position ?? {
                x: 50,
                y: 50
            }, canvasSize = container.canvas.size;
            this.offset = {
                x: canvasSize.width * position.x / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd) - this.dimension.width * $e5cb9ac354b13279$var$half,
                y: canvasSize.height * position.y / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd) - this.dimension.height * $e5cb9ac354b13279$var$half
            };
            return (0, $429673301a418a2a$export$c3bde059a94bfd4d)(this.paths, scale, this.offset);
        };
        this._polygonBounce = (particle, delta, direction)=>{
            const options = this._container.actualOptions.polygon;
            if (!this.raw || !options?.enable || direction !== (0, $0130b9f9f1247165$export$56c1e4693edf08f9).top) return false;
            if (options.type === (0, $cb9eaf2d510804db$export$ccddd95432af39da).inside || options.type === (0, $cb9eaf2d510804db$export$ccddd95432af39da).outside) {
                let closest, dx, dy;
                const pos = particle.getPosition(), radius = particle.getRadius(), offset = 1;
                for(let i = 0, j = this.raw.length - offset; i < this.raw.length; j = i++){
                    const pi = this.raw[i], pj = this.raw[j];
                    closest = (0, $429673301a418a2a$export$1b689e7ccdba1860)(pi, pj, pos);
                    const dist = (0, $1ff4dfb77b7bb646$export$c76b58cfe053f228)(pos, closest);
                    [dx, dy] = [
                        dist.dx,
                        dist.dy
                    ];
                    if (dist.distance < radius) {
                        (0, $429673301a418a2a$export$23ef3aa79969cc55)(pi, pj, particle.velocity);
                        return true;
                    }
                }
                if (closest && dx !== undefined && dy !== undefined && !this._checkInsidePolygon(pos)) {
                    const factor = {
                        x: 1,
                        y: 1
                    }, diameter = radius * $e5cb9ac354b13279$var$double, inverse = -1;
                    if (pos.x >= closest.x) factor.x = -1;
                    if (pos.y >= closest.y) factor.y = -1;
                    particle.position.x = closest.x + diameter * factor.x;
                    particle.position.y = closest.y + diameter * factor.y;
                    particle.velocity.mult(inverse);
                    return true;
                }
            } else if (options.type === (0, $cb9eaf2d510804db$export$ccddd95432af39da).inline && particle.initialPosition) {
                const dist = (0, $1ff4dfb77b7bb646$export$79376507b09a66f)(particle.initialPosition, particle.getPosition()), { velocity: velocity } = particle;
                if (dist > this._moveRadius) {
                    velocity.x = velocity.y * $e5cb9ac354b13279$var$half - velocity.x;
                    velocity.y = velocity.x * $e5cb9ac354b13279$var$half - velocity.y;
                    return true;
                }
            }
            return false;
        };
        this._randomPoint = ()=>{
            const container = this._container, options = container.actualOptions.polygon;
            if (!options) return;
            let position;
            if (options.type === (0, $cb9eaf2d510804db$export$ccddd95432af39da).inline) switch(options.inline.arrangement){
                case (0, $f0dfb1cd20500d26$export$6cbf089632abf287).randomPoint:
                    position = this._getRandomPoint();
                    break;
                case (0, $f0dfb1cd20500d26$export$6cbf089632abf287).randomLength:
                    position = this._getRandomPointByLength();
                    break;
                case (0, $f0dfb1cd20500d26$export$6cbf089632abf287).equidistant:
                    position = this._getEquidistantPointByIndex(container.particles.count);
                    break;
                case (0, $f0dfb1cd20500d26$export$6cbf089632abf287).onePerPoint:
                case (0, $f0dfb1cd20500d26$export$6cbf089632abf287).perPoint:
                default:
                    position = this._getPointByIndex(container.particles.count);
            }
            else {
                const canvasSize = container.canvas.size;
                position = {
                    x: (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * canvasSize.width,
                    y: (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * canvasSize.height
                };
            }
            if (this._checkInsidePolygon(position)) return position;
            else return this._randomPoint();
        };
        this._container = container;
        this._engine = engine;
        this.dimension = {
            height: 0,
            width: 0
        };
        this._moveRadius = 0;
        this._scale = 1;
    }
    clickPositionValid(position) {
        const options = this._container.actualOptions.polygon;
        return !!options?.enable && options.type !== (0, $cb9eaf2d510804db$export$ccddd95432af39da).none && options.type !== (0, $cb9eaf2d510804db$export$ccddd95432af39da).inline && this._checkInsidePolygon(position);
    }
    draw(context) {
        if (!this.paths?.length) return;
        const options = this._container.actualOptions.polygon;
        if (!options?.enable) return;
        const polygonDraw = options.draw;
        if (!polygonDraw.enable) return;
        const rawData = this.raw;
        for (const path of this.paths){
            const path2d = path.path2d;
            if (!context) continue;
            if (path2d && this.offset) (0, $429673301a418a2a$export$4bf14a4637194898)(context, path2d, polygonDraw.stroke, this.offset);
            else if (rawData) (0, $429673301a418a2a$export$5f3afb62a97b18da)(context, rawData, polygonDraw.stroke);
        }
    }
    async init() {
        const container = this._container, polygonMaskOptions = container.actualOptions.polygon, pxRatio = container.retina.pixelRatio;
        if (!polygonMaskOptions) return;
        this._moveRadius = polygonMaskOptions.move.radius * pxRatio;
        this._scale = polygonMaskOptions.scale * pxRatio;
        if (polygonMaskOptions.enable) await this._initRawData();
    }
    particleBounce(particle, delta, direction) {
        return this._polygonBounce(particle, delta, direction);
    }
    particlePosition(position) {
        const options = this._container.actualOptions.polygon, defaultLength = 0;
        if (!(options?.enable && (this.raw?.length ?? defaultLength) > defaultLength)) return;
        return (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)({}, position ? position : this._randomPoint());
    }
    particlesInitialization() {
        const options = this._container.actualOptions.polygon;
        if (options?.enable && options.type === (0, $cb9eaf2d510804db$export$ccddd95432af39da).inline && (options.inline.arrangement === (0, $f0dfb1cd20500d26$export$6cbf089632abf287).onePerPoint || options.inline.arrangement === (0, $f0dfb1cd20500d26$export$6cbf089632abf287).perPoint)) {
            this._drawPoints();
            return true;
        }
        return false;
    }
    resize() {
        const container = this._container, options = container.actualOptions.polygon;
        if (!(options?.enable && options.type !== (0, $cb9eaf2d510804db$export$ccddd95432af39da).none)) return;
        if (this.redrawTimeout) clearTimeout(this.redrawTimeout);
        const timeout = 250;
        this.redrawTimeout = window.setTimeout(()=>{
            (async ()=>{
                await this._initRawData(true);
                await container.particles.redraw();
            })();
        }, timeout);
    }
    stop() {
        delete this.raw;
        delete this.paths;
    }
}



class $c0858e607c51d72f$export$224582ff6d59f5bc {
    constructor(engine){
        this.id = "polygonMask";
        this._engine = engine;
    }
    getPlugin(container) {
        return Promise.resolve(new (0, $e5cb9ac354b13279$export$742f453799c75555)(container, this._engine));
    }
    loadOptions(options, source) {
        if (!this.needsPlugin(options) && !this.needsPlugin(source)) return;
        let polygonOptions = options.polygon;
        if (polygonOptions?.load === undefined) options.polygon = polygonOptions = new (0, $8612b2fc3a5bb050$export$6352cd862da6d1f2)();
        polygonOptions.load(source?.polygon);
    }
    needsPlugin(options) {
        return options?.polygon?.enable ?? (options?.polygon?.type !== undefined && options.polygon.type !== (0, $cb9eaf2d510804db$export$ccddd95432af39da).none);
    }
}





async function $3950c23d6bd2ac31$export$12d8e3e20fc71daf(engine, refresh = true) {
    await engine.addPlugin(new (0, $c0858e607c51d72f$export$224582ff6d59f5bc)(engine), refresh);
}



class $bf6a33870b395c4a$export$a8aee5771362de8b {
    constructor(){
        this._createDirs = ()=>{
            this.dirsList = [];
            for(let i = 0; i < 360; i += 360 / this.options.sides){
                const angle = this.options.angle + i;
                this.dirsList.push((0, $04697537ec8dce5b$export$9b781de7bf37bf48).create(Math.cos(angle * Math.PI / 180), Math.sin(angle * Math.PI / 180)));
            }
        };
        this.dirsList = [];
        this.options = {
            sides: 6,
            turnSteps: 20,
            angle: 30
        };
    }
    generate(p) {
        const { sides: sides } = this.options;
        if (p.hexStep === undefined) p.hexStep = 0;
        if (p.hexDirection === undefined) p.hexDirection = sides === 6 ? ((0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * 3 | 0) * 2 : (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() * sides | 0;
        if (p.hexSpeed === undefined) p.hexSpeed = p.velocity.length;
        if (p.hexStep % this.options.turnSteps === 0) p.hexDirection = (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() > 0.5 ? (p.hexDirection + 1) % sides : (p.hexDirection + sides - 1) % sides;
        p.velocity.x = 0;
        p.velocity.y = 0;
        p.hexStep++;
        const direction = this.dirsList[p.hexDirection];
        return (0, $04697537ec8dce5b$export$9b781de7bf37bf48).create(direction.x * p.hexSpeed, direction.y * p.hexSpeed);
    }
    init(container) {
        const options = container.actualOptions.particles.move.path.options;
        this.options.sides = options.sides > 0 ? options.sides : 6;
        this.options.angle = options.angle ?? 30;
        this.options.turnSteps = options.turnSteps >= 0 ? options.turnSteps : 20;
        this._createDirs();
    }
    reset(particle) {
        delete particle.hexStep;
        delete particle.hexDirection;
        delete particle.hexSpeed;
    }
    update() {}
}


const $5b5a3b0ce636d8e8$export$fb0a623b35fa13b3 = "polygonPathGenerator";
async function $5b5a3b0ce636d8e8$export$5cf08bd8d685725(engine, refresh = true) {
    await engine.addPathGenerator($5b5a3b0ce636d8e8$export$fb0a623b35fa13b3, new (0, $bf6a33870b395c4a$export$a8aee5771362de8b)(), refresh);
}



const $f6d9e524b2ea9b48$var$double = 2, $f6d9e524b2ea9b48$var$doublePI = Math.PI * $f6d9e524b2ea9b48$var$double, $f6d9e524b2ea9b48$var$half = 0.5, $f6d9e524b2ea9b48$var$defaultRotation = 0;
function $f6d9e524b2ea9b48$export$b7b19aa0ee06c73(sides, radius, rot = $f6d9e524b2ea9b48$var$defaultRotation) {
    const step = $f6d9e524b2ea9b48$var$doublePI / sides, path = [];
    for(let i = 0; i < sides; i++)path.push({
        x: Math.cos(i * step + rot) * radius,
        y: Math.sin(i * step + rot) * radius
    });
    return path;
}
function $f6d9e524b2ea9b48$export$7673e8428f9351fe(context, path, radius) {
    const index1 = 0, index2 = 1, increment = 1;
    let p1 = path[index1], p2 = path[index2];
    const len = path.length;
    context.moveTo((p1.x + p2.x) * $f6d9e524b2ea9b48$var$half, (p1.y + p2.y) * $f6d9e524b2ea9b48$var$half);
    for(let i = 1; i <= len; i++){
        p1 = p2;
        p2 = path[(i + increment) % len];
        context.arcTo(p1.x, p1.y, (p1.x + p2.x) * $f6d9e524b2ea9b48$var$half, (p1.y + p2.y) * $f6d9e524b2ea9b48$var$half, radius);
    }
}


const $c12d2428da0f0e24$var$defaultSides = 5, $c12d2428da0f0e24$var$defaultRadius = 5;
class $c12d2428da0f0e24$export$a13dfef645f42541 {
    constructor(){
        this.validTypes = [
            "rounded-polygon"
        ];
    }
    draw(data) {
        const { context: context, particle: particle, radius: radius } = data;
        (0, $f6d9e524b2ea9b48$export$7673e8428f9351fe)(context, (0, $f6d9e524b2ea9b48$export$b7b19aa0ee06c73)(particle.sides, radius), particle.borderRadius ?? $c12d2428da0f0e24$var$defaultRadius);
    }
    getSidesCount(particle) {
        const roundedPolygon = particle.shapeData;
        return Math.round((0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(roundedPolygon?.sides ?? $c12d2428da0f0e24$var$defaultSides));
    }
    particleInit(container, particle) {
        const shapeData = particle.shapeData;
        particle.borderRadius = Math.round((0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(shapeData?.radius ?? $c12d2428da0f0e24$var$defaultSides)) * container.retina.pixelRatio;
    }
}


async function $d0769c127ce72880$export$be50bd2e9593bd84(engine, refresh = true) {
    await engine.addShape(new (0, $c12d2428da0f0e24$export$a13dfef645f42541)(), refresh);
}



function $328340704e03b925$export$c40ecbf27f181c47(ctx, fixedRadius, fixedDiameter, borderRadius) {
    const info = {
        x: -fixedRadius,
        y: -fixedRadius,
        height: fixedDiameter,
        width: fixedDiameter
    }, radius = {
        topLeft: borderRadius,
        topRight: borderRadius,
        bottomLeft: borderRadius,
        bottomRight: borderRadius
    }, { x: x, y: y, width: width, height: height } = info, r = x + width, b = y + height;
    ctx.moveTo(x + radius.topLeft, y);
    ctx.lineTo(r - radius.topRight, y);
    ctx.quadraticCurveTo(r, y, r, y + radius.topRight);
    ctx.lineTo(r, y + height - radius.bottomRight);
    ctx.quadraticCurveTo(r, b, r - radius.bottomRight, b);
    ctx.lineTo(x + radius.bottomLeft, b);
    ctx.quadraticCurveTo(x, b, x, b - radius.bottomLeft);
    ctx.lineTo(x, y + radius.topLeft);
    ctx.quadraticCurveTo(x, y, x + radius.topLeft, y);
}


const $519822a31ac65267$var$fixFactorSquare = 2, $519822a31ac65267$var$fixFactor = Math.sqrt($519822a31ac65267$var$fixFactorSquare), $519822a31ac65267$var$double = 2, $519822a31ac65267$var$defaultRadius = 5;
class $519822a31ac65267$export$8a5aa43db75b9a23 {
    constructor(){
        this.validTypes = [
            "rounded-rect"
        ];
    }
    draw(data) {
        const { context: context, particle: particle, radius: radius } = data, fixedRadius = radius / $519822a31ac65267$var$fixFactor, fixedDiameter = fixedRadius * $519822a31ac65267$var$double, borderRadius = particle.borderRadius ?? $519822a31ac65267$var$defaultRadius;
        if ("roundRect" in context) context.roundRect(-fixedRadius, -fixedRadius, fixedDiameter, fixedDiameter, borderRadius);
        else (0, $328340704e03b925$export$c40ecbf27f181c47)(context, fixedRadius, fixedDiameter, borderRadius);
    }
    particleInit(container, particle) {
        const shapeData = particle.shapeData;
        particle.borderRadius = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(shapeData?.radius ?? $519822a31ac65267$var$defaultRadius) * container.retina.pixelRatio;
    }
}


async function $79d8fb78d9523d94$export$204acac9e7d7a737(engine, refresh = true) {
    await engine.addShape(new (0, $519822a31ac65267$export$8a5aa43db75b9a23)(), refresh);
}



var $d00fd40b96bbd17e$var$SVGPathDirection;
(function(SVGPathDirection) {
    SVGPathDirection[SVGPathDirection["normal"] = 0] = "normal";
    SVGPathDirection[SVGPathDirection["reverse"] = 1] = "reverse";
})($d00fd40b96bbd17e$var$SVGPathDirection || ($d00fd40b96bbd17e$var$SVGPathDirection = {}));
const $d00fd40b96bbd17e$var$defaultSpeed = 1, $d00fd40b96bbd17e$var$half = 0.5, $d00fd40b96bbd17e$var$minStep = 0, $d00fd40b96bbd17e$var$minIndex = 0, $d00fd40b96bbd17e$var$minWidth = 0, $d00fd40b96bbd17e$var$minScale = 1;
class $d00fd40b96bbd17e$export$4f0a0f26ac158820 {
    constructor(){
        this._paths = [];
        this._reverse = false;
        this._size = {
            width: 0,
            height: 0
        };
        this._scale = 1;
        this._offset = {
            x: 0,
            y: 0,
            mode: (0, $990956d8c795e3d5$export$1009f0178778a981).percent
        };
        this._width = 0;
    }
    generate(particle, delta) {
        const container = particle.container, pxRatio = container.retina.pixelRatio;
        if (particle.svgDirection === undefined) particle.svgDirection = (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)() > (0, $dec17af1c054e95f$export$fa0534be1c9f2e23) ? $d00fd40b96bbd17e$var$SVGPathDirection.normal : $d00fd40b96bbd17e$var$SVGPathDirection.reverse;
        if (particle.svgPathIndex === undefined) particle.svgPathIndex = Math.floor(Math.random() * this._paths.length);
        if (particle.svgSpeed === undefined) particle.svgSpeed = particle.velocity.mult((particle.retina.moveSpeed ?? $d00fd40b96bbd17e$var$defaultSpeed) * $d00fd40b96bbd17e$var$half).length;
        if (particle.svgStep === undefined) particle.svgStep = (0, $1ff4dfb77b7bb646$export$8b958c8ecd94a804)({
            min: 0,
            max: this._paths[particle.svgPathIndex].length
        }) * pxRatio;
        if (particle.svgOffset === undefined) particle.svgOffset = {
            width: (0, $1ff4dfb77b7bb646$export$8b958c8ecd94a804)({
                min: -this._width * $d00fd40b96bbd17e$var$half,
                max: this._width * $d00fd40b96bbd17e$var$half
            }) * pxRatio,
            height: (0, $1ff4dfb77b7bb646$export$8b958c8ecd94a804)({
                min: -this._width * $d00fd40b96bbd17e$var$half,
                max: this._width * $d00fd40b96bbd17e$var$half
            }) * pxRatio
        };
        if (particle.svgInitialPosition === undefined) particle.svgInitialPosition = {
            ...particle.position
        };
        particle.velocity.x = 0;
        particle.velocity.y = 0;
        if (particle.svgDirection === $d00fd40b96bbd17e$var$SVGPathDirection.normal) particle.svgStep += particle.svgSpeed * delta.factor;
        else particle.svgStep -= particle.svgSpeed * delta.factor;
        let path = this._paths[particle.svgPathIndex];
        if (path) {
            const pathLength = path.length, indexOffset = 1;
            if (particle.svgStep >= pathLength) {
                particle.svgPathIndex = particle.svgPathIndex + indexOffset;
                if (particle.svgPathIndex >= this._paths.length) {
                    if (this._reverse) {
                        particle.svgPathIndex = this._paths.length - indexOffset;
                        particle.svgDirection = $d00fd40b96bbd17e$var$SVGPathDirection.reverse;
                    } else {
                        particle.svgPathIndex = 0;
                        particle.svgStep = 0;
                    }
                }
            } else if (particle.svgStep <= $d00fd40b96bbd17e$var$minStep) {
                particle.svgPathIndex = particle.svgPathIndex - indexOffset;
                if (particle.svgPathIndex < $d00fd40b96bbd17e$var$minIndex) {
                    if (this._reverse) {
                        particle.svgPathIndex = 0;
                        particle.svgDirection = $d00fd40b96bbd17e$var$SVGPathDirection.normal;
                    } else {
                        particle.svgPathIndex = this._paths.length - indexOffset;
                        path = this._paths[particle.svgPathIndex];
                        particle.svgStep = path.length;
                    }
                }
            }
            path = this._paths[particle.svgPathIndex];
        }
        if (path) {
            const pathElement = path.element, pos = pathElement.getPointAtLength(particle.svgStep), canvasSize = particle.container.canvas.size, offset = (0, $eee2fa4b9ebe63e9$export$1690e12b840569b9)(this._offset, canvasSize), scale = this._scale * pxRatio;
            particle.position.x = (pos.x - this._size.width * $d00fd40b96bbd17e$var$half) * scale + particle.svgInitialPosition.x + offset.x + particle.svgOffset.width;
            particle.position.y = (pos.y - this._size.height * $d00fd40b96bbd17e$var$half) * scale + particle.svgInitialPosition.y + offset.y + particle.svgOffset.height;
        }
        return (0, $04697537ec8dce5b$export$9b781de7bf37bf48).origin;
    }
    init(container) {
        const options = container.actualOptions.particles.move.path.options, position = options.position ?? this._offset;
        this._reverse = options.reverse ?? this._reverse;
        this._scale = options.scale ?? $d00fd40b96bbd17e$var$minScale;
        this._offset.x = position.x;
        this._offset.y = position.y;
        this._offset.mode = position.mode;
        this._width = options.width ?? $d00fd40b96bbd17e$var$minWidth;
        if (options.url && !options.path) {
            const url = options.url;
            (async ()=>{
                const response = await fetch(url), data = await response.text();
                const parser = new DOMParser(), doc = parser.parseFromString(data, "image/svg+xml"), firstIndex = 0, svg = doc.getElementsByTagName("svg")[firstIndex];
                let svgPaths = svg.getElementsByTagName("path");
                if (!svgPaths.length) svgPaths = doc.getElementsByTagName("path");
                this._paths = [];
                for(let i = 0; i < svgPaths.length; i++){
                    const path = svgPaths.item(i);
                    if (path) this._paths.push({
                        element: path,
                        length: path.getTotalLength()
                    });
                }
                this._size.height = parseFloat(svg.getAttribute("height") ?? "0");
                this._size.width = parseFloat(svg.getAttribute("width") ?? "0");
            })();
        } else if (options.path) {
            const path = options.path;
            this._paths = [];
            for (const item of path.data){
                const element = document.createElementNS("http://www.w3.org/2000/svg", "path");
                element.setAttribute("d", item);
                this._paths.push({
                    element: element,
                    length: element.getTotalLength()
                });
            }
            this._size.height = path.size.height;
            this._size.width = path.size.width;
        }
    }
    reset() {}
    update() {}
}


const $c365ea05f98bb5e2$export$bfafd8b04fc7c877 = "svgPathGenerator";
async function $c365ea05f98bb5e2$export$48494e9d19283f78(engine, refresh = true) {
    await engine.addPathGenerator($c365ea05f98bb5e2$export$bfafd8b04fc7c877, new (0, $d00fd40b96bbd17e$export$4f0a0f26ac158820)(), refresh);
}




const $96648ca547de9d24$var$defaultOptions = {
    size: 20,
    increment: 0.004,
    columns: 0,
    rows: 0,
    layers: 0,
    width: 0,
    height: 0,
    offset: {
        x: 40000,
        y: 40000,
        z: 40000
    }
};
class $96648ca547de9d24$export$2ce57c0f9eb77312 {
    constructor(){
        const simplex = new (0, $0c77f4a66b14fc8f$export$7cef8d54b4fb09be)();
        this._simplex = simplex.noise4d;
        this.field = [];
        this.noiseW = 0;
        this.options = (0, $eee2fa4b9ebe63e9$export$54e9fb29908872fa)({}, $96648ca547de9d24$var$defaultOptions);
    }
    generate(particle) {
        const pos = particle.getPosition(), point = {
            x: Math.max(Math.floor(pos.x / this.options.size), 0),
            y: Math.max(Math.floor(pos.y / this.options.size), 0),
            z: Math.max(Math.floor(pos.z / this.options.size), 0)
        }, v = (0, $04697537ec8dce5b$export$9b781de7bf37bf48).origin;
        if (!this.field?.[point.x]?.[point.y]?.[point.z]) return v;
        v.setTo(this.field[point.x][point.y][point.z]);
        return v;
    }
    init(container) {
        this.container = container;
        this._setup();
    }
    reset() {}
    update() {
        if (!this.container) return;
        this._calculateField();
        this.noiseW += this.options.increment;
    }
    _calculateField() {
        const options = this.options;
        for(let x = 0; x < options.columns; x++){
            for(let y = 0; y < options.rows; y++)for(let z = 0; z < options.layers; z++){
                this.field[x][y][z].angle = this._simplex.noise(x / 50, y / 50, z / 50, this.noiseW) * Math.PI * 2;
                this.field[x][y][z].length = this._simplex.noise(x / 100 + options.offset.x, y / 100 + options.offset.y, z / 100 + options.offset.z, this.noiseW);
            }
        }
    }
    _initField() {
        this.field = new Array(this.options.columns);
        for(let x = 0; x < this.options.columns; x++){
            this.field[x] = new Array(this.options.rows);
            for(let y = 0; y < this.options.rows; y++){
                this.field[x][y] = new Array(this.options.layers);
                for(let z = 0; z < this.options.layers; z++)this.field[x][y][z] = (0, $04697537ec8dce5b$export$9b781de7bf37bf48).origin;
            }
        }
    }
    _resetField() {
        const container = this.container;
        if (!container) return;
        const sourceOptions = container.actualOptions.particles.move.path.options;
        this.options.size = sourceOptions.size > 0 ? sourceOptions.size : $96648ca547de9d24$var$defaultOptions.size;
        this.options.increment = sourceOptions.increment > 0 ? sourceOptions.increment : $96648ca547de9d24$var$defaultOptions.increment;
        this.options.width = container.canvas.size.width;
        this.options.height = container.canvas.size.height;
        const offset = sourceOptions.offset;
        this.options.offset.x = offset?.x ?? $96648ca547de9d24$var$defaultOptions.offset.x;
        this.options.offset.y = offset?.y ?? $96648ca547de9d24$var$defaultOptions.offset.y;
        this.options.offset.z = offset?.z ?? $96648ca547de9d24$var$defaultOptions.offset.z;
        this.options.seed = sourceOptions.seed ?? $96648ca547de9d24$var$defaultOptions.seed;
        this._simplex.seed(this.options.seed ?? (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)());
        this.options.columns = Math.floor(this.options.width / this.options.size) + 1;
        this.options.rows = Math.floor(this.options.height / this.options.size) + 1;
        this.options.layers = Math.floor(container.zLayers / this.options.size) + 1;
        this._initField();
    }
    _setup() {
        this.noiseW = 0;
        this._resetField();
        addEventListener("resize", ()=>this._resetField());
    }
}


const $97ed1842be54001e$export$51fefd2ee47bb998 = "simplexNoise";
async function $97ed1842be54001e$export$dcab187a131a8a68(engine, refresh = true) {
    await engine.addPathGenerator($97ed1842be54001e$export$51fefd2ee47bb998, new (0, $96648ca547de9d24$export$2ce57c0f9eb77312)(), refresh);
}





class $9c20007067c35a03$export$b9791a8db40b3fbf {
    constructor(){
        this.loop = false;
        this.source = "";
    }
    load(data) {
        if (data === undefined) return;
        if ((0, $ad25b6e319f6df8c$export$a6cdc56e425d0d0a)(data)) {
            if (data.loop !== undefined) this.loop = data.loop;
            if (data.source !== undefined) this.source = data.source;
        } else this.source = data;
    }
}


class $848bc697b7189fb2$export$59ac6372b1dabbf1 {
    constructor(){
        this.duration = 500;
        this.value = [];
    }
    load(data) {
        if (!data) return;
        if (data.duration !== undefined) this.duration = data.duration;
        if (data.value !== undefined) this.value = data.value;
    }
}


class $1f4f39331ac2053e$export$9d874afcc1be36a6 {
    constructor(){
        this.loop = false;
        this.melodies = [];
        this.notes = [];
    }
    load(data) {
        if (data === undefined) return;
        if (data.loop !== undefined) this.loop = data.loop;
        if (data.melodies !== undefined) this.melodies = data.melodies.map((s)=>{
            const tmp = new $1f4f39331ac2053e$export$9d874afcc1be36a6();
            tmp.load(s);
            return tmp;
        });
        if (data.notes !== undefined) this.notes = data.notes.map((s)=>{
            const tmp = new (0, $848bc697b7189fb2$export$59ac6372b1dabbf1)();
            tmp.load(s);
            return tmp;
        });
    }
}



class $e176c541446adeb3$export$8a8abe7668af986c {
    constructor(){
        this.event = [];
        this.notes = [];
    }
    load(data) {
        if (!data) return;
        if (data.event !== undefined) this.event = data.event;
        if (data.audio !== undefined) {
            if ((0, $ad25b6e319f6df8c$export$43bee75e5e14138e)(data.audio)) this.audio = data.audio.map((s)=>{
                const tmp = new (0, $9c20007067c35a03$export$b9791a8db40b3fbf)();
                tmp.load(s);
                return tmp;
            });
            else {
                this.audio = new (0, $9c20007067c35a03$export$b9791a8db40b3fbf)();
                this.audio.load(data.audio);
            }
        }
        if (data.notes !== undefined) this.notes = data.notes.map((t)=>{
            const tmp = new (0, $848bc697b7189fb2$export$59ac6372b1dabbf1)();
            tmp.load(t);
            return tmp;
        });
        if (data.melodies !== undefined) this.melodies = data.melodies.map((t)=>{
            const tmp = new (0, $1f4f39331ac2053e$export$9d874afcc1be36a6)();
            tmp.load(t);
            return tmp;
        });
        if (data.filter) {
            if ((0, $ad25b6e319f6df8c$export$844ec244b1367d54)(data.filter)) {
                const filterFunc = window[data.filter];
                if ((0, $ad25b6e319f6df8c$export$f6e2535fb5126e54)(filterFunc)) this.filter = filterFunc;
            } else this.filter = data.filter;
        }
    }
}


class $7d030f2d7927a3da$export$93050ba4c0b1d17b {
    constructor(){
        this.width = 24;
        this.height = 24;
        this.style = "";
    }
    load(data) {
        if (!data) return;
        if (data.path !== undefined) this.path = data.path;
        if (data.svg !== undefined) this.svg = data.svg;
        if (data.width !== undefined) this.width = data.width;
        if (data.height !== undefined) this.height = data.height;
    }
}


class $56ef1f5f52733e54$export$b63974f510abcf7e {
    constructor(){
        this.mute = new (0, $7d030f2d7927a3da$export$93050ba4c0b1d17b)();
        this.unmute = new (0, $7d030f2d7927a3da$export$93050ba4c0b1d17b)();
        this.volumeDown = new (0, $7d030f2d7927a3da$export$93050ba4c0b1d17b)();
        this.volumeUp = new (0, $7d030f2d7927a3da$export$93050ba4c0b1d17b)();
        this.enable = false;
        this.mute.svg = `<?xml version="1.0"?>
<svg baseProfile="tiny" height="24px" version="1.2" viewBox="0 0 24 24" width="24px"
    xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Layer_1">
        <path fill="#fff" d="M19.707,5.293c-0.391-0.391-1.023-0.391-1.414,0l-1.551,1.551c-0.345-0.688-0.987-1.02-1.604-1.02c-0.449,0-0.905,0.152-1.356,0.453l-2.672,1.781C10.357,8.561,8.904,9,8,9c-1.654,0-3,1.346-3,3v2c0,1.237,0.754,2.302,1.826,2.76l-1.533,1.533c-0.391,0.391-0.391,1.023,0,1.414C5.488,19.902,5.744,20,6,20s0.512-0.098,0.707-0.293l2.527-2.527c0.697,0.174,1.416,0.455,1.875,0.762l2.672,1.781c0.451,0.301,0.907,0.453,1.356,0.453C16.035,20.176,17,19.495,17,18V9.414l2.707-2.707C20.098,6.316,20.098,5.684,19.707,5.293z M14.891,7.941c0.038-0.025,0.073-0.046,0.104-0.062C14.998,7.914,15,7.954,15,8v1.293l-2,2V9.202L14.891,7.941z M7,12c0-0.552,0.448-1,1-1c1.211,0,2.907-0.495,4-1.146v2.439l-2.83,2.83C8.757,15.046,8.356,15,8,15c-0.552,0-1-0.448-1-1V12z M10.301,15.406L12,13.707v2.439C11.519,15.859,10.925,15.604,10.301,15.406z M14.994,18.12c-0.03-0.016-0.065-0.036-0.104-0.062L13,16.798v-4.091l2-2V18C15,18.046,14.998,18.086,14.994,18.12z"/>
    </g>
</svg>`;
        this.unmute.svg = `<?xml version="1.0"?>
<svg baseProfile="tiny" height="24px" version="1.2" viewBox="0 0 24 24" width="24px"
    xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Layer_1">
        <path fill="#fff" d="M17.138,5.824c-0.449,0-0.905,0.152-1.356,0.453l-2.672,1.781C12.357,8.561,10.904,9,10,9c-1.654,0-3,1.346-3,3v2c0,1.654,1.346,3,3,3c0.904,0,2.357,0.439,3.109,0.941l2.672,1.781c0.451,0.301,0.907,0.453,1.356,0.453C18.035,20.176,19,19.495,19,18V8C19,6.505,18.035,5.824,17.138,5.824z M14,16.146C12.907,15.495,11.211,15,10,15c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1c1.211,0,2.907-0.495,4-1.146V16.146z M17,18c0,0.046-0.002,0.086-0.006,0.12c-0.03-0.016-0.065-0.036-0.104-0.062L15,16.798V9.202l1.891-1.261c0.038-0.025,0.073-0.046,0.104-0.062C16.998,7.914,17,7.954,17,8V18z"/>
    </g>
</svg>`;
        this.volumeDown.svg = `<?xml version="1.0"?>
<svg baseProfile="tiny" height="24px" version="1.2" viewBox="0 0 24 24" width="24px"
    xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Layer_1">
        <path fill="#fff" d="M15.138,5.824c-0.449,0-0.905,0.152-1.356,0.453l-2.672,1.781C10.357,8.561,8.904,9,8,9c-1.654,0-3,1.346-3,3v2c0,1.654,1.346,3,3,3c0.904,0,2.357,0.439,3.109,0.941l2.672,1.781c0.451,0.301,0.907,0.453,1.356,0.453C16.035,20.176,17,19.495,17,18V8C17,6.505,16.035,5.824,15.138,5.824z M8,15c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1c1.211,0,2.907-0.495,4-1.146v6.293C10.907,15.495,9.211,15,8,15z M15,18c0,0.046-0.002,0.086-0.006,0.12c-0.03-0.016-0.065-0.036-0.104-0.062L13,16.798V9.202l1.891-1.261c0.038-0.025,0.073-0.046,0.104-0.062C14.998,7.914,15,7.954,15,8V18z"/>
        <path fill="#fff" d="M18.292,10.294c-0.39,0.391-0.39,1.023,0.002,1.414c0.345,0.345,0.535,0.803,0.535,1.291c0,0.489-0.19,0.948-0.536,1.294c-0.391,0.39-0.391,1.023,0,1.414C18.488,15.902,18.744,16,19,16s0.512-0.098,0.707-0.293c0.724-0.723,1.122-1.685,1.122-2.708s-0.398-1.984-1.123-2.707C19.317,9.903,18.683,9.901,18.292,10.294z"/>
    </g>
</svg>`;
        this.volumeUp.svg = `<?xml version="1.0"?>
<svg baseProfile="tiny" height="24px" version="1.2" viewBox="0 0 24 24" width="24px"
    xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Layer_1">
        <path fill="#fff" d="M16.706,10.292c-0.389-0.389-1.023-0.391-1.414,0.002c-0.39,0.391-0.39,1.023,0.002,1.414c0.345,0.345,0.535,0.803,0.535,1.291c0,0.489-0.19,0.948-0.536,1.294c-0.391,0.39-0.391,1.023,0,1.414C15.488,15.902,15.744,16,16,16s0.512-0.098,0.707-0.293c0.724-0.723,1.122-1.685,1.122-2.708S17.431,11.015,16.706,10.292z"/>
        <path fill="#fff" d="M18.706,8.292c-0.391-0.389-1.023-0.39-1.414,0.002c-0.39,0.391-0.39,1.024,0.002,1.414c0.879,0.877,1.363,2.044,1.364,3.287c0.001,1.246-0.484,2.417-1.365,3.298c-0.391,0.391-0.391,1.023,0,1.414C17.488,17.902,17.744,18,18,18s0.512-0.098,0.707-0.293c1.259-1.259,1.952-2.933,1.951-4.713C20.657,11.217,19.964,9.547,18.706,8.292z"/>
        <path fill="#fff" d="M20.706,6.292c-0.391-0.389-1.023-0.39-1.414,0.002c-0.39,0.391-0.39,1.024,0.002,1.414c1.412,1.409,2.191,3.285,2.192,5.284c0.002,2.002-0.777,3.885-2.193,5.301c-0.391,0.391-0.391,1.023,0,1.414C19.488,19.902,19.744,20,20,20s0.512-0.098,0.707-0.293c1.794-1.794,2.781-4.18,2.779-6.717C23.485,10.457,22.497,8.078,20.706,6.292z"/>
        <path fill="#fff" d="M12.138,5.824c-0.449,0-0.905,0.152-1.356,0.453L8.109,8.059C7.357,8.561,5.904,9,5,9c-1.654,0-3,1.346-3,3v2c0,1.654,1.346,3,3,3c0.904,0,2.357,0.439,3.109,0.941l2.672,1.781c0.451,0.301,0.907,0.453,1.356,0.453C13.035,20.176,14,19.495,14,18V8C14,6.505,13.035,5.824,12.138,5.824z M5,15c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1c1.211,0,2.907-0.495,4-1.146v6.293C7.907,15.495,6.211,15,5,15z M12,18c0,0.046-0.002,0.086-0.006,0.12c-0.03-0.016-0.065-0.036-0.104-0.062L10,16.798V9.202l1.891-1.261c0.038-0.025,0.073-0.046,0.104-0.062C11.998,7.914,12,7.954,12,8V18z"/>
    </g>
</svg>`;
    }
    load(data) {
        if (!data) return;
        if (data.enable !== undefined) this.enable = data.enable;
        this.mute.load(data.mute);
        this.unmute.load(data.unmute);
        this.volumeDown.load(data.volumeDown);
        this.volumeUp.load(data.volumeUp);
    }
}



class $c99ef9fe50517a2e$export$fd19cda896852b4a {
    constructor(){
        this.value = 100;
        this.max = 100;
        this.min = 0;
        this.step = 10;
    }
    load(data) {
        if (data === undefined) return;
        if ((0, $ad25b6e319f6df8c$export$a6cdc56e425d0d0a)(data)) {
            if (data.max !== undefined) this.max = data.max;
            if (data.min !== undefined) this.min = data.min;
            if (data.step !== undefined) this.step = data.step;
            if (data.value !== undefined) this.value = data.value;
        } else this.value = data;
    }
}


class $fa40b69865dbf05b$export$76eeb3aae76ab221 {
    constructor(){
        this.autoPlay = true;
        this.enable = false;
        this.events = [];
        this.icons = new (0, $56ef1f5f52733e54$export$b63974f510abcf7e)();
        this.volume = new (0, $c99ef9fe50517a2e$export$fd19cda896852b4a)();
    }
    load(data) {
        if (!data) return;
        if (data.autoPlay !== undefined) this.autoPlay = data.autoPlay;
        if (data.enable !== undefined) this.enable = data.enable;
        if (data.events !== undefined) this.events = data.events.map((t)=>{
            const event = new (0, $e176c541446adeb3$export$8a8abe7668af986c)();
            event.load(t);
            return event;
        });
        this.icons.load(data.icons);
        if (data.volume !== undefined) this.volume.load(data.volume);
    }
}



var $8f4e56927937b8f4$export$ce468f6dfc712430;
(function(SoundsEventType) {
    SoundsEventType["mute"] = "soundsMuted";
    SoundsEventType["unmute"] = "soundsUnmuted";
})($8f4e56927937b8f4$export$ce468f6dfc712430 || ($8f4e56927937b8f4$export$ce468f6dfc712430 = {}));
var $8f4e56927937b8f4$export$501d3b295794387a;
(function(ImageDisplay) {
    ImageDisplay["Block"] = "block";
    ImageDisplay["None"] = "none";
})($8f4e56927937b8f4$export$501d3b295794387a || ($8f4e56927937b8f4$export$501d3b295794387a = {}));


const $16d7ca110d419961$var$notes = new Map();
$16d7ca110d419961$var$notes.set("C", [
    16.35,
    32.7,
    65.41,
    130.81,
    261.63,
    523.25,
    1046.5,
    2093.0,
    4186.01
]);
$16d7ca110d419961$var$notes.set("Db", [
    17.32,
    34.65,
    69.3,
    138.59,
    277.18,
    554.37,
    1108.73,
    2217.46,
    4434.92
]);
$16d7ca110d419961$var$notes.set("D", [
    18.35,
    36.71,
    73.42,
    146.83,
    293.66,
    587.33,
    1174.66,
    2349.32,
    4698.63
]);
$16d7ca110d419961$var$notes.set("Eb", [
    19.45,
    38.89,
    77.78,
    155.56,
    311.13,
    622.25,
    1244.51,
    2489.02,
    4978.03
]);
$16d7ca110d419961$var$notes.set("E", [
    20.6,
    41.2,
    82.41,
    164.81,
    329.63,
    659.25,
    1318.51,
    2637.02,
    5274.04
]);
$16d7ca110d419961$var$notes.set("F", [
    21.83,
    43.65,
    87.31,
    174.61,
    349.23,
    698.46,
    1396.91,
    2793.83,
    5587.65
]);
$16d7ca110d419961$var$notes.set("Gb", [
    23.12,
    46.25,
    92.5,
    185.0,
    369.99,
    739.99,
    1479.98,
    2959.96,
    5919.91
]);
$16d7ca110d419961$var$notes.set("G", [
    24.5,
    49.0,
    98.0,
    196.0,
    392.0,
    783.99,
    1567.98,
    3135.96,
    6271.93
]);
$16d7ca110d419961$var$notes.set("Ab", [
    25.96,
    51.91,
    103.83,
    207.65,
    415.3,
    830.61,
    1661.22,
    3322.44,
    6644.88
]);
$16d7ca110d419961$var$notes.set("A", [
    27.5,
    55.0,
    110.0,
    220.0,
    440.0,
    880.0,
    1760.0,
    3520.0,
    7040.0
]);
$16d7ca110d419961$var$notes.set("Bb", [
    29.14,
    58.27,
    116.54,
    233.08,
    466.16,
    932.33,
    1864.66,
    3729.31,
    7458.62
]);
$16d7ca110d419961$var$notes.set("B", [
    30.87,
    61.74,
    123.47,
    246.94,
    493.88,
    987.77,
    1975.53,
    3951.07,
    7902.13
]);
$16d7ca110d419961$var$notes.set("pause", [
    0
]);
function $16d7ca110d419961$export$a8f9b7b280712859(note) {
    const regex = /(([A-G]b?)(\d))|pause/i, result = regex.exec(note), groupKey = 2, defaultMatchKey = 0, innerGroupKey = 3;
    if (!result?.length) return;
    const noteKey = result[groupKey] || result[defaultMatchKey], noteItem = $16d7ca110d419961$var$notes.get(noteKey);
    if (!noteItem) return;
    return noteItem[parseInt(result[innerGroupKey] || "0")];
}
let $16d7ca110d419961$var$muted = true;
const $16d7ca110d419961$export$43340e5cf364d321 = ()=>{
    return $16d7ca110d419961$var$muted;
};
const $16d7ca110d419961$export$3dcb5603841ddc5d = ()=>{
    $16d7ca110d419961$var$muted = false;
};


const $4fcc5be793708d1d$var$zIndexOffset = 1, $4fcc5be793708d1d$var$rightOffset = 1, $4fcc5be793708d1d$var$minVolume = 0;
function $4fcc5be793708d1d$var$initImage(data) {
    const img = document.createElement("img"), { clickCb: clickCb, container: container, display: display, iconOptions: iconOptions, margin: margin, options: options, pos: pos, rightOffsets: rightOffsets } = data, { width: width, path: path, style: style, svg: svg } = iconOptions, defaultAccumulator = 0;
    $4fcc5be793708d1d$var$setIconStyle(img, pos.top + margin, pos.right - (margin * (rightOffsets.length + $4fcc5be793708d1d$var$rightOffset) + width + rightOffsets.reduce((a, b)=>a + b, defaultAccumulator)), display, options.fullScreen.zIndex + $4fcc5be793708d1d$var$zIndexOffset, width, margin, style);
    img.src = path ?? (svg ? `data:image/svg+xml;base64,${btoa(svg)}` : "");
    const parent = container.canvas.element?.parentNode ?? document.body;
    parent.append(img);
    img.addEventListener("click", ()=>{
        clickCb();
    });
    return img;
}
function $4fcc5be793708d1d$var$removeImage(image) {
    if (!image) return;
    image.remove();
}
function $4fcc5be793708d1d$var$setIconStyle(icon, top, left, display, zIndex, width, margin, style) {
    icon.style.userSelect = "none";
    icon.style.webkitUserSelect = "none";
    icon.style.position = "absolute";
    icon.style.top = `${top + margin}px`;
    icon.style.left = `${left - margin - width}px`;
    icon.style.display = display;
    icon.style.zIndex = `${zIndex + $4fcc5be793708d1d$var$zIndexOffset}`;
    icon.style.cssText += style;
}
class $4fcc5be793708d1d$export$a0008d5fea52c47e {
    constructor(container, engine){
        this._addBuffer = (audioCtx)=>{
            const buffer = audioCtx.createBufferSource();
            this._audioSources.push(buffer);
            return buffer;
        };
        this._addOscillator = (audioCtx)=>{
            const oscillator = audioCtx.createOscillator();
            this._audioSources.push(oscillator);
            return oscillator;
        };
        this._initEvents = ()=>{
            const container = this._container, soundsOptions = container.actualOptions.sounds;
            if (!soundsOptions?.enable || !container.canvas.element) return;
            for (const event of soundsOptions.events){
                const cb = (args)=>{
                    (async ()=>{
                        const filterNotValid = event.filter && !event.filter(args);
                        if (this._container !== args.container) return;
                        if (!this._container || !!this._container.muted || this._container.destroyed) {
                            (0, $eee2fa4b9ebe63e9$export$8e5dc47097396754)(event.event, (item)=>{
                                this._engine.removeEventListener(item, cb);
                            });
                            return;
                        }
                        if (filterNotValid) return;
                        const defaultNoteIndex = 0;
                        if (event.audio) this._playBuffer((0, $eee2fa4b9ebe63e9$export$3fbf39566d3ee62e)(event.audio));
                        else if (event.melodies) {
                            const melody = (0, $eee2fa4b9ebe63e9$export$3a5d12ca7137122f)(event.melodies);
                            if (melody.melodies.length) await Promise.allSettled(melody.melodies.map((m)=>this._playNote(m.notes, defaultNoteIndex, melody.loop)));
                            else await this._playNote(melody.notes, defaultNoteIndex, melody.loop);
                        } else if (event.notes) {
                            const note = (0, $eee2fa4b9ebe63e9$export$3a5d12ca7137122f)(event.notes);
                            await this._playNote([
                                note
                            ], defaultNoteIndex, false);
                        }
                    })();
                };
                (0, $eee2fa4b9ebe63e9$export$8e5dc47097396754)(event.event, (item)=>{
                    this._engine.addEventListener(item, cb);
                });
            }
        };
        this._mute = async ()=>{
            const container = this._container, audioContext = this._getAudioContext();
            for (const source of this._audioSources)this._removeAudioSource(source);
            if (this._gain) this._gain.disconnect();
            await audioContext.close();
            container.audioContext = undefined;
            this._engine.dispatchEvent((0, $8f4e56927937b8f4$export$ce468f6dfc712430).mute, {
                container: this._container
            });
        };
        this._playBuffer = (audio)=>{
            const audioBuffer = this._audioMap.get(audio.source);
            if (!audioBuffer) return;
            const audioCtx = this._container.audioContext;
            if (!audioCtx) return;
            const source = this._addBuffer(audioCtx);
            source.loop = audio.loop;
            source.buffer = audioBuffer;
            source.connect(this._gain ?? audioCtx.destination);
            source.start();
        };
        this._playFrequency = async (frequency, duration)=>{
            if (!this._gain || this._container.muted) return;
            const audioContext = this._getAudioContext(), oscillator = this._addOscillator(audioContext);
            oscillator.connect(this._gain);
            oscillator.type = "sine";
            oscillator.frequency.value = frequency;
            oscillator.start();
            return new Promise((resolve)=>{
                setTimeout(()=>{
                    this._removeAudioSource(oscillator);
                    resolve();
                }, duration);
            });
        };
        this._playMuteSound = ()=>{
            if (this._container.muted) return;
            const audioContext = this._getAudioContext(), gain = audioContext.createGain();
            gain.connect(audioContext.destination);
            gain.gain.value = 0;
            const oscillator = audioContext.createOscillator();
            oscillator.connect(gain);
            oscillator.type = "sine";
            oscillator.frequency.value = 1;
            oscillator.start();
            setTimeout(()=>{
                oscillator.stop();
                oscillator.disconnect();
                gain.disconnect();
            });
        };
        this._playNote = async (notes, noteIdx, loop)=>{
            if (this._container.muted) return;
            const note = notes[noteIdx];
            if (!note) return;
            const value = note.value;
            const promises = (0, $eee2fa4b9ebe63e9$export$8e5dc47097396754)(value, async (_, idx)=>{
                return this._playNoteValue(notes, noteIdx, idx);
            });
            await ((0, $ad25b6e319f6df8c$export$43bee75e5e14138e)(promises) ? Promise.allSettled(promises) : promises);
            const indexOffset = 1;
            let nextNoteIdx = noteIdx + indexOffset;
            if (loop && nextNoteIdx >= notes.length) nextNoteIdx = nextNoteIdx % notes.length;
            if (this._container.muted) return;
            await this._playNote(notes, nextNoteIdx, loop);
        };
        this._playNoteValue = async (notes, noteIdx, valueIdx)=>{
            const note = notes[noteIdx];
            if (!note) return;
            const value = (0, $eee2fa4b9ebe63e9$export$3fbf39566d3ee62e)(note.value, valueIdx, true);
            try {
                const freq = (0, $16d7ca110d419961$export$a8f9b7b280712859)(value);
                if (!(0, $ad25b6e319f6df8c$export$7e4aa119212bc614)(freq)) return;
                await this._playFrequency(freq, note.duration);
            } catch (e) {
                (0, $eee2fa4b9ebe63e9$export$2b1d391cd05230fd)().error(e);
            }
        };
        this._removeAudioSource = (source)=>{
            source.stop();
            source.disconnect();
            const deleteCount = 1;
            this._audioSources.splice(this._audioSources.indexOf(source), deleteCount);
        };
        this._unmute = ()=>{
            const container = this._container, options = container.actualOptions, soundsOptions = options.sounds;
            if (!soundsOptions) return;
            const audioContext = this._getAudioContext();
            if (!this._audioSources) this._audioSources = [];
            const gain = audioContext.createGain();
            gain.connect(audioContext.destination);
            gain.gain.value = soundsOptions.volume.value / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd);
            this._gain = gain;
            this._initEvents();
            this._engine.dispatchEvent((0, $8f4e56927937b8f4$export$ce468f6dfc712430).unmute, {
                container: this._container
            });
        };
        this._updateMuteIcons = ()=>{
            const container = this._container, soundsOptions = container.actualOptions.sounds;
            if (!soundsOptions?.enable || !soundsOptions.icons.enable) return;
            const muteImg = this._muteImg, unmuteImg = this._unmuteImg;
            if (muteImg) muteImg.style.display = container.muted ? "block" : "none";
            if (unmuteImg) unmuteImg.style.display = container.muted ? "none" : "block";
        };
        this._updateMuteStatus = async ()=>{
            const container = this._container, audioContext = this._getAudioContext();
            if (container.muted) {
                await audioContext?.suspend();
                await this._mute();
            } else {
                await audioContext?.resume();
                this._unmute();
                this._playMuteSound();
            }
        };
        this._updateVolume = async ()=>{
            const container = this._container, soundsOptions = container.actualOptions.sounds;
            if (!soundsOptions?.enable) return;
            (0, $1ff4dfb77b7bb646$export$7d15b64cf5a3a4c4)(this._volume, soundsOptions.volume.min, soundsOptions.volume.max);
            let stateChanged = false;
            if (this._volume <= $4fcc5be793708d1d$var$minVolume && !container.muted) {
                this._volume = 0;
                container.muted = true;
                stateChanged = true;
            } else if (this._volume > $4fcc5be793708d1d$var$minVolume && container.muted) {
                container.muted = false;
                stateChanged = true;
            }
            if (stateChanged) {
                this._updateMuteIcons();
                await this._updateMuteStatus();
            }
            if (this._gain?.gain) this._gain.gain.value = this._volume / (0, $dec17af1c054e95f$export$9519bca7a9fbeccd);
        };
        this._container = container;
        this._engine = engine;
        this._volume = 0;
        this._audioSources = [];
        this._audioMap = new Map();
    }
    async init() {
        const container = this._container, options = container.actualOptions, soundsOptions = options.sounds;
        if (!soundsOptions?.enable) return;
        if (soundsOptions.autoPlay && (0, $16d7ca110d419961$export$43340e5cf364d321)()) {
            const firstClickHandler = ()=>{
                removeEventListener((0, $dec17af1c054e95f$export$9ffd73c9a0e32c34), firstClickHandler);
                removeEventListener((0, $dec17af1c054e95f$export$d5353b6c79bbcc70), firstClickHandler);
                (0, $16d7ca110d419961$export$3dcb5603841ddc5d)();
                this.unmute();
            };
            const listenerOptions = {
                capture: true,
                once: true
            };
            addEventListener((0, $dec17af1c054e95f$export$9ffd73c9a0e32c34), firstClickHandler, listenerOptions);
            addEventListener((0, $dec17af1c054e95f$export$d5353b6c79bbcc70), firstClickHandler, listenerOptions);
        }
        this._volume = soundsOptions.volume.value;
        const events = soundsOptions.events;
        this._audioMap = new Map();
        for (const event of events){
            if (!event.audio) continue;
            const promises = (0, $eee2fa4b9ebe63e9$export$8e5dc47097396754)(event.audio, async (audio)=>{
                const response = await fetch(audio.source);
                if (!response.ok) return;
                const arrayBuffer = await response.arrayBuffer(), audioContext = this._getAudioContext(), audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
                this._audioMap.set(audio.source, audioBuffer);
            });
            if (promises instanceof Promise) await promises;
            else await Promise.allSettled(promises);
        }
    }
    async mute() {
        if (!this._container.muted) await this.toggleMute();
    }
    async start() {
        const container = this._container, options = container.actualOptions, soundsOptions = options.sounds;
        if (!soundsOptions?.enable || !container.canvas.element) return;
        container.muted = true;
        const canvas = container.canvas.element, pos = {
            top: canvas.offsetTop,
            right: canvas.offsetLeft + canvas.offsetWidth
        }, { mute: mute, unmute: unmute, volumeDown: volumeDown, volumeUp: volumeUp } = soundsOptions.icons, margin = 10, toggleMute = async ()=>{
            await this.toggleMute();
        }, enableIcons = soundsOptions.icons.enable, display = enableIcons ? (0, $8f4e56927937b8f4$export$501d3b295794387a).Block : (0, $8f4e56927937b8f4$export$501d3b295794387a).None;
        this._muteImg = $4fcc5be793708d1d$var$initImage({
            container: container,
            options: options,
            pos: pos,
            display: display,
            iconOptions: mute,
            margin: margin,
            rightOffsets: [
                volumeDown.width,
                volumeUp.width
            ],
            clickCb: toggleMute
        });
        this._unmuteImg = $4fcc5be793708d1d$var$initImage({
            container: container,
            options: options,
            pos: pos,
            display: (0, $8f4e56927937b8f4$export$501d3b295794387a).None,
            iconOptions: unmute,
            margin: margin,
            rightOffsets: [
                volumeDown.width,
                volumeUp.width
            ],
            clickCb: toggleMute
        });
        this._volumeDownImg = $4fcc5be793708d1d$var$initImage({
            container: container,
            options: options,
            pos: pos,
            display: display,
            iconOptions: volumeDown,
            margin: margin,
            rightOffsets: [
                volumeUp.width
            ],
            clickCb: async ()=>{
                await this.volumeDown();
            }
        });
        this._volumeUpImg = $4fcc5be793708d1d$var$initImage({
            container: container,
            options: options,
            pos: pos,
            display: display,
            iconOptions: volumeUp,
            margin: margin,
            rightOffsets: [],
            clickCb: async ()=>{
                await this.volumeUp();
            }
        });
        if (!(0, $16d7ca110d419961$export$43340e5cf364d321)() && soundsOptions.autoPlay) await this.unmute();
    }
    stop() {
        this._container.muted = true;
        (async ()=>{
            await this._mute();
            $4fcc5be793708d1d$var$removeImage(this._muteImg);
            $4fcc5be793708d1d$var$removeImage(this._unmuteImg);
            $4fcc5be793708d1d$var$removeImage(this._volumeDownImg);
            $4fcc5be793708d1d$var$removeImage(this._volumeUpImg);
        })();
    }
    async toggleMute() {
        const container = this._container;
        container.muted = !container.muted;
        this._updateMuteIcons();
        await this._updateMuteStatus();
    }
    async unmute() {
        if (this._container.muted) await this.toggleMute();
    }
    async volumeDown() {
        const container = this._container, soundsOptions = container.actualOptions.sounds;
        if (!soundsOptions?.enable) return;
        if (container.muted) this._volume = 0;
        this._volume -= soundsOptions.volume.step;
        await this._updateVolume();
    }
    async volumeUp() {
        const container = this._container, soundsOptions = container.actualOptions.sounds;
        if (!soundsOptions?.enable) return;
        this._volume += soundsOptions.volume.step;
        await this._updateVolume();
    }
    _getAudioContext() {
        const container = this._container;
        if (!container.audioContext) container.audioContext = new AudioContext();
        return container.audioContext;
    }
}



const $8c4c5b4bc96bab77$var$generalFirstClickHandler = ()=>{
    removeEventListener((0, $dec17af1c054e95f$export$9ffd73c9a0e32c34), $8c4c5b4bc96bab77$var$generalFirstClickHandler);
    removeEventListener((0, $dec17af1c054e95f$export$d5353b6c79bbcc70), $8c4c5b4bc96bab77$var$generalFirstClickHandler);
    (0, $16d7ca110d419961$export$3dcb5603841ddc5d)();
};
class $8c4c5b4bc96bab77$export$9e7a13937a8834f0 {
    constructor(engine){
        this.id = "sounds";
        this._engine = engine;
        const listenerOptions = {
            capture: true,
            once: true
        };
        addEventListener((0, $dec17af1c054e95f$export$9ffd73c9a0e32c34), $8c4c5b4bc96bab77$var$generalFirstClickHandler, listenerOptions);
        addEventListener((0, $dec17af1c054e95f$export$d5353b6c79bbcc70), $8c4c5b4bc96bab77$var$generalFirstClickHandler, listenerOptions);
    }
    getPlugin(container) {
        return Promise.resolve(new (0, $4fcc5be793708d1d$export$a0008d5fea52c47e)(container, this._engine));
    }
    loadOptions(options, source) {
        if (!this.needsPlugin(options) && !this.needsPlugin(source)) return;
        let soundsOptions = options.sounds;
        if (soundsOptions?.load === undefined) options.sounds = soundsOptions = new (0, $fa40b69865dbf05b$export$76eeb3aae76ab221)();
        soundsOptions.load(source?.sounds);
    }
    needsPlugin(options) {
        return options?.sounds?.enable ?? false;
    }
}


async function $c4ce37af5afba5bd$export$c26b8ff0df874324(engine, refresh = true) {
    await engine.addPlugin(new (0, $8c4c5b4bc96bab77$export$9e7a13937a8834f0)(engine), refresh);
}



function $764e89033fffb53c$export$cb28a4edc8f8f34b(data) {
    const { context: context, particle: particle, radius: radius } = data;
    if (particle.spiralInnerRadius === undefined || particle.spiralLineSpacing === undefined || particle.spiralWidthFactor === undefined) return;
    const realWidth = (radius - particle.spiralInnerRadius) / particle.spiralLineSpacing, widthFactor = 10;
    for(let i = 0; i < realWidth * widthFactor; i++){
        const angle = i / widthFactor, factor = particle.spiralInnerRadius + particle.spiralLineSpacing * angle, pos = {
            x: factor * Math.cos(angle),
            y: factor * Math.sin(angle)
        };
        context.lineTo(pos.x, pos.y);
    }
}


const $3a659090837269b1$var$defaultInnerRadius = 1, $3a659090837269b1$var$defaultLineSpacing = 1, $3a659090837269b1$var$defaultWidthFactor = 10;
class $3a659090837269b1$export$8355cd685f6edb4b {
    constructor(){
        this.validTypes = [
            "spiral"
        ];
    }
    draw(data) {
        (0, $764e89033fffb53c$export$cb28a4edc8f8f34b)(data);
    }
    particleInit(container, particle) {
        const pixelRatio = container.retina.pixelRatio, shapeData = particle.shapeData;
        particle.spiralInnerRadius = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(shapeData?.innerRadius ?? $3a659090837269b1$var$defaultInnerRadius) * pixelRatio;
        particle.spiralLineSpacing = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(shapeData?.lineSpacing ?? $3a659090837269b1$var$defaultLineSpacing) * pixelRatio;
        particle.spiralWidthFactor = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(shapeData?.widthFactor ?? $3a659090837269b1$var$defaultWidthFactor);
    }
}


async function $4252eab158efd990$export$36bd338850a8b66f(engine, refresh = true) {
    await engine.addShape(new (0, $3a659090837269b1$export$8355cd685f6edb4b)(), refresh);
}



const $924c255ed34a3fa8$var$double = 2, $924c255ed34a3fa8$var$minTrailLength = 2, $924c255ed34a3fa8$var$trailLengthOffset = 1, $924c255ed34a3fa8$var$noItems = 0, $924c255ed34a3fa8$var$half = 0.5, $924c255ed34a3fa8$var$minWidth = -1, $924c255ed34a3fa8$var$defaultLength = 10, $924c255ed34a3fa8$var$defaultAlpha = 1, $924c255ed34a3fa8$var$origin = {
    x: 0,
    y: 0
};
const $924c255ed34a3fa8$var$defaultTransform = {
    a: 1,
    b: 0,
    c: 0,
    d: 1
};
class $924c255ed34a3fa8$export$8e570e423c0bc4ba {
    draw(data) {
        const { context: context, radius: radius, particle: particle, transformData: transformData } = data, diameter = radius * $924c255ed34a3fa8$var$double, pxRatio = particle.container.retina.pixelRatio, currentPos = particle.getPosition(), trail = particle.trail;
        if (!trail || !particle.trailLength) return;
        const pathLength = particle.trailLength + radius;
        trail.push({
            color: context.fillStyle ?? context.strokeStyle,
            position: {
                x: currentPos.x,
                y: currentPos.y
            },
            transformData: {
                ...data.transformData
            }
        });
        if (trail.length < $924c255ed34a3fa8$var$minTrailLength) return;
        while(trail.length > pathLength)trail.shift();
        const trailLength = Math.min(trail.length, pathLength), canvasSize = {
            width: particle.container.canvas.size.width + diameter,
            height: particle.container.canvas.size.height + diameter
        };
        let lastPos = trail[trailLength - $924c255ed34a3fa8$var$trailLengthOffset].position;
        for(let i = trailLength; i > $924c255ed34a3fa8$var$noItems; i--){
            const step = trail[i - $924c255ed34a3fa8$var$trailLengthOffset], position = step.position, stepTransformData = particle.trailTransform ? step.transformData ?? $924c255ed34a3fa8$var$defaultTransform : $924c255ed34a3fa8$var$defaultTransform;
            context.setTransform(stepTransformData.a, stepTransformData.b, stepTransformData.c, stepTransformData.d, position.x, position.y);
            context.beginPath();
            context.moveTo(lastPos.x - position.x, lastPos.y - position.y);
            const warp = {
                x: (lastPos.x + canvasSize.width) % canvasSize.width,
                y: (lastPos.y + canvasSize.height) % canvasSize.height
            };
            if (Math.abs(lastPos.x - position.x) > canvasSize.width * $924c255ed34a3fa8$var$half || Math.abs(lastPos.y - position.y) > canvasSize.height * $924c255ed34a3fa8$var$half) {
                lastPos = position;
                continue;
            }
            context.lineTo(Math.abs(lastPos.x - position.x) > canvasSize.width * $924c255ed34a3fa8$var$half ? warp.x : $924c255ed34a3fa8$var$origin.x, Math.abs(lastPos.y - position.y) > canvasSize.height * $924c255ed34a3fa8$var$half ? warp.y : $924c255ed34a3fa8$var$origin.y);
            const width = Math.max(i / trailLength * diameter, pxRatio, particle.trailMinWidth ?? $924c255ed34a3fa8$var$minWidth), oldAlpha = context.globalAlpha;
            context.globalAlpha = particle.trailFade ? i / trailLength : $924c255ed34a3fa8$var$defaultAlpha;
            context.lineWidth = particle.trailMaxWidth ? Math.min(width, particle.trailMaxWidth) : width;
            context.strokeStyle = step.color;
            context.stroke();
            context.globalAlpha = oldAlpha;
            lastPos = position;
        }
        context.setTransform(transformData.a, transformData.b, transformData.c, transformData.d, currentPos.x, currentPos.y);
    }
    particleInit(container, particle) {
        particle.trail = [];
        const effectData = particle.effectData;
        particle.trailFade = effectData?.fade ?? true;
        particle.trailLength = (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(effectData?.length ?? $924c255ed34a3fa8$var$defaultLength) * container.retina.pixelRatio;
        particle.trailMaxWidth = effectData?.maxWidth ? (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(effectData.maxWidth) * container.retina.pixelRatio : undefined;
        particle.trailMinWidth = effectData?.minWidth ? (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(effectData.minWidth) * container.retina.pixelRatio : undefined;
        particle.trailTransform = effectData?.transform ?? false;
    }
}


async function $9c233f810f5cf959$export$225a975d057d5fd4(engine, refresh = true) {
    await engine.addEffect("trail", new (0, $924c255ed34a3fa8$export$8e570e423c0bc4ba)(), refresh);
}



const $55f841c75cef9300$var$angularFrequencyFactor = 0.5, $55f841c75cef9300$var$half = 0.5, $55f841c75cef9300$var$halfPI = Math.PI * $55f841c75cef9300$var$half;
class $55f841c75cef9300$export$1c2849307462bbe5 {
    constructor(){
        this.options = {
            waveHeight: {
                min: 0,
                max: 3
            },
            waveLength: {
                min: 0,
                max: 5
            }
        };
    }
    generate(particle, delta) {
        if (particle.zigzag === undefined) particle.zigzag = {
            counter: (0, $1ff4dfb77b7bb646$export$1a76347094524b3b)(),
            waveHeight: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(this.options.waveHeight),
            waveLength: (0, $1ff4dfb77b7bb646$export$e70c64b68236cb4e)(this.options.waveLength)
        };
        const angularFrequency = $55f841c75cef9300$var$angularFrequencyFactor / particle.zigzag.waveLength * delta.factor;
        particle.zigzag.counter += angularFrequency;
        const zigzagAngle = particle.zigzag.waveHeight * Math.sin(particle.zigzag.counter);
        particle.position.x += zigzagAngle * Math.cos(particle.velocity.angle + $55f841c75cef9300$var$halfPI);
        particle.position.y += zigzagAngle * Math.sin(particle.velocity.angle + $55f841c75cef9300$var$halfPI);
        return (0, $04697537ec8dce5b$export$9b781de7bf37bf48).origin;
    }
    init(container) {
        const options = container.actualOptions.particles.move.path.options;
        this.options.waveLength = options.waveLength ?? this.options.waveLength;
        this.options.waveHeight = options.waveHeight ?? this.options.waveHeight;
    }
    reset() {}
    update() {}
}


const $f61c37369a1f11fc$export$c6e1792ed9475fec = "zigZagPathGenerator";
async function $f61c37369a1f11fc$export$5f1cdda33a20f3b5(engine, refresh = true) {
    await engine.addPathGenerator($f61c37369a1f11fc$export$c6e1792ed9475fec, new (0, $55f841c75cef9300$export$1c2849307462bbe5)(), refresh);
}


async function $2e697f6c2f74680b$export$7aabae09a30b04c2(engine, refresh = true) {
    (0, $2591792b29c719ea$export$4948e8af77cbffab)(engine);
    await (0, $9848ba7605c0cf1a$export$85493d8c5e7176fb)(engine, false);
    await (0, $c9a5633c6a2864f2$export$25026bf63efa4ca6)();
    await (0, $34d7af5227549100$export$1292eb8e57da4dca)();
    await (0, $1f50d2bd97421d53$export$b6f4c6341a3f449b)();
    await (0, $1c333aa7f69cc831$export$a01549474a230bcd)();
    await (0, $d51093f94a3a099d$export$86a6aa77937f9b42)();
    await (0, $c49c94142b42199c$export$5725066e6e60213a)();
    await (0, $fcac508d4f7ea98d$export$e742b1d10f4d5e8f)();
    await (0, $aa3626bf11063886$export$2e760541d25c06b7)();
    await (0, $d8adda34098bb3b8$export$93658ed80be028d6)();
    await (0, $1d18efe0a688dbc7$export$1201873234d2f4b3)(engine, false);
    await (0, $ff5646612369f51f$export$1e3528e6ddfcfe9e)(engine, false);
    await (0, $33975798350b86d8$export$fa68ca5125f7e68b)(engine, false);
    await (0, $c9a5633c6a2864f2$export$25026bf63efa4ca6)();
    await (0, $497776f81ff8aecd$export$ff99555347c1020e)(engine, false);
    await (0, $91cfb3d96f44a3fa$export$d49e2fd5a9e5c935)(engine, false);
    await (0, $30f79e2f10ab55a1$export$67d9c97c602a4291)(engine, false);
    await (0, $3950c23d6bd2ac31$export$12d8e3e20fc71daf)(engine, false);
    await (0, $c4ce37af5afba5bd$export$c26b8ff0df874324)(engine, false);
    await (0, $854ac5a4136777be$export$dbd4e9728554121e)(engine, false);
    await (0, $cc70e2aba6ea7d4b$export$98e4494e9467da53)(engine, false);
    await (0, $acbbd11e25e5a5bd$export$889f8bbce641cc4d)(engine, false);
    await (0, $d2029b3aa9fc57ee$export$a60020c5bc91fd7e)(engine, false);
    await (0, $dc94056df980545f$export$5f6bc485a10240b7)(engine, false);
    await (0, $8628b62569577efb$export$9e47db2a3b3d6236)(engine, false);
    await (0, $22567d61c1ae3141$export$5a3ef42b8266261e)(engine, false);
    await (0, $f6cd619e839ee383$export$c8b1a80debb89393)(engine, false);
    await (0, $ebc921caee9e3940$export$bc5d21ee1fe964a2)(engine, false);
    await (0, $ec215479089ea60b$export$7abb031a40616b32)(engine, false);
    await (0, $9f069d8e63f559c7$export$676c523f5025179f)(engine, false);
    await (0, $9967d8ae398d0049$export$273036b4e93b2f7f)(engine, false);
    await (0, $12c230f71b3cc0e1$export$4ee19d5fe7c038f2)(engine, false);
    await (0, $5b5a3b0ce636d8e8$export$5cf08bd8d685725)(engine, false);
    await (0, $c365ea05f98bb5e2$export$48494e9d19283f78)(engine, false);
    await (0, $f61c37369a1f11fc$export$5f1cdda33a20f3b5)(engine, false);
    await (0, $97ed1842be54001e$export$dcab187a131a8a68)(engine, false);
    await (0, $8bee22f8f09072ff$export$636d52385760703d)(engine, false);
    await (0, $94bb5d4d7e177ff9$export$c9e682e002889c73)(engine, false);
    await (0, $2b8571bf2a2f9ce8$export$4b909c2789cff23)(engine, false);
    await (0, $4fdce87f255aa872$export$d051d1bf41ebd4ca)(engine, false);
    await (0, $1a9b65e1ab045f28$export$2fd8a165ac5d2fa3)(engine, false);
    await (0, $c4f4158d6d97258c$export$b882071358cdf22a)(engine, false);
    await (0, $4c1bfbde15ab6ae0$export$4cb625f63f063ade)(engine, false);
    await (0, $d0769c127ce72880$export$be50bd2e9593bd84)(engine, false);
    await (0, $79d8fb78d9523d94$export$204acac9e7d7a737)(engine, false);
    await (0, $4252eab158efd990$export$36bd338850a8b66f)(engine, false);
    await (0, $9c233f810f5cf959$export$225a975d057d5fd4)(engine, false);
    await engine.refresh(refresh);
}



var $ad04c12127ab3844$exports = {};
/*   Magic UMD boilerplate Beginning  */ /**/ (function(root, factory) {
    /**/ if (typeof define === "function" && define.amd) /**/ define([], factory);
    else if (0, $ad04c12127ab3844$exports) {
        /**/ $ad04c12127ab3844$exports = factory();
        /**/ $ad04c12127ab3844$exports.default = $ad04c12127ab3844$exports;
    /**/ } else /**/ root.smokemachine = root.SmokeMachine = factory();
/**/ })(typeof self !== "undefined" ? self : $ad04c12127ab3844$exports, function() {
    var opacities = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        3,
        5,
        5,
        7,
        4,
        4,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        17,
        27,
        41,
        52,
        56,
        34,
        23,
        15,
        11,
        4,
        9,
        5,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        45,
        63,
        57,
        45,
        78,
        66,
        52,
        41,
        34,
        37,
        23,
        20,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        43,
        62,
        66,
        64,
        67,
        115,
        112,
        114,
        56,
        58,
        47,
        33,
        18,
        12,
        10,
        0,
        0,
        0,
        0,
        39,
        50,
        63,
        76,
        87,
        107,
        105,
        112,
        128,
        104,
        69,
        64,
        29,
        18,
        21,
        15,
        0,
        0,
        0,
        7,
        42,
        52,
        85,
        91,
        103,
        126,
        153,
        128,
        124,
        82,
        57,
        52,
        52,
        24,
        1,
        0,
        0,
        0,
        2,
        17,
        41,
        67,
        84,
        100,
        122,
        136,
        159,
        127,
        78,
        69,
        60,
        50,
        47,
        25,
        7,
        1,
        0,
        0,
        0,
        34,
        33,
        66,
        82,
        113,
        138,
        149,
        168,
        175,
        82,
        142,
        133,
        70,
        62,
        41,
        25,
        6,
        0,
        0,
        0,
        18,
        39,
        55,
        113,
        111,
        137,
        141,
        139,
        141,
        128,
        102,
        130,
        90,
        96,
        65,
        37,
        0,
        0,
        0,
        2,
        15,
        27,
        71,
        104,
        129,
        129,
        158,
        140,
        154,
        146,
        150,
        131,
        92,
        100,
        67,
        26,
        3,
        0,
        0,
        0,
        0,
        46,
        73,
        104,
        124,
        145,
        135,
        122,
        107,
        120,
        122,
        101,
        98,
        96,
        35,
        38,
        7,
        2,
        0,
        0,
        0,
        50,
        58,
        91,
        124,
        127,
        139,
        118,
        121,
        177,
        156,
        88,
        90,
        88,
        28,
        43,
        3,
        0,
        0,
        0,
        0,
        30,
        62,
        68,
        91,
        83,
        117,
        89,
        139,
        139,
        99,
        105,
        77,
        32,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        16,
        21,
        8,
        45,
        101,
        125,
        118,
        87,
        110,
        86,
        64,
        39,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        28,
        79,
        79,
        117,
        122,
        88,
        84,
        54,
        46,
        11,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        6,
        55,
        61,
        68,
        71,
        30,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        14,
        23,
        25,
        20,
        12,
        5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        12,
        9,
        8,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        4,
        2,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    var smokeSpriteSize = 20;
    var polyfillAnimFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
    function floatInRange(start, end) {
        return start + Math.random() * (end - start);
    }
    function makeSmokeSprite(color) {
        color = color || [
            24,
            46.8,
            48.2
        ];
        var smokeSprite = document.createElement("canvas"), ctx = smokeSprite.getContext("2d"), data = ctx.createImageData(smokeSpriteSize, smokeSpriteSize), d = data.data;
        for(var i = 0; i < d.length; i += 4){
            d[i] = color[0];
            d[i + 1] = color[1];
            d[i + 2] = color[2];
            d[i + 3] = opacities[i / 4];
        }
        smokeSprite.width = smokeSpriteSize;
        smokeSprite.height = smokeSpriteSize;
        ctx.putImageData(data, 0, 0);
        return smokeSprite;
    }
    function createParticle(x, y, options) {
        options = options || {};
        var lifetime = options.lifetime || 4000;
        var particle = {
            x: x,
            y: y,
            vx: floatInRange(options.minVx || -0.04, options.maxVx || 0.04),
            startvy: floatInRange(options.minVy || -0.4, options.maxVy || -0.1),
            scale: floatInRange(options.minScale || 0, options.maxScale || 0.5),
            lifetime: floatInRange(options.minLifetime || 2000, options.maxLifetime || 8000),
            age: 0
        };
        particle.finalScale = floatInRange(options.minScale || 25 + particle.scale, options.maxScale || 30 + particle.scale);
        particle.vy = particle.startvy;
        return particle;
    }
    function updateParticle(particle, deltatime) {
        particle.x += particle.vx * deltatime;
        particle.y += particle.vy * deltatime;
        var frac = Math.sqrt(particle.age / particle.lifetime);
        particle.vy = (1 - frac) * particle.startvy;
        particle.age += deltatime;
        particle.scale = frac * particle.finalScale;
    }
    function drawParticle(particle, smokeParticleImage, context) {
        context.globalAlpha = (1 - Math.abs(1 - 2 * particle.age / particle.lifetime)) / 8;
        var off = particle.scale * smokeSpriteSize / 2;
        var xmin = particle.x - off;
        var xmax = xmin + off * 2;
        var ymin = particle.y - off;
        var ymax = ymin + off * 2;
        context.drawImage(smokeParticleImage, xmin, ymin, xmax - xmin, ymax - ymin);
    // console.log(smokeParticleImage, xmin, ymin, xmax-xmin, ymax-ymin)
    }
    return function SmokeMachine(context, color) {
        var smokeParticleImage = makeSmokeSprite(color), particles = [], preDrawCallback = function() {};
        function updateAndDrawParticles(deltatime) {
            context.clearRect(0, 0, context.canvas.width, context.canvas.height);
            particles.forEach(function(p) {
                updateParticle(p, deltatime);
            });
            particles = particles.filter(function(p) {
                return p.age < p.lifetime;
            });
            preDrawCallback(deltatime, particles);
            particles.forEach(function(p) {
                drawParticle(p, smokeParticleImage, context);
            });
        }
        var running = false, lastframe = performance.now();
        function frame(time) {
            if (!running) return;
            var dt = time - lastframe;
            lastframe = time;
            updateAndDrawParticles(dt);
            polyfillAnimFrame(frame);
        }
        function addParticles(x, y, numParticles, options) {
            numParticles = numParticles || 10;
            if (numParticles < 1) return Math.random() <= numParticles && particles.push(createParticle(x, y, options));
            for(var i = 0; i < numParticles; i++)particles.push(createParticle(x, y, options));
        }
        return {
            step: function step(dt) {
                dt = dt || 16;
                console.log(dt);
                updateAndDrawParticles(dt);
            },
            start: function start() {
                running = true;
                lastframe = performance.now();
                polyfillAnimFrame(frame);
            },
            setPreDrawCallback: function(f) {
                preDrawCallback = f;
            },
            stop: function stop() {
                running = false;
            },
            addsmoke: addParticles,
            addSmoke: addParticles
        };
    };
/* Magic UMD Boilerplate Ending */ /**/ });


//min y maximo incluidos
const $b8f9b7833fa37166$var$randomInteger = (min, max)=>{
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
const $b8f9b7833fa37166$var$randomInRange = (min, max)=>{
    return Math.random() * (max - min) + min;
};
const $b8f9b7833fa37166$var$delay = (delayInms)=>{
    return new Promise((resolve)=>setTimeout(resolve, delayInms));
};
var $ddab1aed2fe421b4$exports = {};
$ddab1aed2fe421b4$exports = JSON.parse('{"autoPlay":true,"backgroundMask":{"composite":"destination-out","cover":{"color":{"value":"#fff"},"opacity":1},"enable":false},"clear":true,"defaultThemes":{},"delay":0,"fullScreen":{"enable":true,"zIndex":0},"detectRetina":true,"duration":0,"fpsLimit":120,"interactivity":{"detectsOn":"window","events":{"onClick":{"enable":false,"mode":{}},"onDiv":{"selectors":{},"enable":false,"mode":{},"type":"circle"},"onHover":{"enable":false,"mode":{},"parallax":{"enable":false,"force":2,"smooth":10}},"resize":{"delay":0.5,"enable":true}},"modes":{"trail":{"delay":1,"pauseOnStop":false,"quantity":1},"attract":{"distance":200,"duration":0.4,"easing":"ease-out-quad","factor":1,"maxSpeed":50,"speed":1},"bounce":{"distance":200},"bubble":{"distance":200,"duration":0.4,"mix":false,"divs":{"distance":200,"duration":0.4,"mix":false,"selectors":[]}},"connect":{"distance":80,"links":{"opacity":0.5},"radius":60},"grab":{"distance":100,"links":{"blink":false,"consent":false,"opacity":1}},"push":{"default":true,"groups":[],"quantity":4},"remove":{"quantity":2},"repulse":{"distance":200,"duration":0.4,"factor":100,"speed":1,"maxSpeed":50,"easing":"ease-out-quad","divs":{"distance":200,"duration":0.4,"factor":100,"speed":1,"maxSpeed":50,"easing":"ease-out-quad","selectors":[]}},"slow":{"factor":3,"radius":200},"light":{"area":{"gradient":{"start":{"value":"#ffffff"},"stop":{"value":"#000000"}},"radius":1000},"shadow":{"color":{"value":"#000000"},"length":2000}}}},"manualParticles":[],"particles":{"bounce":{"horizontal":{"value":1},"vertical":{"value":1}},"collisions":{"absorb":{"speed":2},"bounce":{"horizontal":{"value":1},"vertical":{"value":1}},"enable":false,"maxSpeed":50,"mode":"bounce","overlap":{"enable":true,"retries":0}},"color":{"value":["#fdcf58","#757676","#f27d0c","#800909","#f07f13"]},"effect":{"close":true,"fill":true,"options":{},"type":{}},"groups":{},"move":{"angle":{"offset":0,"value":90},"attract":{"distance":200,"enable":false,"rotate":{"x":3000,"y":3000}},"center":{"x":50,"y":50,"mode":"percent","radius":0},"decay":0,"distance":{},"direction":"none","drift":0,"enable":true,"gravity":{"acceleration":9.81,"enable":false,"inverse":false,"maxSpeed":50},"path":{"clamp":true,"delay":{"value":0},"enable":false,"options":{}},"outModes":{"default":"destroy","bottom":"destroy","left":"destroy","right":"destroy","top":"destroy"},"random":false,"size":false,"speed":5,"spin":{"acceleration":0,"enable":false},"straight":false,"trail":{"enable":false,"length":10,"fill":{}},"vibrate":false,"warp":false},"number":{"density":{"enable":true,"width":1920,"height":1080},"limit":{"mode":"delete","value":0},"value":0},"opacity":{"value":{"min":0.1,"max":0.5}},"reduceDuplicates":false,"shadow":{"blur":0,"color":{"value":"#000"},"enable":false,"offset":{"x":0,"y":0}},"shape":{"close":false,"fill":true,"options":{},"type":"circle"},"size":{"value":{"min":1,"max":3},"animation":{"count":0,"enable":true,"speed":0.6,"decay":0,"delay":0,"sync":true,"mode":"auto","startValue":"min","destroy":"max"}},"stroke":{"width":0},"zIndex":{"value":0,"opacityRate":1,"sizeRate":1,"velocityRate":1},"destroy":{"bounds":{},"mode":"none","split":{"count":1,"factor":{"value":3},"rate":{"value":{"min":4,"max":9}},"sizeOffset":true,"particles":{}}},"roll":{"darken":{"enable":false,"value":0},"enable":false,"enlighten":{"enable":false,"value":0},"mode":"vertical","speed":25},"tilt":{"value":0,"animation":{"enable":false,"speed":0,"decay":0,"sync":false},"direction":"clockwise","enable":false},"twinkle":{"lines":{"enable":false,"frequency":0.05,"opacity":1},"particles":{"enable":false,"frequency":0.005,"opacity":0.1,"color":{"value":"#757676"}}},"wobble":{"distance":5,"enable":false,"speed":{"angle":50,"move":10}},"life":{"count":0,"delay":{"value":0,"sync":false},"duration":{"value":0,"sync":false}},"rotate":{"value":0,"animation":{"enable":false,"speed":0,"decay":0,"sync":false},"direction":"clockwise","path":false},"orbit":{"animation":{"count":0,"enable":false,"speed":1,"decay":0,"delay":0,"sync":false},"enable":false,"opacity":1,"rotation":{"value":45},"width":1},"links":{"blink":false,"color":{"value":"#ffffff"},"consent":false,"distance":150,"enable":false,"frequency":1,"opacity":0.4,"shadow":{"blur":5,"color":{"value":"#000"},"enable":false},"triangles":{"enable":false,"frequency":1},"width":1,"warp":false},"repulse":{"value":0,"enabled":false,"distance":1,"duration":1,"factor":1,"speed":1}},"pauseOnBlur":true,"pauseOnOutsideViewport":true,"responsive":[],"smooth":false,"style":{},"themes":[],"zLayers":100,"name":"Growing","emitters":{"autoPlay":true,"fill":true,"life":{"wait":false},"rate":{"quantity":2,"delay":0.1},"shape":{"options":{},"replace":{"color":false,"opacity":false},"type":"square"},"startCount":0,"size":{"mode":"percent","height":0,"width":100},"direction":"top","particles":{},"position":{"x":50,"y":100}},"motion":{"disable":false,"reduce":{"factor":4,"value":true}}}');


async function $b8f9b7833fa37166$var$loadParticles(options) {
    await (0, $2e697f6c2f74680b$export$7aabae09a30b04c2)((0, $8c96b70d43d04c22$export$218c38ca7c058037));
    await (0, $8c96b70d43d04c22$export$218c38ca7c058037).load({
        id: "tsparticles",
        options: options
    });
}
$b8f9b7833fa37166$var$loadParticles($ddab1aed2fe421b4$exports);
const $b8f9b7833fa37166$var$canvas = document.getElementById("canvas");
const $b8f9b7833fa37166$var$ctx = $b8f9b7833fa37166$var$canvas.getContext("2d");
//OKs 0, 210, 255
const $b8f9b7833fa37166$var$party = (0, (/*@__PURE__*/$parcel$interopDefault($ad04c12127ab3844$exports)))($b8f9b7833fa37166$var$ctx, [
    0,
    210,
    255
]);
$b8f9b7833fa37166$var$party.start(); // start animating
//Primer smoke
//party.addSmoke(Math.floor(innerWidth / 2), innerHeight, 30);
/*
const gosmoke = () => {
  console.log("gosmoke");
  party.stop(); // stop animating
  party.addSmoke(randomInteger(1, innerWidth), innerHeight, 50);
  //for (var i = 0; i < 10; i++) {
    //party.step(10); // pretend 10 ms pass and rerender
  //}
  setTimeout(function () {
    party.start();
  }, 1000);

  setTimeout(gosmoke, 5000);
};
gosmoke();
*/ /*
setTimeout(function () {
  party.stop(); // stop animating

  party.addSmoke(innerWidth/2, innerHeight, 1000);
  party.addSmoke(innerWidth/2, innerHeight, 200);

  for (var i = 0; i < 10; i++) {
    party.step(10); // pretend 10 ms pass and rerender
  }

  setTimeout(function () {
    party.start();
  }, 1000);
}, 1000);
*/ //RANDOM
/*
party.setPreDrawCallback(function () {
  //party.stop(); // stop animating

  //Mientras mas chica la pantalla menos particulas
  party.addSmoke(
    randomInteger(1, innerWidth),
    innerHeight,
    Math.random() * innerWidth * 0.0007
  );
});
*/ //DEFINED
let $b8f9b7833fa37166$var$width_pos = 1;
$b8f9b7833fa37166$var$party.setPreDrawCallback(function() {
    $b8f9b7833fa37166$var$width_pos += Math.floor(innerWidth * 0.1);
    if ($b8f9b7833fa37166$var$width_pos >= innerWidth) $b8f9b7833fa37166$var$width_pos = 1;
    //party.stop(); // stop animating
    //Mientras mas chica la pantalla menos particulas
    $b8f9b7833fa37166$var$party.addSmoke($b8f9b7833fa37166$var$width_pos, innerHeight, Math.random() * innerWidth * 0.0007);
}); // party.addsmoke(innerWidth/2, innerHeight, 100)
 // onclick=e => {
 // 	console.log(e)
 // 	party.step()
 // }
 /*
	onmousemove = function (e) {
		var x = e.clientX
		var y = e.clientY
		var n = .5
		var t = Math.floor(Math.random() * 200) + 3800
		party.addsmoke(x, y, n, t)
	}
  */ 

})();
//# sourceMappingURL=index.1977ab42.js.map
